import { defineComponent as ip, computed as I, watch as Ae, h as Wu, onMounted as mt, onUpdated as Hg, onBeforeUnmount as Yl, inject as Se, reactive as ai, readonly as yi, resolveComponent as $, createElementBlock as U, openBlock as D, createVNode as B, withCtx as j, createTextVNode as Me, toDisplayString as K, normalizeClass as He, createElementVNode as R, renderSlot as tt, createBlock as G, createSlots as Zl, effectScope as $g, getCurrentScope as Fg, onScopeDispose as Vg, shallowRef as de, nextTick as yt, toValue as pe, getCurrentInstance as Xl, toRef as op, ref as Q, customRef as zg, watchEffect as ap, unref as V, markRaw as Wg, toRaw as Gg, withDirectives as yn, normalizeStyle as rt, vShow as sp, Fragment as gt, createCommentVNode as J, useTemplateRef as Cn, renderList as nr, resolveDynamicComponent as si, isRef as lp, defineAsyncComponent as Y, Suspense as Yg, useCssVars as up, withModifiers as dl, toRefs as Kl, provide as ti, onUnmounted as cp, withKeys as Gu } from "vue";
import Yu from "axios";
import Zg, { useVuelidate as dp } from "@vuelidate/core";
import fp from "vuedraggable";
const hp = Symbol("wormhole");
function pp() {
  const n = Se(hp);
  if (!n)
    throw new Error(`
    [portal-vue]: Necessary Injection not found. Make sur you installed the plugin properly.`);
  return n;
}
const vp = typeof window < "u";
function Xg(n, e) {
  return n.map((t, r) => [r, t]).sort(function(t, r) {
    return e(t[1], r[1]) || t[0] - r[0];
  }).map((t) => t[1]);
}
function Kg(n, e) {
  const t = pp();
  function r() {
    if (!vp)
      return;
    const { to: o, name: a, order: s } = n;
    e.default ? t.open({
      to: o,
      from: a,
      order: s,
      content: e.default
    }) : i();
  }
  function i(o) {
    t.close({
      to: o ?? n.to,
      from: n.name
    });
  }
  mt(() => {
    n.disabled || r();
  }), Hg(() => {
    n.disabled ? i() : r();
  }), Yl(() => {
    i();
  }), Ae(
    () => n.to,
    (o, a) => {
      n.disabled || (a && a !== o && i(a), r());
    }
  );
}
const Qg = ip({
  compatConfig: { MODE: 3 },
  name: "portal",
  props: {
    disabled: { type: Boolean },
    name: { type: [String, Symbol], default: () => Symbol() },
    order: { type: Number },
    slotProps: { type: Object, default: () => ({}) },
    to: {
      type: String,
      default: () => String(Math.round(Math.random() * 1e7))
    }
  },
  setup(n, { slots: e }) {
    return Kg(n, e), () => n.disabled && e.default ? e.default(n.slotProps) : null;
  }
}), Jg = (n, { slots: e }) => {
  var t;
  return (t = e.default) == null ? void 0 : t.call(e);
}, fl = ip({
  compatConfig: { MODE: 3 },
  name: "portalTarget",
  props: {
    multiple: { type: Boolean, default: !1 },
    name: { type: String, required: !0 },
    slotProps: { type: Object, default: () => ({}) }
  },
  emits: ["change"],
  setup(n, { emit: e, slots: t }) {
    const r = pp(), i = I(
      () => {
        const o = r.getContentForTarget(
          n.name,
          n.multiple
        ), a = t.wrapper, s = o.map((u) => u.content(n.slotProps)), l = a ? s.flatMap(
          (u) => u.length ? a(u) : []
        ) : s.flat(1);
        return {
          vnodes: l,
          vnodesFn: () => l
        };
      }
    );
    return Ae(
      i,
      ({ vnodes: o }) => {
        const a = o.length > 0, s = r.transports.get(n.name), l = s ? [...s.keys()] : [];
        e("change", { hasContent: a, sources: l });
      },
      { flush: "post" }
    ), () => {
      var o;
      return i.value.vnodes.length ? [
        Wu("div", {
          style: "display: none",
          key: "__portal-vue-hacky-scoped-slot-repair__"
        }),
        Wu(Jg, i.value.vnodesFn)
      ] : (o = t.default) == null ? void 0 : o.call(t);
    };
  }
});
function em(n = !0) {
  const e = ai(/* @__PURE__ */ new Map());
  function t(a) {
    if (!vp)
      return;
    const { to: s, from: l, content: u, order: c = 1 / 0 } = a;
    if (!s || !l || !u)
      return;
    e.has(s) || e.set(s, /* @__PURE__ */ new Map());
    const d = e.get(s), f = {
      to: s,
      from: l,
      content: u,
      order: c
    };
    d.set(l, f);
  }
  function r(a) {
    const { to: s, from: l } = a;
    if (!s || !l)
      return;
    const u = e.get(s);
    !u || (u.delete(l), u.size || e.delete(s));
  }
  function i(a, s) {
    const l = e.get(a);
    if (!l)
      return [];
    const u = Array.from((l == null ? void 0 : l.values()) || []);
    return s ? Xg(
      u,
      (c, d) => c.order - d.order
    ) : [u.pop()];
  }
  const o = {
    open: t,
    close: r,
    transports: e,
    getContentForTarget: i
  };
  return n ? yi(o) : o;
}
const tm = em();
function rm(n, e = {}) {
  e.portalName !== !1 && n.component(e.portalName || "Portal", Qg), e.portalTargetName !== !1 && n.component(e.portalTargetName || "PortalTarget", fl);
  const t = e.wormhole ?? tm;
  n.provide(hp, t);
}
const qe = "BASE_COLUMN", wn = "LAYOUT_NODE_SINGLE_COLUMN", Tn = "LAYOUT_NODE_DOUBLE_COLUMN", Sn = "LAYOUT_NODE_TRIPLE_COLUMN", xn = "LAYOUT_NODE_QUADRUPLE_COLUMN", $r = "LAYOUT_NODE_FULL_WIDTH_COLUMN", An = "LAYOUT_NODE_LEFT_SIDEBAR", On = "LAYOUT_NODE_RIGHT_SIDEBAR", Qe = "LAYOUT_NODE_SHARED_CONTENT", Fr = "CONTENT_NODE_TEXT", ri = "CONTENT_NODE_HEADING", $n = "CONTENT_NODE_IMAGE", hl = "CONTENT_NODE_CODE", pl = "CONTENT_NODE_SPACER", En = "CONTENT_NODE_GALLERY", vl = "CONTENT_NODE_VIDEO", gl = "CONTENT_NODE_SEPARATOR", li = "CONTENT_NODE_BUTTON", ml = "CONTENT_NODE_FORM", _l = "CONTENT_NODE_QUOTE", In = "CONTENT_NODE_SLIDER", Nn = "CONTENT_NODE_CARD", bl = "CONTENT_NODE_TABLE", Bt = "CONTENT_NODE_ACCORDION", Tt = "CONTENT_NODE_PANEL", ui = "CONTENT_NODE_LIST", ci = "CONTENT_NODE_NAVIGATION", kn = "CONTENT_NODE_SHARED_CONTENT_ERROR", mr = "layout", _r = "content", Ql = "sub_content", Zu = "default", d2 = "light", f2 = "dark", Jl = [
  {
    name: "One Column",
    icon: "OneColumnIcon",
    type: wn
  },
  {
    name: "Two Columns",
    icon: "TwoColumnsIcon",
    type: Tn
  },
  {
    name: "Three Columns",
    icon: "ThreeColumnsIcon",
    type: Sn
  },
  {
    name: "Four Columns",
    icon: "FourColumnsIcon",
    type: xn
  },
  {
    name: "Left Sidebar",
    icon: "LeftSidebarIcon",
    type: An
  },
  {
    name: "Right Sidebar",
    icon: "RightSidebarIcon",
    type: On
  },
  {
    name: "Full Width",
    icon: "FullWidthIcon",
    type: $r
  }
].map((n) => ({ ...n, group: mr })), Ci = [
  {
    name: "Heading",
    icon: "HeadingIcon",
    type: ri
  },
  {
    name: "Text",
    icon: "TextIcon",
    type: Fr
  },
  {
    name: "Image",
    icon: "ImageIcon",
    type: $n
  },
  {
    name: "Gallery",
    icon: "GalleryIcon",
    type: En
  },
  {
    name: "Slider",
    icon: "SliderIcon",
    type: In
  },
  {
    name: "Code",
    icon: "EmbedIcon",
    type: hl
  },
  {
    name: "Video",
    icon: "VideoIcon",
    type: vl
  },
  {
    name: "Accordion",
    icon: "AccordionIcon",
    type: Bt
  },
  {
    name: "Spacer",
    icon: "SpacerIcon",
    type: pl
  },
  {
    name: "Separator",
    icon: "SeparatorIcon",
    type: gl
  },
  {
    name: "Card",
    icon: "CardIcon",
    type: Nn
  },
  {
    name: "Table",
    icon: "TableIcon",
    type: bl
  },
  {
    name: "Quote",
    icon: "QuoteIcon",
    type: _l
  },
  {
    name: "Form",
    icon: "FormIcon",
    type: ml
  },
  {
    name: "Button",
    icon: "ButtonIcon",
    type: li
  },
  {
    name: "List",
    type: ui
  },
  {
    name: "Navigation",
    icon: "NavigationIcon",
    type: ci
  },
  {
    name: "SharedContentError",
    icon: "",
    type: kn
  }
].map((n) => ({ ...n, group: _r, component: `${n.name}Node` })), gp = [
  {
    name: "Accordion Panel",
    component: "AccordionPanelNode",
    type: Tt
  }
].map((n) => ({ ...n, group: Ql })), nm = [
  ui
], im = [
  kn
], Mt = {
  BLACK: "#000000",
  WHITE: "#ffffff",
  DARK: "#333333"
};
var Xn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ht(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Ui, Xu;
function om() {
  if (Xu) return Ui;
  Xu = 1;
  function n() {
    this.__data__ = [], this.size = 0;
  }
  return Ui = n, Ui;
}
var ji, Ku;
function wi() {
  if (Ku) return ji;
  Ku = 1;
  function n(e, t) {
    return e === t || e !== e && t !== t;
  }
  return ji = n, ji;
}
var Hi, Qu;
function Ti() {
  if (Qu) return Hi;
  Qu = 1;
  var n = wi();
  function e(t, r) {
    for (var i = t.length; i--; )
      if (n(t[i][0], r))
        return i;
    return -1;
  }
  return Hi = e, Hi;
}
var $i, Ju;
function am() {
  if (Ju) return $i;
  Ju = 1;
  var n = Ti(), e = Array.prototype, t = e.splice;
  function r(i) {
    var o = this.__data__, a = n(o, i);
    if (a < 0)
      return !1;
    var s = o.length - 1;
    return a == s ? o.pop() : t.call(o, a, 1), --this.size, !0;
  }
  return $i = r, $i;
}
var Fi, ec;
function sm() {
  if (ec) return Fi;
  ec = 1;
  var n = Ti();
  function e(t) {
    var r = this.__data__, i = n(r, t);
    return i < 0 ? void 0 : r[i][1];
  }
  return Fi = e, Fi;
}
var Vi, tc;
function lm() {
  if (tc) return Vi;
  tc = 1;
  var n = Ti();
  function e(t) {
    return n(this.__data__, t) > -1;
  }
  return Vi = e, Vi;
}
var zi, rc;
function um() {
  if (rc) return zi;
  rc = 1;
  var n = Ti();
  function e(t, r) {
    var i = this.__data__, o = n(i, t);
    return o < 0 ? (++this.size, i.push([t, r])) : i[o][1] = r, this;
  }
  return zi = e, zi;
}
var Wi, nc;
function Si() {
  if (nc) return Wi;
  nc = 1;
  var n = om(), e = am(), t = sm(), r = lm(), i = um();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = n, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = r, o.prototype.set = i, Wi = o, Wi;
}
var Gi, ic;
function cm() {
  if (ic) return Gi;
  ic = 1;
  var n = Si();
  function e() {
    this.__data__ = new n(), this.size = 0;
  }
  return Gi = e, Gi;
}
var Yi, oc;
function dm() {
  if (oc) return Yi;
  oc = 1;
  function n(e) {
    var t = this.__data__, r = t.delete(e);
    return this.size = t.size, r;
  }
  return Yi = n, Yi;
}
var Zi, ac;
function fm() {
  if (ac) return Zi;
  ac = 1;
  function n(e) {
    return this.__data__.get(e);
  }
  return Zi = n, Zi;
}
var Xi, sc;
function hm() {
  if (sc) return Xi;
  sc = 1;
  function n(e) {
    return this.__data__.has(e);
  }
  return Xi = n, Xi;
}
var Ki, lc;
function mp() {
  if (lc) return Ki;
  lc = 1;
  var n = typeof Xn == "object" && Xn && Xn.Object === Object && Xn;
  return Ki = n, Ki;
}
var Qi, uc;
function Ot() {
  if (uc) return Qi;
  uc = 1;
  var n = mp(), e = typeof self == "object" && self && self.Object === Object && self, t = n || e || Function("return this")();
  return Qi = t, Qi;
}
var Ji, cc;
function xi() {
  if (cc) return Ji;
  cc = 1;
  var n = Ot(), e = n.Symbol;
  return Ji = e, Ji;
}
var eo, dc;
function pm() {
  if (dc) return eo;
  dc = 1;
  var n = xi(), e = Object.prototype, t = e.hasOwnProperty, r = e.toString, i = n ? n.toStringTag : void 0;
  function o(a) {
    var s = t.call(a, i), l = a[i];
    try {
      a[i] = void 0;
      var u = !0;
    } catch {
    }
    var c = r.call(a);
    return u && (s ? a[i] = l : delete a[i]), c;
  }
  return eo = o, eo;
}
var to, fc;
function vm() {
  if (fc) return to;
  fc = 1;
  var n = Object.prototype, e = n.toString;
  function t(r) {
    return e.call(r);
  }
  return to = t, to;
}
var ro, hc;
function rn() {
  if (hc) return ro;
  hc = 1;
  var n = xi(), e = pm(), t = vm(), r = "[object Null]", i = "[object Undefined]", o = n ? n.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? i : r : o && o in Object(s) ? e(s) : t(s);
  }
  return ro = a, ro;
}
var no, pc;
function $t() {
  if (pc) return no;
  pc = 1;
  function n(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return no = n, no;
}
var io, vc;
function eu() {
  if (vc) return io;
  vc = 1;
  var n = rn(), e = $t(), t = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", o = "[object Proxy]";
  function a(s) {
    if (!e(s))
      return !1;
    var l = n(s);
    return l == r || l == i || l == t || l == o;
  }
  return io = a, io;
}
var oo, gc;
function gm() {
  if (gc) return oo;
  gc = 1;
  var n = Ot(), e = n["__core-js_shared__"];
  return oo = e, oo;
}
var ao, mc;
function mm() {
  if (mc) return ao;
  mc = 1;
  var n = gm(), e = function() {
    var r = /[^.]+$/.exec(n && n.keys && n.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function t(r) {
    return !!e && e in r;
  }
  return ao = t, ao;
}
var so, _c;
function _p() {
  if (_c) return so;
  _c = 1;
  var n = Function.prototype, e = n.toString;
  function t(r) {
    if (r != null) {
      try {
        return e.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return so = t, so;
}
var lo, bc;
function _m() {
  if (bc) return lo;
  bc = 1;
  var n = eu(), e = mm(), t = $t(), r = _p(), i = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, u = s.hasOwnProperty, c = RegExp(
    "^" + l.call(u).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function d(f) {
    if (!t(f) || e(f))
      return !1;
    var h = n(f) ? c : o;
    return h.test(r(f));
  }
  return lo = d, lo;
}
var uo, yc;
function bm() {
  if (yc) return uo;
  yc = 1;
  function n(e, t) {
    return e == null ? void 0 : e[t];
  }
  return uo = n, uo;
}
var co, Cc;
function Nr() {
  if (Cc) return co;
  Cc = 1;
  var n = _m(), e = bm();
  function t(r, i) {
    var o = e(r, i);
    return n(o) ? o : void 0;
  }
  return co = t, co;
}
var fo, wc;
function tu() {
  if (wc) return fo;
  wc = 1;
  var n = Nr(), e = Ot(), t = n(e, "Map");
  return fo = t, fo;
}
var ho, Tc;
function Ai() {
  if (Tc) return ho;
  Tc = 1;
  var n = Nr(), e = n(Object, "create");
  return ho = e, ho;
}
var po, Sc;
function ym() {
  if (Sc) return po;
  Sc = 1;
  var n = Ai();
  function e() {
    this.__data__ = n ? n(null) : {}, this.size = 0;
  }
  return po = e, po;
}
var vo, xc;
function Cm() {
  if (xc) return vo;
  xc = 1;
  function n(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  return vo = n, vo;
}
var go, Ac;
function wm() {
  if (Ac) return go;
  Ac = 1;
  var n = Ai(), e = "__lodash_hash_undefined__", t = Object.prototype, r = t.hasOwnProperty;
  function i(o) {
    var a = this.__data__;
    if (n) {
      var s = a[o];
      return s === e ? void 0 : s;
    }
    return r.call(a, o) ? a[o] : void 0;
  }
  return go = i, go;
}
var mo, Oc;
function Tm() {
  if (Oc) return mo;
  Oc = 1;
  var n = Ai(), e = Object.prototype, t = e.hasOwnProperty;
  function r(i) {
    var o = this.__data__;
    return n ? o[i] !== void 0 : t.call(o, i);
  }
  return mo = r, mo;
}
var _o, Ec;
function Sm() {
  if (Ec) return _o;
  Ec = 1;
  var n = Ai(), e = "__lodash_hash_undefined__";
  function t(r, i) {
    var o = this.__data__;
    return this.size += this.has(r) ? 0 : 1, o[r] = n && i === void 0 ? e : i, this;
  }
  return _o = t, _o;
}
var bo, Ic;
function xm() {
  if (Ic) return bo;
  Ic = 1;
  var n = ym(), e = Cm(), t = wm(), r = Tm(), i = Sm();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = n, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = r, o.prototype.set = i, bo = o, bo;
}
var yo, Nc;
function Am() {
  if (Nc) return yo;
  Nc = 1;
  var n = xm(), e = Si(), t = tu();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new n(),
      map: new (t || e)(),
      string: new n()
    };
  }
  return yo = r, yo;
}
var Co, kc;
function Om() {
  if (kc) return Co;
  kc = 1;
  function n(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  return Co = n, Co;
}
var wo, Dc;
function Oi() {
  if (Dc) return wo;
  Dc = 1;
  var n = Om();
  function e(t, r) {
    var i = t.__data__;
    return n(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return wo = e, wo;
}
var To, Rc;
function Em() {
  if (Rc) return To;
  Rc = 1;
  var n = Oi();
  function e(t) {
    var r = n(this, t).delete(t);
    return this.size -= r ? 1 : 0, r;
  }
  return To = e, To;
}
var So, Pc;
function Im() {
  if (Pc) return So;
  Pc = 1;
  var n = Oi();
  function e(t) {
    return n(this, t).get(t);
  }
  return So = e, So;
}
var xo, Mc;
function Nm() {
  if (Mc) return xo;
  Mc = 1;
  var n = Oi();
  function e(t) {
    return n(this, t).has(t);
  }
  return xo = e, xo;
}
var Ao, Lc;
function km() {
  if (Lc) return Ao;
  Lc = 1;
  var n = Oi();
  function e(t, r) {
    var i = n(this, t), o = i.size;
    return i.set(t, r), this.size += i.size == o ? 0 : 1, this;
  }
  return Ao = e, Ao;
}
var Oo, qc;
function ru() {
  if (qc) return Oo;
  qc = 1;
  var n = Am(), e = Em(), t = Im(), r = Nm(), i = km();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = n, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = r, o.prototype.set = i, Oo = o, Oo;
}
var Eo, Bc;
function Dm() {
  if (Bc) return Eo;
  Bc = 1;
  var n = Si(), e = tu(), t = ru(), r = 200;
  function i(o, a) {
    var s = this.__data__;
    if (s instanceof n) {
      var l = s.__data__;
      if (!e || l.length < r - 1)
        return l.push([o, a]), this.size = ++s.size, this;
      s = this.__data__ = new t(l);
    }
    return s.set(o, a), this.size = s.size, this;
  }
  return Eo = i, Eo;
}
var Io, Uc;
function bp() {
  if (Uc) return Io;
  Uc = 1;
  var n = Si(), e = cm(), t = dm(), r = fm(), i = hm(), o = Dm();
  function a(s) {
    var l = this.__data__ = new n(s);
    this.size = l.size;
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = i, a.prototype.set = o, Io = a, Io;
}
var No, jc;
function yp() {
  if (jc) return No;
  jc = 1;
  var n = Nr(), e = function() {
    try {
      var t = n(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  }();
  return No = e, No;
}
var ko, Hc;
function nu() {
  if (Hc) return ko;
  Hc = 1;
  var n = yp();
  function e(t, r, i) {
    r == "__proto__" && n ? n(t, r, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : t[r] = i;
  }
  return ko = e, ko;
}
var Do, $c;
function Cp() {
  if ($c) return Do;
  $c = 1;
  var n = nu(), e = wi();
  function t(r, i, o) {
    (o !== void 0 && !e(r[i], o) || o === void 0 && !(i in r)) && n(r, i, o);
  }
  return Do = t, Do;
}
var Ro, Fc;
function Rm() {
  if (Fc) return Ro;
  Fc = 1;
  function n(e) {
    return function(t, r, i) {
      for (var o = -1, a = Object(t), s = i(t), l = s.length; l--; ) {
        var u = s[e ? l : ++o];
        if (r(a[u], u, a) === !1)
          break;
      }
      return t;
    };
  }
  return Ro = n, Ro;
}
var Po, Vc;
function wp() {
  if (Vc) return Po;
  Vc = 1;
  var n = Rm(), e = n();
  return Po = e, Po;
}
var dn = { exports: {} };
dn.exports;
var zc;
function Tp() {
  return zc || (zc = 1, function(n, e) {
    var t = Ot(), r = e && !e.nodeType && e, i = r && !0 && n && !n.nodeType && n, o = i && i.exports === r, a = o ? t.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function l(u, c) {
      if (c)
        return u.slice();
      var d = u.length, f = s ? s(d) : new u.constructor(d);
      return u.copy(f), f;
    }
    n.exports = l;
  }(dn, dn.exports)), dn.exports;
}
var Mo, Wc;
function Pm() {
  if (Wc) return Mo;
  Wc = 1;
  var n = Ot(), e = n.Uint8Array;
  return Mo = e, Mo;
}
var Lo, Gc;
function iu() {
  if (Gc) return Lo;
  Gc = 1;
  var n = Pm();
  function e(t) {
    var r = new t.constructor(t.byteLength);
    return new n(r).set(new n(t)), r;
  }
  return Lo = e, Lo;
}
var qo, Yc;
function Sp() {
  if (Yc) return qo;
  Yc = 1;
  var n = iu();
  function e(t, r) {
    var i = r ? n(t.buffer) : t.buffer;
    return new t.constructor(i, t.byteOffset, t.length);
  }
  return qo = e, qo;
}
var Bo, Zc;
function xp() {
  if (Zc) return Bo;
  Zc = 1;
  function n(e, t) {
    var r = -1, i = e.length;
    for (t || (t = Array(i)); ++r < i; )
      t[r] = e[r];
    return t;
  }
  return Bo = n, Bo;
}
var Uo, Xc;
function Mm() {
  if (Xc) return Uo;
  Xc = 1;
  var n = $t(), e = Object.create, t = /* @__PURE__ */ function() {
    function r() {
    }
    return function(i) {
      if (!n(i))
        return {};
      if (e)
        return e(i);
      r.prototype = i;
      var o = new r();
      return r.prototype = void 0, o;
    };
  }();
  return Uo = t, Uo;
}
var jo, Kc;
function Ap() {
  if (Kc) return jo;
  Kc = 1;
  function n(e, t) {
    return function(r) {
      return e(t(r));
    };
  }
  return jo = n, jo;
}
var Ho, Qc;
function ou() {
  if (Qc) return Ho;
  Qc = 1;
  var n = Ap(), e = n(Object.getPrototypeOf, Object);
  return Ho = e, Ho;
}
var $o, Jc;
function Ei() {
  if (Jc) return $o;
  Jc = 1;
  var n = Object.prototype;
  function e(t) {
    var r = t && t.constructor, i = typeof r == "function" && r.prototype || n;
    return t === i;
  }
  return $o = e, $o;
}
var Fo, ed;
function Op() {
  if (ed) return Fo;
  ed = 1;
  var n = Mm(), e = ou(), t = Ei();
  function r(i) {
    return typeof i.constructor == "function" && !t(i) ? n(e(i)) : {};
  }
  return Fo = r, Fo;
}
var Vo, td;
function sr() {
  if (td) return Vo;
  td = 1;
  function n(e) {
    return e != null && typeof e == "object";
  }
  return Vo = n, Vo;
}
var zo, rd;
function Lm() {
  if (rd) return zo;
  rd = 1;
  var n = rn(), e = sr(), t = "[object Arguments]";
  function r(i) {
    return e(i) && n(i) == t;
  }
  return zo = r, zo;
}
var Wo, nd;
function au() {
  if (nd) return Wo;
  nd = 1;
  var n = Lm(), e = sr(), t = Object.prototype, r = t.hasOwnProperty, i = t.propertyIsEnumerable, o = n(/* @__PURE__ */ function() {
    return arguments;
  }()) ? n : function(a) {
    return e(a) && r.call(a, "callee") && !i.call(a, "callee");
  };
  return Wo = o, Wo;
}
var Go, id;
function lr() {
  if (id) return Go;
  id = 1;
  var n = Array.isArray;
  return Go = n, Go;
}
var Yo, od;
function Ep() {
  if (od) return Yo;
  od = 1;
  var n = 9007199254740991;
  function e(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= n;
  }
  return Yo = e, Yo;
}
var Zo, ad;
function Fn() {
  if (ad) return Zo;
  ad = 1;
  var n = eu(), e = Ep();
  function t(r) {
    return r != null && e(r.length) && !n(r);
  }
  return Zo = t, Zo;
}
var Xo, sd;
function qm() {
  if (sd) return Xo;
  sd = 1;
  var n = Fn(), e = sr();
  function t(r) {
    return e(r) && n(r);
  }
  return Xo = t, Xo;
}
var fn = { exports: {} }, Ko, ld;
function Bm() {
  if (ld) return Ko;
  ld = 1;
  function n() {
    return !1;
  }
  return Ko = n, Ko;
}
fn.exports;
var ud;
function Ii() {
  return ud || (ud = 1, function(n, e) {
    var t = Ot(), r = Bm(), i = e && !e.nodeType && e, o = i && !0 && n && !n.nodeType && n, a = o && o.exports === i, s = a ? t.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
    n.exports = u;
  }(fn, fn.exports)), fn.exports;
}
var Qo, cd;
function Um() {
  if (cd) return Qo;
  cd = 1;
  var n = rn(), e = ou(), t = sr(), r = "[object Object]", i = Function.prototype, o = Object.prototype, a = i.toString, s = o.hasOwnProperty, l = a.call(Object);
  function u(c) {
    if (!t(c) || n(c) != r)
      return !1;
    var d = e(c);
    if (d === null)
      return !0;
    var f = s.call(d, "constructor") && d.constructor;
    return typeof f == "function" && f instanceof f && a.call(f) == l;
  }
  return Qo = u, Qo;
}
var Jo, dd;
function jm() {
  if (dd) return Jo;
  dd = 1;
  var n = rn(), e = Ep(), t = sr(), r = "[object Arguments]", i = "[object Array]", o = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", u = "[object Map]", c = "[object Number]", d = "[object Object]", f = "[object RegExp]", h = "[object Set]", g = "[object String]", p = "[object WeakMap]", v = "[object ArrayBuffer]", w = "[object DataView]", y = "[object Float32Array]", _ = "[object Float64Array]", b = "[object Int8Array]", C = "[object Int16Array]", m = "[object Int32Array]", T = "[object Uint8Array]", x = "[object Uint8ClampedArray]", A = "[object Uint16Array]", M = "[object Uint32Array]", O = {};
  O[y] = O[_] = O[b] = O[C] = O[m] = O[T] = O[x] = O[A] = O[M] = !0, O[r] = O[i] = O[v] = O[o] = O[w] = O[a] = O[s] = O[l] = O[u] = O[c] = O[d] = O[f] = O[h] = O[g] = O[p] = !1;
  function S(P) {
    return t(P) && e(P.length) && !!O[n(P)];
  }
  return Jo = S, Jo;
}
var ea, fd;
function su() {
  if (fd) return ea;
  fd = 1;
  function n(e) {
    return function(t) {
      return e(t);
    };
  }
  return ea = n, ea;
}
var hn = { exports: {} };
hn.exports;
var hd;
function lu() {
  return hd || (hd = 1, function(n, e) {
    var t = mp(), r = e && !e.nodeType && e, i = r && !0 && n && !n.nodeType && n, o = i && i.exports === r, a = o && t.process, s = function() {
      try {
        var l = i && i.require && i.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    n.exports = s;
  }(hn, hn.exports)), hn.exports;
}
var ta, pd;
function uu() {
  if (pd) return ta;
  pd = 1;
  var n = jm(), e = su(), t = lu(), r = t && t.isTypedArray, i = r ? e(r) : n;
  return ta = i, ta;
}
var ra, vd;
function Ip() {
  if (vd) return ra;
  vd = 1;
  function n(e, t) {
    if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
      return e[t];
  }
  return ra = n, ra;
}
var na, gd;
function Np() {
  if (gd) return na;
  gd = 1;
  var n = nu(), e = wi(), t = Object.prototype, r = t.hasOwnProperty;
  function i(o, a, s) {
    var l = o[a];
    (!(r.call(o, a) && e(l, s)) || s === void 0 && !(a in o)) && n(o, a, s);
  }
  return na = i, na;
}
var ia, md;
function Vn() {
  if (md) return ia;
  md = 1;
  var n = Np(), e = nu();
  function t(r, i, o, a) {
    var s = !o;
    o || (o = {});
    for (var l = -1, u = i.length; ++l < u; ) {
      var c = i[l], d = a ? a(o[c], r[c], c, o, r) : void 0;
      d === void 0 && (d = r[c]), s ? e(o, c, d) : n(o, c, d);
    }
    return o;
  }
  return ia = t, ia;
}
var oa, _d;
function Hm() {
  if (_d) return oa;
  _d = 1;
  function n(e, t) {
    for (var r = -1, i = Array(e); ++r < e; )
      i[r] = t(r);
    return i;
  }
  return oa = n, oa;
}
var aa, bd;
function kp() {
  if (bd) return aa;
  bd = 1;
  var n = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function t(r, i) {
    var o = typeof r;
    return i = i ?? n, !!i && (o == "number" || o != "symbol" && e.test(r)) && r > -1 && r % 1 == 0 && r < i;
  }
  return aa = t, aa;
}
var sa, yd;
function Dp() {
  if (yd) return sa;
  yd = 1;
  var n = Hm(), e = au(), t = lr(), r = Ii(), i = kp(), o = uu(), a = Object.prototype, s = a.hasOwnProperty;
  function l(u, c) {
    var d = t(u), f = !d && e(u), h = !d && !f && r(u), g = !d && !f && !h && o(u), p = d || f || h || g, v = p ? n(u.length, String) : [], w = v.length;
    for (var y in u)
      (c || s.call(u, y)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      i(y, w))) && v.push(y);
    return v;
  }
  return sa = l, sa;
}
var la, Cd;
function $m() {
  if (Cd) return la;
  Cd = 1;
  function n(e) {
    var t = [];
    if (e != null)
      for (var r in Object(e))
        t.push(r);
    return t;
  }
  return la = n, la;
}
var ua, wd;
function Fm() {
  if (wd) return ua;
  wd = 1;
  var n = $t(), e = Ei(), t = $m(), r = Object.prototype, i = r.hasOwnProperty;
  function o(a) {
    if (!n(a))
      return t(a);
    var s = e(a), l = [];
    for (var u in a)
      u == "constructor" && (s || !i.call(a, u)) || l.push(u);
    return l;
  }
  return ua = o, ua;
}
var ca, Td;
function zn() {
  if (Td) return ca;
  Td = 1;
  var n = Dp(), e = Fm(), t = Fn();
  function r(i) {
    return t(i) ? n(i, !0) : e(i);
  }
  return ca = r, ca;
}
var da, Sd;
function Vm() {
  if (Sd) return da;
  Sd = 1;
  var n = Vn(), e = zn();
  function t(r) {
    return n(r, e(r));
  }
  return da = t, da;
}
var fa, xd;
function zm() {
  if (xd) return fa;
  xd = 1;
  var n = Cp(), e = Tp(), t = Sp(), r = xp(), i = Op(), o = au(), a = lr(), s = qm(), l = Ii(), u = eu(), c = $t(), d = Um(), f = uu(), h = Ip(), g = Vm();
  function p(v, w, y, _, b, C, m) {
    var T = h(v, y), x = h(w, y), A = m.get(x);
    if (A) {
      n(v, y, A);
      return;
    }
    var M = C ? C(T, x, y + "", v, w, m) : void 0, O = M === void 0;
    if (O) {
      var S = a(x), P = !S && l(x), k = !S && !P && f(x);
      M = x, S || P || k ? a(T) ? M = T : s(T) ? M = r(T) : P ? (O = !1, M = e(x, !0)) : k ? (O = !1, M = t(x, !0)) : M = [] : d(x) || o(x) ? (M = T, o(T) ? M = g(T) : (!c(T) || u(T)) && (M = i(x))) : O = !1;
    }
    O && (m.set(x, M), b(M, x, _, C, m), m.delete(x)), n(v, y, M);
  }
  return fa = p, fa;
}
var ha, Ad;
function Wm() {
  if (Ad) return ha;
  Ad = 1;
  var n = bp(), e = Cp(), t = wp(), r = zm(), i = $t(), o = zn(), a = Ip();
  function s(l, u, c, d, f) {
    l !== u && t(u, function(h, g) {
      if (f || (f = new n()), i(h))
        r(l, u, g, c, s, d, f);
      else {
        var p = d ? d(a(l, g), h, g + "", l, u, f) : void 0;
        p === void 0 && (p = h), e(l, g, p);
      }
    }, o);
  }
  return ha = s, ha;
}
var pa, Od;
function cu() {
  if (Od) return pa;
  Od = 1;
  function n(e) {
    return e;
  }
  return pa = n, pa;
}
var va, Ed;
function Gm() {
  if (Ed) return va;
  Ed = 1;
  function n(e, t, r) {
    switch (r.length) {
      case 0:
        return e.call(t);
      case 1:
        return e.call(t, r[0]);
      case 2:
        return e.call(t, r[0], r[1]);
      case 3:
        return e.call(t, r[0], r[1], r[2]);
    }
    return e.apply(t, r);
  }
  return va = n, va;
}
var ga, Id;
function Ym() {
  if (Id) return ga;
  Id = 1;
  var n = Gm(), e = Math.max;
  function t(r, i, o) {
    return i = e(i === void 0 ? r.length - 1 : i, 0), function() {
      for (var a = arguments, s = -1, l = e(a.length - i, 0), u = Array(l); ++s < l; )
        u[s] = a[i + s];
      s = -1;
      for (var c = Array(i + 1); ++s < i; )
        c[s] = a[s];
      return c[i] = o(u), n(r, this, c);
    };
  }
  return ga = t, ga;
}
var ma, Nd;
function Zm() {
  if (Nd) return ma;
  Nd = 1;
  function n(e) {
    return function() {
      return e;
    };
  }
  return ma = n, ma;
}
var _a, kd;
function Xm() {
  if (kd) return _a;
  kd = 1;
  var n = Zm(), e = yp(), t = cu(), r = e ? function(i, o) {
    return e(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: n(o),
      writable: !0
    });
  } : t;
  return _a = r, _a;
}
var ba, Dd;
function Km() {
  if (Dd) return ba;
  Dd = 1;
  var n = 800, e = 16, t = Date.now;
  function r(i) {
    var o = 0, a = 0;
    return function() {
      var s = t(), l = e - (s - a);
      if (a = s, l > 0) {
        if (++o >= n)
          return arguments[0];
      } else
        o = 0;
      return i.apply(void 0, arguments);
    };
  }
  return ba = r, ba;
}
var ya, Rd;
function Qm() {
  if (Rd) return ya;
  Rd = 1;
  var n = Xm(), e = Km(), t = e(n);
  return ya = t, ya;
}
var Ca, Pd;
function Jm() {
  if (Pd) return Ca;
  Pd = 1;
  var n = cu(), e = Ym(), t = Qm();
  function r(i, o) {
    return t(e(i, o, n), i + "");
  }
  return Ca = r, Ca;
}
var wa, Md;
function e0() {
  if (Md) return wa;
  Md = 1;
  var n = wi(), e = Fn(), t = kp(), r = $t();
  function i(o, a, s) {
    if (!r(s))
      return !1;
    var l = typeof a;
    return (l == "number" ? e(s) && t(a, s.length) : l == "string" && a in s) ? n(s[a], o) : !1;
  }
  return wa = i, wa;
}
var Ta, Ld;
function t0() {
  if (Ld) return Ta;
  Ld = 1;
  var n = Jm(), e = e0();
  function t(r) {
    return n(function(i, o) {
      var a = -1, s = o.length, l = s > 1 ? o[s - 1] : void 0, u = s > 2 ? o[2] : void 0;
      for (l = r.length > 3 && typeof l == "function" ? (s--, l) : void 0, u && e(o[0], o[1], u) && (l = s < 3 ? void 0 : l, s = 1), i = Object(i); ++a < s; ) {
        var c = o[a];
        c && r(i, c, a, l);
      }
      return i;
    });
  }
  return Ta = t, Ta;
}
var Sa, qd;
function r0() {
  if (qd) return Sa;
  qd = 1;
  var n = Wm(), e = t0(), t = e(function(r, i, o) {
    n(r, i, o);
  });
  return Sa = t, Sa;
}
var n0 = r0();
const Rp = /* @__PURE__ */ Ht(n0), i0 = (n) => Jl.reduce((e, t) => (e[t.type] = {
  marginAllowed: !!(n != null && n.marginAllowed),
  paddingAllowed: !!(n != null && n.paddingAllowed),
  backgroundColorAllowed: !!(n != null && n.backgroundColorAllowed),
  backgroundImageAllowed: !!(n != null && n.backgroundImageAllowed)
}, e), {}), Pr = () => ({
  editor: void 0,
  colorPalette: void 0,
  enabledOptions: void 0,
  extensions: void 0,
  removeExtensions: void 0,
  addExtensions: void 0,
  allowLinks: !0,
  disableFontSizeEditing: !1
});
class Bd {
  constructor(e = {}) {
    var i, o, a, s, l, u, c;
    const t = {
      locale: "en",
      id: null,
      api: {
        localUploader: !1,
        images: "/v1/assets",
        forms: "",
        secondaryOrgId: null,
        // This is a hack to get around different API responses while FAAS is implemented
        projectParent: "cms",
        pathPrefix: ""
      },
      customProperties: {
        nodesIncluded: [],
        nodesExcluded: [],
        experimentalFeatures: {
          roundedLayouts: !0
        },
        global: {
          customAttributesAllowed: !0,
          backgroundColorAllowed: !0,
          backgroundImageAllowed: !0,
          marginAllowed: !0,
          paddingAllowed: !0,
          confirmOnDeleteDialogAllowed: !0,
          focusNewNodeOnCreate: !0,
          maxNestingLevelsAllowed: 4,
          rootElementsWidth: "85%",
          rootElementsMaxWidth: "1920px",
          sharedContentAllowed: !1,
          showConfirmOnDeleteDialog: !1,
          headerSlotOptional: !1,
          footerSlotOptional: !1,
          showHeaderSlot: !1,
          showFooterSlot: !1,
          undoLimit: 100,
          backgroundColorPalette: {
            colors: []
          }
        },
        RTEBar: {
          disabled: !1,
          fontSizes: void 0,
          removeDefaultActions: void 0,
          removeOptions: void 0,
          linkModalOptions: { allowRelative: !0 }
        },
        ...i0((i = e == null ? void 0 : e.customProperties) == null ? void 0 : i.global),
        CONTENT_NODE_HEADING: Pr(),
        CONTENT_NODE_TEXT: Pr(),
        CONTENT_NODE_TABLE: Pr(),
        CONTENT_NODE_CARD: {
          decorativeImageAllowed: !0,
          heading: Pr(),
          text: Pr(),
          uploadLimitMb: 10
        },
        CONTENT_NODE_IMAGE: {
          acceptedFileTypes: [
            "image/png",
            "image/jpeg"
          ],
          captionsAllowed: !0,
          decorativeImageAllowed: !0,
          lightboxAllowed: !0,
          resizableImageAllowed: !0,
          uploadLimitMb: 10
        },
        CONTENT_NODE_CODE: {
          allowScripts: !0
        },
        CONTENT_NODE_SPACER: {
          minHeight: 20,
          maxHeight: 1e3
        },
        CONTENT_NODE_GALLERY: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          captionsAllowed: !0,
          decorativeImageAllowed: !0,
          focalPointAllowed: !0,
          lightboxAllowed: !0,
          minColumnsAllowed: 1,
          maxColumnsAllowed: 10,
          maxImagesAllowed: 20,
          resizableImageAllowed: !0,
          uploadLimitMb: 10
        },
        CONTENT_NODE_VIDEO: {},
        CONTENT_NODE_SEPARATOR: {
          maxThickness: 10
        },
        CONTENT_NODE_BUTTON: {
          icons: {
            global_icons: [],
            custom_icons: []
          },
          textareaMaxLength: 40
        },
        CONTENT_NODE_FORM: {},
        CONTENT_NODE_QUOTE: {},
        CONTENT_NODE_SLIDER: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          decorativeImageAllowed: !0,
          maxImagesAllowed: 30,
          transitionSpeedMin: 3,
          transitionSpeedMax: 6,
          uploadLimitMb: 10
        },
        CONTENT_NODE_ACCORDION: {},
        CONTENT_NODE_PANEL: {},
        CONTENT_NODE_LIST: {
          legacyListOptions: {
            ...Pr(),
            enabledOptions: ["bold", "italic", "strike", "color", "add-link"]
          }
        },
        CONTENT_NODE_NAVIGATION: {
          siteMenu: []
        }
      },
      sharedContent: {
        content: {},
        createSharedContentAllowed: !0,
        editSharedContentAllowed: !0,
        detachSharedContentAllowed: !0,
        onContentCreated: ((o = e.sharedContent) == null ? void 0 : o.onContentCreated) || null,
        onSaveContentEdited: ((a = e.sharedContent) == null ? void 0 : a.onSaveContentEdited) || null,
        onCancelContentEdited: ((s = e.sharedContent) == null ? void 0 : s.onCancelContentEdited) || null,
        onContentDetached: ((l = e.sharedContent) == null ? void 0 : l.onContentDetached) || null,
        onOpenSettings: ((u = e.sharedContent) == null ? void 0 : u.onOpenSettings) || null,
        onSharedContentDeleted: ((c = e.sharedContent) == null ? void 0 : c.onSharedContentDeleted) || null
      },
      legacyAdapters: {
        pageToBuilder: null
      },
      assets: {},
      theme: {
        headingColor: null,
        linkColor: null,
        mainColor: null,
        primaryColor: null,
        secondaryColor: null
      },
      structure: {
        id: "root",
        name: "Root",
        type: qe,
        properties: {
          backgroundColor: {
            toggle: !1,
            value: ""
          },
          backgroundImage: {
            toggle: !1,
            image: null
          },
          margin: {
            value: 0
          },
          padding: {
            value: 0
          },
          borderRadius: {
            value: 0
          }
        },
        nodes: []
      }
    }, r = Rp({}, t, e);
    Object.keys(r).forEach((d) => {
      this[`_${d}`] = r[d];
    });
  }
  get assets() {
    return this._assets;
  }
  set assets(e) {
    this._assets = e;
  }
  get id() {
    return this._id;
  }
  get structure() {
    return this._structure;
  }
  get api() {
    return this._api;
  }
  get sharedContent() {
    return this._sharedContent;
  }
  set sharedContent(e) {
    this._sharedContent = e;
  }
  get theme() {
    return this._theme;
  }
  set theme(e) {
    this._theme = e;
  }
  get icons() {
    return this._assets.icons;
  }
  get customProperties() {
    return this._customProperties;
  }
  get legacyAdapters() {
    return this._legacyAdapters;
  }
  get locale() {
    return this._locale;
  }
}
const o0 = (n) => ({
  activeNode: null,
  editingSharedContent: {
    node: null,
    boundingRect: null,
    originalContent: null
  },
  builder: null,
  editor: null,
  isLinkModalOpen: !1,
  isCodeModalOpen: !1,
  nodeDragging: null,
  showCustomAttributesSidebar: !1,
  userAgent: "windows",
  addAsset(e) {
    this.builder.assets = {
      ...this.builder.assets,
      ...e
    };
  },
  setActiveNode(e) {
    this.showCustomAttributesSidebar = !1, this.activeNode = e;
  },
  clearActiveNode() {
    this.showCustomAttributesSidebar = !1, this.activeNode = null;
  },
  clearEditor() {
    this.editor = {
      editor: {},
      editorKey: "",
      enabledOptions: [],
      removeOptions: [],
      colorPalette: {}
    };
  },
  removeFavorite({ id: e }) {
    this.builder.favorites = this.builder.favorites.filter((t) => t.id !== e);
  },
  emitToConsumingApp(e, t) {
    n(e, t);
  }
}), a0 = ({ customProperties: n, structure: e, theme: t }) => {
  const r = "#004b8d", i = "#8369cb", o = "#ad98e6", a = "#B1CB69", s = "#0000ee", l = "#2a5a5a", { properties: u } = e, { backgroundColorAllowed: c } = n.global, d = t.mainColor || Mt.DARK, f = t.headingColor || Mt.DARK, h = t.linkColor || s;
  return {
    // THEME VARIABLES
    "--color-favorite": a,
    "--color-heading": f,
    "--color-link": h,
    "--color-main": d,
    "--color-main-10": `${d}10`,
    "--color-main-20": `${d}20`,
    "--color-main-30": `${d}30`,
    "--font-family": "'Neue Haas Grotesk Disp', 'Inter', 'Helvetica Neue', Arial, sans-serif",
    // BUILDER VARIABLES
    "--builder-background-color": c && u.backgroundColor.toggle && u.backgroundColor.value,
    "--color-layout": r,
    "--color-content": i,
    "--color-sub-content": o,
    "--color-shared-content": l,
    // PB CUSTOM COLOR VARIABLES
    "--pb-black": "#000000",
    "--pb-black-10": "#0000001a",
    "--pb-black-20": "#00000033",
    "--pb-grey-35": "#cccccc",
    "--pb-purple-45": "#ab91dd",
    "--pb-transparent": "#ffffff00",
    "--pb-white-10": "#ffffff1a",
    "--pb-white-90": "#ffffffe6",
    "--pb-code-background-color": "#091E4214",
    // LAYOUT VARIABLES
    "--layout-outline": "1px dashed hsla(0, 0%, 49%, 0.5)",
    "--lightbox-background": "rgba(0, 0, 0, .85)",
    // SIDEBAR VARIABLES
    "--sidebar-width": "240px",
    "--block-container-max-height": "800px"
  };
}, X = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [r, i] of e)
    t[r] = i;
  return t;
}, s0 = {
  name: "ColorPalette",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    colorPalette: {
      type: Array,
      required: !0
    }
  },
  computed: {
    colorValue: {
      get() {
        return this.modelValue;
      },
      set(n) {
        this.$emit("update:modelValue", n);
      }
    },
    backgroundColors() {
      if (!this.colorPalette.length) return [Mt.WHITE];
      const n = this.colorPalette.map((t) => (t == null ? void 0 : t.hex) || t || Mt.WHITE), e = /* @__PURE__ */ new Set([Mt.WHITE, ...n]);
      return Array.from(e);
    }
  }
};
function l0(n, e, t, r, i, o) {
  const a = $("a-form-color-input"), s = $("a-button");
  return D(), U("div", { class: "inline-control space-between gap-10" }, [
    B(a, {
      class: "background-color-input",
      "model-value": o.colorValue,
      "palette-only": !0,
      palette: o.backgroundColors,
      "header-text": n.$t("builder.backgroundColor.subTitle"),
      "onUpdate:modelValue": e[0] || (e[0] = (l) => o.colorValue = l),
      "onReset:modelValue": e[1] || (e[1] = (l) => o.colorValue = "#ffffff"),
      width: "160px"
    }, null, 8, ["model-value", "palette", "header-text"]),
    B(s, {
      class: "clear-button",
      variant: "link",
      onClick: e[2] || (e[2] = (l) => n.$emit("clear"))
    }, {
      default: j(() => [
        Me(K(n.$t("builder.clear")), 1)
      ]),
      _: 1
    })
  ]);
}
const u0 = /* @__PURE__ */ X(s0, [["render", l0], ["__scopeId", "data-v-ccf96737"]]), c0 = {
  name: "NodeControl",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  }
};
function d0(n, e, t, r, i, o) {
  return D(), U("div", {
    class: He(["node-control", { disabled: t.disabled }])
  }, [
    R("div", { class: "control-header" }, [
      R("div", { class: "control-title" }, [
        tt(n.$slots, "title", {}, void 0, !0)
      ]),
      tt(n.$slots, "control", {}, void 0, !0)
    ]),
    R("div", { class: "control-content" }, [
      tt(n.$slots, "content", {}, void 0, !0)
    ])
  ], 2);
}
const xr = /* @__PURE__ */ X(c0, [["render", d0], ["__scopeId", "data-v-256bf46a"]]), f0 = {
  name: "BackgroundColorControl",
  components: {
    ColorPalette: u0,
    NodeControl: xr
  },
  inject: ["state"],
  props: {
    node: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    backgroundColor: {
      get() {
        var n, e, t;
        return ((t = (e = (n = this.node) == null ? void 0 : n.properties) == null ? void 0 : e.backgroundColor) == null ? void 0 : t.value) || Mt.WHITE;
      },
      set(n) {
        this.$emit("update", "value", n);
      }
    },
    toggle: {
      get() {
        var n, e, t;
        return ((t = (e = (n = this.node) == null ? void 0 : n.properties) == null ? void 0 : e.backgroundColor) == null ? void 0 : t.toggle) || !1;
      },
      set(n) {
        this.$emit("update", "toggle", n);
      }
    },
    backgroundColorPalette() {
      var e, t, r, i;
      const { colors: n = [] } = (i = (r = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : r.global) == null ? void 0 : i.backgroundColorPalette;
      return n;
    }
  }
};
function h0(n, e, t, r, i, o) {
  const a = $("a-toggle"), s = $("ColorPalette"), l = $("NodeControl");
  return D(), G(l, null, Zl({
    title: j(() => [
      R("h4", null, K(n.$t("builder.backgroundColor.title")), 1)
    ]),
    control: j(() => [
      B(a, {
        id: "background-color-toggle",
        modelValue: o.toggle,
        "onUpdate:modelValue": e[0] || (e[0] = (u) => o.toggle = u)
      }, null, 8, ["modelValue"])
    ]),
    _: 2
  }, [
    o.toggle ? {
      name: "content",
      fn: j(() => [
        B(s, {
          modelValue: o.backgroundColor,
          "onUpdate:modelValue": e[1] || (e[1] = (u) => o.backgroundColor = u),
          "color-palette": o.backgroundColorPalette,
          onClear: e[2] || (e[2] = (u) => o.backgroundColor = null)
        }, null, 8, ["modelValue", "color-palette"])
      ]),
      key: "0"
    } : void 0
  ]), 1024);
}
const Pp = /* @__PURE__ */ X(f0, [["render", h0]]);
function Et(n) {
  return Fg() ? (Vg(n), !0) : !1;
}
function Mp(n) {
  let e = 0, t, r;
  const i = () => {
    e -= 1, r && e <= 0 && (r.stop(), t = void 0, r = void 0);
  };
  return (...o) => (e += 1, r || (r = $g(!0), t = r.run(() => n(...o))), Et(i), t);
}
const nn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Lp = (n) => n != null, p0 = Object.prototype.toString, qp = (n) => p0.call(n) === "[object Object]", v0 = () => +Date.now(), lt = () => {
}, yl = /* @__PURE__ */ g0();
function g0() {
  var n, e;
  return nn && ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function m0(n, e) {
  function t(...r) {
    return new Promise((i, o) => {
      Promise.resolve(n(() => e.apply(this, r), { fn: e, thisArg: this, args: r })).then(i).catch(o);
    });
  }
  return t;
}
const Bp = (n) => n();
function _0(n, e = {}) {
  let t, r, i = lt;
  const o = (l) => {
    clearTimeout(l), i(), i = lt;
  };
  let a;
  return (l) => {
    const u = pe(n), c = pe(e.maxWait);
    return t && o(t), u <= 0 || c !== void 0 && c <= 0 ? (r && (o(r), r = null), Promise.resolve(l())) : new Promise((d, f) => {
      i = e.rejectOnCancel ? f : d, a = l, c && !r && (r = setTimeout(() => {
        t && o(t), r = null, d(a());
      }, c)), t = setTimeout(() => {
        r && o(r), r = null, d(l());
      }, u);
    });
  };
}
function b0(n = Bp, e = {}) {
  const {
    initialState: t = "active"
  } = e, r = di(t === "active");
  function i() {
    r.value = !1;
  }
  function o() {
    r.value = !0;
  }
  const a = (...s) => {
    r.value && n(...s);
  };
  return { isActive: yi(r), pause: i, resume: o, eventFilter: a };
}
function y0(n) {
  let e;
  function t() {
    return e || (e = n()), e;
  }
  return t.reset = async () => {
    const r = e;
    e = void 0, r && await r;
  }, t;
}
function C0(n) {
  return Xl();
}
function er(n) {
  return Array.isArray(n) ? n : [n];
}
function di(...n) {
  if (n.length !== 1)
    return op(...n);
  const e = n[0];
  return typeof e == "function" ? yi(zg(() => ({ get: e, set: lt }))) : Q(e);
}
function w0(n, e = !0, t) {
  C0() ? mt(n, t) : e ? n() : yt(n);
}
function T0(n, e, t = {}) {
  const {
    immediate: r = !0,
    immediateCallback: i = !1
  } = t, o = de(!1);
  let a = null;
  function s() {
    a && (clearTimeout(a), a = null);
  }
  function l() {
    o.value = !1, s();
  }
  function u(...c) {
    i && n(), s(), o.value = !0, a = setTimeout(() => {
      o.value = !1, a = null, n(...c);
    }, pe(e));
  }
  return r && (o.value = !0, nn && u()), Et(l), {
    isPending: yi(o),
    start: u,
    stop: l
  };
}
function S0(n, e, t = {}) {
  const {
    eventFilter: r = Bp,
    ...i
  } = t, o = m0(
    r,
    e
  );
  let a, s, l;
  if (i.flush === "sync") {
    const u = de(!1);
    s = () => {
    }, a = (c) => {
      u.value = !0, c(), u.value = !1;
    }, l = Ae(
      n,
      (...c) => {
        u.value || o(...c);
      },
      i
    );
  } else {
    const u = [], c = de(0), d = de(0);
    s = () => {
      c.value = d.value;
    }, u.push(
      Ae(
        n,
        () => {
          d.value++;
        },
        { ...i, flush: "sync" }
      )
    ), a = (f) => {
      const h = d.value;
      f(), c.value += d.value - h;
    }, u.push(
      Ae(
        n,
        (...f) => {
          const h = c.value > 0 && c.value === d.value;
          c.value = 0, d.value = 0, !h && o(...f);
        },
        i
      )
    ), l = () => {
      u.forEach((f) => f());
    };
  }
  return { stop: l, ignoreUpdates: a, ignorePrevAsyncUpdates: s };
}
function Up(n, e, t) {
  return Ae(
    n,
    e,
    {
      ...t,
      immediate: !0
    }
  );
}
function Nt(n, e, t) {
  return Ae(
    n,
    (i, o, a) => {
      i && e(i, o, a);
    },
    {
      ...t,
      once: !1
    }
  );
}
const Ft = nn ? window : void 0, jp = nn ? window.navigator : void 0;
function Ar(n) {
  var e;
  const t = pe(n);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
function ke(...n) {
  const e = [], t = () => {
    e.forEach((s) => s()), e.length = 0;
  }, r = (s, l, u, c) => (s.addEventListener(l, u, c), () => s.removeEventListener(l, u, c)), i = I(() => {
    const s = er(pe(n[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), o = Up(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((u) => Ar(u))) != null ? l : [Ft].filter((u) => u != null),
        er(pe(i.value ? n[1] : n[0])),
        er(V(i.value ? n[2] : n[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        pe(i.value ? n[3] : n[2])
      ];
    },
    ([s, l, u, c]) => {
      if (t(), !(s != null && s.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const d = qp(c) ? { ...c } : c;
      e.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => u.map((g) => r(f, h, g, d))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    o(), t();
  };
  return Et(t), a;
}
function x0() {
  const n = de(!1), e = Xl();
  return e && mt(() => {
    n.value = !0;
  }, e), n;
}
function Ni(n) {
  const e = x0();
  return I(() => (e.value, !!n()));
}
function Hp(n, e, t = {}) {
  const { window: r = Ft, ...i } = t;
  let o;
  const a = Ni(() => r && "MutationObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = I(() => {
    const f = pe(n), h = er(f).map(Ar).filter(Lp);
    return new Set(h);
  }), u = Ae(
    () => l.value,
    (f) => {
      s(), a.value && f.size && (o = new MutationObserver(e), f.forEach((h) => o.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => o == null ? void 0 : o.takeRecords(), d = () => {
    u(), s();
  };
  return Et(d), {
    isSupported: a,
    stop: d,
    takeRecords: c
  };
}
function A0(n, e, t = {}) {
  const {
    window: r = Ft,
    document: i = r == null ? void 0 : r.document,
    flush: o = "sync"
  } = t;
  if (!r || !i)
    return lt;
  let a;
  const s = (c) => {
    a == null || a(), a = c;
  }, l = ap(() => {
    const c = Ar(n);
    if (c) {
      const { stop: d } = Hp(
        i,
        (f) => {
          f.map((g) => [...g.removedNodes]).flat().some((g) => g === c || g.contains(c)) && e(f);
        },
        {
          window: r,
          childList: !0,
          subtree: !0
        }
      );
      s(d);
    }
  }, { flush: o }), u = () => {
    l(), s();
  };
  return Et(u), u;
}
function Ud(n = {}) {
  var e;
  const {
    window: t = Ft,
    deep: r = !0,
    triggerOnRemoval: i = !1
  } = n, o = (e = n.document) != null ? e : t == null ? void 0 : t.document, a = () => {
    var u;
    let c = o == null ? void 0 : o.activeElement;
    if (r)
      for (; c != null && c.shadowRoot; )
        c = (u = c == null ? void 0 : c.shadowRoot) == null ? void 0 : u.activeElement;
    return c;
  }, s = de(), l = () => {
    s.value = a();
  };
  if (t) {
    const u = {
      capture: !0,
      passive: !0
    };
    ke(
      t,
      "blur",
      (c) => {
        c.relatedTarget === null && l();
      },
      u
    ), ke(
      t,
      "focus",
      l,
      u
    );
  }
  return i && A0(s, l, { document: o }), l(), s;
}
function jd(n, e = {}) {
  const {
    controls: t = !1,
    navigator: r = jp
  } = e, i = Ni(() => r && "permissions" in r), o = de(), a = typeof n == "string" ? { name: n } : n, s = de(), l = () => {
    var c, d;
    s.value = (d = (c = o.value) == null ? void 0 : c.state) != null ? d : "prompt";
  };
  ke(o, "change", l, { passive: !0 });
  const u = y0(async () => {
    if (i.value) {
      if (!o.value)
        try {
          o.value = await r.permissions.query(a);
        } catch {
          o.value = void 0;
        } finally {
          l();
        }
      if (t)
        return Gg(o.value);
    }
  });
  return u(), t ? {
    state: s,
    isSupported: i,
    query: u
  } : s;
}
function O0(n = {}) {
  const {
    navigator: e = jp,
    read: t = !1,
    source: r,
    copiedDuring: i = 1500,
    legacy: o = !1
  } = n, a = Ni(() => e && "clipboard" in e), s = jd("clipboard-read"), l = jd("clipboard-write"), u = I(() => a.value || o), c = de(""), d = de(!1), f = T0(() => d.value = !1, i, { immediate: !1 });
  async function h() {
    let y = !(a.value && w(s.value));
    if (!y)
      try {
        c.value = await e.clipboard.readText();
      } catch {
        y = !0;
      }
    y && (c.value = v());
  }
  u.value && t && ke(["copy", "cut"], h, { passive: !0 });
  async function g(y = pe(r)) {
    if (u.value && y != null) {
      let _ = !(a.value && w(l.value));
      if (!_)
        try {
          await e.clipboard.writeText(y);
        } catch {
          _ = !0;
        }
      _ && p(y), c.value = y, d.value = !0, f.start();
    }
  }
  function p(y) {
    const _ = document.createElement("textarea");
    _.value = y ?? "", _.style.position = "absolute", _.style.opacity = "0", document.body.appendChild(_), _.select(), document.execCommand("copy"), _.remove();
  }
  function v() {
    var y, _, b;
    return (b = (_ = (y = document == null ? void 0 : document.getSelection) == null ? void 0 : y.call(document)) == null ? void 0 : _.toString()) != null ? b : "";
  }
  function w(y) {
    return y === "granted" || y === "prompt";
  }
  return {
    isSupported: u,
    text: c,
    copied: d,
    copy: g
  };
}
function $p(n) {
  return JSON.parse(JSON.stringify(n));
}
function Fp(n) {
  return n;
}
function E0(n, e) {
  return n.value = e;
}
function I0(n) {
  return n ? typeof n == "function" ? n : $p : Fp;
}
function N0(n) {
  return n ? typeof n == "function" ? n : $p : Fp;
}
function k0(n, e = {}) {
  const {
    clone: t = !1,
    dump: r = I0(t),
    parse: i = N0(t),
    setSource: o = E0
  } = e;
  function a() {
    return Wg({
      snapshot: r(n.value),
      timestamp: v0()
    });
  }
  const s = Q(a()), l = Q([]), u = Q([]), c = (_) => {
    o(n, i(_.snapshot)), s.value = _;
  }, d = () => {
    l.value.unshift(s.value), s.value = a(), e.capacity && l.value.length > e.capacity && l.value.splice(e.capacity, Number.POSITIVE_INFINITY), u.value.length && u.value.splice(0, u.value.length);
  }, f = () => {
    l.value.splice(0, l.value.length), u.value.splice(0, u.value.length);
  }, h = () => {
    const _ = l.value.shift();
    _ && (u.value.unshift(s.value), c(_));
  }, g = () => {
    const _ = u.value.shift();
    _ && (l.value.unshift(s.value), c(_));
  }, p = () => {
    c(s.value);
  }, v = I(() => [s.value, ...l.value]), w = I(() => l.value.length > 0), y = I(() => u.value.length > 0);
  return {
    source: n,
    undoStack: l,
    redoStack: u,
    last: s,
    history: v,
    canUndo: w,
    canRedo: y,
    clear: f,
    commit: d,
    reset: p,
    undo: h,
    redo: g
  };
}
function D0(n, e = {}) {
  const {
    deep: t = !1,
    flush: r = "pre",
    eventFilter: i
  } = e, {
    eventFilter: o,
    pause: a,
    resume: s,
    isActive: l
  } = b0(i), {
    ignoreUpdates: u,
    ignorePrevAsyncUpdates: c,
    stop: d
  } = S0(
    n,
    v,
    { deep: t, flush: r, eventFilter: o }
  );
  function f(b, C) {
    c(), u(() => {
      b.value = C;
    });
  }
  const h = k0(n, { ...e, clone: e.clone || t, setSource: f }), { clear: g, commit: p } = h;
  function v() {
    c(), p();
  }
  function w(b) {
    s(), b && v();
  }
  function y(b) {
    let C = !1;
    const m = () => C = !0;
    u(() => {
      b(m);
    }), C || v();
  }
  function _() {
    d(), g();
  }
  return {
    ...h,
    isTracking: l,
    pause: a,
    resume: w,
    commit: v,
    batch: y,
    dispose: _
  };
}
function Vp(n, e = {}) {
  const t = e.debounce ? _0(e.debounce) : void 0;
  return {
    ...D0(n, { ...e, eventFilter: t })
  };
}
function du(n, e = {}) {
  var t, r;
  const i = de(!1), o = de(null);
  let a = 0, s = !0;
  if (nn) {
    const l = typeof e == "function" ? { onDrop: e } : e, u = (t = l.multiple) != null ? t : !0, c = (r = l.preventDefaultForUnhandled) != null ? r : !1, d = (v) => {
      var w, y;
      const _ = Array.from((y = (w = v.dataTransfer) == null ? void 0 : w.files) != null ? y : []);
      return _.length === 0 ? null : u ? _ : [_[0]];
    }, f = (v) => {
      const w = V(l.dataTypes);
      return typeof w == "function" ? w(v) : w != null && w.length ? v.length === 0 ? !1 : v.every(
        (y) => w.some((_) => y.includes(_))
      ) : !0;
    }, h = (v) => {
      const w = Array.from(v ?? []).map((b) => b.type), y = f(w), _ = u || v.length <= 1;
      return y && _;
    }, g = () => /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window), p = (v, w) => {
      var y, _, b, C, m, T;
      const x = (y = v.dataTransfer) == null ? void 0 : y.items;
      if (s = (_ = x && h(x)) != null ? _ : !1, c && v.preventDefault(), !g() && !s) {
        v.dataTransfer && (v.dataTransfer.dropEffect = "none");
        return;
      }
      v.preventDefault(), v.dataTransfer && (v.dataTransfer.dropEffect = "copy");
      const A = d(v);
      switch (w) {
        case "enter":
          a += 1, i.value = !0, (b = l.onEnter) == null || b.call(l, null, v);
          break;
        case "over":
          (C = l.onOver) == null || C.call(l, null, v);
          break;
        case "leave":
          a -= 1, a === 0 && (i.value = !1), (m = l.onLeave) == null || m.call(l, null, v);
          break;
        case "drop":
          a = 0, i.value = !1, s && (o.value = A, (T = l.onDrop) == null || T.call(l, A, v));
          break;
      }
    };
    ke(n, "dragenter", (v) => p(v, "enter")), ke(n, "dragover", (v) => p(v, "over")), ke(n, "dragleave", (v) => p(v, "leave")), ke(n, "drop", (v) => p(v, "drop"));
  }
  return {
    files: o,
    isOverDropZone: i
  };
}
function fu(n, e, t = {}) {
  const { window: r = Ft, ...i } = t;
  let o;
  const a = Ni(() => r && "ResizeObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = I(() => {
    const d = pe(n);
    return Array.isArray(d) ? d.map((f) => Ar(f)) : [Ar(d)];
  }), u = Ae(
    l,
    (d) => {
      if (s(), a.value && r) {
        o = new ResizeObserver(e);
        for (const f of d)
          f && o.observe(f, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    s(), u();
  };
  return Et(c), {
    isSupported: a,
    stop: c
  };
}
function zp(n, e = {}) {
  const {
    reset: t = !0,
    windowResize: r = !0,
    windowScroll: i = !0,
    immediate: o = !0,
    updateTiming: a = "sync"
  } = e, s = de(0), l = de(0), u = de(0), c = de(0), d = de(0), f = de(0), h = de(0), g = de(0);
  function p() {
    const w = Ar(n);
    if (!w) {
      t && (s.value = 0, l.value = 0, u.value = 0, c.value = 0, d.value = 0, f.value = 0, h.value = 0, g.value = 0);
      return;
    }
    const y = w.getBoundingClientRect();
    s.value = y.height, l.value = y.bottom, u.value = y.left, c.value = y.right, d.value = y.top, f.value = y.width, h.value = y.x, g.value = y.y;
  }
  function v() {
    a === "sync" ? p() : a === "next-frame" && requestAnimationFrame(() => p());
  }
  return fu(n, v), Ae(() => Ar(n), (w) => !w && v()), Hp(n, v, {
    attributeFilter: ["style", "class"]
  }), i && ke("scroll", v, { capture: !0, passive: !0 }), r && ke("resize", v, { passive: !0 }), w0(() => {
    o && v();
  }), {
    height: s,
    bottom: l,
    left: u,
    right: c,
    top: d,
    width: f,
    x: h,
    y: g,
    update: v
  };
}
const R0 = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function P0(n = {}) {
  const {
    reactive: e = !1,
    target: t = Ft,
    aliasMap: r = R0,
    passive: i = !0,
    onEventFired: o = lt
  } = n, a = ai(/* @__PURE__ */ new Set()), s = {
    toJSON() {
      return {};
    },
    current: a
  }, l = e ? ai(s) : s, u = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  function d(p, v) {
    p in l && (e ? l[p] = v : l[p].value = v);
  }
  function f() {
    a.clear();
    for (const p of c)
      d(p, !1);
  }
  function h(p, v) {
    var w, y;
    const _ = (w = p.key) == null ? void 0 : w.toLowerCase(), C = [(y = p.code) == null ? void 0 : y.toLowerCase(), _].filter(Boolean);
    _ && (v ? a.add(_) : a.delete(_));
    for (const m of C)
      c.add(m), d(m, v);
    _ === "meta" && !v ? (u.forEach((m) => {
      a.delete(m), d(m, !1);
    }), u.clear()) : typeof p.getModifierState == "function" && p.getModifierState("Meta") && v && [...a, ...C].forEach((m) => u.add(m));
  }
  ke(t, "keydown", (p) => (h(p, !0), o(p)), { passive: i }), ke(t, "keyup", (p) => (h(p, !1), o(p)), { passive: i }), ke("blur", f, { passive: i }), ke("focus", f, { passive: i });
  const g = new Proxy(
    l,
    {
      get(p, v, w) {
        if (typeof v != "string")
          return Reflect.get(p, v, w);
        if (v = v.toLowerCase(), v in r && (v = r[v]), !(v in l))
          if (/[+_-]/.test(v)) {
            const _ = v.split(/[+_-]/g).map((b) => b.trim());
            l[v] = I(() => _.map((b) => pe(g[b])).every(Boolean));
          } else
            l[v] = de(!1);
        const y = Reflect.get(p, v, w);
        return e ? pe(y) : y;
      }
    }
  );
  return g;
}
function M0(n) {
  var e;
  const t = (e = n.rangeCount) != null ? e : 0;
  return Array.from({ length: t }, (r, i) => n.getRangeAt(i));
}
function L0(n = {}) {
  const {
    window: e = Ft
  } = n, t = Q(null), r = I(() => {
    var s, l;
    return (l = (s = t.value) == null ? void 0 : s.toString()) != null ? l : "";
  }), i = I(() => t.value ? M0(t.value) : []), o = I(() => i.value.map((s) => s.getBoundingClientRect()));
  function a() {
    t.value = null, e && (t.value = e.getSelection());
  }
  return e && ke(e.document, "selectionchange", a, { passive: !0 }), {
    text: r,
    rects: o,
    ranges: i,
    selection: t
  };
}
function q0(n = Ft, e) {
  n && typeof n.requestAnimationFrame == "function" ? n.requestAnimationFrame(e) : e();
}
function h2(n = {}) {
  var e, t;
  const { window: r = Ft } = n, i = di(n == null ? void 0 : n.element), o = di((e = n == null ? void 0 : n.input) != null ? e : ""), a = (t = n == null ? void 0 : n.styleProp) != null ? t : "height", s = de(1), l = de(0);
  function u() {
    var c;
    if (!i.value)
      return;
    let d = "";
    i.value.style[a] = "1px", s.value = (c = i.value) == null ? void 0 : c.scrollHeight;
    const f = pe(n == null ? void 0 : n.styleTarget);
    f ? f.style[a] = `${s.value}px` : d = `${s.value}px`, i.value.style[a] = d;
  }
  return Ae([o, i], () => yt(u), { immediate: !0 }), Ae(s, () => {
    var c;
    return (c = n == null ? void 0 : n.onResize) == null ? void 0 : c.call(n);
  }), fu(i, ([{ contentRect: c }]) => {
    l.value !== c.width && q0(r, () => {
      l.value = c.width, u();
    });
  }), n != null && n.watch && Ae(n.watch, u, { immediate: !0, deep: !0 }), {
    textarea: i,
    input: o,
    triggerResize: u
  };
}
const Hd = (n) => /* eslint-disable-next-line no-useless-escape */ /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(n), B0 = (n) => {
  if (n !== "" && n !== void 0 && !Hd(n))
    return new Promise((e, t) => {
      const r = new FileReader();
      r.readAsDataURL(n), r.onloadend = (i) => {
        e(r.result);
      }, r.onerror = (i) => {
        t(i);
      };
    });
  if (Hd(n))
    return Promise.resolve(n);
}, Wp = (n, e, t = 10) => {
  var i;
  if (!n.size || !n.type) return !1;
  const r = !((i = n.name) != null && i.includes(".")) || !e.includes(n.type);
  return hu(n, t) || r || n.type === "";
}, hu = (n, e = 10) => n.size / 1e6 > e, U0 = (n) => ({
  [n.content.assetId]: {
    url: n.assetUrl,
    file: n.content.imageFile
  }
}), p2 = (n, e) => {
  const t = Object.keys(e)[0];
  return !n.hasOwnProperty(t);
};
var xa, $d;
function j0() {
  if ($d) return xa;
  $d = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length; ++r < i && t(e[r], r, e) !== !1; )
      ;
    return e;
  }
  return xa = n, xa;
}
var Aa, Fd;
function H0() {
  if (Fd) return Aa;
  Fd = 1;
  var n = Ap(), e = n(Object.keys, Object);
  return Aa = e, Aa;
}
var Oa, Vd;
function Gp() {
  if (Vd) return Oa;
  Vd = 1;
  var n = Ei(), e = H0(), t = Object.prototype, r = t.hasOwnProperty;
  function i(o) {
    if (!n(o))
      return e(o);
    var a = [];
    for (var s in Object(o))
      r.call(o, s) && s != "constructor" && a.push(s);
    return a;
  }
  return Oa = i, Oa;
}
var Ea, zd;
function ki() {
  if (zd) return Ea;
  zd = 1;
  var n = Dp(), e = Gp(), t = Fn();
  function r(i) {
    return t(i) ? n(i) : e(i);
  }
  return Ea = r, Ea;
}
var Ia, Wd;
function $0() {
  if (Wd) return Ia;
  Wd = 1;
  var n = Vn(), e = ki();
  function t(r, i) {
    return r && n(i, e(i), r);
  }
  return Ia = t, Ia;
}
var Na, Gd;
function F0() {
  if (Gd) return Na;
  Gd = 1;
  var n = Vn(), e = zn();
  function t(r, i) {
    return r && n(i, e(i), r);
  }
  return Na = t, Na;
}
var ka, Yd;
function V0() {
  if (Yd) return ka;
  Yd = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
      var s = e[r];
      t(s, r, e) && (a[o++] = s);
    }
    return a;
  }
  return ka = n, ka;
}
var Da, Zd;
function Yp() {
  if (Zd) return Da;
  Zd = 1;
  function n() {
    return [];
  }
  return Da = n, Da;
}
var Ra, Xd;
function pu() {
  if (Xd) return Ra;
  Xd = 1;
  var n = V0(), e = Yp(), t = Object.prototype, r = t.propertyIsEnumerable, i = Object.getOwnPropertySymbols, o = i ? function(a) {
    return a == null ? [] : (a = Object(a), n(i(a), function(s) {
      return r.call(a, s);
    }));
  } : e;
  return Ra = o, Ra;
}
var Pa, Kd;
function z0() {
  if (Kd) return Pa;
  Kd = 1;
  var n = Vn(), e = pu();
  function t(r, i) {
    return n(r, e(r), i);
  }
  return Pa = t, Pa;
}
var Ma, Qd;
function Zp() {
  if (Qd) return Ma;
  Qd = 1;
  function n(e, t) {
    for (var r = -1, i = t.length, o = e.length; ++r < i; )
      e[o + r] = t[r];
    return e;
  }
  return Ma = n, Ma;
}
var La, Jd;
function Xp() {
  if (Jd) return La;
  Jd = 1;
  var n = Zp(), e = ou(), t = pu(), r = Yp(), i = Object.getOwnPropertySymbols, o = i ? function(a) {
    for (var s = []; a; )
      n(s, t(a)), a = e(a);
    return s;
  } : r;
  return La = o, La;
}
var qa, ef;
function W0() {
  if (ef) return qa;
  ef = 1;
  var n = Vn(), e = Xp();
  function t(r, i) {
    return n(r, e(r), i);
  }
  return qa = t, qa;
}
var Ba, tf;
function Kp() {
  if (tf) return Ba;
  tf = 1;
  var n = Zp(), e = lr();
  function t(r, i, o) {
    var a = i(r);
    return e(r) ? a : n(a, o(r));
  }
  return Ba = t, Ba;
}
var Ua, rf;
function G0() {
  if (rf) return Ua;
  rf = 1;
  var n = Kp(), e = pu(), t = ki();
  function r(i) {
    return n(i, t, e);
  }
  return Ua = r, Ua;
}
var ja, nf;
function Y0() {
  if (nf) return ja;
  nf = 1;
  var n = Kp(), e = Xp(), t = zn();
  function r(i) {
    return n(i, t, e);
  }
  return ja = r, ja;
}
var Ha, of;
function Z0() {
  if (of) return Ha;
  of = 1;
  var n = Nr(), e = Ot(), t = n(e, "DataView");
  return Ha = t, Ha;
}
var $a, af;
function X0() {
  if (af) return $a;
  af = 1;
  var n = Nr(), e = Ot(), t = n(e, "Promise");
  return $a = t, $a;
}
var Fa, sf;
function Qp() {
  if (sf) return Fa;
  sf = 1;
  var n = Nr(), e = Ot(), t = n(e, "Set");
  return Fa = t, Fa;
}
var Va, lf;
function K0() {
  if (lf) return Va;
  lf = 1;
  var n = Nr(), e = Ot(), t = n(e, "WeakMap");
  return Va = t, Va;
}
var za, uf;
function Di() {
  if (uf) return za;
  uf = 1;
  var n = Z0(), e = tu(), t = X0(), r = Qp(), i = K0(), o = rn(), a = _p(), s = "[object Map]", l = "[object Object]", u = "[object Promise]", c = "[object Set]", d = "[object WeakMap]", f = "[object DataView]", h = a(n), g = a(e), p = a(t), v = a(r), w = a(i), y = o;
  return (n && y(new n(new ArrayBuffer(1))) != f || e && y(new e()) != s || t && y(t.resolve()) != u || r && y(new r()) != c || i && y(new i()) != d) && (y = function(_) {
    var b = o(_), C = b == l ? _.constructor : void 0, m = C ? a(C) : "";
    if (m)
      switch (m) {
        case h:
          return f;
        case g:
          return s;
        case p:
          return u;
        case v:
          return c;
        case w:
          return d;
      }
    return b;
  }), za = y, za;
}
var Wa, cf;
function Q0() {
  if (cf) return Wa;
  cf = 1;
  var n = Object.prototype, e = n.hasOwnProperty;
  function t(r) {
    var i = r.length, o = new r.constructor(i);
    return i && typeof r[0] == "string" && e.call(r, "index") && (o.index = r.index, o.input = r.input), o;
  }
  return Wa = t, Wa;
}
var Ga, df;
function J0() {
  if (df) return Ga;
  df = 1;
  var n = iu();
  function e(t, r) {
    var i = r ? n(t.buffer) : t.buffer;
    return new t.constructor(i, t.byteOffset, t.byteLength);
  }
  return Ga = e, Ga;
}
var Ya, ff;
function e_() {
  if (ff) return Ya;
  ff = 1;
  var n = /\w*$/;
  function e(t) {
    var r = new t.constructor(t.source, n.exec(t));
    return r.lastIndex = t.lastIndex, r;
  }
  return Ya = e, Ya;
}
var Za, hf;
function t_() {
  if (hf) return Za;
  hf = 1;
  var n = xi(), e = n ? n.prototype : void 0, t = e ? e.valueOf : void 0;
  function r(i) {
    return t ? Object(t.call(i)) : {};
  }
  return Za = r, Za;
}
var Xa, pf;
function r_() {
  if (pf) return Xa;
  pf = 1;
  var n = iu(), e = J0(), t = e_(), r = t_(), i = Sp(), o = "[object Boolean]", a = "[object Date]", s = "[object Map]", l = "[object Number]", u = "[object RegExp]", c = "[object Set]", d = "[object String]", f = "[object Symbol]", h = "[object ArrayBuffer]", g = "[object DataView]", p = "[object Float32Array]", v = "[object Float64Array]", w = "[object Int8Array]", y = "[object Int16Array]", _ = "[object Int32Array]", b = "[object Uint8Array]", C = "[object Uint8ClampedArray]", m = "[object Uint16Array]", T = "[object Uint32Array]";
  function x(A, M, O) {
    var S = A.constructor;
    switch (M) {
      case h:
        return n(A);
      case o:
      case a:
        return new S(+A);
      case g:
        return e(A, O);
      case p:
      case v:
      case w:
      case y:
      case _:
      case b:
      case C:
      case m:
      case T:
        return i(A, O);
      case s:
        return new S();
      case l:
      case d:
        return new S(A);
      case u:
        return t(A);
      case c:
        return new S();
      case f:
        return r(A);
    }
  }
  return Xa = x, Xa;
}
var Ka, vf;
function n_() {
  if (vf) return Ka;
  vf = 1;
  var n = Di(), e = sr(), t = "[object Map]";
  function r(i) {
    return e(i) && n(i) == t;
  }
  return Ka = r, Ka;
}
var Qa, gf;
function i_() {
  if (gf) return Qa;
  gf = 1;
  var n = n_(), e = su(), t = lu(), r = t && t.isMap, i = r ? e(r) : n;
  return Qa = i, Qa;
}
var Ja, mf;
function o_() {
  if (mf) return Ja;
  mf = 1;
  var n = Di(), e = sr(), t = "[object Set]";
  function r(i) {
    return e(i) && n(i) == t;
  }
  return Ja = r, Ja;
}
var es, _f;
function a_() {
  if (_f) return es;
  _f = 1;
  var n = o_(), e = su(), t = lu(), r = t && t.isSet, i = r ? e(r) : n;
  return es = i, es;
}
var ts, bf;
function s_() {
  if (bf) return ts;
  bf = 1;
  var n = bp(), e = j0(), t = Np(), r = $0(), i = F0(), o = Tp(), a = xp(), s = z0(), l = W0(), u = G0(), c = Y0(), d = Di(), f = Q0(), h = r_(), g = Op(), p = lr(), v = Ii(), w = i_(), y = $t(), _ = a_(), b = ki(), C = zn(), m = 1, T = 2, x = 4, A = "[object Arguments]", M = "[object Array]", O = "[object Boolean]", S = "[object Date]", P = "[object Error]", k = "[object Function]", E = "[object GeneratorFunction]", q = "[object Map]", H = "[object Number]", z = "[object Object]", ee = "[object RegExp]", se = "[object Set]", ue = "[object String]", oe = "[object Symbol]", le = "[object WeakMap]", ce = "[object ArrayBuffer]", be = "[object DataView]", ht = "[object Float32Array]", cr = "[object Float64Array]", Dr = "[object Int8Array]", N = "[object Int16Array]", L = "[object Int32Array]", F = "[object Uint8Array]", W = "[object Uint8ClampedArray]", ie = "[object Uint16Array]", ve = "[object Uint32Array]", Z = {};
  Z[A] = Z[M] = Z[ce] = Z[be] = Z[O] = Z[S] = Z[ht] = Z[cr] = Z[Dr] = Z[N] = Z[L] = Z[q] = Z[H] = Z[z] = Z[ee] = Z[se] = Z[ue] = Z[oe] = Z[F] = Z[W] = Z[ie] = Z[ve] = !0, Z[P] = Z[k] = Z[le] = !1;
  function Re(re, pt, ye, Vt, It, _t) {
    var $e, Yn = pt & m, Zn = pt & T, Ug = pt & x;
    if (ye && ($e = It ? ye(re, Vt, It, _t) : ye(re)), $e !== void 0)
      return $e;
    if (!y(re))
      return re;
    var $u = p(re);
    if ($u) {
      if ($e = f(re), !Yn)
        return a(re, $e);
    } else {
      var Rr = d(re), Fu = Rr == k || Rr == E;
      if (v(re))
        return o(re, Yn);
      if (Rr == z || Rr == A || Fu && !It) {
        if ($e = Zn || Fu ? {} : g(re), !Yn)
          return Zn ? l(re, i($e, re)) : s(re, r($e, re));
      } else {
        if (!Z[Rr])
          return It ? re : {};
        $e = h(re, Rr, Yn);
      }
    }
    _t || (_t = new n());
    var Vu = _t.get(re);
    if (Vu)
      return Vu;
    _t.set(re, $e), _(re) ? re.forEach(function(zt) {
      $e.add(Re(zt, pt, ye, zt, re, _t));
    }) : w(re) && re.forEach(function(zt, dr) {
      $e.set(dr, Re(zt, pt, ye, dr, re, _t));
    });
    var jg = Ug ? Zn ? c : u : Zn ? C : b, zu = $u ? void 0 : jg(re);
    return e(zu || re, function(zt, dr) {
      zu && (dr = zt, zt = re[dr]), t($e, dr, Re(zt, pt, ye, dr, re, _t));
    }), $e;
  }
  return ts = Re, ts;
}
var rs, yf;
function l_() {
  if (yf) return rs;
  yf = 1;
  var n = s_(), e = 1, t = 4;
  function r(i) {
    return n(i, e | t);
  }
  return rs = r, rs;
}
var u_ = l_();
const Or = /* @__PURE__ */ Ht(u_);
var ns, Cf;
function vu() {
  if (Cf) return ns;
  Cf = 1;
  var n = rn(), e = sr(), t = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || e(i) && n(i) == t;
  }
  return ns = r, ns;
}
var is, wf;
function c_() {
  if (wf) return is;
  wf = 1;
  var n = lr(), e = vu(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(o, a) {
    if (n(o))
      return !1;
    var s = typeof o;
    return s == "number" || s == "symbol" || s == "boolean" || o == null || e(o) ? !0 : r.test(o) || !t.test(o) || a != null && o in Object(a);
  }
  return is = i, is;
}
var os, Tf;
function d_() {
  if (Tf) return os;
  Tf = 1;
  var n = ru(), e = "Expected a function";
  function t(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(e);
    var o = function() {
      var a = arguments, s = i ? i.apply(this, a) : a[0], l = o.cache;
      if (l.has(s))
        return l.get(s);
      var u = r.apply(this, a);
      return o.cache = l.set(s, u) || l, u;
    };
    return o.cache = new (t.Cache || n)(), o;
  }
  return t.Cache = n, os = t, os;
}
var as, Sf;
function f_() {
  if (Sf) return as;
  Sf = 1;
  var n = d_(), e = 500;
  function t(r) {
    var i = n(r, function(a) {
      return o.size === e && o.clear(), a;
    }), o = i.cache;
    return i;
  }
  return as = t, as;
}
var ss, xf;
function h_() {
  if (xf) return ss;
  xf = 1;
  var n = f_(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, r = n(function(i) {
    var o = [];
    return i.charCodeAt(0) === 46 && o.push(""), i.replace(e, function(a, s, l, u) {
      o.push(l ? u.replace(t, "$1") : s || a);
    }), o;
  });
  return ss = r, ss;
}
var ls, Af;
function p_() {
  if (Af) return ls;
  Af = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
      o[r] = t(e[r], r, e);
    return o;
  }
  return ls = n, ls;
}
var us, Of;
function v_() {
  if (Of) return us;
  Of = 1;
  var n = xi(), e = p_(), t = lr(), r = vu(), i = n ? n.prototype : void 0, o = i ? i.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (t(s))
      return e(s, a) + "";
    if (r(s))
      return o ? o.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return us = a, us;
}
var cs, Ef;
function Wn() {
  if (Ef) return cs;
  Ef = 1;
  var n = v_();
  function e(t) {
    return t == null ? "" : n(t);
  }
  return cs = e, cs;
}
var ds, If;
function g_() {
  if (If) return ds;
  If = 1;
  var n = lr(), e = c_(), t = h_(), r = Wn();
  function i(o, a) {
    return n(o) ? o : e(o, a) ? [o] : t(r(o));
  }
  return ds = i, ds;
}
var fs, Nf;
function m_() {
  if (Nf) return fs;
  Nf = 1;
  var n = vu();
  function e(t) {
    if (typeof t == "string" || n(t))
      return t;
    var r = t + "";
    return r == "0" && 1 / t == -1 / 0 ? "-0" : r;
  }
  return fs = e, fs;
}
var hs, kf;
function __() {
  if (kf) return hs;
  kf = 1;
  var n = g_(), e = m_();
  function t(r, i) {
    i = n(i, r);
    for (var o = 0, a = i.length; r != null && o < a; )
      r = r[e(i[o++])];
    return o && o == a ? r : void 0;
  }
  return hs = t, hs;
}
var ps, Df;
function b_() {
  if (Df) return ps;
  Df = 1;
  var n = __();
  function e(t, r, i) {
    var o = t == null ? void 0 : n(t, r);
    return o === void 0 ? i : o;
  }
  return ps = e, ps;
}
var y_ = b_();
const gu = /* @__PURE__ */ Ht(y_);
var C_ = $t();
const Ri = /* @__PURE__ */ Ht(C_);
var vs, Rf;
function w_() {
  if (Rf) return vs;
  Rf = 1;
  var n = wp(), e = ki();
  function t(r, i) {
    return r && n(r, i, e);
  }
  return vs = t, vs;
}
var gs, Pf;
function T_() {
  if (Pf) return gs;
  Pf = 1;
  var n = cu();
  function e(t) {
    return typeof t == "function" ? t : n;
  }
  return gs = e, gs;
}
var ms, Mf;
function S_() {
  if (Mf) return ms;
  Mf = 1;
  var n = w_(), e = T_();
  function t(r, i) {
    return r && n(r, e(i));
  }
  return ms = t, ms;
}
var x_ = S_();
const Pi = /* @__PURE__ */ Ht(x_), Pe = () => ({
  anchorTag: "",
  customClasses: []
}), Wt = (n = {}) => ({
  ...n.roundedLayouts && {
    borderRadius: {
      value: 0
    }
  },
  backgroundColor: {
    toggle: !1,
    value: null
  },
  backgroundImage: {
    toggle: !1,
    image: null
  },
  margin: {
    linked: !0,
    value: 10,
    top: 10,
    bottom: 10,
    left: 10,
    right: 10
  },
  padding: {
    linked: !0,
    value: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  ...Pe()
}), A_ = () => ({
  name: "Base Column",
  type: qe,
  nodes: []
}), ae = () => crypto.randomUUID(), Ve = (n, e = {}) => {
  if (!n) return null;
  switch (n.type) {
    case qe:
      return {
        ...A_()
      };
    case wn:
      return {
        id: ae(),
        name: "One Column",
        type: wn,
        properties: { ...Wt(e) },
        nodes: [Ve({ type: qe })]
      };
    case Tn:
      return {
        id: ae(),
        name: "Two Columns",
        type: Tn,
        properties: { ...Wt(e) },
        nodes: new Array(2).fill(null).map((t) => Ve({ type: qe }))
      };
    case Sn:
      return {
        id: ae(),
        name: "Three Columns",
        type: Sn,
        properties: { ...Wt(e) },
        nodes: new Array(3).fill(null).map((t) => Ve({ type: qe }))
      };
    case xn:
      return {
        id: ae(),
        name: "Four Columns",
        type: xn,
        properties: { ...Wt(e) },
        nodes: new Array(4).fill(null).map((t) => Ve({ type: qe }))
      };
    case $r:
      return {
        id: ae(),
        name: "Full Width",
        type: $r,
        properties: {
          ...Wt(e),
          margin: {
            linked: !1,
            value: 0,
            top: 10,
            bottom: 10,
            left: 0,
            right: 0
          }
        },
        nodes: [Ve({ type: qe })]
      };
    case An:
      return {
        id: ae(),
        name: "Left Sidebar",
        type: An,
        properties: { ...Wt(e) },
        nodes: new Array(2).fill(null).map((t) => Ve({ type: qe }))
      };
    case On:
      return {
        id: ae(),
        name: "Right Sidebar",
        type: On,
        properties: { ...Wt(e) },
        nodes: new Array(2).fill(null).map((t) => Ve({ type: qe }))
      };
    case Qe:
      if (!n.sharedContentId) {
        console.error("Node must have a sharedContentId UUID property");
        return;
      }
      return {
        id: ae(),
        name: "Shared content",
        type: Qe,
        properties: {
          ...Wt(e),
          margin: {
            linked: !0,
            value: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          padding: {
            linked: !0,
            value: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }
        },
        sharedContentId: n.sharedContentId,
        nodes: [Ve({ type: qe })]
      };
  }
}, yr = (n, e = {}) => {
  if (!n) return null;
  const { id: t, type: r, content: i, parentId: o } = n;
  switch (r) {
    case ri:
      return {
        id: t || ae(),
        name: "Heading",
        type: ri,
        content: {
          html: (i == null ? void 0 : i.html) || ""
        },
        properties: {
          ...Pe()
        }
      };
    case Fr:
      return {
        id: t || ae(),
        name: "Text",
        type: Fr,
        content: {
          html: (i == null ? void 0 : i.html) || ""
        },
        properties: {
          ...Pe()
        }
      };
    case $n:
      return {
        ...new qt()
      };
    case En:
      return {
        id: ae(),
        name: "Gallery",
        type: En,
        content: {
          images: []
        },
        properties: {
          columnsCount: 4,
          isLightbox: !1,
          showCaptions: !1,
          captionsAlignment: "center",
          ...Pe()
        }
      };
    case vl:
      return {
        id: ae(),
        name: "Video",
        type: vl,
        content: {
          embeddableUrl: ""
        },
        properties: {
          columnPercentage: 100,
          isResized: !1,
          videoAlignment: "center",
          ...Pe()
        }
      };
    case hl:
      return {
        id: ae(),
        name: "Code",
        type: hl,
        content: {
          html: ""
        },
        properties: {
          hasScriptTag: !1,
          ...Pe()
        }
      };
    case pl:
      return {
        id: ae(),
        name: "Spacer",
        type: pl,
        properties: {
          height: 20,
          isTransparent: !1,
          backgroundColor: Mt.WHITE,
          ...Pe()
        }
      };
    case gl:
      return {
        id: ae(),
        name: "Separator",
        type: gl,
        properties: {
          thickness: 1,
          width: 100,
          color: "",
          style: "solid",
          ...Pe()
        }
      };
    case _l:
      return {
        id: ae(),
        name: "Quote",
        type: _l,
        content: {
          quote: "",
          author: "",
          source: ""
        },
        properties: {
          design: "design-1",
          color: e.mainColor || Mt.BLACK,
          ...Pe()
        }
      };
    case In:
      return {
        id: ae(),
        name: "Slider",
        type: In,
        content: {
          images: []
        },
        properties: {
          showDots: !0,
          dotsPosition: "top",
          showArrows: !0,
          arrowsPosition: "top",
          isAutoplay: !0,
          transitionSpeed: 3,
          ...Pe()
        }
      };
    case Nn:
      return {
        id: ae(),
        name: "Card",
        type: Nn,
        content: {
          heading: yr({ type: ri }),
          text: yr({ type: Fr }),
          image: new qt()
        },
        properties: {
          design: "box-shadow",
          showHeadline: !0,
          showImage: !0,
          imagePosition: "left",
          wrapText: !1,
          ...Pe()
        }
      };
    case ml:
      return {
        id: ae(),
        name: "Form",
        type: ml,
        content: {
          formId: null
        },
        properties: {
          showOneQuestionAtATime: !1,
          ...Pe()
        }
      };
    case li:
      return {
        id: ae(),
        name: "Button",
        type: li,
        content: {
          buttons: [N_()]
        },
        properties: {
          type: "regular",
          theme: "light",
          size: "regular",
          pillShape: !1,
          alignment: "left",
          style: "1",
          hasIcons: !1,
          ...Pe()
        }
      };
    case bl:
      return {
        id: ae(),
        name: "Table",
        type: bl,
        content: {
          html: ""
        },
        properties: {
          theme: Zu,
          alternatingColors: !0,
          ...Pe()
        }
      };
    case Bt:
      const a = {
        id: ae(),
        name: "Accordion",
        type: Bt,
        nodes: [],
        properties: {
          theme: Zu,
          iconStyle: "plus",
          allowMultipleOpenPanels: !0,
          ...Pe()
        }
      }, s = {
        ...Ve({ type: qe }),
        nodes: [
          yr({
            type: Tt,
            parentId: a.id
          })
        ]
      };
      return a.nodes.push(s), a;
    case Tt:
      return {
        id: ae(),
        name: "Accordion Panel",
        type: Tt,
        properties: {
          text: "",
          panelExpanded: !0,
          defaultToExpanded: !1,
          ...Pe()
        },
        parentAccordionId: o,
        nodes: [Ve({ type: qe })]
      };
    case ui:
      return {
        id: ae(),
        name: "List",
        type: ui,
        content: {
          items: [k_()]
        },
        properties: {
          design: "simple",
          format: "disc",
          ...Pe()
        }
      };
    case ci:
      return {
        id: ae(),
        name: "Navigation",
        type: ci,
        content: {
          selectedPageId: null,
          selectedChildrenIds: []
        },
        properties: {
          design: "style-1",
          color: e.mainColor || Mt.BLACK,
          isSiteMenuSynced: !1
        }
      };
    case kn:
      return {
        id: t || ae(),
        name: "Shared Component Error",
        type: kn
      };
  }
}, ir = (n) => !!Jl.find((e) => e.type === n.type), Jp = (n) => !!Ci.find((e) => e.type === n.type), ev = (n) => n.type === qe, v2 = (n) => {
  switch (n.type) {
    case Tn:
    case Sn:
    case An:
    case On:
    case xn:
      return !0;
    default:
      return !1;
  }
}, O_ = (n) => !!gp.find((e) => e.type === n.type), E_ = (n, e) => e ? n.type === qe && n.nodes.length === 0 : !1, I_ = (n) => ir(n) ? mr : Jp(n) ? _r : O_(n) ? Ql : "", Dn = (n = {}, e = 0, t = null) => {
  var a;
  if (!((a = n.nodes) != null && a.length)) return { ...Or(n), id: ae() };
  const r = ae(), i = n.type === Bt ? r : t, o = (n.nodes || []).map((s) => Dn(s, e + 1, i)) || [];
  return {
    ...Or(n),
    hasAnimated: !1,
    id: r,
    nodes: o,
    ...n.type === Tt && { parentAccordionId: t }
  };
}, g2 = (n) => yr(n), m2 = () => new qt(), N_ = () => ({
  id: ae(),
  title: "",
  icon: null,
  iconId: null,
  link: "",
  newTab: !1
}), k_ = () => ({
  id: ae(),
  content: yr({ type: Fr }),
  details: yr({ type: Fr })
}), D_ = ({ customProperties: n = null }) => n ? Ci.some((e) => {
  var o, a, s, l, u;
  const t = (a = (o = n[e.type]) == null ? void 0 : o.colorPalette) == null ? void 0 : a.enabled, r = (u = (l = (s = n[e.type]) == null ? void 0 : s.colorPalette) == null ? void 0 : l.colors) == null ? void 0 : u.length;
  return n.hasOwnProperty(e.type) && t && !!r;
}) : !1, Lt = (n, e) => {
  if (gu(n, "id") === e) return n;
  let t = null, r = (n == null ? void 0 : n.nodes) || {};
  return Pi(r, (i) => {
    if (Ri(i) && (t = Lt(i, e), t))
      return !1;
  }), t;
}, Pt = (n, e, t = null) => {
  if (n.id === e) {
    const r = t == null ? void 0 : t.nodes.indexOf(n);
    return { parent: t, index: r };
  }
  if (n.nodes && Array.isArray(n.nodes))
    for (let r = 0; r < n.nodes.length; r++) {
      const i = n.nodes[r], o = Pt(i, e, n);
      if (o) return o;
    }
  return null;
}, tv = (n, e, t = null, r = null, i = -1) => {
  if (n.id === e) {
    const o = (t == null ? void 0 : t.type) === "BASE_COLUMN" ? r : t, a = (t == null ? void 0 : t.type) === "BASE_COLUMN" ? i : t == null ? void 0 : t.nodes.indexOf(n);
    return { parent: o, grandparent: r, index: a };
  }
  if (n.nodes && Array.isArray(n.nodes))
    for (let o = 0; o < n.nodes.length; o++) {
      const a = n.nodes[o], s = tv(
        a,
        e,
        n,
        t,
        o
      );
      if (s) return s;
    }
  return null;
}, Lf = (n) => n.type === Tt, rv = (n) => {
  if (gu(n, "type") === Bt) return !0;
  let e = !1, t = n.nodes || {};
  return Pi(t, (r) => {
    if (Ri(r) && (e = rv(r), e))
      return !1;
  }), e;
}, nv = (n, e) => {
  if (gu(n, "type") === e) return !0;
  let t = !1, r = n.nodes || {};
  return Pi(r, (i) => {
    if (Ri(i) && (t = nv(i, e), t))
      return !1;
  }), t;
}, R_ = (n = {}) => Object.values(n).some((e) => !!e), _2 = (n, e) => typeof e == "string" && (e.startsWith("http://") || e.startsWith("https://")) ? e : (n && n.endsWith("/") && (n = n.slice(0, -1)), n ? `${n}${e}` : e);
class qt {
  constructor(e = {}) {
    const t = {
      id: ae(),
      name: "Image",
      type: $n,
      content: {
        assetId: "",
        altText: "",
        caption: "",
        imageFile: null,
        // We need to remove this at some point since its not being used outside of builder
        link: ""
      },
      properties: {
        actionOnClick: "no-action",
        captionAlignment: "center",
        columnPercentage: 100,
        focalPointPosition: {
          x: 50,
          y: 50
        },
        imageAlignment: "center",
        isDecorative: !1,
        isResized: !1,
        naturalWidth: null,
        naturalHeight: null,
        newTab: !1,
        preferredWidth: null,
        preferredHeight: null,
        resizeMode: "actual-size",
        showCaption: null,
        // Necessary to distinguish from old pages that havent been adapted
        backgroundPosition: "fill",
        tilePercentage: 100,
        rotation: 0,
        // Not used right now, just left overs from an old idea
        anchorTag: "",
        customClasses: [""]
      }
    }, r = Rp(t, e);
    Object.assign(this, r);
  }
}
const P_ = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3cpath%20d='M4%2017.2105V10.2105C4%209.65823%204.44772%209.21051%205%209.21051H7.38197C7.76074%209.21051%208.107%208.99651%208.27639%208.65772L8.72361%207.7633C8.893%207.42451%209.23926%207.21051%209.61803%207.21051H14.382C14.7607%207.21051%2015.107%207.42451%2015.2764%207.7633L15.7236%208.65772C15.893%208.99651%2016.2393%209.21051%2016.618%209.21051H19C19.5523%209.21051%2020%209.65823%2020%2010.2105V17.2105C20%2017.7628%2019.5523%2018.2105%2019%2018.2105H5C4.44772%2018.2105%204%2017.7628%204%2017.2105Z'%20stroke='var(--primary-dark)'%20/%3e%3ccircle%20cx='12'%20cy='13.2105'%20r='3'%20stroke='var(---primary-dark)'%20/%3e%3c/svg%3e";
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function qf(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function iv(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qf(Object(t), !0).forEach(function(r) {
      B_(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : qf(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function M_(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function ov(n) {
  var e = M_(n, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Cl(n) {
  "@babel/helpers - typeof";
  return Cl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Cl(n);
}
function L_(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Bf(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, ov(r.key), r);
  }
}
function q_(n, e, t) {
  return e && Bf(n.prototype, e), t && Bf(n, t), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function B_(n, e, t) {
  return e = ov(e), e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function av(n) {
  return U_(n) || j_(n) || H_(n) || $_();
}
function U_(n) {
  if (Array.isArray(n)) return wl(n);
}
function j_(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function H_(n, e) {
  if (n) {
    if (typeof n == "string") return wl(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return wl(n, e);
  }
}
function wl(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function $_() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Mi = typeof window < "u" && typeof window.document < "u", xt = Mi ? window : {}, mu = Mi && xt.document.documentElement ? "ontouchstart" in xt.document.documentElement : !1, _u = Mi ? "PointerEvent" in xt : !1, ge = "cropper", bu = "all", sv = "crop", lv = "move", uv = "zoom", fr = "e", hr = "w", Mr = "s", Gt = "n", an = "ne", sn = "nw", ln = "se", un = "sw", Tl = "".concat(ge, "-crop"), Uf = "".concat(ge, "-disabled"), ze = "".concat(ge, "-hidden"), jf = "".concat(ge, "-hide"), F_ = "".concat(ge, "-invisible"), fi = "".concat(ge, "-modal"), Sl = "".concat(ge, "-move"), Rn = "".concat(ge, "Action"), Kn = "".concat(ge, "Preview"), yu = "crop", cv = "move", dv = "none", xl = "crop", Al = "cropend", Ol = "cropmove", El = "cropstart", Hf = "dblclick", V_ = mu ? "touchstart" : "mousedown", z_ = mu ? "touchmove" : "mousemove", W_ = mu ? "touchend touchcancel" : "mouseup", $f = _u ? "pointerdown" : V_, Ff = _u ? "pointermove" : z_, Vf = _u ? "pointerup pointercancel" : W_, zf = "ready", Wf = "resize", Gf = "wheel", Il = "zoom", Yf = "image/jpeg", G_ = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, Y_ = /^data:/, Z_ = /^data:image\/jpeg;base64,/, X_ = /^img|canvas$/i, fv = 200, hv = 100, Zf = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: yu,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: fv,
  minContainerHeight: hv,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, K_ = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Q_ = Number.isNaN || xt.isNaN;
function te(n) {
  return typeof n == "number" && !Q_(n);
}
var Xf = function(e) {
  return e > 0 && e < 1 / 0;
};
function _s(n) {
  return typeof n > "u";
}
function Er(n) {
  return Cl(n) === "object" && n !== null;
}
var J_ = Object.prototype.hasOwnProperty;
function Br(n) {
  if (!Er(n))
    return !1;
  try {
    var e = n.constructor, t = e.prototype;
    return e && t && J_.call(t, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function Fe(n) {
  return typeof n == "function";
}
var e1 = Array.prototype.slice;
function pv(n) {
  return Array.from ? Array.from(n) : e1.call(n);
}
function Ie(n, e) {
  return n && Fe(e) && (Array.isArray(n) || te(n.length) ? pv(n).forEach(function(t, r) {
    e.call(n, t, r, n);
  }) : Er(n) && Object.keys(n).forEach(function(t) {
    e.call(n, n[t], t, n);
  })), n;
}
var me = Object.assign || function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    r[i - 1] = arguments[i];
  return Er(e) && r.length > 0 && r.forEach(function(o) {
    Er(o) && Object.keys(o).forEach(function(a) {
      e[a] = o[a];
    });
  }), e;
}, t1 = /\.\d*(?:0|9){12}\d*$/;
function Vr(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return t1.test(n) ? Math.round(n * e) / e : n;
}
var r1 = /^width|height|left|top|marginLeft|marginTop$/;
function Yt(n, e) {
  var t = n.style;
  Ie(e, function(r, i) {
    r1.test(i) && te(r) && (r = "".concat(r, "px")), t[i] = r;
  });
}
function n1(n, e) {
  return n.classList ? n.classList.contains(e) : n.className.indexOf(e) > -1;
}
function Ne(n, e) {
  if (e) {
    if (te(n.length)) {
      Ie(n, function(r) {
        Ne(r, e);
      });
      return;
    }
    if (n.classList) {
      n.classList.add(e);
      return;
    }
    var t = n.className.trim();
    t ? t.indexOf(e) < 0 && (n.className = "".concat(t, " ").concat(e)) : n.className = e;
  }
}
function St(n, e) {
  if (e) {
    if (te(n.length)) {
      Ie(n, function(t) {
        St(t, e);
      });
      return;
    }
    if (n.classList) {
      n.classList.remove(e);
      return;
    }
    n.className.indexOf(e) >= 0 && (n.className = n.className.replace(e, ""));
  }
}
function Ur(n, e, t) {
  if (e) {
    if (te(n.length)) {
      Ie(n, function(r) {
        Ur(r, e, t);
      });
      return;
    }
    t ? Ne(n, e) : St(n, e);
  }
}
var i1 = /([a-z\d])([A-Z])/g;
function Cu(n) {
  return n.replace(i1, "$1-$2").toLowerCase();
}
function Nl(n, e) {
  return Er(n[e]) ? n[e] : n.dataset ? n.dataset[e] : n.getAttribute("data-".concat(Cu(e)));
}
function Pn(n, e, t) {
  Er(t) ? n[e] = t : n.dataset ? n.dataset[e] = t : n.setAttribute("data-".concat(Cu(e)), t);
}
function o1(n, e) {
  if (Er(n[e]))
    try {
      delete n[e];
    } catch {
      n[e] = void 0;
    }
  else if (n.dataset)
    try {
      delete n.dataset[e];
    } catch {
      n.dataset[e] = void 0;
    }
  else
    n.removeAttribute("data-".concat(Cu(e)));
}
var vv = /\s\s*/, gv = function() {
  var n = !1;
  if (Mi) {
    var e = !1, t = function() {
    }, r = Object.defineProperty({}, "once", {
      get: function() {
        return n = !0, e;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(o) {
        e = o;
      }
    });
    xt.addEventListener("test", t, r), xt.removeEventListener("test", t, r);
  }
  return n;
}();
function vt(n, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = t;
  e.trim().split(vv).forEach(function(o) {
    if (!gv) {
      var a = n.listeners;
      a && a[o] && a[o][t] && (i = a[o][t], delete a[o][t], Object.keys(a[o]).length === 0 && delete a[o], Object.keys(a).length === 0 && delete n.listeners);
    }
    n.removeEventListener(o, i, r);
  });
}
function at(n, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = t;
  e.trim().split(vv).forEach(function(o) {
    if (r.once && !gv) {
      var a = n.listeners, s = a === void 0 ? {} : a;
      i = function() {
        delete s[o][t], n.removeEventListener(o, i, r);
        for (var u = arguments.length, c = new Array(u), d = 0; d < u; d++)
          c[d] = arguments[d];
        t.apply(n, c);
      }, s[o] || (s[o] = {}), s[o][t] && n.removeEventListener(o, s[o][t], r), s[o][t] = i, n.listeners = s;
    }
    n.addEventListener(o, i, r);
  });
}
function zr(n, e, t) {
  var r;
  return Fe(Event) && Fe(CustomEvent) ? r = new CustomEvent(e, {
    detail: t,
    bubbles: !0,
    cancelable: !0
  }) : (r = document.createEvent("CustomEvent"), r.initCustomEvent(e, !0, !0, t)), n.dispatchEvent(r);
}
function mv(n) {
  var e = n.getBoundingClientRect();
  return {
    left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: e.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var bs = xt.location, a1 = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function Kf(n) {
  var e = n.match(a1);
  return e !== null && (e[1] !== bs.protocol || e[2] !== bs.hostname || e[3] !== bs.port);
}
function Qf(n) {
  var e = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return n + (n.indexOf("?") === -1 ? "?" : "&") + e;
}
function gn(n) {
  var e = n.rotate, t = n.scaleX, r = n.scaleY, i = n.translateX, o = n.translateY, a = [];
  te(i) && i !== 0 && a.push("translateX(".concat(i, "px)")), te(o) && o !== 0 && a.push("translateY(".concat(o, "px)")), te(e) && e !== 0 && a.push("rotate(".concat(e, "deg)")), te(t) && t !== 1 && a.push("scaleX(".concat(t, ")")), te(r) && r !== 1 && a.push("scaleY(".concat(r, ")"));
  var s = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: s,
    msTransform: s,
    transform: s
  };
}
function s1(n) {
  var e = iv({}, n), t = 0;
  return Ie(n, function(r, i) {
    delete e[i], Ie(e, function(o) {
      var a = Math.abs(r.startX - o.startX), s = Math.abs(r.startY - o.startY), l = Math.abs(r.endX - o.endX), u = Math.abs(r.endY - o.endY), c = Math.sqrt(a * a + s * s), d = Math.sqrt(l * l + u * u), f = (d - c) / c;
      Math.abs(f) > Math.abs(t) && (t = f);
    });
  }), t;
}
function Qn(n, e) {
  var t = n.pageX, r = n.pageY, i = {
    endX: t,
    endY: r
  };
  return e ? i : iv({
    startX: t,
    startY: r
  }, i);
}
function l1(n) {
  var e = 0, t = 0, r = 0;
  return Ie(n, function(i) {
    var o = i.startX, a = i.startY;
    e += o, t += a, r += 1;
  }), e /= r, t /= r, {
    pageX: e,
    pageY: t
  };
}
function Zt(n) {
  var e = n.aspectRatio, t = n.height, r = n.width, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", o = Xf(r), a = Xf(t);
  if (o && a) {
    var s = t * e;
    i === "contain" && s > r || i === "cover" && s < r ? t = r / e : r = t * e;
  } else o ? t = r / e : a && (r = t * e);
  return {
    width: r,
    height: t
  };
}
function u1(n) {
  var e = n.width, t = n.height, r = n.degree;
  if (r = Math.abs(r) % 180, r === 90)
    return {
      width: t,
      height: e
    };
  var i = r % 90 * Math.PI / 180, o = Math.sin(i), a = Math.cos(i), s = e * a + t * o, l = e * o + t * a;
  return r > 90 ? {
    width: l,
    height: s
  } : {
    width: s,
    height: l
  };
}
function c1(n, e, t, r) {
  var i = e.aspectRatio, o = e.naturalWidth, a = e.naturalHeight, s = e.rotate, l = s === void 0 ? 0 : s, u = e.scaleX, c = u === void 0 ? 1 : u, d = e.scaleY, f = d === void 0 ? 1 : d, h = t.aspectRatio, g = t.naturalWidth, p = t.naturalHeight, v = r.fillColor, w = v === void 0 ? "transparent" : v, y = r.imageSmoothingEnabled, _ = y === void 0 ? !0 : y, b = r.imageSmoothingQuality, C = b === void 0 ? "low" : b, m = r.maxWidth, T = m === void 0 ? 1 / 0 : m, x = r.maxHeight, A = x === void 0 ? 1 / 0 : x, M = r.minWidth, O = M === void 0 ? 0 : M, S = r.minHeight, P = S === void 0 ? 0 : S, k = document.createElement("canvas"), E = k.getContext("2d"), q = Zt({
    aspectRatio: h,
    width: T,
    height: A
  }), H = Zt({
    aspectRatio: h,
    width: O,
    height: P
  }, "cover"), z = Math.min(q.width, Math.max(H.width, g)), ee = Math.min(q.height, Math.max(H.height, p)), se = Zt({
    aspectRatio: i,
    width: T,
    height: A
  }), ue = Zt({
    aspectRatio: i,
    width: O,
    height: P
  }, "cover"), oe = Math.min(se.width, Math.max(ue.width, o)), le = Math.min(se.height, Math.max(ue.height, a)), ce = [-oe / 2, -le / 2, oe, le];
  return k.width = Vr(z), k.height = Vr(ee), E.fillStyle = w, E.fillRect(0, 0, z, ee), E.save(), E.translate(z / 2, ee / 2), E.rotate(l * Math.PI / 180), E.scale(c, f), E.imageSmoothingEnabled = _, E.imageSmoothingQuality = C, E.drawImage.apply(E, [n].concat(av(ce.map(function(be) {
    return Math.floor(Vr(be));
  })))), E.restore(), k;
}
var _v = String.fromCharCode;
function d1(n, e, t) {
  var r = "";
  t += e;
  for (var i = e; i < t; i += 1)
    r += _v(n.getUint8(i));
  return r;
}
var f1 = /^data:.*,/;
function h1(n) {
  var e = n.replace(f1, ""), t = atob(e), r = new ArrayBuffer(t.length), i = new Uint8Array(r);
  return Ie(i, function(o, a) {
    i[a] = t.charCodeAt(a);
  }), r;
}
function p1(n, e) {
  for (var t = [], r = 8192, i = new Uint8Array(n); i.length > 0; )
    t.push(_v.apply(null, pv(i.subarray(0, r)))), i = i.subarray(r);
  return "data:".concat(e, ";base64,").concat(btoa(t.join("")));
}
function v1(n) {
  var e = new DataView(n), t;
  try {
    var r, i, o;
    if (e.getUint8(0) === 255 && e.getUint8(1) === 216)
      for (var a = e.byteLength, s = 2; s + 1 < a; ) {
        if (e.getUint8(s) === 255 && e.getUint8(s + 1) === 225) {
          i = s;
          break;
        }
        s += 1;
      }
    if (i) {
      var l = i + 4, u = i + 10;
      if (d1(e, l, 4) === "Exif") {
        var c = e.getUint16(u);
        if (r = c === 18761, (r || c === 19789) && e.getUint16(u + 2, r) === 42) {
          var d = e.getUint32(u + 4, r);
          d >= 8 && (o = u + d);
        }
      }
    }
    if (o) {
      var f = e.getUint16(o, r), h, g;
      for (g = 0; g < f; g += 1)
        if (h = o + g * 12 + 2, e.getUint16(h, r) === 274) {
          h += 8, t = e.getUint16(h, r), e.setUint16(h, 1, r);
          break;
        }
    }
  } catch {
    t = 1;
  }
  return t;
}
function g1(n) {
  var e = 0, t = 1, r = 1;
  switch (n) {
    // Flip horizontal
    case 2:
      t = -1;
      break;
    // Rotate left 180°
    case 3:
      e = -180;
      break;
    // Flip vertical
    case 4:
      r = -1;
      break;
    // Flip vertical and rotate right 90°
    case 5:
      e = 90, r = -1;
      break;
    // Rotate right 90°
    case 6:
      e = 90;
      break;
    // Flip horizontal and rotate right 90°
    case 7:
      e = 90, t = -1;
      break;
    // Rotate left 90°
    case 8:
      e = -90;
      break;
  }
  return {
    rotate: e,
    scaleX: t,
    scaleY: r
  };
}
var m1 = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, t = this.options, r = this.container, i = this.cropper, o = Number(t.minContainerWidth), a = Number(t.minContainerHeight);
    Ne(i, ze), St(e, ze);
    var s = {
      width: Math.max(r.offsetWidth, o >= 0 ? o : fv),
      height: Math.max(r.offsetHeight, a >= 0 ? a : hv)
    };
    this.containerData = s, Yt(i, {
      width: s.width,
      height: s.height
    }), Ne(e, ze), St(i, ze);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, t = this.imageData, r = this.options.viewMode, i = Math.abs(t.rotate) % 180 === 90, o = i ? t.naturalHeight : t.naturalWidth, a = i ? t.naturalWidth : t.naturalHeight, s = o / a, l = e.width, u = e.height;
    e.height * s > e.width ? r === 3 ? l = e.height * s : u = e.width / s : r === 3 ? u = e.width / s : l = e.height * s;
    var c = {
      aspectRatio: s,
      naturalWidth: o,
      naturalHeight: a,
      width: l,
      height: u
    };
    this.canvasData = c, this.limited = r === 1 || r === 2, this.limitCanvas(!0, !0), c.width = Math.min(Math.max(c.width, c.minWidth), c.maxWidth), c.height = Math.min(Math.max(c.height, c.minHeight), c.maxHeight), c.left = (e.width - c.width) / 2, c.top = (e.height - c.height) / 2, c.oldLeft = c.left, c.oldTop = c.top, this.initialCanvasData = me({}, c);
  },
  limitCanvas: function(e, t) {
    var r = this.options, i = this.containerData, o = this.canvasData, a = this.cropBoxData, s = r.viewMode, l = o.aspectRatio, u = this.cropped && a;
    if (e) {
      var c = Number(r.minCanvasWidth) || 0, d = Number(r.minCanvasHeight) || 0;
      s > 1 ? (c = Math.max(c, i.width), d = Math.max(d, i.height), s === 3 && (d * l > c ? c = d * l : d = c / l)) : s > 0 && (c ? c = Math.max(c, u ? a.width : 0) : d ? d = Math.max(d, u ? a.height : 0) : u && (c = a.width, d = a.height, d * l > c ? c = d * l : d = c / l));
      var f = Zt({
        aspectRatio: l,
        width: c,
        height: d
      });
      c = f.width, d = f.height, o.minWidth = c, o.minHeight = d, o.maxWidth = 1 / 0, o.maxHeight = 1 / 0;
    }
    if (t)
      if (s > (u ? 0 : 1)) {
        var h = i.width - o.width, g = i.height - o.height;
        o.minLeft = Math.min(0, h), o.minTop = Math.min(0, g), o.maxLeft = Math.max(0, h), o.maxTop = Math.max(0, g), u && this.limited && (o.minLeft = Math.min(a.left, a.left + (a.width - o.width)), o.minTop = Math.min(a.top, a.top + (a.height - o.height)), o.maxLeft = a.left, o.maxTop = a.top, s === 2 && (o.width >= i.width && (o.minLeft = Math.min(0, h), o.maxLeft = Math.max(0, h)), o.height >= i.height && (o.minTop = Math.min(0, g), o.maxTop = Math.max(0, g))));
      } else
        o.minLeft = -o.width, o.minTop = -o.height, o.maxLeft = i.width, o.maxTop = i.height;
  },
  renderCanvas: function(e, t) {
    var r = this.canvasData, i = this.imageData;
    if (t) {
      var o = u1({
        width: i.naturalWidth * Math.abs(i.scaleX || 1),
        height: i.naturalHeight * Math.abs(i.scaleY || 1),
        degree: i.rotate || 0
      }), a = o.width, s = o.height, l = r.width * (a / r.naturalWidth), u = r.height * (s / r.naturalHeight);
      r.left -= (l - r.width) / 2, r.top -= (u - r.height) / 2, r.width = l, r.height = u, r.aspectRatio = a / s, r.naturalWidth = a, r.naturalHeight = s, this.limitCanvas(!0, !1);
    }
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCanvas(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, Yt(this.canvas, me({
      width: r.width,
      height: r.height
    }, gn({
      translateX: r.left,
      translateY: r.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var t = this.canvasData, r = this.imageData, i = r.naturalWidth * (t.width / t.naturalWidth), o = r.naturalHeight * (t.height / t.naturalHeight);
    me(r, {
      width: i,
      height: o,
      left: (t.width - i) / 2,
      top: (t.height - o) / 2
    }), Yt(this.image, me({
      width: r.width,
      height: r.height
    }, gn(me({
      translateX: r.left,
      translateY: r.top
    }, r)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, t = this.canvasData, r = e.aspectRatio || e.initialAspectRatio, i = Number(e.autoCropArea) || 0.8, o = {
      width: t.width,
      height: t.height
    };
    r && (t.height * r > t.width ? o.height = o.width / r : o.width = o.height * r), this.cropBoxData = o, this.limitCropBox(!0, !0), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), o.width = Math.max(o.minWidth, o.width * i), o.height = Math.max(o.minHeight, o.height * i), o.left = t.left + (t.width - o.width) / 2, o.top = t.top + (t.height - o.height) / 2, o.oldLeft = o.left, o.oldTop = o.top, this.initialCropBoxData = me({}, o);
  },
  limitCropBox: function(e, t) {
    var r = this.options, i = this.containerData, o = this.canvasData, a = this.cropBoxData, s = this.limited, l = r.aspectRatio;
    if (e) {
      var u = Number(r.minCropBoxWidth) || 0, c = Number(r.minCropBoxHeight) || 0, d = s ? Math.min(i.width, o.width, o.width + o.left, i.width - o.left) : i.width, f = s ? Math.min(i.height, o.height, o.height + o.top, i.height - o.top) : i.height;
      u = Math.min(u, i.width), c = Math.min(c, i.height), l && (u && c ? c * l > u ? c = u / l : u = c * l : u ? c = u / l : c && (u = c * l), f * l > d ? f = d / l : d = f * l), a.minWidth = Math.min(u, d), a.minHeight = Math.min(c, f), a.maxWidth = d, a.maxHeight = f;
    }
    t && (s ? (a.minLeft = Math.max(0, o.left), a.minTop = Math.max(0, o.top), a.maxLeft = Math.min(i.width, o.left + o.width) - a.width, a.maxTop = Math.min(i.height, o.top + o.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = i.width - a.width, a.maxTop = i.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, t = this.containerData, r = this.cropBoxData;
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCropBox(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, e.movable && e.cropBoxMovable && Pn(this.face, Rn, r.width >= t.width && r.height >= t.height ? lv : bu), Yt(this.cropBox, me({
      width: r.width,
      height: r.height
    }, gn({
      translateX: r.left,
      translateY: r.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), zr(this.element, xl, this.getData());
  }
}, _1 = {
  initPreview: function() {
    var e = this.element, t = this.crossOrigin, r = this.options.preview, i = t ? this.crossOriginUrl : this.url, o = e.alt || "The image to preview", a = document.createElement("img");
    if (t && (a.crossOrigin = t), a.src = i, a.alt = o, this.viewBox.appendChild(a), this.viewBoxImage = a, !!r) {
      var s = r;
      typeof r == "string" ? s = e.ownerDocument.querySelectorAll(r) : r.querySelector && (s = [r]), this.previews = s, Ie(s, function(l) {
        var u = document.createElement("img");
        Pn(l, Kn, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), t && (u.crossOrigin = t), u.src = i, u.alt = o, u.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(u);
      });
    }
  },
  resetPreview: function() {
    Ie(this.previews, function(e) {
      var t = Nl(e, Kn);
      Yt(e, {
        width: t.width,
        height: t.height
      }), e.innerHTML = t.html, o1(e, Kn);
    });
  },
  preview: function() {
    var e = this.imageData, t = this.canvasData, r = this.cropBoxData, i = r.width, o = r.height, a = e.width, s = e.height, l = r.left - t.left - e.left, u = r.top - t.top - e.top;
    !this.cropped || this.disabled || (Yt(this.viewBoxImage, me({
      width: a,
      height: s
    }, gn(me({
      translateX: -l,
      translateY: -u
    }, e)))), Ie(this.previews, function(c) {
      var d = Nl(c, Kn), f = d.width, h = d.height, g = f, p = h, v = 1;
      i && (v = f / i, p = o * v), o && p > h && (v = h / o, g = i * v, p = h), Yt(c, {
        width: g,
        height: p
      }), Yt(c.getElementsByTagName("img")[0], me({
        width: a * v,
        height: s * v
      }, gn(me({
        translateX: -l * v,
        translateY: -u * v
      }, e))));
    }));
  }
}, b1 = {
  bind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    Fe(t.cropstart) && at(e, El, t.cropstart), Fe(t.cropmove) && at(e, Ol, t.cropmove), Fe(t.cropend) && at(e, Al, t.cropend), Fe(t.crop) && at(e, xl, t.crop), Fe(t.zoom) && at(e, Il, t.zoom), at(r, $f, this.onCropStart = this.cropStart.bind(this)), t.zoomable && t.zoomOnWheel && at(r, Gf, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && at(r, Hf, this.onDblclick = this.dblclick.bind(this)), at(e.ownerDocument, Ff, this.onCropMove = this.cropMove.bind(this)), at(e.ownerDocument, Vf, this.onCropEnd = this.cropEnd.bind(this)), t.responsive && at(window, Wf, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    Fe(t.cropstart) && vt(e, El, t.cropstart), Fe(t.cropmove) && vt(e, Ol, t.cropmove), Fe(t.cropend) && vt(e, Al, t.cropend), Fe(t.crop) && vt(e, xl, t.crop), Fe(t.zoom) && vt(e, Il, t.zoom), vt(r, $f, this.onCropStart), t.zoomable && t.zoomOnWheel && vt(r, Gf, this.onWheel, {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && vt(r, Hf, this.onDblclick), vt(e.ownerDocument, Ff, this.onCropMove), vt(e.ownerDocument, Vf, this.onCropEnd), t.responsive && vt(window, Wf, this.onResize);
  }
}, y1 = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, t = this.container, r = this.containerData, i = t.offsetWidth / r.width, o = t.offsetHeight / r.height, a = Math.abs(i - 1) > Math.abs(o - 1) ? i : o;
      if (a !== 1) {
        var s, l;
        e.restore && (s = this.getCanvasData(), l = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(Ie(s, function(u, c) {
          s[c] = u * a;
        })), this.setCropBoxData(Ie(l, function(u, c) {
          l[c] = u * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === dv || this.setDragMode(n1(this.dragBox, Tl) ? cv : yu);
  },
  wheel: function(e) {
    var t = this, r = Number(this.options.wheelZoomRatio) || 0.1, i = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      t.wheeling = !1;
    }, 50), e.deltaY ? i = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? i = -e.wheelDelta / 120 : e.detail && (i = e.detail > 0 ? 1 : -1), this.zoom(-i * r, e)));
  },
  cropStart: function(e) {
    var t = e.buttons, r = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (te(t) && t !== 1 || te(r) && r !== 0 || e.ctrlKey))) {
      var i = this.options, o = this.pointers, a;
      e.changedTouches ? Ie(e.changedTouches, function(s) {
        o[s.identifier] = Qn(s);
      }) : o[e.pointerId || 0] = Qn(e), Object.keys(o).length > 1 && i.zoomable && i.zoomOnTouch ? a = uv : a = Nl(e.target, Rn), G_.test(a) && zr(this.element, El, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === sv && (this.cropping = !0, Ne(this.dragBox, fi)));
    }
  },
  cropMove: function(e) {
    var t = this.action;
    if (!(this.disabled || !t)) {
      var r = this.pointers;
      e.preventDefault(), zr(this.element, Ol, {
        originalEvent: e,
        action: t
      }) !== !1 && (e.changedTouches ? Ie(e.changedTouches, function(i) {
        me(r[i.identifier] || {}, Qn(i, !0));
      }) : me(r[e.pointerId || 0] || {}, Qn(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var t = this.action, r = this.pointers;
      e.changedTouches ? Ie(e.changedTouches, function(i) {
        delete r[i.identifier];
      }) : delete r[e.pointerId || 0], t && (e.preventDefault(), Object.keys(r).length || (this.action = ""), this.cropping && (this.cropping = !1, Ur(this.dragBox, fi, this.cropped && this.options.modal)), zr(this.element, Al, {
        originalEvent: e,
        action: t
      }));
    }
  }
}, C1 = {
  change: function(e) {
    var t = this.options, r = this.canvasData, i = this.containerData, o = this.cropBoxData, a = this.pointers, s = this.action, l = t.aspectRatio, u = o.left, c = o.top, d = o.width, f = o.height, h = u + d, g = c + f, p = 0, v = 0, w = i.width, y = i.height, _ = !0, b;
    !l && e.shiftKey && (l = d && f ? d / f : 1), this.limited && (p = o.minLeft, v = o.minTop, w = p + Math.min(i.width, r.width, r.left + r.width), y = v + Math.min(i.height, r.height, r.top + r.height));
    var C = a[Object.keys(a)[0]], m = {
      x: C.endX - C.startX,
      y: C.endY - C.startY
    }, T = function(A) {
      switch (A) {
        case fr:
          h + m.x > w && (m.x = w - h);
          break;
        case hr:
          u + m.x < p && (m.x = p - u);
          break;
        case Gt:
          c + m.y < v && (m.y = v - c);
          break;
        case Mr:
          g + m.y > y && (m.y = y - g);
          break;
      }
    };
    switch (s) {
      // Move crop box
      case bu:
        u += m.x, c += m.y;
        break;
      // Resize crop box
      case fr:
        if (m.x >= 0 && (h >= w || l && (c <= v || g >= y))) {
          _ = !1;
          break;
        }
        T(fr), d += m.x, d < 0 && (s = hr, d = -d, u -= d), l && (f = d / l, c += (o.height - f) / 2);
        break;
      case Gt:
        if (m.y <= 0 && (c <= v || l && (u <= p || h >= w))) {
          _ = !1;
          break;
        }
        T(Gt), f -= m.y, c += m.y, f < 0 && (s = Mr, f = -f, c -= f), l && (d = f * l, u += (o.width - d) / 2);
        break;
      case hr:
        if (m.x <= 0 && (u <= p || l && (c <= v || g >= y))) {
          _ = !1;
          break;
        }
        T(hr), d -= m.x, u += m.x, d < 0 && (s = fr, d = -d, u -= d), l && (f = d / l, c += (o.height - f) / 2);
        break;
      case Mr:
        if (m.y >= 0 && (g >= y || l && (u <= p || h >= w))) {
          _ = !1;
          break;
        }
        T(Mr), f += m.y, f < 0 && (s = Gt, f = -f, c -= f), l && (d = f * l, u += (o.width - d) / 2);
        break;
      case an:
        if (l) {
          if (m.y <= 0 && (c <= v || h >= w)) {
            _ = !1;
            break;
          }
          T(Gt), f -= m.y, c += m.y, d = f * l;
        } else
          T(Gt), T(fr), m.x >= 0 ? h < w ? d += m.x : m.y <= 0 && c <= v && (_ = !1) : d += m.x, m.y <= 0 ? c > v && (f -= m.y, c += m.y) : (f -= m.y, c += m.y);
        d < 0 && f < 0 ? (s = un, f = -f, d = -d, c -= f, u -= d) : d < 0 ? (s = sn, d = -d, u -= d) : f < 0 && (s = ln, f = -f, c -= f);
        break;
      case sn:
        if (l) {
          if (m.y <= 0 && (c <= v || u <= p)) {
            _ = !1;
            break;
          }
          T(Gt), f -= m.y, c += m.y, d = f * l, u += o.width - d;
        } else
          T(Gt), T(hr), m.x <= 0 ? u > p ? (d -= m.x, u += m.x) : m.y <= 0 && c <= v && (_ = !1) : (d -= m.x, u += m.x), m.y <= 0 ? c > v && (f -= m.y, c += m.y) : (f -= m.y, c += m.y);
        d < 0 && f < 0 ? (s = ln, f = -f, d = -d, c -= f, u -= d) : d < 0 ? (s = an, d = -d, u -= d) : f < 0 && (s = un, f = -f, c -= f);
        break;
      case un:
        if (l) {
          if (m.x <= 0 && (u <= p || g >= y)) {
            _ = !1;
            break;
          }
          T(hr), d -= m.x, u += m.x, f = d / l;
        } else
          T(Mr), T(hr), m.x <= 0 ? u > p ? (d -= m.x, u += m.x) : m.y >= 0 && g >= y && (_ = !1) : (d -= m.x, u += m.x), m.y >= 0 ? g < y && (f += m.y) : f += m.y;
        d < 0 && f < 0 ? (s = an, f = -f, d = -d, c -= f, u -= d) : d < 0 ? (s = ln, d = -d, u -= d) : f < 0 && (s = sn, f = -f, c -= f);
        break;
      case ln:
        if (l) {
          if (m.x >= 0 && (h >= w || g >= y)) {
            _ = !1;
            break;
          }
          T(fr), d += m.x, f = d / l;
        } else
          T(Mr), T(fr), m.x >= 0 ? h < w ? d += m.x : m.y >= 0 && g >= y && (_ = !1) : d += m.x, m.y >= 0 ? g < y && (f += m.y) : f += m.y;
        d < 0 && f < 0 ? (s = sn, f = -f, d = -d, c -= f, u -= d) : d < 0 ? (s = un, d = -d, u -= d) : f < 0 && (s = an, f = -f, c -= f);
        break;
      // Move canvas
      case lv:
        this.move(m.x, m.y), _ = !1;
        break;
      // Zoom canvas
      case uv:
        this.zoom(s1(a), e), _ = !1;
        break;
      // Create crop box
      case sv:
        if (!m.x || !m.y) {
          _ = !1;
          break;
        }
        b = mv(this.cropper), u = C.startX - b.left, c = C.startY - b.top, d = o.minWidth, f = o.minHeight, m.x > 0 ? s = m.y > 0 ? ln : an : m.x < 0 && (u -= d, s = m.y > 0 ? un : sn), m.y < 0 && (c -= f), this.cropped || (St(this.cropBox, ze), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    _ && (o.width = d, o.height = f, o.left = u, o.top = c, this.action = s, this.renderCropBox()), Ie(a, function(x) {
      x.startX = x.endX, x.startY = x.endY;
    });
  }
}, w1 = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && Ne(this.dragBox, fi), St(this.cropBox, ze), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = me({}, this.initialImageData), this.canvasData = me({}, this.initialCanvasData), this.cropBoxData = me({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (me(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), St(this.dragBox, fi), Ne(this.cropBox, ze)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), t ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, Ie(this.previews, function(r) {
      r.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, St(this.cropper, Uf)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, Ne(this.cropper, Uf)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[ge] ? (e[ge] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, i = r.left, o = r.top;
    return this.moveTo(_s(e) ? e : i + Number(e), _s(t) ? t : o + Number(t));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, i = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.movable && (te(e) && (r.left = e, i = !0), te(t) && (r.top = t, i = !0), i && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, t) {
    var r = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(r.width * e / r.naturalWidth, null, t);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, t, r) {
    var i = this.options, o = this.canvasData, a = o.width, s = o.height, l = o.naturalWidth, u = o.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && i.zoomable) {
      var c = l * e, d = u * e;
      if (zr(this.element, Il, {
        ratio: e,
        oldRatio: a / l,
        originalEvent: r
      }) === !1)
        return this;
      if (r) {
        var f = this.pointers, h = mv(this.cropper), g = f && Object.keys(f).length ? l1(f) : {
          pageX: r.pageX,
          pageY: r.pageY
        };
        o.left -= (c - a) * ((g.pageX - h.left - o.left) / a), o.top -= (d - s) * ((g.pageY - h.top - o.top) / s);
      } else Br(t) && te(t.x) && te(t.y) ? (o.left -= (c - a) * ((t.x - o.left) / a), o.top -= (d - s) * ((t.y - o.top) / s)) : (o.left -= (c - a) / 2, o.top -= (d - s) / 2);
      o.width = c, o.height = d, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), te(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var t = this.imageData.scaleY;
    return this.scale(e, te(t) ? t : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var t = this.imageData.scaleX;
    return this.scale(te(t) ? t : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.imageData, i = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.scalable && (te(e) && (r.scaleX = e, i = !0), te(t) && (r.scaleY = t, i = !0), i && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = this.options, r = this.imageData, i = this.canvasData, o = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: o.left - i.left,
        y: o.top - i.top,
        width: o.width,
        height: o.height
      };
      var s = r.width / r.naturalWidth;
      if (Ie(a, function(c, d) {
        a[d] = c / s;
      }), e) {
        var l = Math.round(a.y + a.height), u = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = u - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return t.rotatable && (a.rotate = r.rotate || 0), t.scalable && (a.scaleX = r.scaleX || 1, a.scaleY = r.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var t = this.options, r = this.imageData, i = this.canvasData, o = {};
    if (this.ready && !this.disabled && Br(e)) {
      var a = !1;
      t.rotatable && te(e.rotate) && e.rotate !== r.rotate && (r.rotate = e.rotate, a = !0), t.scalable && (te(e.scaleX) && e.scaleX !== r.scaleX && (r.scaleX = e.scaleX, a = !0), te(e.scaleY) && e.scaleY !== r.scaleY && (r.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var s = r.width / r.naturalWidth;
      te(e.x) && (o.left = e.x * s + i.left), te(e.y) && (o.top = e.y * s + i.top), te(e.width) && (o.width = e.width * s), te(e.height) && (o.height = e.height * s), this.setCropBoxData(o);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? me({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? me({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, t = {};
    return this.ready && Ie(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(r) {
      t[r] = e[r];
    }), t;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var t = this.canvasData, r = t.aspectRatio;
    return this.ready && !this.disabled && Br(e) && (te(e.left) && (t.left = e.left), te(e.top) && (t.top = e.top), te(e.width) ? (t.width = e.width, t.height = e.width / r) : te(e.height) && (t.height = e.height, t.width = e.height * r), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, t;
    return this.ready && this.cropped && (t = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), t || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var t = this.cropBoxData, r = this.options.aspectRatio, i, o;
    return this.ready && this.cropped && !this.disabled && Br(e) && (te(e.left) && (t.left = e.left), te(e.top) && (t.top = e.top), te(e.width) && e.width !== t.width && (i = !0, t.width = e.width), te(e.height) && e.height !== t.height && (o = !0, t.height = e.height), r && (i ? t.height = t.width / r : o && (t.width = t.height * r)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var t = this.canvasData, r = c1(this.image, this.imageData, t, e);
    if (!this.cropped)
      return r;
    var i = this.getData(e.rounded), o = i.x, a = i.y, s = i.width, l = i.height, u = r.width / Math.floor(t.naturalWidth);
    u !== 1 && (o *= u, a *= u, s *= u, l *= u);
    var c = s / l, d = Zt({
      aspectRatio: c,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), f = Zt({
      aspectRatio: c,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), h = Zt({
      aspectRatio: c,
      width: e.width || (u !== 1 ? r.width : s),
      height: e.height || (u !== 1 ? r.height : l)
    }), g = h.width, p = h.height;
    g = Math.min(d.width, Math.max(f.width, g)), p = Math.min(d.height, Math.max(f.height, p));
    var v = document.createElement("canvas"), w = v.getContext("2d");
    v.width = Vr(g), v.height = Vr(p), w.fillStyle = e.fillColor || "transparent", w.fillRect(0, 0, g, p);
    var y = e.imageSmoothingEnabled, _ = y === void 0 ? !0 : y, b = e.imageSmoothingQuality;
    w.imageSmoothingEnabled = _, b && (w.imageSmoothingQuality = b);
    var C = r.width, m = r.height, T = o, x = a, A, M, O, S, P, k;
    T <= -s || T > C ? (T = 0, A = 0, O = 0, P = 0) : T <= 0 ? (O = -T, T = 0, A = Math.min(C, s + T), P = A) : T <= C && (O = 0, A = Math.min(s, C - T), P = A), A <= 0 || x <= -l || x > m ? (x = 0, M = 0, S = 0, k = 0) : x <= 0 ? (S = -x, x = 0, M = Math.min(m, l + x), k = M) : x <= m && (S = 0, M = Math.min(l, m - x), k = M);
    var E = [T, x, A, M];
    if (P > 0 && k > 0) {
      var q = g / s;
      E.push(O * q, S * q, P * q, k * q);
    }
    return w.drawImage.apply(w, [r].concat(av(E.map(function(H) {
      return Math.floor(Vr(H));
    })))), v;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var t = this.options;
    return !this.disabled && !_s(e) && (t.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var t = this.options, r = this.dragBox, i = this.face;
    if (this.ready && !this.disabled) {
      var o = e === yu, a = t.movable && e === cv;
      e = o || a ? e : dv, t.dragMode = e, Pn(r, Rn, e), Ur(r, Tl, o), Ur(r, Sl, a), t.cropBoxMovable || (Pn(i, Rn, e), Ur(i, Tl, o), Ur(i, Sl, a));
    }
    return this;
  }
}, T1 = xt.Cropper, bv = /* @__PURE__ */ function() {
  function n(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (L_(this, n), !e || !X_.test(e.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = e, this.options = me({}, Zf, Br(t) && t), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return q_(n, [{
    key: "init",
    value: function() {
      var t = this.element, r = t.tagName.toLowerCase(), i;
      if (!t[ge]) {
        if (t[ge] = this, r === "img") {
          if (this.isImg = !0, i = t.getAttribute("src") || "", this.originalUrl = i, !i)
            return;
          i = t.src;
        } else r === "canvas" && window.HTMLCanvasElement && (i = t.toDataURL());
        this.load(i);
      }
    }
  }, {
    key: "load",
    value: function(t) {
      var r = this;
      if (t) {
        this.url = t, this.imageData = {};
        var i = this.element, o = this.options;
        if (!o.rotatable && !o.scalable && (o.checkOrientation = !1), !o.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (Y_.test(t)) {
          Z_.test(t) ? this.read(h1(t)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), s = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = s, a.onerror = s, a.ontimeout = s, a.onprogress = function() {
          a.getResponseHeader("content-type") !== Yf && a.abort();
        }, a.onload = function() {
          r.read(a.response);
        }, a.onloadend = function() {
          r.reloading = !1, r.xhr = null;
        }, o.checkCrossOrigin && Kf(t) && i.crossOrigin && (t = Qf(t)), a.open("GET", t, !0), a.responseType = "arraybuffer", a.withCredentials = i.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(t) {
      var r = this.options, i = this.imageData, o = v1(t), a = 0, s = 1, l = 1;
      if (o > 1) {
        this.url = p1(t, Yf);
        var u = g1(o);
        a = u.rotate, s = u.scaleX, l = u.scaleY;
      }
      r.rotatable && (i.rotate = a), r.scalable && (i.scaleX = s, i.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var t = this.element, r = this.url, i = t.crossOrigin, o = r;
      this.options.checkCrossOrigin && Kf(r) && (i || (i = "anonymous"), o = Qf(r)), this.crossOrigin = i, this.crossOriginUrl = o;
      var a = document.createElement("img");
      i && (a.crossOrigin = i), a.src = o || r, a.alt = t.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), Ne(a, jf), t.parentNode.insertBefore(a, t.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var t = this, r = this.image;
      r.onload = null, r.onerror = null, this.sizing = !0;
      var i = xt.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(xt.navigator.userAgent), o = function(u, c) {
        me(t.imageData, {
          naturalWidth: u,
          naturalHeight: c,
          aspectRatio: u / c
        }), t.initialImageData = me({}, t.imageData), t.sizing = !1, t.sized = !0, t.build();
      };
      if (r.naturalWidth && !i) {
        o(r.naturalWidth, r.naturalHeight);
        return;
      }
      var a = document.createElement("img"), s = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        o(a.width, a.height), i || s.removeChild(a);
      }, a.src = r.src, i || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", s.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var t = this.image;
      t.onload = null, t.onerror = null, t.parentNode.removeChild(t), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var t = this.element, r = this.options, i = this.image, o = t.parentNode, a = document.createElement("div");
        a.innerHTML = K_;
        var s = a.querySelector(".".concat(ge, "-container")), l = s.querySelector(".".concat(ge, "-canvas")), u = s.querySelector(".".concat(ge, "-drag-box")), c = s.querySelector(".".concat(ge, "-crop-box")), d = c.querySelector(".".concat(ge, "-face"));
        this.container = o, this.cropper = s, this.canvas = l, this.dragBox = u, this.cropBox = c, this.viewBox = s.querySelector(".".concat(ge, "-view-box")), this.face = d, l.appendChild(i), Ne(t, ze), o.insertBefore(s, t.nextSibling), St(i, jf), this.initPreview(), this.bind(), r.initialAspectRatio = Math.max(0, r.initialAspectRatio) || NaN, r.aspectRatio = Math.max(0, r.aspectRatio) || NaN, r.viewMode = Math.max(0, Math.min(3, Math.round(r.viewMode))) || 0, Ne(c, ze), r.guides || Ne(c.getElementsByClassName("".concat(ge, "-dashed")), ze), r.center || Ne(c.getElementsByClassName("".concat(ge, "-center")), ze), r.background && Ne(s, "".concat(ge, "-bg")), r.highlight || Ne(d, F_), r.cropBoxMovable && (Ne(d, Sl), Pn(d, Rn, bu)), r.cropBoxResizable || (Ne(c.getElementsByClassName("".concat(ge, "-line")), ze), Ne(c.getElementsByClassName("".concat(ge, "-point")), ze)), this.render(), this.ready = !0, this.setDragMode(r.dragMode), r.autoCrop && this.crop(), this.setData(r.data), Fe(r.ready) && at(t, zf, r.ready, {
          once: !0
        }), zr(t, zf);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var t = this.cropper.parentNode;
        t && t.removeChild(this.cropper), St(this.element, ze);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = T1, n;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(t) {
      me(Zf, Br(t) && t);
    }
  }]);
}();
me(bv.prototype, m1, _1, b1, y1, C1, w1);
const S1 = {
  name: "FocalPoint",
  props: {
    modelValue: {
      type: Object,
      // default position to the focal point to start
      default: () => ({
        x: 50,
        y: 50
      })
    },
    src: {
      type: String,
      default: () => ""
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    isSelected: Boolean
  },
  data() {
    return {
      pin: null,
      // local position for the focal point
      localFocalPoint: {
        x: 50,
        y: 50
      },
      // style for the container based on the loaded image
      focalContainerStyle: {
        height: 0,
        width: 0,
        left: 0,
        top: 0
      },
      pinPositioned: !1,
      isModified: !1
    };
  },
  computed: {
    pinStyle() {
      if (!this.pin)
        return null;
      const { width: n, height: e } = this.pin;
      if (!this.localFocalPoint)
        return {
          left: this.s(50, n),
          top: this.s(50, e)
        };
      const { x: t, y: r } = this.localFocalPoint;
      return {
        left: this.s(t, n),
        top: this.s(r, e)
      };
    }
  },
  watch: {
    modelValue(n) {
      this.localFocalPoint = n;
    }
  },
  mounted() {
    this.pin = this.$refs.pin.getBoundingClientRect(), this.modelValue && (this.localFocalPoint = { ...this.modelValue });
  },
  // Remove event listeners on destroy
  beforeUnmount() {
    window !== "undefined" && (window.removeEventListener("mouseup", this.handlePointerMouseUp), window.removeEventListener("blur", this.handlePointerMouseUp));
  },
  methods: {
    click(n) {
      this.isModified = !0, this.$emit("update:modelValue", this.getPercentage(n));
    },
    // Every position needs to be transformed to percentage
    getPercentage(n) {
      const { offsetX: e, offsetY: t } = n, { width: r, height: i } = this.$refs.focalContainer.getBoundingClientRect();
      return {
        x: this.calculatePercentage(e, r),
        y: this.calculatePercentage(t, i)
      };
    },
    // This helps for the drag event of the focal point
    handleContainerMouseMove(n) {
      this.localFocalPoint = this.getPercentage(n);
    },
    // Calculate mouse position on mouse up
    handlePointerMouseUp(n) {
      typeof window < "u" && (this.$refs.focalContainer.removeEventListener(
        "mousemove",
        this.handleContainerMouseMove
      ), window.removeEventListener("mouseup", this.handlePointerMouseUp), window.removeEventListener("blur", this.handlePointerMouseUp), this.$refs.pin.style.pointerEvents = "", this.$emit("input", this.localFocalPoint));
    },
    // Calculate mouse position on mouse down
    handlePointerMouseDown(n) {
      typeof window < "u" && (this.$refs.focalContainer.addEventListener(
        "mousemove",
        this.handleContainerMouseMove
      ), this.$refs.pin.style.pointerEvents = "none", window.addEventListener("mouseup", this.handlePointerMouseUp), window.addEventListener("blur", this.handlePointerMouseUp));
    },
    loadVirtualImage() {
      const { height: n, width: e } = this.getRenderedImageSize(this.$refs.image), { clientHeight: t = 0, clientWidth: r = 0 } = this.$refs.image.parentNode;
      this.focalContainerStyle = {
        height: n,
        width: e,
        left: (r - e) / 2,
        top: (t - n) / 2
      }, this.pinPositioned = !0;
    },
    getRenderedImageSize(n) {
      const {
        width: e,
        height: t,
        naturalWidth: r,
        naturalHeight: i
      } = n, o = r / i, a = e / t;
      let s, l;
      return o > a ? (l = e, s = e / o) : (l = t * o, s = t), { height: s, width: l };
    },
    calculatePercentage(n, e) {
      return Math.round(n * 100 / e);
    },
    s(n, e) {
      return `calc(${n}% - ${e / 2}px)`;
    },
    // Allow setting focal point from image cropper
    setFocalPoint(n) {
      n && n.x > -1 && n.y > -1 && (this.localFocalPoint = { ...n }), this.$emit("input", this.localFocalPoint);
    },
    // Allow returning focal point to center position from image cropper
    resetFocalPoint() {
      this.localFocalPoint = { x: 50, y: 50 }, this.$emit("input", this.localFocalPoint);
    }
  }
};
function x1(n, e, t, r, i, o) {
  return D(), U("div", { class: "focal-point" }, [
    R("img", {
      ref: "image",
      src: t.src,
      name: "image",
      class: "virtual-image",
      onLoad: e[0] || (e[0] = (...a) => o.loadVirtualImage && o.loadVirtualImage(...a))
    }, null, 40, ["src"]),
    yn(R("div", {
      ref: "focalContainer",
      style: rt({
        height: `${i.focalContainerStyle.height}px`,
        width: `${i.focalContainerStyle.width}px`,
        left: `${i.focalContainerStyle.left}px`,
        top: `${i.focalContainerStyle.top}px`,
        position: "absolute"
      }),
      onClick: e[2] || (e[2] = (...a) => o.click && o.click(...a))
    }, [
      R("div", {
        ref: "pin",
        style: rt(o.pinStyle),
        class: "focal-point-pin",
        onMousedown: e[1] || (e[1] = (...a) => o.handlePointerMouseDown && o.handlePointerMouseDown(...a))
      }, [
        tt(n.$slots, "pin")
      ], 36)
    ], 4), [
      [sp, t.focalPointAllowed]
    ])
  ]);
}
const A1 = /* @__PURE__ */ X(S1, [["render", x1]]), O1 = {};
function E1(n, e) {
  return D(), U("svg", {
    width: "33",
    height: "34",
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("circle", {
      cx: "16.5",
      cy: "17.2773",
      r: "16",
      fill: "black",
      "fill-opacity": "0.5",
      stroke: "white"
    }),
    R("rect", {
      x: "16",
      y: "10.7734",
      width: "1",
      height: "5",
      rx: "0.5",
      fill: "white"
    }),
    R("rect", {
      x: "16",
      y: "18.7773",
      width: "1",
      height: "5",
      rx: "0.5",
      fill: "white"
    }),
    R("rect", {
      x: "23",
      y: "16.7773",
      width: "1",
      height: "5",
      rx: "0.5",
      transform: "rotate(90 23 16.7773)",
      fill: "white"
    }),
    R("rect", {
      x: "15",
      y: "16.7773",
      width: "1",
      height: "5",
      rx: "0.5",
      transform: "rotate(90 15 16.7773)",
      fill: "white"
    })
  ]);
}
const yv = /* @__PURE__ */ X(O1, [["render", E1]]), b2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yv
}, Symbol.toStringTag, { value: "Module" })), I1 = {
  components: {
    FocalPoint: A1,
    FocalPointIcon: yv
  },
  props: {
    image: {
      type: Object,
      required: !0
    },
    isCropping: {
      type: Boolean,
      required: !1
    },
    imgStyle: {
      type: Object,
      default: () => ({})
    },
    containerStyle: {
      type: Object,
      default: () => ({})
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    isSelected: Boolean
  },
  data() {
    return {
      cropper: null,
      localFocalPoint: { x: 50, y: 50 },
      showFocusImage: !0
    };
  },
  watch: {
    isCropping(n) {
      n ? this.cropper.crop() : this.cropper.clear();
    },
    localFocalPoint(n, e) {
      (n.x !== e.x || n.y !== e.y) && this.$emit("focal-point-changed", n);
    }
  },
  mounted() {
    var n;
    (n = this.image) != null && n.properties.focalPointPosition && (this.localFocalPoint = this.image.properties.focalPointPosition), this.cropper = new bv(this.$refs.img, {
      zoomable: !1,
      viewMode: 1,
      autoCropArea: 1,
      autoCrop: !1,
      background: !1,
      modal: !0,
      ready: () => {
        this.enableEditingIfCropperIsReady();
      },
      ...this.$attrs
    });
  },
  computed: {
    src() {
      return this.image.previewUrl;
    },
    alt() {
      return this.image.alt_text;
    }
  },
  methods: {
    enableEditingIfCropperIsReady() {
      this.$emit("set-natural-size", {
        width: this.cropper.initialImageData.naturalWidth,
        height: this.cropper.initialImageData.naturalHeight
      }), this.$emit("enable-editing", !0);
    },
    fn(n, ...e) {
      return this.cropper[n](...e);
    }
  }
};
function N1(n, e, t, r, i, o) {
  const a = $("FocalPointIcon"), s = $("FocalPoint");
  return D(), U("div", { class: "image-container" }, [
    yn(R("div", { class: "focal-point-container" }, [
      B(s, {
        modelValue: i.localFocalPoint,
        "onUpdate:modelValue": e[0] || (e[0] = (l) => i.localFocalPoint = l),
        "is-selected": t.isSelected,
        src: o.src,
        "focal-point-allowed": t.focalPointAllowed
      }, {
        pin: j(() => [
          B(a)
        ]),
        _: 1
      }, 8, ["modelValue", "is-selected", "src", "focal-point-allowed"])
    ], 512), [
      [sp, !t.isCropping]
    ]),
    R("img", {
      ref: "img",
      class: "image",
      src: o.src,
      alt: o.alt
    }, null, 8, ["src", "alt"])
  ]);
}
const k1 = /* @__PURE__ */ X(I1, [["render", N1], ["__scopeId", "data-v-0642fe82"]]), D1 = {};
function R1(n, e) {
  return D(), U("svg", {
    width: "23",
    height: "23",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("path", {
      d: "M5.5 3.57143V1M5.5 7.42857V14.5H19M1 5.5H14.5V12.5714M14.5 16.4286V19",
      stroke: "var(--purple)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]);
}
const Cv = /* @__PURE__ */ X(D1, [["render", R1]]), y2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cv
}, Symbol.toStringTag, { value: "Module" })), P1 = {
  name: "ImageEditorControls",
  components: {
    CropIcon: Cv
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpg", "image/jpeg", "image/gif"]
    },
    isCropping: Boolean,
    disableResetButton: Boolean
  }
};
function M1(n, e, t, r, i, o) {
  const a = $("a-button"), s = $("CropIcon"), l = $("a-icon");
  return D(), U("div", { class: "image-controls" }, [
    t.isCropping ? (D(), U(gt, { key: 0 }, [
      B(a, {
        variant: "secondary",
        onClick: e[0] || (e[0] = (u) => n.$emit("confirm-crop"))
      }, {
        default: j(() => [
          Me(K(n.$t("builder.imageUploader.confirmCrop")), 1)
        ]),
        _: 1
      }),
      B(a, {
        variant: "secondary",
        class: "cancel-crop",
        onClick: e[1] || (e[1] = (u) => n.$emit("cancel-crop"))
      }, {
        default: j(() => [
          Me(K(n.$t("builder.imageUploader.cancelCrop")), 1)
        ]),
        _: 1
      })
    ], 64)) : (D(), U(gt, { key: 1 }, [
      R("input", {
        ref: "replaceImageInput",
        hidden: "",
        class: "file-input",
        type: "file",
        accept: t.acceptedFileTypes,
        onChange: e[2] || (e[2] = (u) => n.$emit("replace-image", u))
      }, null, 40, ["accept"]),
      B(a, {
        variant: "secondary",
        onClick: e[3] || (e[3] = (u) => n.$refs.replaceImageInput.click())
      }, {
        default: j(() => [
          Me(K(n.$t("builder.imageUploader.replace")), 1)
        ]),
        _: 1
      }),
      B(a, {
        variant: "secondary",
        class: "begin-crop",
        size: "small",
        "aria-label": "Crop Image",
        onClick: e[4] || (e[4] = (u) => n.$emit("begin-crop"))
      }, {
        default: j(() => [
          B(s)
        ]),
        _: 1
      }),
      B(a, {
        variant: "secondary",
        class: "rotate-left",
        size: "small",
        "aria-label": "Rotate Left",
        onClick: e[5] || (e[5] = (u) => n.$emit("rotate", -90))
      }, {
        default: j(() => [
          B(l, { icon: "24:arrow-counter-clockwise" })
        ]),
        _: 1
      }),
      B(a, {
        variant: "secondary",
        class: "rotate-right",
        size: "small",
        "aria-label": "Rotate Right",
        onClick: e[6] || (e[6] = (u) => n.$emit("rotate", 90))
      }, {
        default: j(() => [
          B(l, { icon: "24:arrow-clockwise" })
        ]),
        _: 1
      }),
      B(a, {
        disabled: t.disableResetButton,
        variant: "secondary",
        class: "reset-button",
        onClick: e[7] || (e[7] = (u) => n.$emit("reset-image"))
      }, {
        default: j(() => [
          Me(K(n.$t("builder.imageUploader.reset")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 64))
  ]);
}
const L1 = /* @__PURE__ */ X(P1, [["render", M1], ["__scopeId", "data-v-a8e27e8f"]]), q1 = {};
function B1(n, e) {
  return D(), U("svg", {
    id: "info_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14"
  }, [
    R("circle", {
      class: "cls-1",
      cx: "7",
      cy: "7",
      r: "7"
    }),
    R("path", {
      id: "i",
      class: "cls-2",
      d: "M1277.7,1701.09h1.86l0.99-5.1h-1.86Zm1.3-6.09h1.75l0.19-1.06h-1.86Z",
      transform: "translate(-1272 -1691)"
    })
  ]);
}
const wv = /* @__PURE__ */ X(q1, [["render", B1], ["__scopeId", "data-v-88c4d34d"]]), C2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wv
}, Symbol.toStringTag, { value: "Module" })), U1 = {
  setup: (n) => ({
    v$: dp({
      $registerAs: n.validationName
    })
  }),
  name: "ImageEditor",
  components: {
    InfoIcon: wv,
    ImageCropper: k1,
    ImageEditorControls: L1
  },
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    acceptedFileTypes: {
      type: Array,
      required: !0
    },
    validationName: {
      type: String,
      required: !0
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    captionsAllowed: Boolean,
    decorativeAllowed: Boolean,
    isBg: Boolean,
    isSelected: Boolean
  },
  validations() {
    return {
      image: {
        content: {
          altText: {
            required: (n) => this.decorativeAllowed && this.image.properties.isDecorative || this.isBg ? !0 : (n == null ? void 0 : n.length) > 0
          }
        }
      }
    };
  },
  data() {
    return {
      isCropping: !1,
      originalImage: null,
      changedImageFile: !1
    };
  },
  mounted() {
    this.originalImage = Or(this.image);
  },
  computed: {
    image: {
      get() {
        return this.modelValue;
      },
      set(n) {
        this.$emit("update:modelValue", n);
      }
    },
    showError() {
      return this.v$.$error;
    }
  },
  methods: {
    beginCrop() {
      this.isCropping = !0, this.$emit("begin-crop"), this.$refs.imageCropper.fn("crop");
    },
    async confirmCrop() {
      await this.storeCroppedData(), this.cancelCrop();
    },
    cancelCrop() {
      this.$refs.imageCropper.fn("clear"), this.$emit("end-crop"), this.isCropping = !1;
    },
    focalPointChanged(n) {
      this.changedImageFile = !0, n && (this.image.properties.focalPointPosition = n);
    },
    async storeCroppedData() {
      const { type: n = "image/jpeg", name: e = "croppedImage.jpeg" } = this.image.content.imageFile || {}, t = await new Promise(
        (i) => this.$refs.imageCropper.fn("getCroppedCanvas", { imageSmoothingEnabled: !1 }).toBlob(
          (o) => {
            i(o);
          },
          n,
          1
        )
      ), r = new File([t], e, { type: n });
      this.replaceCurrentImage(r);
    },
    replaceCurrentImage(n) {
      if (this.changedImageFile = !0, hu(n)) {
        this.$emit("exceeds-upload-limit");
        return;
      }
      if (Wp(n, this.acceptedFileTypes)) return;
      this.applyNewNaturalSize();
      const e = URL.createObjectURL(n);
      this.$refs.imageCropper.fn("replace", e), URL.revokeObjectURL(this.image.previewUrl), this.image = new qt({
        ...this.image,
        previewUrl: e,
        imageModified: !0,
        content: {
          ...this.image.content,
          imageFile: n
        },
        properties: {
          ...this.image.properties,
          focalPointPosition: { x: 50, y: 50 }
        }
      });
    },
    applyNewNaturalSize() {
      const n = this.$refs.imageCropper.fn("getCroppedCanvas").width, e = this.$refs.imageCropper.fn("getCroppedCanvas").height;
      this.image.properties.naturalWidth = n, this.image.properties.naturalHeight = e, this.image.properties.preferredWidth = n, this.image.properties.preferredHeight = e;
    },
    resetImage() {
      const { imageFile: n } = this.originalImage.content;
      this.focalPointChanged(this.originalImage.properties.focalPointPosition), this.replaceCurrentImage(n), this.changedImageFile = !1;
    },
    async rotate(n) {
      this.$emit("is-rotating", !0), this.$refs.imageCropper.fn("rotate", n), await this.storeCroppedData(), this.$emit("is-rotating", !1);
    },
    uploadNewImage(n) {
      const e = n.target.files[0];
      n.target.value = "", this.replaceCurrentImage(e);
    },
    setNaturalSize({ width: n, height: e }) {
      this.image.properties.naturalWidth = n, this.image.properties.naturalHeight = e, (this.image.properties.preferredWidth === null || this.image.properties.preferredHeight === null) && (this.image.properties.preferredWidth = n, this.image.properties.preferredHeight = e);
    }
  }
};
function j1(n, e, t, r, i, o) {
  const a = $("ImageCropper"), s = $("ImageEditorControls"), l = $("a-form-input"), u = $("a-checkbox"), c = $("InfoIcon"), d = $("a-tooltip");
  return t.isSelected ? (D(), U("div", { key: 0 }, [
    R("div", { class: "image-preview" }, [
      B(a, {
        ref: "imageCropper",
        image: o.image,
        "is-cropping": i.isCropping,
        "focal-point-allowed": t.focalPointAllowed,
        "is-selected": t.isSelected,
        onSetNaturalSize: o.setNaturalSize,
        onFocalPointChanged: o.focalPointChanged
      }, null, 8, ["image", "is-cropping", "focal-point-allowed", "is-selected", "onSetNaturalSize", "onFocalPointChanged"])
    ]),
    B(s, {
      "is-cropping": i.isCropping,
      "disable-reset-button": !i.changedImageFile,
      onBeginCrop: o.beginCrop,
      onCancelCrop: o.cancelCrop,
      onConfirmCrop: o.confirmCrop,
      onResetImage: o.resetImage,
      onReplaceImage: o.uploadNewImage,
      onRotate: o.rotate
    }, null, 8, ["is-cropping", "disable-reset-button", "onBeginCrop", "onCancelCrop", "onConfirmCrop", "onResetImage", "onReplaceImage", "onRotate"]),
    R("div", { class: "text-inputs" }, [
      t.isBg ? J("", !0) : (D(), U("div", {
        key: 0,
        class: "alt-text"
      }, [
        B(l, {
          id: "alt-text",
          modelValue: o.image.content.altText,
          "onUpdate:modelValue": e[0] || (e[0] = (f) => o.image.content.altText = f),
          disabled: o.image.properties.isDecorative,
          "show-error": o.showError,
          "error-message": n.$t("builder.imageUploader.altTextRequired"),
          label: n.$t("builder.imageUploader.altText"),
          placeholder: n.$t("builder.imageUploader.imageDescriptionPlaceholder"),
          required: ""
        }, null, 8, ["modelValue", "disabled", "show-error", "error-message", "label", "placeholder"]),
        t.decorativeAllowed ? (D(), U("div", {
          key: 0,
          class: "decorative-input"
        }, [
          B(u, {
            checked: o.image.properties.isDecorative,
            "onUpdate:checked": e[1] || (e[1] = ({ checked: f }) => o.image.properties.isDecorative = f)
          }, {
            default: j(() => [
              Me(K(n.$t("builder.imageUploader.decorativeImage")), 1)
            ]),
            _: 1
          }, 8, ["checked"]),
          B(d, {
            label: n.$t("builder.imageUploader.decorativeImageTooltip"),
            position: "right",
            size: "small"
          }, {
            default: j(() => [
              B(c)
            ]),
            _: 1
          }, 8, ["label"])
        ])) : J("", !0)
      ])),
      t.captionsAllowed ? (D(), U("div", {
        key: 1,
        class: "caption-text"
      }, [
        B(l, {
          id: "caption-text",
          modelValue: o.image.content.caption,
          "onUpdate:modelValue": e[2] || (e[2] = (f) => o.image.content.caption = f),
          label: n.$t("builder.imageUploader.caption"),
          placeholder: n.$t("builder.imageUploader.captionPlaceholder")
        }, null, 8, ["modelValue", "label", "placeholder"])
      ])) : J("", !0)
    ])
  ])) : J("", !0);
}
const H1 = /* @__PURE__ */ X(U1, [["render", j1], ["__scopeId", "data-v-a3b557c3"]]), Tv = {
  __name: "ImageIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M957.988,1395.53c0,0.01-.005.02-0.007,0.04A1.5,1.5,0,0,1,956.5,1397H938.511a1.5,1.5,0,0,1-1.5-1.5v-14a1.5,1.5,0,0,1,1.5-1.5H956.5a1.5,1.5,0,0,1,1.5,1.5v14C958,1395.51,957.989,1395.52,957.988,1395.53Zm-19.977-.03a0.5,0.5,0,0,0,.5.5H956.5a0.5,0.5,0,0,0,.471-0.35l-4.549-5.46-3.619,2.71a0.494,0.494,0,0,1-.653-0.05l-3.662-5.67-6.472,5.55v2.77Zm18.984-14a0.5,0.5,0,0,0-.5-0.5H938.511a0.5,0.5,0,0,0-.5.5v9.91l6.173-5.29a0.5,0.5,0,0,1,.679.03l3.682,5.69,3.652-2.74a0.5,0.5,0,0,1,.684.08l4.114,4.94V1381.5Zm-6,4a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,951,1385.5Zm2,0a0.5,0.5,0,1,0-.5.5A0.5,0.5,0,0,0,953,1385.5Z",
        transform: "translate(-932.5 -1373.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, $1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tv
}, Symbol.toStringTag, { value: "Module" })), F1 = 1e6, V1 = {
  __name: "ImageThumbnails",
  props: {
    acceptedFileTypes: {
      type: Array,
      required: !0
    },
    images: {
      type: Array,
      required: !0
    },
    currentImageIndex: {
      type: Number,
      default: 0
    },
    maxFilesAllowed: {
      type: Number,
      default: 1
    },
    maxImageSize: {
      type: Number,
      default: 10
    }
  },
  emits: [
    "select-image-index",
    "exceeds-upload-limit",
    "images-uploaded"
  ],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Cn("newFileInput"), o = Cn("dropZoneRef"), a = (u) => {
      var d, f, h, g;
      if (!((f = (d = u.target) == null ? void 0 : d.files) != null && f[0])) return;
      const c = (g = (h = u.target) == null ? void 0 : h.files) == null ? void 0 : g[0];
      s(c);
    }, s = (u) => {
      if (u.size / F1 > t.maxImageSize) {
        r("exceeds-upload-limit");
        return;
      }
      r("images-uploaded", u), i.value && (i.value.value = "");
    };
    return du(o, {
      onDrop: (u) => {
        const c = Array.from(u)[0];
        c && s(c);
      },
      multiple: !1,
      dataTypes: t.acceptedFileTypes
    }), (u, c) => {
      const d = $("a-button");
      return D(), U("div", {
        ref_key: "dropZoneRef",
        ref: o,
        class: "all-images"
      }, [
        R("input", {
          ref_key: "newFileInput",
          ref: i,
          hidden: "",
          type: "file",
          accept: n.acceptedFileTypes,
          onChange: a
        }, null, 40, ["accept"]),
        (D(!0), U(gt, null, nr(n.images, (f, h) => (D(), U("div", {
          key: h,
          class: "image-thumbnail-container"
        }, [
          R("img", {
            src: f.previewUrl,
            class: He(["preview-image", {
              selected: n.currentImageIndex === h
            }]),
            onClick: (g) => r("select-image-index", h)
          }, null, 10, ["src", "onClick"])
        ]))), 128)),
        n.images.length < n.maxFilesAllowed ? (D(), G(d, {
          key: 0,
          class: "new-image-button preview-image",
          variant: "none",
          onClick: c[0] || (c[0] = (f) => {
            var h;
            return (h = i.value) == null ? void 0 : h.click();
          })
        }, {
          default: j(() => [
            B(Tv),
            R("p", { class: "add-new-image" }, K(u.$t("builder.imageUploader.addNewImage")), 1)
          ]),
          _: 1
        })) : J("", !0)
      ], 512);
    };
  }
}, z1 = /* @__PURE__ */ X(V1, [["__scopeId", "data-v-f2807731"]]), W1 = {
  name: "ImageUploaderV3",
  components: {
    ImageEditor: H1,
    ImageThumbnails: z1
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpg", "image/jpeg", "image/gif"]
    },
    images: {
      type: Array,
      required: !0
    },
    maxFiles: {
      type: Number,
      default: 1
    },
    initialImageIndex: {
      type: Number,
      default: 0
    },
    uploadApi: {
      type: String,
      required: !0
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    captionsAllowed: Boolean,
    decorativeAllowed: Boolean,
    isBg: Boolean,
    localUploader: Boolean,
    // TODO: Delete when implementing FAAS
    projectParent: {
      type: String,
      default: ""
    },
    isEditing: Boolean
  },
  setup: () => ({ v$: Zg() }),
  data() {
    return {
      currentImageIndex: 0,
      isCropping: !1,
      isRotating: !1,
      isUploading: !1,
      workingImages: []
    };
  },
  computed: {
    dialogHeader() {
      return this.isEditing ? this.$t("builder.imageUploader.editImage") : this.$t("builder.imageUploader.uploadImage");
    }
  },
  watch: {
    initialImageIndex(n) {
      this.selectImage(n);
    }
  },
  created() {
    this.workingImages = this.images.map((n) => {
      const e = Or(n);
      return {
        ...e,
        previewUrl: e.assetUrl || URL.createObjectURL(e.content.imageFile),
        imageModified: !1,
        isBg: this.isBg
      };
    }), this.selectImage(this.initialImageIndex);
  },
  methods: {
    addNewImageFile(n) {
      if (this.fileHasValidationError(n))
        return;
      const e = URL.createObjectURL(n);
      this.workingImages.push(
        new qt({
          imageModified: !1,
          previewUrl: e,
          content: {
            imageFile: n
          }
        })
      ), this.currentImageIndex = this.workingImages.length - 1;
    },
    async createCmsRequest(n) {
      const e = {
        create_px2560: !1,
        create_px1920: !1,
        create_px1600: !1,
        create_px1280: !1,
        create_px960: !1,
        create_px600: !1
      }, t = await B0(n.content.imageFile);
      return Yu.post(this.uploadApi, {
        asset: {
          file_base64: t,
          upload_options: e
        }
      });
    },
    createUploadRequests() {
      return this.workingImages.map((n) => {
        const e = new FormData();
        if (e.append("file", n.content.imageFile), n.content.assetId === "" || n.imageModified)
          switch (this.projectParent) {
            case "cms":
              return this.createCmsRequest(n);
            default:
              return Yu.post(this.uploadApi, e, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
          }
        return Promise.resolve({
          data: { id: n.content.assetId },
          status: 201
        });
      });
    },
    fileHasValidationError(n) {
      const e = n.size / 1e6 > this.uploadLimit;
      return this.acceptedFileTypes.includes(n.type) ? e ? (console.error("File size exceeds limit"), !0) : !1 : (console.error("Unsupported File"), !0);
    },
    selectImage(n) {
      this.currentImageIndex = n >= 0 ? n : this.workingImages.length - 1;
    },
    async uploadImages() {
      if (this.v$.$touch(), this.v$.$error) {
        const t = [];
        this.workingImages.forEach((r, i) => {
          var o;
          (o = this.v$.$getResultsForChild(`image-${i}`)) != null && o.$error && t.push(i);
        }), this.currentImageIndex = t[0];
        return;
      }
      this.isUploading = !0;
      let n = null;
      if (!this.localUploader) {
        const t = this.createUploadRequests();
        if (n = await Promise.allSettled(t), n.some((r) => r.status === "rejected")) {
          this.isUploading = !1;
          return;
        }
      }
      const e = this.workingImages.map((t, r) => {
        var o, a;
        URL.revokeObjectURL(t.previewUrl);
        const i = this.localUploader ? URL.createObjectURL(this.workingImages[r].content.imageFile) : this.getImageAssetUrl(n[r]);
        return new qt({
          ...t,
          assetUrl: i,
          content: {
            ...t.content,
            assetId: this.localUploader ? crypto.randomUUID() : (a = (o = n[r].value) == null ? void 0 : o.data) == null ? void 0 : a.id,
            assetUrl: i
          }
        });
      });
      this.$emit("images-changed", e), this.isUploading = !1;
    },
    // TODO: Delete when implementing FAAS
    getImageAssetUrl(n) {
      var e, t, r, i, o;
      if (this.projectParent === "engage")
        return ((t = (e = n.value) == null ? void 0 : e.data) == null ? void 0 : t.file) || "";
      if (this.projectParent === "cms")
        return ((o = (i = (r = n.value) == null ? void 0 : r.data) == null ? void 0 : i.file) == null ? void 0 : o.url) || "";
    }
  }
};
function G1(n, e, t, r, i, o) {
  const a = $("a-dialog-header"), s = $("ImageThumbnails"), l = $("ImageEditor"), u = $("a-dialog-content"), c = $("a-button"), d = $("a-dialog-footer"), f = $("a-dialog");
  return D(), G(f, {
    show: "",
    "no-close-on-overlay": "",
    size: "l",
    class: "image-editor",
    onClose: e[5] || (e[5] = (h) => n.$emit("close"))
  }, {
    default: j(() => [
      B(a, null, {
        default: j(() => [
          Me(K(o.dialogHeader), 1)
        ]),
        _: 1
      }),
      B(u, { class: "content" }, {
        default: j(() => [
          t.maxFiles > 1 ? (D(), G(s, {
            key: 0,
            "accepted-file-types": t.acceptedFileTypes,
            images: i.workingImages,
            "max-files-allowed": t.maxFiles,
            "current-image-index": i.currentImageIndex,
            onImagesUploaded: o.addNewImageFile,
            onSelectImageIndex: o.selectImage,
            onExceedsUploadLimit: e[0] || (e[0] = (h) => n.$emit("exceeds-upload-limit"))
          }, null, 8, ["accepted-file-types", "images", "max-files-allowed", "current-image-index", "onImagesUploaded", "onSelectImageIndex"])) : J("", !0),
          (D(!0), U(gt, null, nr(i.workingImages, (h, g) => (D(), U("div", { key: g }, [
            B(l, {
              modelValue: i.workingImages[g],
              "onUpdate:modelValue": (p) => i.workingImages[g] = p,
              "is-selected": g === i.currentImageIndex,
              "validation-name": `image-${g}`,
              "accepted-file-types": t.acceptedFileTypes,
              "captions-allowed": t.captionsAllowed,
              "decorative-allowed": t.decorativeAllowed,
              "is-bg": t.isBg,
              "focal-point-allowed": t.focalPointAllowed,
              onBeginCrop: e[1] || (e[1] = (p) => i.isCropping = !0),
              onEndCrop: e[2] || (e[2] = (p) => i.isCropping = !1),
              onIsRotating: e[3] || (e[3] = (p) => i.isRotating = p),
              onExceedsUploadLimit: e[4] || (e[4] = (p) => n.$emit("exceeds-upload-limit"))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "is-selected", "validation-name", "accepted-file-types", "captions-allowed", "decorative-allowed", "is-bg", "focal-point-allowed"])
          ]))), 128))
        ]),
        _: 1
      }),
      B(d, { class: "footer" }, {
        default: j(() => [
          B(c, {
            variant: "primary",
            disabled: i.isCropping || i.isRotating || i.isUploading,
            onClick: o.uploadImages
          }, {
            default: j(() => [
              Me(K(n.$t("builder.imageUploader.upload")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const Y1 = /* @__PURE__ */ X(W1, [["render", G1], ["__scopeId", "data-v-4fc29ffc"]]), Z1 = {
  __name: "BackgroundImageControl",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    assets: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    uploadApi: {
      type: String,
      required: !0
    }
  },
  emits: ["update", "asset-entry"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Se("state"), o = Q(null), a = Q(!1), s = Q(null), l = [
      {
        label: "Fill",
        value: "fill"
      },
      {
        label: "Tile",
        value: "tile"
      },
      {
        label: "Center",
        value: "center"
      }
    ], u = ["image/png", "image/jpg", "image/jpeg", "image/gif"], c = I(() => [s.value || d.value]), d = I({
      get() {
        var k, E, q;
        return (q = (E = (k = t.node) == null ? void 0 : k.properties) == null ? void 0 : E.backgroundImage) == null ? void 0 : q.image;
      },
      set(k) {
        r("update", "image", k);
      }
    }), f = I({
      get() {
        var k, E;
        return ((E = (k = d.value) == null ? void 0 : k.properties) == null ? void 0 : E.backgroundPosition) || "fill";
      },
      set(k) {
        d.value.properties.backgroundPosition = k;
      }
    }), h = I({
      get() {
        var k, E;
        return ((E = (k = d.value) == null ? void 0 : k.properties) == null ? void 0 : E.tilePercentage) || 100;
      },
      set(k) {
        d.value.properties.tilePercentage = k;
      }
    }), g = I(() => {
      var k, E;
      return (E = (k = t.node) == null ? void 0 : k.properties) == null ? void 0 : E.backgroundImage;
    }), p = I(() => {
      var q, H, z, ee, se, ue, oe, le, ce, be, ht, cr;
      let k = {};
      switch ((H = (q = d.value) == null ? void 0 : q.properties) == null ? void 0 : H.backgroundPosition) {
        case "center":
          k = {
            "background-position": "center",
            "background-repeat": "no-repeat",
            "background-size": "contain"
          };
          break;
        case "fill":
          k = {
            "background-repeat": "no-repeat",
            "background-size": "cover",
            "background-position": `${((se = (ee = (z = d.value) == null ? void 0 : z.properties) == null ? void 0 : ee.focalPointPosition) == null ? void 0 : se.x) || 50}% ${((le = (oe = (ue = d.value) == null ? void 0 : ue.properties) == null ? void 0 : oe.focalPointPosition) == null ? void 0 : le.y) || 50}%`
          };
          break;
        case "tile":
          k = {
            "background-repeat": "repeat",
            "background-size": `${((be = (ce = d.value) == null ? void 0 : ce.properties) == null ? void 0 : be.tilePercentage) || 100}%`
          };
          break;
      }
      const E = (cr = (ht = d.value) == null ? void 0 : ht.content) != null && cr.assetId ? `url(${v.value.url})` : `url("${P_}")`;
      return {
        ...k,
        backgroundImage: E
      };
    }), v = I(() => {
      var k, E;
      return t.assets[(E = (k = d.value) == null ? void 0 : k.content) == null ? void 0 : E.assetId] || "";
    }), w = I(
      () => {
        var k, E;
        return (E = (k = d.value) == null ? void 0 : k.content) != null && E.assetId ? "builder.imageUploader.editImage" : "builder.imageUploader.uploadImage";
      }
    ), y = (k) => {
      d.value === null && (d.value = new qt()), r("update", "toggle", k);
    }, _ = () => {
      var k, E, q;
      (E = (k = d.value) == null ? void 0 : k.content) != null && E.assetId ? x() : (q = o.value) == null || q.click();
    }, b = () => {
      o.value && (o.value.value = ""), a.value = !0;
    }, C = (k) => {
      var q;
      const E = Array.from((q = k.target) == null ? void 0 : q.files);
      !E || E.length !== 1 || m(E[0]);
    }, m = (k) => {
      const E = k.name.includes("."), q = k.type === "", H = Wp(k, u);
      if (hu(k)) {
        O();
        return;
      }
      !E || q || H || (s.value = new qt({
        content: {
          imageFile: k
        },
        properties: {
          isDecorative: !0
        }
      }), b());
    }, T = (k) => {
      const E = k[0];
      E.assetUrl && r("asset-entry", U0(E)), d.value = E, a.value = !1, s.value = null;
    }, x = () => {
      a.value = !0;
    }, A = () => {
      d.value = new qt(), s.value = null;
    }, M = () => {
      s.value = null, a.value = !1;
    }, O = () => {
      i.emitToConsumingApp("toast-message", {
        message: "10 MB Limit Exceeded",
        type: "error"
      });
    }, S = Cn("imageDropZone");
    return du(S, {
      onDrop: (k) => {
        k && k.length === 1 && m(k[0]);
      },
      multiple: !1,
      dataTypes: u
    }), (k, E) => {
      var ue;
      const q = $("a-toggle"), H = $("a-button"), z = $("portal"), ee = $("a-form-input"), se = $("a-form-radio-group");
      return D(), G(xr, null, Zl({
        title: j(() => [
          R("h4", null, K(k.$t("builder.backgroundImage.title")), 1)
        ]),
        control: j(() => [
          B(q, {
            "model-value": g.value.toggle,
            "onUpdate:modelValue": E[0] || (E[0] = (oe) => y(oe))
          }, null, 8, ["model-value"])
        ]),
        _: 2
      }, [
        (ue = g.value) != null && ue.toggle ? {
          name: "content",
          fn: j(() => {
            var oe;
            return [
              R("div", {
                ref_key: "imageDropZone",
                ref: S,
                class: "inline-control gap-5"
              }, [
                R("input", {
                  ref_key: "fileInput",
                  ref: o,
                  type: "file",
                  hidden: "",
                  accept: u,
                  onChange: C,
                  onClick: E[1] || (E[1] = (le) => le.target.value = null)
                }, null, 544),
                R("div", {
                  class: "image-thumbnail",
                  style: rt(p.value),
                  onClick: _
                }, null, 4),
                B(H, {
                  variant: "tertiary",
                  onClick: _
                }, {
                  default: j(() => [
                    Me(K(k.$t(w.value)), 1)
                  ]),
                  _: 1
                }),
                a.value ? (D(), G(z, {
                  key: 0,
                  to: "root-dialog-container"
                }, {
                  default: j(() => [
                    B(Y1, {
                      "is-bg": "",
                      "max-files": 1,
                      images: c.value,
                      "local-uploader": V(i).builder.api.localUploader,
                      "upload-api": n.uploadApi,
                      "project-parent": V(i).builder.api.projectParent,
                      onExceedsUploadLimit: O,
                      onImagesChanged: T,
                      onClose: M
                    }, null, 8, ["images", "local-uploader", "upload-api", "project-parent"])
                  ]),
                  _: 1
                })) : J("", !0),
                (oe = d.value.content) != null && oe.assetId ? (D(), G(H, {
                  key: 1,
                  class: "clear-button",
                  variant: "link",
                  onClick: A
                }, {
                  default: j(() => [
                    Me(K(k.$t("builder.clear")), 1)
                  ]),
                  _: 1
                })) : J("", !0)
              ], 512),
              R("div", { class: "inline-control position-radio-group" }, [
                B(se, {
                  label: k.$t("builder.backgroundImage.position"),
                  options: l,
                  modelValue: f.value,
                  "onUpdate:modelValue": E[3] || (E[3] = (le) => f.value = le)
                }, {
                  "content-tile": j(() => [
                    R("div", null, [
                      B(ee, {
                        modelValue: h.value,
                        "onUpdate:modelValue": E[2] || (E[2] = (le) => h.value = le),
                        class: "tile-input",
                        type: "number",
                        width: "70px",
                        height: "40px",
                        label: `${k.$t("builder.backgroundImage.tile")} (%)`,
                        min: 1,
                        max: 100
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label", "modelValue"])
              ])
            ];
          }),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
}, Sv = /* @__PURE__ */ X(Z1, [["__scopeId", "data-v-dc1dc409"]]), X1 = {};
function K1(n, e) {
  return D(), U("svg", {
    id: "backButtonIcon",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("path", {
      id: "background",
      d: "M0 3C0 1.34315 1.34315 0 3 0H29C30.6569 0 32 1.34315 32 3V29C32 30.6569 30.6569 32 29 32H3C1.34315 32 0 30.6569 0 29V3Z",
      fill: "none"
    }),
    R("path", {
      id: "arrow",
      d: "M25 17C25.5523 17 26 16.5523 26 16C26 15.4477 25.5523 15 25 15L25 17ZM7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071L13.6569 23.0711C14.0474 23.4616 14.6805 23.4616 15.0711 23.0711C15.4616 22.6805 15.4616 22.0474 15.0711 21.6569L9.41421 16L15.0711 10.3431C15.4616 9.95262 15.4616 9.31946 15.0711 8.92893C14.6805 8.53841 14.0474 8.53841 13.6569 8.92893L7.29289 15.2929ZM25 15L8 15L8 17L25 17L25 15Z",
      fill: "var(--purple)"
    })
  ]);
}
const xv = /* @__PURE__ */ X(X1, [["render", K1]]), w2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xv
}, Symbol.toStringTag, { value: "Module" })), Q1 = {
  name: "SidebarHeader",
  components: {
    BackIcon: xv
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
function J1(n, e, t, r, i, o) {
  const a = $("BackIcon");
  return D(), U("div", { class: "header" }, [
    R("div", {
      class: "sidebar-back-button",
      onClick: e[0] || (e[0] = (s) => n.$emit("close-sidebar"))
    }, [
      B(a)
    ]),
    R("h4", null, K(t.title), 1)
  ]);
}
const wu = /* @__PURE__ */ X(Q1, [["render", J1], ["__scopeId", "data-v-fcc5486e"]]), eb = {
  name: "GlobalSettings",
  components: {
    BackgroundColorControl: Pp,
    BackgroundImageControl: Sv,
    NodeControl: xr,
    SidebarHeader: wu
  },
  props: {
    builder: {
      type: Object,
      default: () => {
      }
    }
  },
  inject: ["state"],
  computed: {
    globalCustomProperties() {
      var n, e;
      return ((e = (n = this.builder) == null ? void 0 : n.customProperties) == null ? void 0 : e.global) || {};
    },
    structure() {
      return this.builder.structure;
    }
  }
};
function tb(n, e, t, r, i, o) {
  const a = $("SidebarHeader"), s = $("a-toggle"), l = $("NodeControl"), u = $("BackgroundColorControl"), c = $("BackgroundImageControl");
  return D(), U(gt, null, [
    B(a, {
      title: n.$t("builder.builderTabs.globalSettings"),
      onCloseSidebar: e[0] || (e[0] = (d) => n.$emit("close-sidebar"))
    }, null, 8, ["title"]),
    o.globalCustomProperties.headerSlotOptional ? (D(), G(l, { key: 0 }, {
      title: j(() => [
        R("h4", null, K(n.$t("builder.header")), 1)
      ]),
      control: j(() => [
        B(s, {
          modelValue: o.globalCustomProperties.showHeaderSlot,
          "onUpdate:modelValue": e[1] || (e[1] = (d) => o.globalCustomProperties.showHeaderSlot = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : J("", !0),
    o.globalCustomProperties.footerSlotOptional ? (D(), G(l, { key: 1 }, {
      title: j(() => [
        R("h4", null, K(n.$t("builder.footer")), 1)
      ]),
      control: j(() => [
        B(s, {
          modelValue: o.globalCustomProperties.showFooterSlot,
          "onUpdate:modelValue": e[2] || (e[2] = (d) => o.globalCustomProperties.showFooterSlot = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : J("", !0),
    o.globalCustomProperties.backgroundColorAllowed ? (D(), G(u, {
      key: 2,
      node: o.structure,
      onUpdate: e[3] || (e[3] = (d, f) => o.structure.properties.backgroundColor[d] = f)
    }, null, 8, ["node"])) : J("", !0),
    o.globalCustomProperties.backgroundImageAllowed ? (D(), G(c, {
      key: 3,
      node: o.structure,
      assets: o.state.builder.assets,
      "upload-api": o.state.builder.api.images,
      onUpdate: e[4] || (e[4] = (d, f) => o.structure.properties.backgroundImage[d] = f),
      onAssetEntry: e[5] || (e[5] = (d) => o.state.addAsset(d))
    }, null, 8, ["node", "assets", "upload-api"])) : J("", !0),
    o.globalCustomProperties.confirmOnDeleteDialogAllowed ? (D(), G(l, { key: 4 }, {
      title: j(() => [
        R("h4", null, K(n.$t("builder.controls.global.showConfirmationDialog")), 1)
      ]),
      control: j(() => [
        B(s, {
          modelValue: o.globalCustomProperties.showConfirmOnDeleteDialog,
          "onUpdate:modelValue": e[6] || (e[6] = (d) => o.globalCustomProperties.showConfirmOnDeleteDialog = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : J("", !0),
    B(l, null, {
      title: j(() => [
        R("h4", null, K(n.$t("builder.controls.global.focusNewNodeOnCreate")), 1)
      ]),
      control: j(() => [
        B(s, {
          modelValue: o.globalCustomProperties.focusNewNodeOnCreate,
          "onUpdate:modelValue": e[7] || (e[7] = (d) => o.globalCustomProperties.focusNewNodeOnCreate = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64);
}
const rb = /* @__PURE__ */ X(eb, [["render", tb], ["__scopeId", "data-v-c08ba7c5"]]), nb = {
  __name: "AccordionIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      R("rect", {
        x: "5",
        y: "9",
        width: "17",
        height: "1",
        rx: "0.5",
        fill: t.value
      }, null, 8, ["fill"]),
      R("rect", {
        x: "5",
        y: "21",
        width: "17",
        height: "1",
        rx: "0.5",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M21 13H6L6 18H21V13ZM6 12C5.44772 12 5 12.4477 5 13V18C5 18.5523 5.44772 19 6 19H21C21.5523 19 22 18.5523 22 18V13C22 12.4477 21.5523 12 21 12H6Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("rect", {
        x: "24",
        y: "15",
        width: "3",
        height: "1",
        rx: "0.5",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M26.4 9C26.1791 9 26 8.82091 26 8.6V8.4C26 8.17909 25.8209 8 25.6 8H25.4C25.1791 8 25 8.17909 25 8.4V8.6C25 8.82091 24.8209 9 24.6 9H24.4C24.1791 9 24 9.17909 24 9.4V9.6C24 9.82091 24.1791 10 24.4 10H24.6C24.8209 10 25 10.1791 25 10.4V10.6C25 10.8209 25.1791 11 25.4 11H25.6C25.8209 11 26 10.8209 26 10.6V10.4C26 10.1791 26.1791 10 26.4 10H26.6C26.8209 10 27 9.82091 27 9.6V9.4C27 9.17909 26.8209 9 26.6 9H26.4Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M26.4 21C26.1791 21 26 20.8209 26 20.6V20.4C26 20.1791 25.8209 20 25.6 20H25.4C25.1791 20 25 20.1791 25 20.4V20.6C25 20.8209 24.8209 21 24.6 21H24.4C24.1791 21 24 21.1791 24 21.4V21.6C24 21.8209 24.1791 22 24.4 22H24.6C24.8209 22 25 22.1791 25 22.4V22.6C25 22.8209 25.1791 23 25.4 23H25.6C25.8209 23 26 22.8209 26 22.6V22.4C26 22.1791 26.1791 22 26.4 22H26.6C26.8209 22 27 21.8209 27 21.6V21.4C27 21.1791 26.8209 21 26.6 21H26.4Z",
        fill: t.value
      }, null, 8, ["fill"])
    ]));
  }
}, ib = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nb
}, Symbol.toStringTag, { value: "Module" })), ob = {
  __name: "ButtonIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      width: "30",
      height: "30",
      viewBox: "0 0 33 10",
      fill: "none"
    }, [
      R("rect", {
        x: "0.5",
        y: "0.5",
        width: "32",
        height: "9",
        fill: "transparent",
        stroke: t.value
      }, null, 8, ["stroke"])
    ]));
  }
}, ab = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ob
}, Symbol.toStringTag, { value: "Module" })), sb = {
  __name: "CardIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        id: "card",
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        "fill-rule": "evenodd",
        d: "M938,1887h20a2,2,0,0,1,2,2v11a2,2,0,0,1-2,2H938a2,2,0,0,1-2-2v-11A2,2,0,0,1,938,1887Z",
        transform: "translate(-933 -1879.5)"
      }, null, 8, ["stroke"])
    ]));
  }
}, lb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sb
}, Symbol.toStringTag, { value: "Module" })), ub = {
  __name: "EmbedIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        id: "embed",
        class: "cls-1",
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M934,1538.82l9.986-5.82v1.34l-9.155,5.17v0.04l9.155,6.13v1.33L934,1540.2v-1.38Zm25,0-9.986-5.82v1.34l9.155,5.17v0.04l-9.155,6.13v1.33L959,1540.2v-1.38Z",
        transform: "translate(-931.5 -1525)"
      }, null, 8, ["fill"])
    ]));
  }
}, cb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ub
}, Symbol.toStringTag, { value: "Module" })), db = {
  __name: "FormIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none"
    }, [
      R("path", {
        d: "M10 7.5C10 6.67157 10.6716 6 11.5 6H22.5C23.3284 6 24 6.67157 24 7.5V21.5C24 22.3284 23.3284 23 22.5 23H22V22H22.5C22.7761 22 23 21.7762 23 21.5V7.5C23 7.22385 22.7761 7 22.5 7H11.5C11.2239 7 11 7.22385 11 7.5V8H10V7.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M10 12H18V13H10V12Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M10 15H18V16H10V15Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M18 18H10V19H18V18Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M10 21H18V22H10V21Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 10.5C7 9.67157 7.67157 9 8.5 9H19.5C20.3284 9 21 9.67157 21 10.5V24.5C21 25.3284 20.3284 26 19.5 26H8.5C7.67157 26 7 25.3284 7 24.5V10.5ZM8.5 10C8.22385 10 8 10.2238 8 10.5V24.5C8 24.7762 8.22385 25 8.5 25H19.5C19.7761 25 20 24.7762 20 24.5V10.5C20 10.2238 19.7761 10 19.5 10H8.5Z",
        fill: t.value
      }, null, 8, ["fill"])
    ]));
  }
}, fb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: db
}, Symbol.toStringTag, { value: "Module" })), hb = {
  __name: "FourColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "51",
      height: "17",
      viewBox: "0 0 51 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "13.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "26.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "39.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, pb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hb
}, Symbol.toStringTag, { value: "Module" })), vb = {
  __name: "FullWidthIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "56",
      height: "17",
      viewBox: "0 0 56 17"
    }, [
      R("rect", {
        id: "full-width",
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "55",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, gb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vb
}, Symbol.toStringTag, { value: "Module" })), mb = {
  __name: "GalleryIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M1052.53,1392a0.5,0.5,0,0,1-.5-0.5v-9.27a0.24,0.24,0,0,0-.23-0.23h-16.53a0.233,0.233,0,0,0-.23.23v0.27a0.5,0.5,0,0,1-.5.5,0.5,0.5,0,0,1-.5-0.5v-0.27a1.229,1.229,0,0,1,1.23-1.23h16.53a1.236,1.236,0,0,1,1.23,1.23v9.27A0.5,0.5,0,0,1,1052.53,1392Zm-1.5-7.74v12.48a1.249,1.249,0,0,1-1.23,1.26h-17.53a1.249,1.249,0,0,1-1.23-1.26v-3.38h0v-9.1a1.249,1.249,0,0,1,1.23-1.26h17.53A1.249,1.249,0,0,1,1051.03,1384.26Zm-18.99,12.48a0.254,0.254,0,0,0,.23.26h17.53a0.254,0.254,0,0,0,.23-0.26v-0.38a0.449,0.449,0,0,1-.13-0.1l-4.39-5.03-2.62,2.62a0.5,0.5,0,0,1-.38.15,0.5,0.5,0,0,1-.36-0.18l-4.65-5.58-5.46,5.34v3.16Zm0-12.48v7.92l5.15-5.04a0.468,0.468,0,0,1,.37-0.14,0.5,0.5,0,0,1,.36.18l4.65,5.58,2.61-2.61a0.463,0.463,0,0,1,.37-0.15,0.494,0.494,0,0,1,.36.17l4.12,4.72v-10.63a0.254,0.254,0,0,0-.23-0.26h-17.53A0.254,0.254,0,0,0,1032.04,1384.26Zm13.43,4.74a1.5,1.5,0,1,1,1.49-1.5A1.5,1.5,0,0,1,1045.47,1389Zm0-2a0.5,0.5,0,0,0-.5.5A0.5,0.5,0,1,0,1045.47,1387Z",
        transform: "translate(-1027.03 -1374.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, _b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mb
}, Symbol.toStringTag, { value: "Module" })), bb = {
  __name: "HeadingIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M954,1322v-9h-2v-1a2.636,2.636,0,0,0,.546.18,2.124,2.124,0,0,0,.726-0.3,1.913,1.913,0,0,0,.529-0.57,4.728,4.728,0,0,0,.427-1.32H955v11.99Zm-6-6h-7v6l-1-.01v-11.98l1-.01v5h7v-5l0.923,0.01v11.98L948,1322v-6Z",
        transform: "translate(-932.5 -1301)"
      }, null, 8, ["fill"])
    ]));
  }
}, yb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bb
}, Symbol.toStringTag, { value: "Module" })), Cb = {
  __name: "LeftSidebarIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      id: "left_sidebar",
      "data-name": "left sidebar",
      xmlns: "http://www.w3.org/2000/svg",
      width: "47",
      height: "17",
      viewBox: "0 0 47 17"
    }, [
      R("rect", {
        id: "Rectangle_2133_copy_21",
        "data-name": "Rectangle 2133 copy 21",
        class: "cls-1",
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        id: "Rectangle_2133_copy_21-2",
        "data-name": "Rectangle 2133 copy 21",
        class: "cls-1",
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "16.5",
        y: "0.5",
        width: "30",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, wb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cb
}, Symbol.toStringTag, { value: "Module" })), Tb = {
  __name: "NavigationIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M19 1H5C4.44771 1 4 1.44772 4 2V22C4 22.5523 4.44772 23 5 23H19C19.5523 23 20 22.5523 20 22V2C20 1.44772 19.5523 1 19 1ZM5 0C3.89543 0 3 0.89543 3 2V22C3 23.1046 3.89543 24 5 24H19C20.1046 24 21 23.1046 21 22V2C21 0.895431 20.1046 0 19 0H5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 4.5C8 4.22386 8.22386 4 8.5 4H16.5C16.7761 4 17 4.22386 17 4.5C17 4.77614 16.7761 5 16.5 5H8.5C8.22386 5 8 4.77614 8 4.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M7 4.5C7 4.77614 6.77614 5 6.5 5C6.22386 5 6 4.77614 6 4.5C6 4.22386 6.22386 4 6.5 4C6.77614 4 7 4.22386 7 4.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 7.5C8 7.22386 8.22386 7 8.5 7H16.5C16.7761 7 17 7.22386 17 7.5C17 7.77614 16.7761 8 16.5 8H8.5C8.22386 8 8 7.77614 8 7.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M7 7.5C7 7.77614 6.77614 8 6.5 8C6.22386 8 6 7.77614 6 7.5C6 7.22386 6.22386 7 6.5 7C6.77614 7 7 7.22386 7 7.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 10.5C8 10.2239 8.22386 10 8.5 10H16.5C16.7761 10 17 10.2239 17 10.5C17 10.7761 16.7761 11 16.5 11H8.5C8.22386 11 8 10.7761 8 10.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M7 10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5C6 10.2239 6.22386 10 6.5 10C6.77614 10 7 10.2239 7 10.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 13.5C8 13.2239 8.22386 13 8.5 13H16.5C16.7761 13 17 13.2239 17 13.5C17 13.7761 16.7761 14 16.5 14H8.5C8.22386 14 8 13.7761 8 13.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M7 13.5C7 13.7761 6.77614 14 6.5 14C6.22386 14 6 13.7761 6 13.5C6 13.2239 6.22386 13 6.5 13C6.77614 13 7 13.2239 7 13.5Z",
        fill: t.value
      }, null, 8, ["fill"])
    ]));
  }
}, Sb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tb
}, Symbol.toStringTag, { value: "Module" })), xb = {
  __name: "OneColumnIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "39",
      height: "17",
      viewBox: "0 0 39 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "38",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, Ab = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xb
}, Symbol.toStringTag, { value: "Module" })), Ob = {
  __name: "QuoteIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: "none",
        stroke: t.value,
        "fill-rule": "evenodd",
        d: "M1042.18,1981s5.76-7.92.4-9.76a5.466,5.466,0,1,1,9.42-3.76C1051.97,1977.66,1042.18,1981,1042.18,1981Zm-13,0s5.76-7.92.4-9.76a5.466,5.466,0,1,1,9.42-3.76C1038.97,1977.66,1029.18,1981,1029.18,1981Z",
        transform: "translate(-1025.045 -1956.5)"
      }, null, 8, ["stroke"])
    ]));
  }
}, Eb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ob
}, Symbol.toStringTag, { value: "Module" })), Ib = {
  __name: "RightSidebarIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "47",
      height: "17",
      viewBox: "0 0 47 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "32.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "30",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, Nb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ib
}, Symbol.toStringTag, { value: "Module" })), kb = {
  __name: "SeparatorIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M1031,1680v-1h26v1h-26Z",
        transform: "translate(-1029 -1664.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, Db = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kb
}, Symbol.toStringTag, { value: "Module" })), Rb = {
  __name: "SliderIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M959.5,1472a0.5,0.5,0,0,1-.5-0.5v-10a0.5,0.5,0,0,1,1,0v10A0.5,0.5,0,0,1,959.5,1472Zm-3,1a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,1,0v12A0.5,0.5,0,0,1,956.5,1473Zm-3,0h-12a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,.5-0.5h12a0.5,0.5,0,0,1,.5.5v12A0.5,0.5,0,0,1,953.5,1473Zm-0.5-12H942v11h11v-11Zm-14.5,12a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,1,0v12A0.5,0.5,0,0,1,938.5,1473Zm-3-1a0.5,0.5,0,0,1-.5-0.5v-10a0.5,0.5,0,0,1,1,0v10A0.5,0.5,0,0,1,935.5,1472Z",
        transform: "translate(-932.5 -1451.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, Pb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rb
}, Symbol.toStringTag, { value: "Module" })), Mb = {
  __name: "SpacerIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "2",
        y: "7.5",
        width: "26",
        height: "15"
      }, null, 8, ["stroke"])
    ]));
  }
}, Lb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mb
}, Symbol.toStringTag, { value: "Module" })), qb = {
  __name: "TableIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M957,1979H933v-15h25v15h-1Zm-21-14h-2v6h2v-6Zm0,7h-2v6h2v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Z",
        transform: "translate(-930.5 -1956.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, Bb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qb
}, Symbol.toStringTag, { value: "Module" })), Ub = {
  __name: "TextIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M1052.13,1313.42a2.093,2.093,0,0,0-1.41-.45,2.323,2.323,0,0,0-1.08.24,2.229,2.229,0,0,0-.78.65,2.777,2.777,0,0,0-.47.96,4.427,4.427,0,0,0-.16,1.18,4.485,4.485,0,0,0,.16,1.18,2.728,2.728,0,0,0,.47.95,2.279,2.279,0,0,0,1.86.88,2.1,2.1,0,0,0,1.48-.5,2.029,2.029,0,0,0,.62-1.39h1.19a3.024,3.024,0,0,1-.98,2.14,3.415,3.415,0,0,1-2.31.75,3.7,3.7,0,0,1-1.55-.32,3.487,3.487,0,0,1-1.17-.86,3.773,3.773,0,0,1-.74-1.28,4.388,4.388,0,0,1-.26-1.55,4.483,4.483,0,0,1,.26-1.56,3.825,3.825,0,0,1,.74-1.27,3.357,3.357,0,0,1,1.17-.86,3.554,3.554,0,0,1,1.55-.32,3.406,3.406,0,0,1,2.23.71,3.113,3.113,0,0,1,1.06,1.94h-1.22A1.957,1.957,0,0,0,1052.13,1313.42Zm-8.02,5.48a3,3,0,0,1-1.05.82,3.338,3.338,0,0,1-1.4.29,3.1,3.1,0,0,1-1.37-.29,2.933,2.933,0,0,1-1.06-.95h-0.03v1.03H1038v-10.81h1.2v4.08h0.03a3.43,3.43,0,0,1,1.03-.95,2.856,2.856,0,0,1,1.45-.35,3.079,3.079,0,0,1,1.33.28,3,3,0,0,1,1.04.8,3.889,3.889,0,0,1,.67,1.3,5.809,5.809,0,0,1,.24,1.74,5.975,5.975,0,0,1-.23,1.7A3.921,3.921,0,0,1,1044.11,1318.9Zm-0.5-4.22a2.971,2.971,0,0,0-.4-0.98,1.891,1.891,0,0,0-.67-0.65,1.812,1.812,0,0,0-.95-0.24,2.289,2.289,0,0,0-1.1.25,2.027,2.027,0,0,0-.76.66,3.1,3.1,0,0,0-.45.99,4.564,4.564,0,0,0-.15,1.19,4.71,4.71,0,0,0,.15,1.23,2.8,2.8,0,0,0,.45.97,2.306,2.306,0,0,0,.77.65,2.439,2.439,0,0,0,1.07.23,1.948,1.948,0,0,0,.96-0.23,2.013,2.013,0,0,0,.68-0.65,2.75,2.75,0,0,0,.4-0.97,5.2,5.2,0,0,0,.14-1.23A5.3,5.3,0,0,0,1043.61,1314.68Zm-8.26,5.12a1.19,1.19,0,0,1-1.29-1.13h-0.02a3.19,3.19,0,0,1-.4.43,2.659,2.659,0,0,1-.54.39,5.528,5.528,0,0,1-.69.35,2.128,2.128,0,0,1-.86.17,3.557,3.557,0,0,1-1-.13,2.2,2.2,0,0,1-.81-0.4,1.781,1.781,0,0,1-.54-0.67,2.193,2.193,0,0,1-.19-0.96,2.3,2.3,0,0,1,.24-1.12,2.01,2.01,0,0,1,.69-0.7,3.312,3.312,0,0,1,1.03-.41c0.41-.1.84-0.18,1.3-0.27,0.27-.03.51-0.08,0.73-0.12a3.2,3.2,0,0,0,.57-0.18,0.941,0.941,0,0,0,.37-0.3,0.845,0.845,0,0,0,.13-0.5,1.213,1.213,0,0,0-.43-1.01,1.919,1.919,0,0,0-1.25-.35,2.048,2.048,0,0,0-1.38.4,1.689,1.689,0,0,0-.49,1.27h-1.13a2.687,2.687,0,0,1,.2-1.02,2.108,2.108,0,0,1,.56-0.82,2.609,2.609,0,0,1,.93-0.53,3.9,3.9,0,0,1,1.3-.2,4.817,4.817,0,0,1,1.1.12,2.464,2.464,0,0,1,.88.41,1.882,1.882,0,0,1,.58.74,2.763,2.763,0,0,1,.21,1.14v3.61a1.172,1.172,0,0,0,.16.69,0.373,0.373,0,0,0,.35.16,1.112,1.112,0,0,0,.29-0.04h0.04v0.86c-0.08.03-.16,0.06-0.26,0.09A1.943,1.943,0,0,1,1035.35,1319.8Zm-1.26-4.04a3.667,3.667,0,0,1-.76.33,8.639,8.639,0,0,1-.95.22c-0.29.06-.57,0.12-0.83,0.18a2.471,2.471,0,0,0-.68.26,1.327,1.327,0,0,0-.45.43,1.292,1.292,0,0,0-.16.68,1.309,1.309,0,0,0,.13.63,1.065,1.065,0,0,0,.36.37,1.308,1.308,0,0,0,.49.18,2.76,2.76,0,0,0,.57.06,2.474,2.474,0,0,0,1.02-.2,2.373,2.373,0,0,0,.71-0.5,1.934,1.934,0,0,0,.41-0.65,1.983,1.983,0,0,0,.14-0.7v-1.29Z",
        transform: "translate(-1026.5 -1299.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, jb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ub
}, Symbol.toStringTag, { value: "Module" })), Hb = {
  __name: "ThreeColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "47",
      height: "17",
      viewBox: "0 0 47 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "32.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "16.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, $b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hb
}, Symbol.toStringTag, { value: "Module" })), Fb = {
  __name: "TwoColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "43",
      height: "17",
      viewBox: "0 0 43 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "20",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "22.5",
        y: "0.5",
        width: "20",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, Vb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fb
}, Symbol.toStringTag, { value: "Module" })), zb = {
  __name: "VideoIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M1049.98,1474.5a1.5,1.5,0,0,1-1.49,1.5h-12a1.5,1.5,0,0,1-1.5-1.5v-17a1.5,1.5,0,0,1,1.5-1.5h8a0.142,0.142,0,0,1,.06.02,0.2,0.2,0,0,1,.07.01,0.477,0.477,0,0,1,.22.12l5,6a0.464,0.464,0,0,1,.12.23,0.127,0.127,0,0,1,.01.06c0,0.02.01,0.04,0.01,0.06v12Zm-13.99-17v17a0.508,0.508,0,0,0,.5.5h12a0.508,0.508,0,0,0,.5-0.5V1463h-4.5a0.5,0.5,0,0,1-.5-0.5V1457h-7.5A0.508,0.508,0,0,0,1035.99,1457.5Zm9,0.21V1462h3.29Zm0.72,10.24a0.532,0.532,0,0,1,.28.45,0.522,0.522,0,0,1-.27.45l-6,3.09a0.465,0.465,0,0,1-.23.06,0.484,0.484,0,0,1-.26-0.07,0.507,0.507,0,0,1-.24-0.43v-6a0.5,0.5,0,0,1,.23-0.42,0.531,0.531,0,0,1,.49-0.03Zm-5.72,2.73,4.38-2.26-4.38-2.12v4.38Z",
        transform: "translate(-1027.5 -1451)"
      }, null, 8, ["fill"])
    ]));
  }
}, Wb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zb
}, Symbol.toStringTag, { value: "Module" })), on = nn ? window : void 0;
function Xt(n) {
  var e;
  const t = pe(n);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
function Rt(...n) {
  const e = [], t = () => {
    e.forEach((s) => s()), e.length = 0;
  }, r = (s, l, u, c) => (s.addEventListener(l, u, c), () => s.removeEventListener(l, u, c)), i = I(() => {
    const s = er(pe(n[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), o = Up(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((u) => Xt(u))) != null ? l : [on].filter((u) => u != null),
        er(pe(i.value ? n[1] : n[0])),
        er(V(i.value ? n[2] : n[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        pe(i.value ? n[3] : n[2])
      ];
    },
    ([s, l, u, c]) => {
      if (t(), !(s != null && s.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const d = qp(c) ? { ...c } : c;
      e.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => u.map((g) => r(f, h, g, d))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    o(), t();
  };
  return Et(t), a;
}
let Jf = !1;
function eh(n, e, t = {}) {
  const { window: r = on, ignore: i = [], capture: o = !0, detectIframe: a = !1, controls: s = !1 } = t;
  if (!r)
    return s ? { stop: lt, cancel: lt, trigger: lt } : lt;
  if (yl && !Jf) {
    Jf = !0;
    const v = { passive: !0 };
    Array.from(r.document.body.children).forEach((w) => Rt(w, "click", lt, v)), Rt(r.document.documentElement, "click", lt, v);
  }
  let l = !0;
  const u = (v) => pe(i).some((w) => {
    if (typeof w == "string")
      return Array.from(r.document.querySelectorAll(w)).some((y) => y === v.target || v.composedPath().includes(y));
    {
      const y = Xt(w);
      return y && (v.target === y || v.composedPath().includes(y));
    }
  });
  function c(v) {
    const w = pe(v);
    return w && w.$.subTree.shapeFlag === 16;
  }
  function d(v, w) {
    const y = pe(v), _ = y.$.subTree && y.$.subTree.children;
    return _ == null || !Array.isArray(_) ? !1 : _.some((b) => b.el === w.target || w.composedPath().includes(b.el));
  }
  const f = (v) => {
    const w = Xt(n);
    if (v.target != null && !(!(w instanceof Element) && c(n) && d(n, v)) && !(!w || w === v.target || v.composedPath().includes(w))) {
      if ("detail" in v && v.detail === 0 && (l = !u(v)), !l) {
        l = !0;
        return;
      }
      e(v);
    }
  };
  let h = !1;
  const g = [
    Rt(r, "click", (v) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), f(v));
    }, { passive: !0, capture: o }),
    Rt(r, "pointerdown", (v) => {
      const w = Xt(n);
      l = !u(v) && !!(w && !v.composedPath().includes(w));
    }, { passive: !0 }),
    a && Rt(r, "blur", (v) => {
      setTimeout(() => {
        var w;
        const y = Xt(n);
        ((w = r.document.activeElement) == null ? void 0 : w.tagName) === "IFRAME" && !(y != null && y.contains(r.document.activeElement)) && e(v);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), p = () => g.forEach((v) => v());
  return s ? {
    stop: p,
    cancel: () => {
      l = !1;
    },
    trigger: (v) => {
      l = !0, f(v), l = !1;
    }
  } : p;
}
const T2 = {
  mounted(n, e) {
    const t = !e.modifiers.bubble;
    if (typeof e.value == "function")
      n.__onClickOutside_stop = eh(n, e.value, { capture: t });
    else {
      const [r, i] = e.value;
      n.__onClickOutside_stop = eh(n, r, Object.assign({ capture: t }, i));
    }
  },
  unmounted(n) {
    n.__onClickOutside_stop();
  }
};
function Gb(n) {
  return typeof n == "function" ? n : typeof n == "string" ? (e) => e.key === n : Array.isArray(n) ? (e) => n.includes(e.key) : () => !0;
}
function th(...n) {
  let e, t, r = {};
  n.length === 3 ? (e = n[0], t = n[1], r = n[2]) : n.length === 2 ? typeof n[1] == "object" ? (e = !0, t = n[0], r = n[1]) : (e = n[0], t = n[1]) : (e = !0, t = n[0]);
  const {
    target: i = on,
    eventName: o = "keydown",
    passive: a = !1,
    dedupe: s = !1
  } = r, l = Gb(e);
  return Rt(i, o, (c) => {
    c.repeat && pe(s) || l(c) && t(c);
  }, a);
}
const S2 = {
  mounted(n, e) {
    var t, r;
    const i = (r = (t = e.arg) == null ? void 0 : t.split(",")) != null ? r : !0;
    if (typeof e.value == "function")
      th(i, e.value, {
        target: n
      });
    else {
      const [o, a] = e.value;
      th(i, o, {
        target: n,
        ...a
      });
    }
  }
};
function Yb() {
  const n = de(!1), e = Xl();
  return e && mt(() => {
    n.value = !0;
  }, e), n;
}
function Zb(n) {
  const e = Yb();
  return I(() => (e.value, !!n()));
}
function Xb(n, e, t = {}) {
  const { window: r = on, ...i } = t;
  let o;
  const a = Zb(() => r && "MutationObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = I(() => {
    const f = pe(n), h = er(f).map(Xt).filter(Lp);
    return new Set(h);
  }), u = Ae(
    () => l.value,
    (f) => {
      s(), a.value && f.size && (o = new MutationObserver(e), f.forEach((h) => o.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => o == null ? void 0 : o.takeRecords(), d = () => {
    u(), s();
  };
  return Et(d), {
    isSupported: a,
    stop: d,
    takeRecords: c
  };
}
function Kb(n, e, t = {}) {
  const {
    window: r = on,
    document: i = r == null ? void 0 : r.document,
    flush: o = "sync"
  } = t;
  if (!r || !i)
    return lt;
  let a;
  const s = (c) => {
    a == null || a(), a = c;
  }, l = ap(() => {
    const c = Xt(n);
    if (c) {
      const { stop: d } = Xb(
        i,
        (f) => {
          f.map((g) => [...g.removedNodes]).flat().some((g) => g === c || g.contains(c)) && e(f);
        },
        {
          window: r,
          childList: !0,
          subtree: !0
        }
      );
      s(d);
    }
  }, { flush: o }), u = () => {
    l(), s();
  };
  return Et(u), u;
}
function rh(n, e = {}) {
  const {
    delayEnter: t = 0,
    delayLeave: r = 0,
    triggerOnRemoval: i = !1,
    window: o = on
  } = e, a = de(!1);
  let s;
  const l = (u) => {
    const c = u ? t : r;
    s && (clearTimeout(s), s = void 0), c ? s = setTimeout(() => a.value = u, c) : a.value = u;
  };
  return o && (Rt(n, "mouseenter", () => l(!0), { passive: !0 }), Rt(n, "mouseleave", () => l(!1), { passive: !0 }), i && Kb(
    I(() => Xt(n)),
    () => l(!1)
  )), a;
}
const kl = {
  mounted(n, e) {
    const t = e.value;
    if (typeof t == "function") {
      const r = rh(n);
      Ae(r, (i) => t(i));
    } else {
      const [r, i] = t, o = rh(n, i);
      Ae(o, (a) => r(a));
    }
  }
};
function ys(n) {
  return typeof Window < "u" && n instanceof Window ? n.document.documentElement : typeof Document < "u" && n instanceof Document ? n.documentElement : n;
}
function Av(n) {
  const e = window.getComputedStyle(n);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && n.clientWidth < n.scrollWidth || e.overflowY === "auto" && n.clientHeight < n.scrollHeight)
    return !0;
  {
    const t = n.parentNode;
    return !t || t.tagName === "BODY" ? !1 : Av(t);
  }
}
function Qb(n) {
  const e = n || window.event, t = e.target;
  return Av(t) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const Cs = /* @__PURE__ */ new WeakMap();
function Jb(n, e = !1) {
  const t = de(e);
  let r = null, i = "";
  Ae(di(n), (s) => {
    const l = ys(pe(s));
    if (l) {
      const u = l;
      if (Cs.get(u) || Cs.set(u, u.style.overflow), u.style.overflow !== "hidden" && (i = u.style.overflow), u.style.overflow === "hidden")
        return t.value = !0;
      if (t.value)
        return u.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const o = () => {
    const s = ys(pe(n));
    !s || t.value || (yl && (r = Rt(
      s,
      "touchmove",
      (l) => {
        Qb(l);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", t.value = !0);
  }, a = () => {
    const s = ys(pe(n));
    !s || !t.value || (yl && (r == null || r()), s.style.overflow = i, Cs.delete(s), t.value = !1);
  };
  return Et(a), I({
    get() {
      return t.value;
    },
    set(s) {
      s ? o() : a();
    }
  });
}
function ey() {
  let n = !1;
  const e = de(!1);
  return (t, r) => {
    if (e.value = r.value, n)
      return;
    n = !0;
    const i = Jb(t, r.value);
    Ae(e, (o) => i.value = o);
  };
}
ey();
var ws, nh;
function ty() {
  if (nh) return ws;
  nh = 1;
  function n(e, t, r) {
    var i = -1, o = e.length;
    t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
    for (var a = Array(o); ++i < o; )
      a[i] = e[i + t];
    return a;
  }
  return ws = n, ws;
}
var Ts, ih;
function ry() {
  if (ih) return Ts;
  ih = 1;
  var n = ty();
  function e(t, r, i) {
    var o = t.length;
    return i = i === void 0 ? o : i, !r && i >= o ? t : n(t, r, i);
  }
  return Ts = e, Ts;
}
var Ss, oh;
function Ov() {
  if (oh) return Ss;
  oh = 1;
  var n = "\\ud800-\\udfff", e = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = e + t + r, o = "\\ufe0e\\ufe0f", a = "\\u200d", s = RegExp("[" + a + n + i + o + "]");
  function l(u) {
    return s.test(u);
  }
  return Ss = l, Ss;
}
var xs, ah;
function ny() {
  if (ah) return xs;
  ah = 1;
  function n(e) {
    return e.split("");
  }
  return xs = n, xs;
}
var As, sh;
function iy() {
  if (sh) return As;
  sh = 1;
  var n = "\\ud800-\\udfff", e = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = e + t + r, o = "\\ufe0e\\ufe0f", a = "[" + n + "]", s = "[" + i + "]", l = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + l + ")", c = "[^" + n + "]", d = "(?:\\ud83c[\\udde6-\\uddff]){2}", f = "[\\ud800-\\udbff][\\udc00-\\udfff]", h = "\\u200d", g = u + "?", p = "[" + o + "]?", v = "(?:" + h + "(?:" + [c, d, f].join("|") + ")" + p + g + ")*", w = p + g + v, y = "(?:" + [c + s + "?", s, d, f, a].join("|") + ")", _ = RegExp(l + "(?=" + l + ")|" + y + w, "g");
  function b(C) {
    return C.match(_) || [];
  }
  return As = b, As;
}
var Os, lh;
function oy() {
  if (lh) return Os;
  lh = 1;
  var n = ny(), e = Ov(), t = iy();
  function r(i) {
    return e(i) ? t(i) : n(i);
  }
  return Os = r, Os;
}
var Es, uh;
function ay() {
  if (uh) return Es;
  uh = 1;
  var n = ry(), e = Ov(), t = oy(), r = Wn();
  function i(o) {
    return function(a) {
      a = r(a);
      var s = e(a) ? t(a) : void 0, l = s ? s[0] : a.charAt(0), u = s ? n(s, 1).join("") : a.slice(1);
      return l[o]() + u;
    };
  }
  return Es = i, Es;
}
var Is, ch;
function sy() {
  if (ch) return Is;
  ch = 1;
  var n = ay(), e = n("toUpperCase");
  return Is = e, Is;
}
var Ns, dh;
function Ev() {
  if (dh) return Ns;
  dh = 1;
  var n = Wn(), e = sy();
  function t(r) {
    return e(n(r).toLowerCase());
  }
  return Ns = t, Ns;
}
var ks, fh;
function ly() {
  if (fh) return ks;
  fh = 1;
  function n(e, t, r, i) {
    var o = -1, a = e == null ? 0 : e.length;
    for (i && a && (r = e[++o]); ++o < a; )
      r = t(r, e[o], o, e);
    return r;
  }
  return ks = n, ks;
}
var Ds, hh;
function uy() {
  if (hh) return Ds;
  hh = 1;
  function n(e) {
    return function(t) {
      return e == null ? void 0 : e[t];
    };
  }
  return Ds = n, Ds;
}
var Rs, ph;
function cy() {
  if (ph) return Rs;
  ph = 1;
  var n = uy(), e = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, t = n(e);
  return Rs = t, Rs;
}
var Ps, vh;
function dy() {
  if (vh) return Ps;
  vh = 1;
  var n = cy(), e = Wn(), t = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, r = "\\u0300-\\u036f", i = "\\ufe20-\\ufe2f", o = "\\u20d0-\\u20ff", a = r + i + o, s = "[" + a + "]", l = RegExp(s, "g");
  function u(c) {
    return c = e(c), c && c.replace(t, n).replace(l, "");
  }
  return Ps = u, Ps;
}
var Ms, gh;
function fy() {
  if (gh) return Ms;
  gh = 1;
  var n = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function e(t) {
    return t.match(n) || [];
  }
  return Ms = e, Ms;
}
var Ls, mh;
function hy() {
  if (mh) return Ls;
  mh = 1;
  var n = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function e(t) {
    return n.test(t);
  }
  return Ls = e, Ls;
}
var qs, _h;
function py() {
  if (_h) return qs;
  _h = 1;
  var n = "\\ud800-\\udfff", e = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = e + t + r, o = "\\u2700-\\u27bf", a = "a-z\\xdf-\\xf6\\xf8-\\xff", s = "\\xac\\xb1\\xd7\\xf7", l = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", u = "\\u2000-\\u206f", c = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", d = "A-Z\\xc0-\\xd6\\xd8-\\xde", f = "\\ufe0e\\ufe0f", h = s + l + u + c, g = "['’]", p = "[" + h + "]", v = "[" + i + "]", w = "\\d+", y = "[" + o + "]", _ = "[" + a + "]", b = "[^" + n + h + w + o + a + d + "]", C = "\\ud83c[\\udffb-\\udfff]", m = "(?:" + v + "|" + C + ")", T = "[^" + n + "]", x = "(?:\\ud83c[\\udde6-\\uddff]){2}", A = "[\\ud800-\\udbff][\\udc00-\\udfff]", M = "[" + d + "]", O = "\\u200d", S = "(?:" + _ + "|" + b + ")", P = "(?:" + M + "|" + b + ")", k = "(?:" + g + "(?:d|ll|m|re|s|t|ve))?", E = "(?:" + g + "(?:D|LL|M|RE|S|T|VE))?", q = m + "?", H = "[" + f + "]?", z = "(?:" + O + "(?:" + [T, x, A].join("|") + ")" + H + q + ")*", ee = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", se = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ue = H + q + z, oe = "(?:" + [y, x, A].join("|") + ")" + ue, le = RegExp([
    M + "?" + _ + "+" + k + "(?=" + [p, M, "$"].join("|") + ")",
    P + "+" + E + "(?=" + [p, M + S, "$"].join("|") + ")",
    M + "?" + S + "+" + k,
    M + "+" + E,
    se,
    ee,
    w,
    oe
  ].join("|"), "g");
  function ce(be) {
    return be.match(le) || [];
  }
  return qs = ce, qs;
}
var Bs, bh;
function vy() {
  if (bh) return Bs;
  bh = 1;
  var n = fy(), e = hy(), t = Wn(), r = py();
  function i(o, a, s) {
    return o = t(o), a = s ? void 0 : a, a === void 0 ? e(o) ? r(o) : n(o) : o.match(a) || [];
  }
  return Bs = i, Bs;
}
var Us, yh;
function gy() {
  if (yh) return Us;
  yh = 1;
  var n = ly(), e = dy(), t = vy(), r = "['’]", i = RegExp(r, "g");
  function o(a) {
    return function(s) {
      return n(t(e(s).replace(i, "")), a, "");
    };
  }
  return Us = o, Us;
}
var js, Ch;
function my() {
  if (Ch) return js;
  Ch = 1;
  var n = Ev(), e = gy(), t = e(function(r, i, o) {
    return i = i.toLowerCase(), r + (o ? n(i) : i);
  });
  return js = t, js;
}
var _y = my();
const by = /* @__PURE__ */ Ht(_y), yy = {
  __name: "DefaultNodeIcon",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    groupType: {
      type: String,
      default: "",
      validator: (n) => ["layout", "content"].includes(n)
    }
  },
  setup(n) {
    const e = n, t = /* @__PURE__ */ Object.assign({
      "/src/assets/icons/nodes/AccordionIcon.vue": ib,
      "/src/assets/icons/nodes/ButtonIcon.vue": ab,
      "/src/assets/icons/nodes/CardIcon.vue": lb,
      "/src/assets/icons/nodes/EmbedIcon.vue": cb,
      "/src/assets/icons/nodes/FormIcon.vue": fb,
      "/src/assets/icons/nodes/FourColumnsIcon.vue": pb,
      "/src/assets/icons/nodes/FullWidthIcon.vue": gb,
      "/src/assets/icons/nodes/GalleryIcon.vue": _b,
      "/src/assets/icons/nodes/HeadingIcon.vue": yb,
      "/src/assets/icons/nodes/ImageIcon.vue": $1,
      "/src/assets/icons/nodes/LeftSidebarIcon.vue": wb,
      "/src/assets/icons/nodes/NavigationIcon.vue": Sb,
      "/src/assets/icons/nodes/OneColumnIcon.vue": Ab,
      "/src/assets/icons/nodes/QuoteIcon.vue": Eb,
      "/src/assets/icons/nodes/RightSidebarIcon.vue": Nb,
      "/src/assets/icons/nodes/SeparatorIcon.vue": Db,
      "/src/assets/icons/nodes/SliderIcon.vue": Pb,
      "/src/assets/icons/nodes/SpacerIcon.vue": Lb,
      "/src/assets/icons/nodes/TableIcon.vue": Bb,
      "/src/assets/icons/nodes/TextIcon.vue": jb,
      "/src/assets/icons/nodes/ThreeColumnsIcon.vue": $b,
      "/src/assets/icons/nodes/TwoColumnsIcon.vue": Vb,
      "/src/assets/icons/nodes/VideoIcon.vue": Wb
    }), r = I(() => {
      var l;
      const s = `/src/assets/icons/nodes/${e.node.icon}.vue`;
      return ((l = t[s]) == null ? void 0 : l.default) || null;
    }), i = I(
      () => `builder.${e.groupType}.${by(e.node.name)}.title`
    ), o = Q(!1), a = (s) => o.value = s;
    return (s, l) => yn((D(), U("div", {
      class: He(["block", n.groupType]),
      onDblclick: l[0] || (l[0] = (u) => s.$emit("add-node"))
    }, [
      (D(), G(si(r.value), {
        class: "icon",
        "is-hovering": o.value
      }, null, 8, ["is-hovering"])),
      R("p", { class: "node-name" }, K(s.$t(i.value)), 1)
    ], 34)), [
      [V(kl), a]
    ]);
  }
}, Cy = /* @__PURE__ */ X(yy, [["__scopeId", "data-v-00b6ed94"]]), wy = {};
function Ty(n, e) {
  return D(), U("div", { class: "pb-overlay" });
}
const Sy = /* @__PURE__ */ X(wy, [["render", Ty], ["__scopeId", "data-v-f6f53f85"]]);
function kt(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Iv(n, e) {
  n.prototype = Object.create(e.prototype), n.prototype.constructor = n, n.__proto__ = e;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var nt = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, Xr = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, Tu, Le, _e, ut = 1e8, he = 1 / ut, Dl = Math.PI * 2, xy = Dl / 4, Ay = 0, Nv = Math.sqrt, Oy = Math.cos, Ey = Math.sin, De = function(e) {
  return typeof e == "string";
}, Te = function(e) {
  return typeof e == "function";
}, Ut = function(e) {
  return typeof e == "number";
}, Su = function(e) {
  return typeof e > "u";
}, At = function(e) {
  return typeof e == "object";
}, We = function(e) {
  return e !== !1;
}, xu = function() {
  return typeof window < "u";
}, Jn = function(e) {
  return Te(e) || De(e);
}, kv = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, Ue = Array.isArray, Rl = /(?:-?\.?\d|\.)+/gi, Dv = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, jr = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Hs = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Rv = /[+-]=-?[.\d]+/, Pv = /[^,'"\[\]\s]+/gi, Iy = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, Ce, bt, Pl, Au, it = {}, hi = {}, Mv, Lv = function(e) {
  return (hi = Kr(e, it)) && Xe;
}, Ou = function(e, t) {
  return console.warn("Invalid property", e, "set to", t, "Missing plugin? gsap.registerPlugin()");
}, Mn = function(e, t) {
  return !t && console.warn(e);
}, qv = function(e, t) {
  return e && (it[e] = t) && hi && (hi[e] = t) || it;
}, Ln = function() {
  return 0;
}, Ny = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, ni = {
  suppressEvents: !0,
  kill: !1
}, ky = {
  suppressEvents: !0
}, Eu = {}, tr = [], Ml = {}, Bv, Ke = {}, $s = {}, wh = 30, ii = [], Iu = "", Nu = function(e) {
  var t = e[0], r, i;
  if (At(t) || Te(t) || (e = [e]), !(r = (t._gsap || {}).harness)) {
    for (i = ii.length; i-- && !ii[i].targetTest(t); )
      ;
    r = ii[i];
  }
  for (i = e.length; i--; )
    e[i] && (e[i]._gsap || (e[i]._gsap = new lg(e[i], r))) || e.splice(i, 1);
  return e;
}, Cr = function(e) {
  return e._gsap || Nu(ct(e))[0]._gsap;
}, Uv = function(e, t, r) {
  return (r = e[t]) && Te(r) ? e[t]() : Su(r) && e.getAttribute && e.getAttribute(t) || r;
}, Ge = function(e, t) {
  return (e = e.split(",")).forEach(t) || e;
}, xe = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, Ee = function(e) {
  return Math.round(e * 1e7) / 1e7 || 0;
}, Wr = function(e, t) {
  var r = t.charAt(0), i = parseFloat(t.substr(2));
  return e = parseFloat(e), r === "+" ? e + i : r === "-" ? e - i : r === "*" ? e * i : e / i;
}, Dy = function(e, t) {
  for (var r = t.length, i = 0; e.indexOf(t[i]) < 0 && ++i < r; )
    ;
  return i < r;
}, pi = function() {
  var e = tr.length, t = tr.slice(0), r, i;
  for (Ml = {}, tr.length = 0, r = 0; r < e; r++)
    i = t[r], i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
}, ku = function(e) {
  return !!(e._initted || e._startAt || e.add);
}, jv = function(e, t, r, i) {
  tr.length && !Le && pi(), e.render(t, r, !!(Le && t < 0 && ku(e))), tr.length && !Le && pi();
}, Hv = function(e) {
  var t = parseFloat(e);
  return (t || t === 0) && (e + "").match(Pv).length < 2 ? t : De(e) ? e.trim() : e;
}, $v = function(e) {
  return e;
}, ot = function(e, t) {
  for (var r in t)
    r in e || (e[r] = t[r]);
  return e;
}, Ry = function(e) {
  return function(t, r) {
    for (var i in r)
      i in t || i === "duration" && e || i === "ease" || (t[i] = r[i]);
  };
}, Kr = function(e, t) {
  for (var r in t)
    e[r] = t[r];
  return e;
}, Th = function n(e, t) {
  for (var r in t)
    r !== "__proto__" && r !== "constructor" && r !== "prototype" && (e[r] = At(t[r]) ? n(e[r] || (e[r] = {}), t[r]) : t[r]);
  return e;
}, vi = function(e, t) {
  var r = {}, i;
  for (i in e)
    i in t || (r[i] = e[i]);
  return r;
}, mn = function(e) {
  var t = e.parent || Ce, r = e.keyframes ? Ry(Ue(e.keyframes)) : ot;
  if (We(e.inherit))
    for (; t; )
      r(e, t.vars.defaults), t = t.parent || t._dp;
  return e;
}, Py = function(e, t) {
  for (var r = e.length, i = r === t.length; i && r-- && e[r] === t[r]; )
    ;
  return r < 0;
}, Fv = function(e, t, r, i, o) {
  var a = e[i], s;
  if (o)
    for (s = t[o]; a && a[o] > s; )
      a = a._prev;
  return a ? (t._next = a._next, a._next = t) : (t._next = e[r], e[r] = t), t._next ? t._next._prev = t : e[i] = t, t._prev = a, t.parent = t._dp = e, t;
}, Li = function(e, t, r, i) {
  r === void 0 && (r = "_first"), i === void 0 && (i = "_last");
  var o = t._prev, a = t._next;
  o ? o._next = a : e[r] === t && (e[r] = a), a ? a._prev = o : e[i] === t && (e[i] = o), t._next = t._prev = t.parent = null;
}, or = function(e, t) {
  e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, wr = function(e, t) {
  if (e && (!t || t._end > e._dur || t._start < 0))
    for (var r = e; r; )
      r._dirty = 1, r = r.parent;
  return e;
}, My = function(e) {
  for (var t = e.parent; t && t.parent; )
    t._dirty = 1, t.totalDuration(), t = t.parent;
  return e;
}, Ll = function(e, t, r, i) {
  return e._startAt && (Le ? e._startAt.revert(ni) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(t, !0, i));
}, Ly = function n(e) {
  return !e || e._ts && n(e.parent);
}, Sh = function(e) {
  return e._repeat ? Qr(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, Qr = function(e, t) {
  var r = Math.floor(e = Ee(e / t));
  return e && r === e ? r - 1 : r;
}, gi = function(e, t) {
  return (e - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
}, qi = function(e) {
  return e._end = Ee(e._start + (e._tDur / Math.abs(e._ts || e._rts || he) || 0));
}, Bi = function(e, t) {
  var r = e._dp;
  return r && r.smoothChildTiming && e._ts && (e._start = Ee(r._time - (e._ts > 0 ? t / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)), qi(e), r._dirty || wr(r, e)), e;
}, Vv = function(e, t) {
  var r;
  if ((t._time || !t._dur && t._initted || t._start < e._time && (t._dur || !t.add)) && (r = gi(e.rawTime(), t), (!t._dur || Gn(0, t.totalDuration(), r) - t._tTime > he) && t.render(r, !0)), wr(e, t)._dp && e._initted && e._time >= e._dur && e._ts) {
    if (e._dur < e.duration())
      for (r = e; r._dp; )
        r.rawTime() >= 0 && r.totalTime(r._tTime), r = r._dp;
    e._zTime = -he;
  }
}, Ct = function(e, t, r, i) {
  return t.parent && or(t), t._start = Ee((Ut(r) ? r : r || e !== Ce ? st(e, r, t) : e._time) + t._delay), t._end = Ee(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)), Fv(e, t, "_first", "_last", e._sort ? "_start" : 0), ql(t) || (e._recent = t), i || Vv(e, t), e._ts < 0 && Bi(e, e._tTime), e;
}, zv = function(e, t) {
  return (it.ScrollTrigger || Ou("scrollTrigger", t)) && it.ScrollTrigger.create(t, e);
}, Wv = function(e, t, r, i, o) {
  if (Ru(e, t, o), !e._initted)
    return 1;
  if (!r && e._pt && !Le && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && Bv !== Je.frame)
    return tr.push(e), e._lazy = [o, i], 1;
}, qy = function n(e) {
  var t = e.parent;
  return t && t._ts && t._initted && !t._lock && (t.rawTime() < 0 || n(t));
}, ql = function(e) {
  var t = e.data;
  return t === "isFromStart" || t === "isStart";
}, By = function(e, t, r, i) {
  var o = e.ratio, a = t < 0 || !t && (!e._start && qy(e) && !(!e._initted && ql(e)) || (e._ts < 0 || e._dp._ts < 0) && !ql(e)) ? 0 : 1, s = e._rDelay, l = 0, u, c, d;
  if (s && e._repeat && (l = Gn(0, e._tDur, t), c = Qr(l, s), e._yoyo && c & 1 && (a = 1 - a), c !== Qr(e._tTime, s) && (o = 1 - a, e.vars.repeatRefresh && e._initted && e.invalidate())), a !== o || Le || i || e._zTime === he || !t && e._zTime) {
    if (!e._initted && Wv(e, t, i, r, l))
      return;
    for (d = e._zTime, e._zTime = t || (r ? he : 0), r || (r = t && !d), e.ratio = a, e._from && (a = 1 - a), e._time = 0, e._tTime = l, u = e._pt; u; )
      u.r(a, u.d), u = u._next;
    t < 0 && Ll(e, t, r, !0), e._onUpdate && !r && et(e, "onUpdate"), l && e._repeat && !r && e.parent && et(e, "onRepeat"), (t >= e._tDur || t < 0) && e.ratio === a && (a && or(e, 1), !r && !Le && (et(e, a ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
  } else e._zTime || (e._zTime = t);
}, Uy = function(e, t, r) {
  var i;
  if (r > t)
    for (i = e._first; i && i._start <= r; ) {
      if (i.data === "isPause" && i._start > t)
        return i;
      i = i._next;
    }
  else
    for (i = e._last; i && i._start >= r; ) {
      if (i.data === "isPause" && i._start < t)
        return i;
      i = i._prev;
    }
}, Jr = function(e, t, r, i) {
  var o = e._repeat, a = Ee(t) || 0, s = e._tTime / e._tDur;
  return s && !i && (e._time *= a / e._dur), e._dur = a, e._tDur = o ? o < 0 ? 1e10 : Ee(a * (o + 1) + e._rDelay * o) : a, s > 0 && !i && Bi(e, e._tTime = e._tDur * s), e.parent && qi(e), r || wr(e.parent, e), e;
}, xh = function(e) {
  return e instanceof je ? wr(e) : Jr(e, e._dur);
}, jy = {
  _start: 0,
  endTime: Ln,
  totalDuration: Ln
}, st = function n(e, t, r) {
  var i = e.labels, o = e._recent || jy, a = e.duration() >= ut ? o.endTime(!1) : e._dur, s, l, u;
  return De(t) && (isNaN(t) || t in i) ? (l = t.charAt(0), u = t.substr(-1) === "%", s = t.indexOf("="), l === "<" || l === ">" ? (s >= 0 && (t = t.replace(/=/, "")), (l === "<" ? o._start : o.endTime(o._repeat >= 0)) + (parseFloat(t.substr(1)) || 0) * (u ? (s < 0 ? o : r).totalDuration() / 100 : 1)) : s < 0 ? (t in i || (i[t] = a), i[t]) : (l = parseFloat(t.charAt(s - 1) + t.substr(s + 1)), u && r && (l = l / 100 * (Ue(r) ? r[0] : r).totalDuration()), s > 1 ? n(e, t.substr(0, s - 1), r) + l : a + l)) : t == null ? a : +t;
}, _n = function(e, t, r) {
  var i = Ut(t[1]), o = (i ? 2 : 1) + (e < 2 ? 0 : 1), a = t[o], s, l;
  if (i && (a.duration = t[1]), a.parent = r, e) {
    for (s = a, l = r; l && !("immediateRender" in s); )
      s = l.vars.defaults || {}, l = We(l.vars.inherit) && l.parent;
    a.immediateRender = We(s.immediateRender), e < 2 ? a.runBackwards = 1 : a.startAt = t[o - 1];
  }
  return new Oe(t[0], a, t[o + 1]);
}, ur = function(e, t) {
  return e || e === 0 ? t(e) : t;
}, Gn = function(e, t, r) {
  return r < e ? e : r > t ? t : r;
}, Be = function(e, t) {
  return !De(e) || !(t = Iy.exec(e)) ? "" : t[1];
}, Hy = function(e, t, r) {
  return ur(r, function(i) {
    return Gn(e, t, i);
  });
}, Bl = [].slice, Gv = function(e, t) {
  return e && At(e) && "length" in e && (!t && !e.length || e.length - 1 in e && At(e[0])) && !e.nodeType && e !== bt;
}, $y = function(e, t, r) {
  return r === void 0 && (r = []), e.forEach(function(i) {
    var o;
    return De(i) && !t || Gv(i, 1) ? (o = r).push.apply(o, ct(i)) : r.push(i);
  }) || r;
}, ct = function(e, t, r) {
  return _e && !t && _e.selector ? _e.selector(e) : De(e) && !r && (Pl || !en()) ? Bl.call((t || Au).querySelectorAll(e), 0) : Ue(e) ? $y(e, r) : Gv(e) ? Bl.call(e, 0) : e ? [e] : [];
}, Ul = function(e) {
  return e = ct(e)[0] || Mn("Invalid scope") || {}, function(t) {
    var r = e.current || e.nativeElement || e;
    return ct(t, r.querySelectorAll ? r : r === e ? Mn("Invalid scope") || Au.createElement("div") : e);
  };
}, Yv = function(e) {
  return e.sort(function() {
    return 0.5 - Math.random();
  });
}, Zv = function(e) {
  if (Te(e))
    return e;
  var t = At(e) ? e : {
    each: e
  }, r = Tr(t.ease), i = t.from || 0, o = parseFloat(t.base) || 0, a = {}, s = i > 0 && i < 1, l = isNaN(i) || s, u = t.axis, c = i, d = i;
  return De(i) ? c = d = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[i] || 0 : !s && l && (c = i[0], d = i[1]), function(f, h, g) {
    var p = (g || t).length, v = a[p], w, y, _, b, C, m, T, x, A;
    if (!v) {
      if (A = t.grid === "auto" ? 0 : (t.grid || [1, ut])[1], !A) {
        for (T = -ut; T < (T = g[A++].getBoundingClientRect().left) && A < p; )
          ;
        A < p && A--;
      }
      for (v = a[p] = [], w = l ? Math.min(A, p) * c - 0.5 : i % A, y = A === ut ? 0 : l ? p * d / A - 0.5 : i / A | 0, T = 0, x = ut, m = 0; m < p; m++)
        _ = m % A - w, b = y - (m / A | 0), v[m] = C = u ? Math.abs(u === "y" ? b : _) : Nv(_ * _ + b * b), C > T && (T = C), C < x && (x = C);
      i === "random" && Yv(v), v.max = T - x, v.min = x, v.v = p = (parseFloat(t.amount) || parseFloat(t.each) * (A > p ? p - 1 : u ? u === "y" ? p / A : A : Math.max(A, p / A)) || 0) * (i === "edges" ? -1 : 1), v.b = p < 0 ? o - p : o, v.u = Be(t.amount || t.each) || 0, r = r && p < 0 ? og(r) : r;
    }
    return p = (v[f] - v.min) / v.max || 0, Ee(v.b + (r ? r(p) : p) * v.v) + v.u;
  };
}, jl = function(e) {
  var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
  return function(r) {
    var i = Ee(Math.round(parseFloat(r) / e) * e * t);
    return (i - i % 1) / t + (Ut(r) ? 0 : Be(r));
  };
}, Xv = function(e, t) {
  var r = Ue(e), i, o;
  return !r && At(e) && (i = r = e.radius || ut, e.values ? (e = ct(e.values), (o = !Ut(e[0])) && (i *= i)) : e = jl(e.increment)), ur(t, r ? Te(e) ? function(a) {
    return o = e(a), Math.abs(o - a) <= i ? o : a;
  } : function(a) {
    for (var s = parseFloat(o ? a.x : a), l = parseFloat(o ? a.y : 0), u = ut, c = 0, d = e.length, f, h; d--; )
      o ? (f = e[d].x - s, h = e[d].y - l, f = f * f + h * h) : f = Math.abs(e[d] - s), f < u && (u = f, c = d);
    return c = !i || u <= i ? e[c] : a, o || c === a || Ut(a) ? c : c + Be(a);
  } : jl(e));
}, Kv = function(e, t, r, i) {
  return ur(Ue(e) ? !t : r === !0 ? !!(r = 0) : !i, function() {
    return Ue(e) ? e[~~(Math.random() * e.length)] : (r = r || 1e-5) && (i = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) && Math.floor(Math.round((e - r / 2 + Math.random() * (t - e + r * 0.99)) / r) * r * i) / i;
  });
}, Fy = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(i) {
    return t.reduce(function(o, a) {
      return a(o);
    }, i);
  };
}, Vy = function(e, t) {
  return function(r) {
    return e(parseFloat(r)) + (t || Be(r));
  };
}, zy = function(e, t, r) {
  return Jv(e, t, 0, 1, r);
}, Qv = function(e, t, r) {
  return ur(r, function(i) {
    return e[~~t(i)];
  });
}, Wy = function n(e, t, r) {
  var i = t - e;
  return Ue(e) ? Qv(e, n(0, e.length), t) : ur(r, function(o) {
    return (i + (o - e) % i) % i + e;
  });
}, Gy = function n(e, t, r) {
  var i = t - e, o = i * 2;
  return Ue(e) ? Qv(e, n(0, e.length - 1), t) : ur(r, function(a) {
    return a = (o + (a - e) % o) % o || 0, e + (a > i ? o - a : a);
  });
}, qn = function(e) {
  for (var t = 0, r = "", i, o, a, s; ~(i = e.indexOf("random(", t)); )
    a = e.indexOf(")", i), s = e.charAt(i + 7) === "[", o = e.substr(i + 7, a - i - 7).match(s ? Pv : Rl), r += e.substr(t, i - t) + Kv(s ? o : +o[0], s ? 0 : +o[1], +o[2] || 1e-5), t = a + 1;
  return r + e.substr(t, e.length - t);
}, Jv = function(e, t, r, i, o) {
  var a = t - e, s = i - r;
  return ur(o, function(l) {
    return r + ((l - e) / a * s || 0);
  });
}, Yy = function n(e, t, r, i) {
  var o = isNaN(e + t) ? 0 : function(h) {
    return (1 - h) * e + h * t;
  };
  if (!o) {
    var a = De(e), s = {}, l, u, c, d, f;
    if (r === !0 && (i = 1) && (r = null), a)
      e = {
        p: e
      }, t = {
        p: t
      };
    else if (Ue(e) && !Ue(t)) {
      for (c = [], d = e.length, f = d - 2, u = 1; u < d; u++)
        c.push(n(e[u - 1], e[u]));
      d--, o = function(g) {
        g *= d;
        var p = Math.min(f, ~~g);
        return c[p](g - p);
      }, r = t;
    } else i || (e = Kr(Ue(e) ? [] : {}, e));
    if (!c) {
      for (l in t)
        Du.call(s, e, l, "get", t[l]);
      o = function(g) {
        return Lu(g, s) || (a ? e.p : e);
      };
    }
  }
  return ur(r, o);
}, Ah = function(e, t, r) {
  var i = e.labels, o = ut, a, s, l;
  for (a in i)
    s = i[a] - t, s < 0 == !!r && s && o > (s = Math.abs(s)) && (l = a, o = s);
  return l;
}, et = function(e, t, r) {
  var i = e.vars, o = i[t], a = _e, s = e._ctx, l, u, c;
  if (o)
    return l = i[t + "Params"], u = i.callbackScope || e, r && tr.length && pi(), s && (_e = s), c = l ? o.apply(u, l) : o.call(u), _e = a, c;
}, pn = function(e) {
  return or(e), e.scrollTrigger && e.scrollTrigger.kill(!!Le), e.progress() < 1 && et(e, "onInterrupt"), e;
}, Hr, eg = [], tg = function(e) {
  if (e)
    if (e = !e.name && e.default || e, xu() || e.headless) {
      var t = e.name, r = Te(e), i = t && !r && e.init ? function() {
        this._props = [];
      } : e, o = {
        init: Ln,
        render: Lu,
        add: Du,
        kill: cC,
        modifier: uC,
        rawVars: 0
      }, a = {
        targetTest: 0,
        get: 0,
        getSetter: Mu,
        aliases: {},
        register: 0
      };
      if (en(), e !== i) {
        if (Ke[t])
          return;
        ot(i, ot(vi(e, o), a)), Kr(i.prototype, Kr(o, vi(e, a))), Ke[i.prop = t] = i, e.targetTest && (ii.push(i), Eu[t] = 1), t = (t === "css" ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin";
      }
      qv(t, i), e.register && e.register(Xe, i, Ye);
    } else
      eg.push(e);
}, fe = 255, vn = {
  aqua: [0, fe, fe],
  lime: [0, fe, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, fe],
  navy: [0, 0, 128],
  white: [fe, fe, fe],
  olive: [128, 128, 0],
  yellow: [fe, fe, 0],
  orange: [fe, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [fe, 0, 0],
  pink: [fe, 192, 203],
  cyan: [0, fe, fe],
  transparent: [fe, fe, fe, 0]
}, Fs = function(e, t, r) {
  return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? t + (r - t) * e * 6 : e < 0.5 ? r : e * 3 < 2 ? t + (r - t) * (2 / 3 - e) * 6 : t) * fe + 0.5 | 0;
}, rg = function(e, t, r) {
  var i = e ? Ut(e) ? [e >> 16, e >> 8 & fe, e & fe] : 0 : vn.black, o, a, s, l, u, c, d, f, h, g;
  if (!i) {
    if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), vn[e])
      i = vn[e];
    else if (e.charAt(0) === "#") {
      if (e.length < 6 && (o = e.charAt(1), a = e.charAt(2), s = e.charAt(3), e = "#" + o + o + a + a + s + s + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9)
        return i = parseInt(e.substr(1, 6), 16), [i >> 16, i >> 8 & fe, i & fe, parseInt(e.substr(7), 16) / 255];
      e = parseInt(e.substr(1), 16), i = [e >> 16, e >> 8 & fe, e & fe];
    } else if (e.substr(0, 3) === "hsl") {
      if (i = g = e.match(Rl), !t)
        l = +i[0] % 360 / 360, u = +i[1] / 100, c = +i[2] / 100, a = c <= 0.5 ? c * (u + 1) : c + u - c * u, o = c * 2 - a, i.length > 3 && (i[3] *= 1), i[0] = Fs(l + 1 / 3, o, a), i[1] = Fs(l, o, a), i[2] = Fs(l - 1 / 3, o, a);
      else if (~e.indexOf("="))
        return i = e.match(Dv), r && i.length < 4 && (i[3] = 1), i;
    } else
      i = e.match(Rl) || vn.transparent;
    i = i.map(Number);
  }
  return t && !g && (o = i[0] / fe, a = i[1] / fe, s = i[2] / fe, d = Math.max(o, a, s), f = Math.min(o, a, s), c = (d + f) / 2, d === f ? l = u = 0 : (h = d - f, u = c > 0.5 ? h / (2 - d - f) : h / (d + f), l = d === o ? (a - s) / h + (a < s ? 6 : 0) : d === a ? (s - o) / h + 2 : (o - a) / h + 4, l *= 60), i[0] = ~~(l + 0.5), i[1] = ~~(u * 100 + 0.5), i[2] = ~~(c * 100 + 0.5)), r && i.length < 4 && (i[3] = 1), i;
}, ng = function(e) {
  var t = [], r = [], i = -1;
  return e.split(rr).forEach(function(o) {
    var a = o.match(jr) || [];
    t.push.apply(t, a), r.push(i += a.length + 1);
  }), t.c = r, t;
}, Oh = function(e, t, r) {
  var i = "", o = (e + i).match(rr), a = t ? "hsla(" : "rgba(", s = 0, l, u, c, d;
  if (!o)
    return e;
  if (o = o.map(function(f) {
    return (f = rg(f, t, 1)) && a + (t ? f[0] + "," + f[1] + "%," + f[2] + "%," + f[3] : f.join(",")) + ")";
  }), r && (c = ng(e), l = r.c, l.join(i) !== c.c.join(i)))
    for (u = e.replace(rr, "1").split(jr), d = u.length - 1; s < d; s++)
      i += u[s] + (~l.indexOf(s) ? o.shift() || a + "0,0,0,0)" : (c.length ? c : o.length ? o : r).shift());
  if (!u)
    for (u = e.split(rr), d = u.length - 1; s < d; s++)
      i += u[s] + o[s];
  return i + u[d];
}, rr = function() {
  var n = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in vn)
    n += "|" + e + "\\b";
  return new RegExp(n + ")", "gi");
}(), Zy = /hsl[a]?\(/, ig = function(e) {
  var t = e.join(" "), r;
  if (rr.lastIndex = 0, rr.test(t))
    return r = Zy.test(t), e[1] = Oh(e[1], r), e[0] = Oh(e[0], r, ng(e[1])), !0;
}, Bn, Je = function() {
  var n = Date.now, e = 500, t = 33, r = n(), i = r, o = 1e3 / 240, a = o, s = [], l, u, c, d, f, h, g = function p(v) {
    var w = n() - i, y = v === !0, _, b, C, m;
    if ((w > e || w < 0) && (r += w - t), i += w, C = i - r, _ = C - a, (_ > 0 || y) && (m = ++d.frame, f = C - d.time * 1e3, d.time = C = C / 1e3, a += _ + (_ >= o ? 4 : o - _), b = 1), y || (l = u(p)), b)
      for (h = 0; h < s.length; h++)
        s[h](C, f, m, v);
  };
  return d = {
    time: 0,
    frame: 0,
    tick: function() {
      g(!0);
    },
    deltaRatio: function(v) {
      return f / (1e3 / (v || 60));
    },
    wake: function() {
      Mv && (!Pl && xu() && (bt = Pl = window, Au = bt.document || {}, it.gsap = Xe, (bt.gsapVersions || (bt.gsapVersions = [])).push(Xe.version), Lv(hi || bt.GreenSockGlobals || !bt.gsap && bt || {}), eg.forEach(tg)), c = typeof requestAnimationFrame < "u" && requestAnimationFrame, l && d.sleep(), u = c || function(v) {
        return setTimeout(v, a - d.time * 1e3 + 1 | 0);
      }, Bn = 1, g(2));
    },
    sleep: function() {
      (c ? cancelAnimationFrame : clearTimeout)(l), Bn = 0, u = Ln;
    },
    lagSmoothing: function(v, w) {
      e = v || 1 / 0, t = Math.min(w || 33, e);
    },
    fps: function(v) {
      o = 1e3 / (v || 240), a = d.time * 1e3 + o;
    },
    add: function(v, w, y) {
      var _ = w ? function(b, C, m, T) {
        v(b, C, m, T), d.remove(_);
      } : v;
      return d.remove(v), s[y ? "unshift" : "push"](_), en(), _;
    },
    remove: function(v, w) {
      ~(w = s.indexOf(v)) && s.splice(w, 1) && h >= w && h--;
    },
    _listeners: s
  }, d;
}(), en = function() {
  return !Bn && Je.wake();
}, ne = {}, Xy = /^[\d.\-M][\d.\-,\s]/, Ky = /["']/g, Qy = function(e) {
  for (var t = {}, r = e.substr(1, e.length - 3).split(":"), i = r[0], o = 1, a = r.length, s, l, u; o < a; o++)
    l = r[o], s = o !== a - 1 ? l.lastIndexOf(",") : l.length, u = l.substr(0, s), t[i] = isNaN(u) ? u.replace(Ky, "").trim() : +u, i = l.substr(s + 1).trim();
  return t;
}, Jy = function(e) {
  var t = e.indexOf("(") + 1, r = e.indexOf(")"), i = e.indexOf("(", t);
  return e.substring(t, ~i && i < r ? e.indexOf(")", r + 1) : r);
}, eC = function(e) {
  var t = (e + "").split("("), r = ne[t[0]];
  return r && t.length > 1 && r.config ? r.config.apply(null, ~e.indexOf("{") ? [Qy(t[1])] : Jy(e).split(",").map(Hv)) : ne._CE && Xy.test(e) ? ne._CE("", e) : r;
}, og = function(e) {
  return function(t) {
    return 1 - e(1 - t);
  };
}, ag = function n(e, t) {
  for (var r = e._first, i; r; )
    r instanceof je ? n(r, t) : r.vars.yoyoEase && (!r._yoyo || !r._repeat) && r._yoyo !== t && (r.timeline ? n(r.timeline, t) : (i = r._ease, r._ease = r._yEase, r._yEase = i, r._yoyo = t)), r = r._next;
}, Tr = function(e, t) {
  return e && (Te(e) ? e : ne[e] || eC(e)) || t;
}, kr = function(e, t, r, i) {
  r === void 0 && (r = function(l) {
    return 1 - t(1 - l);
  }), i === void 0 && (i = function(l) {
    return l < 0.5 ? t(l * 2) / 2 : 1 - t((1 - l) * 2) / 2;
  });
  var o = {
    easeIn: t,
    easeOut: r,
    easeInOut: i
  }, a;
  return Ge(e, function(s) {
    ne[s] = it[s] = o, ne[a = s.toLowerCase()] = r;
    for (var l in o)
      ne[a + (l === "easeIn" ? ".in" : l === "easeOut" ? ".out" : ".inOut")] = ne[s + "." + l] = o[l];
  }), o;
}, sg = function(e) {
  return function(t) {
    return t < 0.5 ? (1 - e(1 - t * 2)) / 2 : 0.5 + e((t - 0.5) * 2) / 2;
  };
}, Vs = function n(e, t, r) {
  var i = t >= 1 ? t : 1, o = (r || (e ? 0.3 : 0.45)) / (t < 1 ? t : 1), a = o / Dl * (Math.asin(1 / i) || 0), s = function(c) {
    return c === 1 ? 1 : i * Math.pow(2, -10 * c) * Ey((c - a) * o) + 1;
  }, l = e === "out" ? s : e === "in" ? function(u) {
    return 1 - s(1 - u);
  } : sg(s);
  return o = Dl / o, l.config = function(u, c) {
    return n(e, u, c);
  }, l;
}, zs = function n(e, t) {
  t === void 0 && (t = 1.70158);
  var r = function(a) {
    return a ? --a * a * ((t + 1) * a + t) + 1 : 0;
  }, i = e === "out" ? r : e === "in" ? function(o) {
    return 1 - r(1 - o);
  } : sg(r);
  return i.config = function(o) {
    return n(e, o);
  }, i;
};
Ge("Linear,Quad,Cubic,Quart,Quint,Strong", function(n, e) {
  var t = e < 5 ? e + 1 : e;
  kr(n + ",Power" + (t - 1), e ? function(r) {
    return Math.pow(r, t);
  } : function(r) {
    return r;
  }, function(r) {
    return 1 - Math.pow(1 - r, t);
  }, function(r) {
    return r < 0.5 ? Math.pow(r * 2, t) / 2 : 1 - Math.pow((1 - r) * 2, t) / 2;
  });
});
ne.Linear.easeNone = ne.none = ne.Linear.easeIn;
kr("Elastic", Vs("in"), Vs("out"), Vs());
(function(n, e) {
  var t = 1 / e, r = 2 * t, i = 2.5 * t, o = function(s) {
    return s < t ? n * s * s : s < r ? n * Math.pow(s - 1.5 / e, 2) + 0.75 : s < i ? n * (s -= 2.25 / e) * s + 0.9375 : n * Math.pow(s - 2.625 / e, 2) + 0.984375;
  };
  kr("Bounce", function(a) {
    return 1 - o(1 - a);
  }, o);
})(7.5625, 2.75);
kr("Expo", function(n) {
  return Math.pow(2, 10 * (n - 1)) * n + n * n * n * n * n * n * (1 - n);
});
kr("Circ", function(n) {
  return -(Nv(1 - n * n) - 1);
});
kr("Sine", function(n) {
  return n === 1 ? 1 : -Oy(n * xy) + 1;
});
kr("Back", zs("in"), zs("out"), zs());
ne.SteppedEase = ne.steps = it.SteppedEase = {
  config: function(e, t) {
    e === void 0 && (e = 1);
    var r = 1 / e, i = e + (t ? 0 : 1), o = t ? 1 : 0, a = 1 - he;
    return function(s) {
      return ((i * Gn(0, a, s) | 0) + o) * r;
    };
  }
};
Xr.ease = ne["quad.out"];
Ge("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(n) {
  return Iu += n + "," + n + "Params,";
});
var lg = function(e, t) {
  this.id = Ay++, e._gsap = this, this.target = e, this.harness = t, this.get = t ? t.get : Uv, this.set = t ? t.getSetter : Mu;
}, Un = /* @__PURE__ */ function() {
  function n(t) {
    this.vars = t, this._delay = +t.delay || 0, (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && (this._rDelay = t.repeatDelay || 0, this._yoyo = !!t.yoyo || !!t.yoyoEase), this._ts = 1, Jr(this, +t.duration, 1, 1), this.data = t.data, _e && (this._ctx = _e, _e.data.push(this)), Bn || Je.wake();
  }
  var e = n.prototype;
  return e.delay = function(r) {
    return r || r === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + r - this._delay), this._delay = r, this) : this._delay;
  }, e.duration = function(r) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? r + (r + this._rDelay) * this._repeat : r) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(r) {
    return arguments.length ? (this._dirty = 0, Jr(this, this._repeat < 0 ? r : (r - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(r, i) {
    if (en(), !arguments.length)
      return this._tTime;
    var o = this._dp;
    if (o && o.smoothChildTiming && this._ts) {
      for (Bi(this, r), !o._dp || o.parent || Vv(o, this); o && o.parent; )
        o.parent._time !== o._start + (o._ts >= 0 ? o._tTime / o._ts : (o.totalDuration() - o._tTime) / -o._ts) && o.totalTime(o._tTime, !0), o = o.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && r < this._tDur || this._ts < 0 && r > 0 || !this._tDur && !r) && Ct(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== r || !this._dur && !i || this._initted && Math.abs(this._zTime) === he || !r && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = r), jv(this, r, i)), this;
  }, e.time = function(r, i) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), r + Sh(this)) % (this._dur + this._rDelay) || (r ? this._dur : 0), i) : this._time;
  }, e.totalProgress = function(r, i) {
    return arguments.length ? this.totalTime(this.totalDuration() * r, i) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, e.progress = function(r, i) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - r : r) + Sh(this), i) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(r, i) {
    var o = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (r - 1) * o, i) : this._repeat ? Qr(this._tTime, o) + 1 : 1;
  }, e.timeScale = function(r, i) {
    if (!arguments.length)
      return this._rts === -he ? 0 : this._rts;
    if (this._rts === r)
      return this;
    var o = this.parent && this._ts ? gi(this.parent._time, this) : this._tTime;
    return this._rts = +r || 0, this._ts = this._ps || r === -he ? 0 : this._rts, this.totalTime(Gn(-Math.abs(this._delay), this.totalDuration(), o), i !== !1), qi(this), My(this);
  }, e.paused = function(r) {
    return arguments.length ? (this._ps !== r && (this._ps = r, r ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (en(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== he && (this._tTime -= he)))), this) : this._ps;
  }, e.startTime = function(r) {
    if (arguments.length) {
      this._start = r;
      var i = this.parent || this._dp;
      return i && (i._sort || !this.parent) && Ct(i, this, r - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(r) {
    return this._start + (We(r) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(r) {
    var i = this.parent || this._dp;
    return i ? r && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? gi(i.rawTime(r), this) : this._tTime : this._tTime;
  }, e.revert = function(r) {
    r === void 0 && (r = ky);
    var i = Le;
    return Le = r, ku(this) && (this.timeline && this.timeline.revert(r), this.totalTime(-0.01, r.suppressEvents)), this.data !== "nested" && r.kill !== !1 && this.kill(), Le = i, this;
  }, e.globalTime = function(r) {
    for (var i = this, o = arguments.length ? r : i.rawTime(); i; )
      o = i._start + o / (Math.abs(i._ts) || 1), i = i._dp;
    return !this.parent && this._sat ? this._sat.globalTime(r) : o;
  }, e.repeat = function(r) {
    return arguments.length ? (this._repeat = r === 1 / 0 ? -2 : r, xh(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(r) {
    if (arguments.length) {
      var i = this._time;
      return this._rDelay = r, xh(this), i ? this.time(i) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(r) {
    return arguments.length ? (this._yoyo = r, this) : this._yoyo;
  }, e.seek = function(r, i) {
    return this.totalTime(st(this, r), We(i));
  }, e.restart = function(r, i) {
    return this.play().totalTime(r ? -this._delay : 0, We(i)), this._dur || (this._zTime = -he), this;
  }, e.play = function(r, i) {
    return r != null && this.seek(r, i), this.reversed(!1).paused(!1);
  }, e.reverse = function(r, i) {
    return r != null && this.seek(r || this.totalDuration(), i), this.reversed(!0).paused(!1);
  }, e.pause = function(r, i) {
    return r != null && this.seek(r, i), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(r) {
    return arguments.length ? (!!r !== this.reversed() && this.timeScale(-this._rts || (r ? -he : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -he, this;
  }, e.isActive = function() {
    var r = this.parent || this._dp, i = this._start, o;
    return !!(!r || this._ts && this._initted && r.isActive() && (o = r.rawTime(!0)) >= i && o < this.endTime(!0) - he);
  }, e.eventCallback = function(r, i, o) {
    var a = this.vars;
    return arguments.length > 1 ? (i ? (a[r] = i, o && (a[r + "Params"] = o), r === "onUpdate" && (this._onUpdate = i)) : delete a[r], this) : a[r];
  }, e.then = function(r) {
    var i = this;
    return new Promise(function(o) {
      var a = Te(r) ? r : $v, s = function() {
        var u = i.then;
        i.then = null, Te(a) && (a = a(i)) && (a.then || a === i) && (i.then = u), o(a), i.then = u;
      };
      i._initted && i.totalProgress() === 1 && i._ts >= 0 || !i._tTime && i._ts < 0 ? s() : i._prom = s;
    });
  }, e.kill = function() {
    pn(this);
  }, n;
}();
ot(Un.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -he,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var je = /* @__PURE__ */ function(n) {
  Iv(e, n);
  function e(r, i) {
    var o;
    return r === void 0 && (r = {}), o = n.call(this, r) || this, o.labels = {}, o.smoothChildTiming = !!r.smoothChildTiming, o.autoRemoveChildren = !!r.autoRemoveChildren, o._sort = We(r.sortChildren), Ce && Ct(r.parent || Ce, kt(o), i), r.reversed && o.reverse(), r.paused && o.paused(!0), r.scrollTrigger && zv(kt(o), r.scrollTrigger), o;
  }
  var t = e.prototype;
  return t.to = function(i, o, a) {
    return _n(0, arguments, this), this;
  }, t.from = function(i, o, a) {
    return _n(1, arguments, this), this;
  }, t.fromTo = function(i, o, a, s) {
    return _n(2, arguments, this), this;
  }, t.set = function(i, o, a) {
    return o.duration = 0, o.parent = this, mn(o).repeatDelay || (o.repeat = 0), o.immediateRender = !!o.immediateRender, new Oe(i, o, st(this, a), 1), this;
  }, t.call = function(i, o, a) {
    return Ct(this, Oe.delayedCall(0, i, o), a);
  }, t.staggerTo = function(i, o, a, s, l, u, c) {
    return a.duration = o, a.stagger = a.stagger || s, a.onComplete = u, a.onCompleteParams = c, a.parent = this, new Oe(i, a, st(this, l)), this;
  }, t.staggerFrom = function(i, o, a, s, l, u, c) {
    return a.runBackwards = 1, mn(a).immediateRender = We(a.immediateRender), this.staggerTo(i, o, a, s, l, u, c);
  }, t.staggerFromTo = function(i, o, a, s, l, u, c, d) {
    return s.startAt = a, mn(s).immediateRender = We(s.immediateRender), this.staggerTo(i, o, s, l, u, c, d);
  }, t.render = function(i, o, a) {
    var s = this._time, l = this._dirty ? this.totalDuration() : this._tDur, u = this._dur, c = i <= 0 ? 0 : Ee(i), d = this._zTime < 0 != i < 0 && (this._initted || !u), f, h, g, p, v, w, y, _, b, C, m, T;
    if (this !== Ce && c > l && i >= 0 && (c = l), c !== this._tTime || a || d) {
      if (s !== this._time && u && (c += this._time - s, i += this._time - s), f = c, b = this._start, _ = this._ts, w = !_, d && (u || (s = this._zTime), (i || !o) && (this._zTime = i)), this._repeat) {
        if (m = this._yoyo, v = u + this._rDelay, this._repeat < -1 && i < 0)
          return this.totalTime(v * 100 + i, o, a);
        if (f = Ee(c % v), c === l ? (p = this._repeat, f = u) : (C = Ee(c / v), p = ~~C, p && p === C && (f = u, p--), f > u && (f = u)), C = Qr(this._tTime, v), !s && this._tTime && C !== p && this._tTime - C * v - this._dur <= 0 && (C = p), m && p & 1 && (f = u - f, T = 1), p !== C && !this._lock) {
          var x = m && C & 1, A = x === (m && p & 1);
          if (p < C && (x = !x), s = x ? 0 : c % u ? u : c, this._lock = 1, this.render(s || (T ? 0 : Ee(p * v)), o, !u)._lock = 0, this._tTime = c, !o && this.parent && et(this, "onRepeat"), this.vars.repeatRefresh && !T && (this.invalidate()._lock = 1), s && s !== this._time || w !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (u = this._dur, l = this._tDur, A && (this._lock = 2, s = x ? u : -1e-4, this.render(s, !0), this.vars.repeatRefresh && !T && this.invalidate()), this._lock = 0, !this._ts && !w)
            return this;
          ag(this, T);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (y = Uy(this, Ee(s), Ee(f)), y && (c -= f - (f = y._start))), this._tTime = c, this._time = f, this._act = !_, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = i, s = 0), !s && c && !o && !C && (et(this, "onStart"), this._tTime !== c))
        return this;
      if (f >= s && i >= 0)
        for (h = this._first; h; ) {
          if (g = h._next, (h._act || f >= h._start) && h._ts && y !== h) {
            if (h.parent !== this)
              return this.render(i, o, a);
            if (h.render(h._ts > 0 ? (f - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (f - h._start) * h._ts, o, a), f !== this._time || !this._ts && !w) {
              y = 0, g && (c += this._zTime = -he);
              break;
            }
          }
          h = g;
        }
      else {
        h = this._last;
        for (var M = i < 0 ? i : f; h; ) {
          if (g = h._prev, (h._act || M <= h._end) && h._ts && y !== h) {
            if (h.parent !== this)
              return this.render(i, o, a);
            if (h.render(h._ts > 0 ? (M - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (M - h._start) * h._ts, o, a || Le && ku(h)), f !== this._time || !this._ts && !w) {
              y = 0, g && (c += this._zTime = M ? -he : he);
              break;
            }
          }
          h = g;
        }
      }
      if (y && !o && (this.pause(), y.render(f >= s ? 0 : -he)._zTime = f >= s ? 1 : -1, this._ts))
        return this._start = b, qi(this), this.render(i, o, a);
      this._onUpdate && !o && et(this, "onUpdate", !0), (c === l && this._tTime >= this.totalDuration() || !c && s) && (b === this._start || Math.abs(_) !== Math.abs(this._ts)) && (this._lock || ((i || !u) && (c === l && this._ts > 0 || !c && this._ts < 0) && or(this, 1), !o && !(i < 0 && !s) && (c || s || !l) && (et(this, c === l && i >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(c < l && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, t.add = function(i, o) {
    var a = this;
    if (Ut(o) || (o = st(this, o, i)), !(i instanceof Un)) {
      if (Ue(i))
        return i.forEach(function(s) {
          return a.add(s, o);
        }), this;
      if (De(i))
        return this.addLabel(i, o);
      if (Te(i))
        i = Oe.delayedCall(0, i);
      else
        return this;
    }
    return this !== i ? Ct(this, i, o) : this;
  }, t.getChildren = function(i, o, a, s) {
    i === void 0 && (i = !0), o === void 0 && (o = !0), a === void 0 && (a = !0), s === void 0 && (s = -ut);
    for (var l = [], u = this._first; u; )
      u._start >= s && (u instanceof Oe ? o && l.push(u) : (a && l.push(u), i && l.push.apply(l, u.getChildren(!0, o, a)))), u = u._next;
    return l;
  }, t.getById = function(i) {
    for (var o = this.getChildren(1, 1, 1), a = o.length; a--; )
      if (o[a].vars.id === i)
        return o[a];
  }, t.remove = function(i) {
    return De(i) ? this.removeLabel(i) : Te(i) ? this.killTweensOf(i) : (i.parent === this && Li(this, i), i === this._recent && (this._recent = this._last), wr(this));
  }, t.totalTime = function(i, o) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Ee(Je.time - (this._ts > 0 ? i / this._ts : (this.totalDuration() - i) / -this._ts))), n.prototype.totalTime.call(this, i, o), this._forcing = 0, this) : this._tTime;
  }, t.addLabel = function(i, o) {
    return this.labels[i] = st(this, o), this;
  }, t.removeLabel = function(i) {
    return delete this.labels[i], this;
  }, t.addPause = function(i, o, a) {
    var s = Oe.delayedCall(0, o || Ln, a);
    return s.data = "isPause", this._hasPause = 1, Ct(this, s, st(this, i));
  }, t.removePause = function(i) {
    var o = this._first;
    for (i = st(this, i); o; )
      o._start === i && o.data === "isPause" && or(o), o = o._next;
  }, t.killTweensOf = function(i, o, a) {
    for (var s = this.getTweensOf(i, a), l = s.length; l--; )
      Kt !== s[l] && s[l].kill(i, o);
    return this;
  }, t.getTweensOf = function(i, o) {
    for (var a = [], s = ct(i), l = this._first, u = Ut(o), c; l; )
      l instanceof Oe ? Dy(l._targets, s) && (u ? (!Kt || l._initted && l._ts) && l.globalTime(0) <= o && l.globalTime(l.totalDuration()) > o : !o || l.isActive()) && a.push(l) : (c = l.getTweensOf(s, o)).length && a.push.apply(a, c), l = l._next;
    return a;
  }, t.tweenTo = function(i, o) {
    o = o || {};
    var a = this, s = st(a, i), l = o, u = l.startAt, c = l.onStart, d = l.onStartParams, f = l.immediateRender, h, g = Oe.to(a, ot({
      ease: o.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: s,
      overwrite: "auto",
      duration: o.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale()) || he,
      onStart: function() {
        if (a.pause(), !h) {
          var v = o.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale());
          g._dur !== v && Jr(g, v, 0, 1).render(g._time, !0, !0), h = 1;
        }
        c && c.apply(g, d || []);
      }
    }, o));
    return f ? g.render(0) : g;
  }, t.tweenFromTo = function(i, o, a) {
    return this.tweenTo(o, ot({
      startAt: {
        time: st(this, i)
      }
    }, a));
  }, t.recent = function() {
    return this._recent;
  }, t.nextLabel = function(i) {
    return i === void 0 && (i = this._time), Ah(this, st(this, i));
  }, t.previousLabel = function(i) {
    return i === void 0 && (i = this._time), Ah(this, st(this, i), 1);
  }, t.currentLabel = function(i) {
    return arguments.length ? this.seek(i, !0) : this.previousLabel(this._time + he);
  }, t.shiftChildren = function(i, o, a) {
    a === void 0 && (a = 0);
    for (var s = this._first, l = this.labels, u; s; )
      s._start >= a && (s._start += i, s._end += i), s = s._next;
    if (o)
      for (u in l)
        l[u] >= a && (l[u] += i);
    return wr(this);
  }, t.invalidate = function(i) {
    var o = this._first;
    for (this._lock = 0; o; )
      o.invalidate(i), o = o._next;
    return n.prototype.invalidate.call(this, i);
  }, t.clear = function(i) {
    i === void 0 && (i = !0);
    for (var o = this._first, a; o; )
      a = o._next, this.remove(o), o = a;
    return this._dp && (this._time = this._tTime = this._pTime = 0), i && (this.labels = {}), wr(this);
  }, t.totalDuration = function(i) {
    var o = 0, a = this, s = a._last, l = ut, u, c, d;
    if (arguments.length)
      return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -i : i));
    if (a._dirty) {
      for (d = a.parent; s; )
        u = s._prev, s._dirty && s.totalDuration(), c = s._start, c > l && a._sort && s._ts && !a._lock ? (a._lock = 1, Ct(a, s, c - s._delay, 1)._lock = 0) : l = c, c < 0 && s._ts && (o -= c, (!d && !a._dp || d && d.smoothChildTiming) && (a._start += c / a._ts, a._time -= c, a._tTime -= c), a.shiftChildren(-c, !1, -1 / 0), l = 0), s._end > o && s._ts && (o = s._end), s = u;
      Jr(a, a === Ce && a._time > o ? a._time : o, 1, 1), a._dirty = 0;
    }
    return a._tDur;
  }, e.updateRoot = function(i) {
    if (Ce._ts && (jv(Ce, gi(i, Ce)), Bv = Je.frame), Je.frame >= wh) {
      wh += nt.autoSleep || 120;
      var o = Ce._first;
      if ((!o || !o._ts) && nt.autoSleep && Je._listeners.length < 2) {
        for (; o && !o._ts; )
          o = o._next;
        o || Je.sleep();
      }
    }
  }, e;
}(Un);
ot(je.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var tC = function(e, t, r, i, o, a, s) {
  var l = new Ye(this._pt, e, t, 0, 1, pg, null, o), u = 0, c = 0, d, f, h, g, p, v, w, y;
  for (l.b = r, l.e = i, r += "", i += "", (w = ~i.indexOf("random(")) && (i = qn(i)), a && (y = [r, i], a(y, e, t), r = y[0], i = y[1]), f = r.match(Hs) || []; d = Hs.exec(i); )
    g = d[0], p = i.substring(u, d.index), h ? h = (h + 1) % 5 : p.substr(-5) === "rgba(" && (h = 1), g !== f[c++] && (v = parseFloat(f[c - 1]) || 0, l._pt = {
      _next: l._pt,
      p: p || c === 1 ? p : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: v,
      c: g.charAt(1) === "=" ? Wr(v, g) - v : parseFloat(g) - v,
      m: h && h < 4 ? Math.round : 0
    }, u = Hs.lastIndex);
  return l.c = u < i.length ? i.substring(u, i.length) : "", l.fp = s, (Rv.test(i) || w) && (l.e = 0), this._pt = l, l;
}, Du = function(e, t, r, i, o, a, s, l, u, c) {
  Te(i) && (i = i(o || 0, e, a));
  var d = e[t], f = r !== "get" ? r : Te(d) ? u ? e[t.indexOf("set") || !Te(e["get" + t.substr(3)]) ? t : "get" + t.substr(3)](u) : e[t]() : d, h = Te(d) ? u ? aC : fg : Pu, g;
  if (De(i) && (~i.indexOf("random(") && (i = qn(i)), i.charAt(1) === "=" && (g = Wr(f, i) + (Be(f) || 0), (g || g === 0) && (i = g))), !c || f !== i || Hl)
    return !isNaN(f * i) && i !== "" ? (g = new Ye(this._pt, e, t, +f || 0, i - (f || 0), typeof d == "boolean" ? lC : hg, 0, h), u && (g.fp = u), s && g.modifier(s, this, e), this._pt = g) : (!d && !(t in e) && Ou(t, i), tC.call(this, e, t, f, i, h, l || nt.stringFilter, u));
}, rC = function(e, t, r, i, o) {
  if (Te(e) && (e = bn(e, o, t, r, i)), !At(e) || e.style && e.nodeType || Ue(e) || kv(e))
    return De(e) ? bn(e, o, t, r, i) : e;
  var a = {}, s;
  for (s in e)
    a[s] = bn(e[s], o, t, r, i);
  return a;
}, ug = function(e, t, r, i, o, a) {
  var s, l, u, c;
  if (Ke[e] && (s = new Ke[e]()).init(o, s.rawVars ? t[e] : rC(t[e], i, o, a, r), r, i, a) !== !1 && (r._pt = l = new Ye(r._pt, o, e, 0, 1, s.render, s, 0, s.priority), r !== Hr))
    for (u = r._ptLookup[r._targets.indexOf(o)], c = s._props.length; c--; )
      u[s._props[c]] = l;
  return s;
}, Kt, Hl, Ru = function n(e, t, r) {
  var i = e.vars, o = i.ease, a = i.startAt, s = i.immediateRender, l = i.lazy, u = i.onUpdate, c = i.runBackwards, d = i.yoyoEase, f = i.keyframes, h = i.autoRevert, g = e._dur, p = e._startAt, v = e._targets, w = e.parent, y = w && w.data === "nested" ? w.vars.targets : v, _ = e._overwrite === "auto" && !Tu, b = e.timeline, C, m, T, x, A, M, O, S, P, k, E, q, H;
  if (b && (!f || !o) && (o = "none"), e._ease = Tr(o, Xr.ease), e._yEase = d ? og(Tr(d === !0 ? o : d, Xr.ease)) : 0, d && e._yoyo && !e._repeat && (d = e._yEase, e._yEase = e._ease, e._ease = d), e._from = !b && !!i.runBackwards, !b || f && !i.stagger) {
    if (S = v[0] ? Cr(v[0]).harness : 0, q = S && i[S.prop], C = vi(i, Eu), p && (p._zTime < 0 && p.progress(1), t < 0 && c && s && !h ? p.render(-1, !0) : p.revert(c && g ? ni : Ny), p._lazy = 0), a) {
      if (or(e._startAt = Oe.set(v, ot({
        data: "isStart",
        overwrite: !1,
        parent: w,
        immediateRender: !0,
        lazy: !p && We(l),
        startAt: null,
        delay: 0,
        onUpdate: u && function() {
          return et(e, "onUpdate");
        },
        stagger: 0
      }, a))), e._startAt._dp = 0, e._startAt._sat = e, t < 0 && (Le || !s && !h) && e._startAt.revert(ni), s && g && t <= 0 && r <= 0) {
        t && (e._zTime = t);
        return;
      }
    } else if (c && g && !p) {
      if (t && (s = !1), T = ot({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: s && !p && We(l),
        immediateRender: s,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: w
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, C), q && (T[S.prop] = q), or(e._startAt = Oe.set(v, T)), e._startAt._dp = 0, e._startAt._sat = e, t < 0 && (Le ? e._startAt.revert(ni) : e._startAt.render(-1, !0)), e._zTime = t, !s)
        n(e._startAt, he, he);
      else if (!t)
        return;
    }
    for (e._pt = e._ptCache = 0, l = g && We(l) || l && !g, m = 0; m < v.length; m++) {
      if (A = v[m], O = A._gsap || Nu(v)[m]._gsap, e._ptLookup[m] = k = {}, Ml[O.id] && tr.length && pi(), E = y === v ? m : y.indexOf(A), S && (P = new S()).init(A, q || C, e, E, y) !== !1 && (e._pt = x = new Ye(e._pt, A, P.name, 0, 1, P.render, P, 0, P.priority), P._props.forEach(function(z) {
        k[z] = x;
      }), P.priority && (M = 1)), !S || q)
        for (T in C)
          Ke[T] && (P = ug(T, C, e, E, A, y)) ? P.priority && (M = 1) : k[T] = x = Du.call(e, A, T, "get", C[T], E, y, 0, i.stringFilter);
      e._op && e._op[m] && e.kill(A, e._op[m]), _ && e._pt && (Kt = e, Ce.killTweensOf(A, k, e.globalTime(t)), H = !e.parent, Kt = 0), e._pt && l && (Ml[O.id] = 1);
    }
    M && vg(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = u, e._initted = (!e._op || e._pt) && !H, f && t <= 0 && b.render(ut, !0, !0);
}, nC = function(e, t, r, i, o, a, s, l) {
  var u = (e._pt && e._ptCache || (e._ptCache = {}))[t], c, d, f, h;
  if (!u)
    for (u = e._ptCache[t] = [], f = e._ptLookup, h = e._targets.length; h--; ) {
      if (c = f[h][t], c && c.d && c.d._pt)
        for (c = c.d._pt; c && c.p !== t && c.fp !== t; )
          c = c._next;
      if (!c)
        return Hl = 1, e.vars[t] = "+=0", Ru(e, s), Hl = 0, l ? Mn(t + " not eligible for reset") : 1;
      u.push(c);
    }
  for (h = u.length; h--; )
    d = u[h], c = d._pt || d, c.s = (i || i === 0) && !o ? i : c.s + (i || 0) + a * c.c, c.c = r - c.s, d.e && (d.e = xe(r) + Be(d.e)), d.b && (d.b = c.s + Be(d.b));
}, iC = function(e, t) {
  var r = e[0] ? Cr(e[0]).harness : 0, i = r && r.aliases, o, a, s, l;
  if (!i)
    return t;
  o = Kr({}, t);
  for (a in i)
    if (a in o)
      for (l = i[a].split(","), s = l.length; s--; )
        o[l[s]] = o[a];
  return o;
}, oC = function(e, t, r, i) {
  var o = t.ease || i || "power1.inOut", a, s;
  if (Ue(t))
    s = r[e] || (r[e] = []), t.forEach(function(l, u) {
      return s.push({
        t: u / (t.length - 1) * 100,
        v: l,
        e: o
      });
    });
  else
    for (a in t)
      s = r[a] || (r[a] = []), a === "ease" || s.push({
        t: parseFloat(e),
        v: t[a],
        e: o
      });
}, bn = function(e, t, r, i, o) {
  return Te(e) ? e.call(t, r, i, o) : De(e) && ~e.indexOf("random(") ? qn(e) : e;
}, cg = Iu + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", dg = {};
Ge(cg + ",id,stagger,delay,duration,paused,scrollTrigger", function(n) {
  return dg[n] = 1;
});
var Oe = /* @__PURE__ */ function(n) {
  Iv(e, n);
  function e(r, i, o, a) {
    var s;
    typeof i == "number" && (o.duration = i, i = o, o = null), s = n.call(this, a ? i : mn(i)) || this;
    var l = s.vars, u = l.duration, c = l.delay, d = l.immediateRender, f = l.stagger, h = l.overwrite, g = l.keyframes, p = l.defaults, v = l.scrollTrigger, w = l.yoyoEase, y = i.parent || Ce, _ = (Ue(r) || kv(r) ? Ut(r[0]) : "length" in i) ? [r] : ct(r), b, C, m, T, x, A, M, O;
    if (s._targets = _.length ? Nu(_) : Mn("GSAP target " + r + " not found. https://gsap.com", !nt.nullTargetWarn) || [], s._ptLookup = [], s._overwrite = h, g || f || Jn(u) || Jn(c)) {
      if (i = s.vars, b = s.timeline = new je({
        data: "nested",
        defaults: p || {},
        targets: y && y.data === "nested" ? y.vars.targets : _
      }), b.kill(), b.parent = b._dp = kt(s), b._start = 0, f || Jn(u) || Jn(c)) {
        if (T = _.length, M = f && Zv(f), At(f))
          for (x in f)
            ~cg.indexOf(x) && (O || (O = {}), O[x] = f[x]);
        for (C = 0; C < T; C++)
          m = vi(i, dg), m.stagger = 0, w && (m.yoyoEase = w), O && Kr(m, O), A = _[C], m.duration = +bn(u, kt(s), C, A, _), m.delay = (+bn(c, kt(s), C, A, _) || 0) - s._delay, !f && T === 1 && m.delay && (s._delay = c = m.delay, s._start += c, m.delay = 0), b.to(A, m, M ? M(C, A, _) : 0), b._ease = ne.none;
        b.duration() ? u = c = 0 : s.timeline = 0;
      } else if (g) {
        mn(ot(b.vars.defaults, {
          ease: "none"
        })), b._ease = Tr(g.ease || i.ease || "none");
        var S = 0, P, k, E;
        if (Ue(g))
          g.forEach(function(q) {
            return b.to(_, q, ">");
          }), b.duration();
        else {
          m = {};
          for (x in g)
            x === "ease" || x === "easeEach" || oC(x, g[x], m, g.easeEach);
          for (x in m)
            for (P = m[x].sort(function(q, H) {
              return q.t - H.t;
            }), S = 0, C = 0; C < P.length; C++)
              k = P[C], E = {
                ease: k.e,
                duration: (k.t - (C ? P[C - 1].t : 0)) / 100 * u
              }, E[x] = k.v, b.to(_, E, S), S += E.duration;
          b.duration() < u && b.to({}, {
            duration: u - b.duration()
          });
        }
      }
      u || s.duration(u = b.duration());
    } else
      s.timeline = 0;
    return h === !0 && !Tu && (Kt = kt(s), Ce.killTweensOf(_), Kt = 0), Ct(y, kt(s), o), i.reversed && s.reverse(), i.paused && s.paused(!0), (d || !u && !g && s._start === Ee(y._time) && We(d) && Ly(kt(s)) && y.data !== "nested") && (s._tTime = -he, s.render(Math.max(0, -c) || 0)), v && zv(kt(s), v), s;
  }
  var t = e.prototype;
  return t.render = function(i, o, a) {
    var s = this._time, l = this._tDur, u = this._dur, c = i < 0, d = i > l - he && !c ? l : i < he ? 0 : i, f, h, g, p, v, w, y, _, b;
    if (!u)
      By(this, i, o, a);
    else if (d !== this._tTime || !i || a || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== c || this._lazy) {
      if (f = d, _ = this.timeline, this._repeat) {
        if (p = u + this._rDelay, this._repeat < -1 && c)
          return this.totalTime(p * 100 + i, o, a);
        if (f = Ee(d % p), d === l ? (g = this._repeat, f = u) : (v = Ee(d / p), g = ~~v, g && g === v ? (f = u, g--) : f > u && (f = u)), w = this._yoyo && g & 1, w && (b = this._yEase, f = u - f), v = Qr(this._tTime, p), f === s && !a && this._initted && g === v)
          return this._tTime = d, this;
        g !== v && (_ && this._yEase && ag(_, w), this.vars.repeatRefresh && !w && !this._lock && f !== p && this._initted && (this._lock = a = 1, this.render(Ee(p * g), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (Wv(this, c ? i : f, a, o, d))
          return this._tTime = 0, this;
        if (s !== this._time && !(a && this.vars.repeatRefresh && g !== v))
          return this;
        if (u !== this._dur)
          return this.render(i, o, a);
      }
      if (this._tTime = d, this._time = f, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = y = (b || this._ease)(f / u), this._from && (this.ratio = y = 1 - y), !s && d && !o && !v && (et(this, "onStart"), this._tTime !== d))
        return this;
      for (h = this._pt; h; )
        h.r(y, h.d), h = h._next;
      _ && _.render(i < 0 ? i : _._dur * _._ease(f / this._dur), o, a) || this._startAt && (this._zTime = i), this._onUpdate && !o && (c && Ll(this, i, o, a), et(this, "onUpdate")), this._repeat && g !== v && this.vars.onRepeat && !o && this.parent && et(this, "onRepeat"), (d === this._tDur || !d) && this._tTime === d && (c && !this._onUpdate && Ll(this, i, !0, !0), (i || !u) && (d === this._tDur && this._ts > 0 || !d && this._ts < 0) && or(this, 1), !o && !(c && !s) && (d || s || w) && (et(this, d === l ? "onComplete" : "onReverseComplete", !0), this._prom && !(d < l && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, t.targets = function() {
    return this._targets;
  }, t.invalidate = function(i) {
    return (!i || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(i), n.prototype.invalidate.call(this, i);
  }, t.resetTo = function(i, o, a, s, l) {
    Bn || Je.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), c;
    return this._initted || Ru(this, u), c = this._ease(u / this._dur), nC(this, i, o, a, s, c, u, l) ? this.resetTo(i, o, a, s, 1) : (Bi(this, 0), this.parent || Fv(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, t.kill = function(i, o) {
    if (o === void 0 && (o = "all"), !i && (!o || o === "all"))
      return this._lazy = this._pt = 0, this.parent ? pn(this) : this.scrollTrigger && this.scrollTrigger.kill(!!Le), this;
    if (this.timeline) {
      var a = this.timeline.totalDuration();
      return this.timeline.killTweensOf(i, o, Kt && Kt.vars.overwrite !== !0)._first || pn(this), this.parent && a !== this.timeline.totalDuration() && Jr(this, this._dur * this.timeline._tDur / a, 0, 1), this;
    }
    var s = this._targets, l = i ? ct(i) : s, u = this._ptLookup, c = this._pt, d, f, h, g, p, v, w;
    if ((!o || o === "all") && Py(s, l))
      return o === "all" && (this._pt = 0), pn(this);
    for (d = this._op = this._op || [], o !== "all" && (De(o) && (p = {}, Ge(o, function(y) {
      return p[y] = 1;
    }), o = p), o = iC(s, o)), w = s.length; w--; )
      if (~l.indexOf(s[w])) {
        f = u[w], o === "all" ? (d[w] = o, g = f, h = {}) : (h = d[w] = d[w] || {}, g = o);
        for (p in g)
          v = f && f[p], v && ((!("kill" in v.d) || v.d.kill(p) === !0) && Li(this, v, "_pt"), delete f[p]), h !== "all" && (h[p] = 1);
      }
    return this._initted && !this._pt && c && pn(this), this;
  }, e.to = function(i, o) {
    return new e(i, o, arguments[2]);
  }, e.from = function(i, o) {
    return _n(1, arguments);
  }, e.delayedCall = function(i, o, a, s) {
    return new e(o, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: i,
      onComplete: o,
      onReverseComplete: o,
      onCompleteParams: a,
      onReverseCompleteParams: a,
      callbackScope: s
    });
  }, e.fromTo = function(i, o, a) {
    return _n(2, arguments);
  }, e.set = function(i, o) {
    return o.duration = 0, o.repeatDelay || (o.repeat = 0), new e(i, o);
  }, e.killTweensOf = function(i, o, a) {
    return Ce.killTweensOf(i, o, a);
  }, e;
}(Un);
ot(Oe.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Ge("staggerTo,staggerFrom,staggerFromTo", function(n) {
  Oe[n] = function() {
    var e = new je(), t = Bl.call(arguments, 0);
    return t.splice(n === "staggerFromTo" ? 5 : 4, 0, 0), e[n].apply(e, t);
  };
});
var Pu = function(e, t, r) {
  return e[t] = r;
}, fg = function(e, t, r) {
  return e[t](r);
}, aC = function(e, t, r, i) {
  return e[t](i.fp, r);
}, sC = function(e, t, r) {
  return e.setAttribute(t, r);
}, Mu = function(e, t) {
  return Te(e[t]) ? fg : Su(e[t]) && e.setAttribute ? sC : Pu;
}, hg = function(e, t) {
  return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e6) / 1e6, t);
}, lC = function(e, t) {
  return t.set(t.t, t.p, !!(t.s + t.c * e), t);
}, pg = function(e, t) {
  var r = t._pt, i = "";
  if (!e && t.b)
    i = t.b;
  else if (e === 1 && t.e)
    i = t.e;
  else {
    for (; r; )
      i = r.p + (r.m ? r.m(r.s + r.c * e) : Math.round((r.s + r.c * e) * 1e4) / 1e4) + i, r = r._next;
    i += t.c;
  }
  t.set(t.t, t.p, i, t);
}, Lu = function(e, t) {
  for (var r = t._pt; r; )
    r.r(e, r.d), r = r._next;
}, uC = function(e, t, r, i) {
  for (var o = this._pt, a; o; )
    a = o._next, o.p === i && o.modifier(e, t, r), o = a;
}, cC = function(e) {
  for (var t = this._pt, r, i; t; )
    i = t._next, t.p === e && !t.op || t.op === e ? Li(this, t, "_pt") : t.dep || (r = 1), t = i;
  return !r;
}, dC = function(e, t, r, i) {
  i.mSet(e, t, i.m.call(i.tween, r, i.mt), i);
}, vg = function(e) {
  for (var t = e._pt, r, i, o, a; t; ) {
    for (r = t._next, i = o; i && i.pr > t.pr; )
      i = i._next;
    (t._prev = i ? i._prev : a) ? t._prev._next = t : o = t, (t._next = i) ? i._prev = t : a = t, t = r;
  }
  e._pt = o;
}, Ye = /* @__PURE__ */ function() {
  function n(t, r, i, o, a, s, l, u, c) {
    this.t = r, this.s = o, this.c = a, this.p = i, this.r = s || hg, this.d = l || this, this.set = u || Pu, this.pr = c || 0, this._next = t, t && (t._prev = this);
  }
  var e = n.prototype;
  return e.modifier = function(r, i, o) {
    this.mSet = this.mSet || this.set, this.set = dC, this.m = r, this.mt = o, this.tween = i;
  }, n;
}();
Ge(Iu + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(n) {
  return Eu[n] = 1;
});
it.TweenMax = it.TweenLite = Oe;
it.TimelineLite = it.TimelineMax = je;
Ce = new je({
  sortChildren: !1,
  defaults: Xr,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
nt.stringFilter = ig;
var Sr = [], oi = {}, fC = [], Eh = 0, hC = 0, Ws = function(e) {
  return (oi[e] || fC).map(function(t) {
    return t();
  });
}, $l = function() {
  var e = Date.now(), t = [];
  e - Eh > 2 && (Ws("matchMediaInit"), Sr.forEach(function(r) {
    var i = r.queries, o = r.conditions, a, s, l, u;
    for (s in i)
      a = bt.matchMedia(i[s]).matches, a && (l = 1), a !== o[s] && (o[s] = a, u = 1);
    u && (r.revert(), l && t.push(r));
  }), Ws("matchMediaRevert"), t.forEach(function(r) {
    return r.onMatch(r, function(i) {
      return r.add(null, i);
    });
  }), Eh = e, Ws("matchMedia"));
}, gg = /* @__PURE__ */ function() {
  function n(t, r) {
    this.selector = r && Ul(r), this.data = [], this._r = [], this.isReverted = !1, this.id = hC++, t && this.add(t);
  }
  var e = n.prototype;
  return e.add = function(r, i, o) {
    Te(r) && (o = i, i = r, r = Te);
    var a = this, s = function() {
      var u = _e, c = a.selector, d;
      return u && u !== a && u.data.push(a), o && (a.selector = Ul(o)), _e = a, d = i.apply(a, arguments), Te(d) && a._r.push(d), _e = u, a.selector = c, a.isReverted = !1, d;
    };
    return a.last = s, r === Te ? s(a, function(l) {
      return a.add(null, l);
    }) : r ? a[r] = s : s;
  }, e.ignore = function(r) {
    var i = _e;
    _e = null, r(this), _e = i;
  }, e.getTweens = function() {
    var r = [];
    return this.data.forEach(function(i) {
      return i instanceof n ? r.push.apply(r, i.getTweens()) : i instanceof Oe && !(i.parent && i.parent.data === "nested") && r.push(i);
    }), r;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(r, i) {
    var o = this;
    if (r ? function() {
      for (var s = o.getTweens(), l = o.data.length, u; l--; )
        u = o.data[l], u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(c) {
          return s.splice(s.indexOf(c), 1);
        }));
      for (s.map(function(c) {
        return {
          g: c._dur || c._delay || c._sat && !c._sat.vars.immediateRender ? c.globalTime(0) : -1 / 0,
          t: c
        };
      }).sort(function(c, d) {
        return d.g - c.g || -1 / 0;
      }).forEach(function(c) {
        return c.t.revert(r);
      }), l = o.data.length; l--; )
        u = o.data[l], u instanceof je ? u.data !== "nested" && (u.scrollTrigger && u.scrollTrigger.revert(), u.kill()) : !(u instanceof Oe) && u.revert && u.revert(r);
      o._r.forEach(function(c) {
        return c(r, o);
      }), o.isReverted = !0;
    }() : this.data.forEach(function(s) {
      return s.kill && s.kill();
    }), this.clear(), i)
      for (var a = Sr.length; a--; )
        Sr[a].id === this.id && Sr.splice(a, 1);
  }, e.revert = function(r) {
    this.kill(r || {});
  }, n;
}(), pC = /* @__PURE__ */ function() {
  function n(t) {
    this.contexts = [], this.scope = t, _e && _e.data.push(this);
  }
  var e = n.prototype;
  return e.add = function(r, i, o) {
    At(r) || (r = {
      matches: r
    });
    var a = new gg(0, o || this.scope), s = a.conditions = {}, l, u, c;
    _e && !a.selector && (a.selector = _e.selector), this.contexts.push(a), i = a.add("onMatch", i), a.queries = r;
    for (u in r)
      u === "all" ? c = 1 : (l = bt.matchMedia(r[u]), l && (Sr.indexOf(a) < 0 && Sr.push(a), (s[u] = l.matches) && (c = 1), l.addListener ? l.addListener($l) : l.addEventListener("change", $l)));
    return c && i(a, function(d) {
      return a.add(null, d);
    }), this;
  }, e.revert = function(r) {
    this.kill(r || {});
  }, e.kill = function(r) {
    this.contexts.forEach(function(i) {
      return i.kill(r, !0);
    });
  }, n;
}(), mi = {
  registerPlugin: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    t.forEach(function(i) {
      return tg(i);
    });
  },
  timeline: function(e) {
    return new je(e);
  },
  getTweensOf: function(e, t) {
    return Ce.getTweensOf(e, t);
  },
  getProperty: function(e, t, r, i) {
    De(e) && (e = ct(e)[0]);
    var o = Cr(e || {}).get, a = r ? $v : Hv;
    return r === "native" && (r = ""), e && (t ? a((Ke[t] && Ke[t].get || o)(e, t, r, i)) : function(s, l, u) {
      return a((Ke[s] && Ke[s].get || o)(e, s, l, u));
    });
  },
  quickSetter: function(e, t, r) {
    if (e = ct(e), e.length > 1) {
      var i = e.map(function(c) {
        return Xe.quickSetter(c, t, r);
      }), o = i.length;
      return function(c) {
        for (var d = o; d--; )
          i[d](c);
      };
    }
    e = e[0] || {};
    var a = Ke[t], s = Cr(e), l = s.harness && (s.harness.aliases || {})[t] || t, u = a ? function(c) {
      var d = new a();
      Hr._pt = 0, d.init(e, r ? c + r : c, Hr, 0, [e]), d.render(1, d), Hr._pt && Lu(1, Hr);
    } : s.set(e, l);
    return a ? u : function(c) {
      return u(e, l, r ? c + r : c, s, 1);
    };
  },
  quickTo: function(e, t, r) {
    var i, o = Xe.to(e, ot((i = {}, i[t] = "+=0.1", i.paused = !0, i.stagger = 0, i), r || {})), a = function(l, u, c) {
      return o.resetTo(t, l, u, c);
    };
    return a.tween = o, a;
  },
  isTweening: function(e) {
    return Ce.getTweensOf(e, !0).length > 0;
  },
  defaults: function(e) {
    return e && e.ease && (e.ease = Tr(e.ease, Xr.ease)), Th(Xr, e || {});
  },
  config: function(e) {
    return Th(nt, e || {});
  },
  registerEffect: function(e) {
    var t = e.name, r = e.effect, i = e.plugins, o = e.defaults, a = e.extendTimeline;
    (i || "").split(",").forEach(function(s) {
      return s && !Ke[s] && !it[s] && Mn(t + " effect requires " + s + " plugin.");
    }), $s[t] = function(s, l, u) {
      return r(ct(s), ot(l || {}, o), u);
    }, a && (je.prototype[t] = function(s, l, u) {
      return this.add($s[t](s, At(l) ? l : (u = l) && {}, this), u);
    });
  },
  registerEase: function(e, t) {
    ne[e] = Tr(t);
  },
  parseEase: function(e, t) {
    return arguments.length ? Tr(e, t) : ne;
  },
  getById: function(e) {
    return Ce.getById(e);
  },
  exportRoot: function(e, t) {
    e === void 0 && (e = {});
    var r = new je(e), i, o;
    for (r.smoothChildTiming = We(e.smoothChildTiming), Ce.remove(r), r._dp = 0, r._time = r._tTime = Ce._time, i = Ce._first; i; )
      o = i._next, (t || !(!i._dur && i instanceof Oe && i.vars.onComplete === i._targets[0])) && Ct(r, i, i._start - i._delay), i = o;
    return Ct(Ce, r, 0), r;
  },
  context: function(e, t) {
    return e ? new gg(e, t) : _e;
  },
  matchMedia: function(e) {
    return new pC(e);
  },
  matchMediaRefresh: function() {
    return Sr.forEach(function(e) {
      var t = e.conditions, r, i;
      for (i in t)
        t[i] && (t[i] = !1, r = 1);
      r && e.revert();
    }) || $l();
  },
  addEventListener: function(e, t) {
    var r = oi[e] || (oi[e] = []);
    ~r.indexOf(t) || r.push(t);
  },
  removeEventListener: function(e, t) {
    var r = oi[e], i = r && r.indexOf(t);
    i >= 0 && r.splice(i, 1);
  },
  utils: {
    wrap: Wy,
    wrapYoyo: Gy,
    distribute: Zv,
    random: Kv,
    snap: Xv,
    normalize: zy,
    getUnit: Be,
    clamp: Hy,
    splitColor: rg,
    toArray: ct,
    selector: Ul,
    mapRange: Jv,
    pipe: Fy,
    unitize: Vy,
    interpolate: Yy,
    shuffle: Yv
  },
  install: Lv,
  effects: $s,
  ticker: Je,
  updateRoot: je.updateRoot,
  plugins: Ke,
  globalTimeline: Ce,
  core: {
    PropTween: Ye,
    globals: qv,
    Tween: Oe,
    Timeline: je,
    Animation: Un,
    getCache: Cr,
    _removeLinkedListItem: Li,
    reverting: function() {
      return Le;
    },
    context: function(e) {
      return e && _e && (_e.data.push(e), e._ctx = _e), _e;
    },
    suppressOverwrites: function(e) {
      return Tu = e;
    }
  }
};
Ge("to,from,fromTo,delayedCall,set,killTweensOf", function(n) {
  return mi[n] = Oe[n];
});
Je.add(je.updateRoot);
Hr = mi.to({}, {
  duration: 0
});
var vC = function(e, t) {
  for (var r = e._pt; r && r.p !== t && r.op !== t && r.fp !== t; )
    r = r._next;
  return r;
}, gC = function(e, t) {
  var r = e._targets, i, o, a;
  for (i in t)
    for (o = r.length; o--; )
      a = e._ptLookup[o][i], a && (a = a.d) && (a._pt && (a = vC(a, i)), a && a.modifier && a.modifier(t[i], e, r[o], i));
}, Gs = function(e, t) {
  return {
    name: e,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(i, o, a) {
      a._onInit = function(s) {
        var l, u;
        if (De(o) && (l = {}, Ge(o, function(c) {
          return l[c] = 1;
        }), o = l), t) {
          l = {};
          for (u in o)
            l[u] = t(o[u]);
          o = l;
        }
        gC(s, o);
      };
    }
  };
}, Xe = mi.registerPlugin({
  name: "attr",
  init: function(e, t, r, i, o) {
    var a, s, l;
    this.tween = r;
    for (a in t)
      l = e.getAttribute(a) || "", s = this.add(e, "setAttribute", (l || 0) + "", t[a], i, o, 0, 0, a), s.op = a, s.b = l, this._props.push(a);
  },
  render: function(e, t) {
    for (var r = t._pt; r; )
      Le ? r.set(r.t, r.p, r.b, r) : r.r(e, r.d), r = r._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(e, t) {
    for (var r = t.length; r--; )
      this.add(e, r, e[r] || 0, t[r], 0, 0, 0, 0, 0, 1);
  }
}, Gs("roundProps", jl), Gs("modifiers"), Gs("snap", Xv)) || mi;
Oe.version = je.version = Xe.version = "3.13.0";
Mv = 1;
xu() && en();
ne.Power0;
ne.Power1;
ne.Power2;
ne.Power3;
ne.Power4;
ne.Linear;
ne.Quad;
ne.Cubic;
ne.Quart;
ne.Quint;
ne.Strong;
ne.Elastic;
ne.Back;
ne.SteppedEase;
ne.Bounce;
ne.Sine;
ne.Expo;
ne.Circ;
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Ih, Qt, Gr, qu, br, Nh, Bu, mC = function() {
  return typeof window < "u";
}, jt = {}, gr = 180 / Math.PI, Yr = Math.PI / 180, Lr = Math.atan2, kh = 1e8, Uu = /([A-Z])/g, _C = /(left|right|width|margin|padding|x)/i, bC = /[\s,\(]\S/, wt = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, Fl = function(e, t) {
  return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, yC = function(e, t) {
  return t.set(t.t, t.p, e === 1 ? t.e : Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, CC = function(e, t) {
  return t.set(t.t, t.p, e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b, t);
}, wC = function(e, t) {
  var r = t.s + t.c * e;
  t.set(t.t, t.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + t.u, t);
}, mg = function(e, t) {
  return t.set(t.t, t.p, e ? t.e : t.b, t);
}, _g = function(e, t) {
  return t.set(t.t, t.p, e !== 1 ? t.b : t.e, t);
}, TC = function(e, t, r) {
  return e.style[t] = r;
}, SC = function(e, t, r) {
  return e.style.setProperty(t, r);
}, xC = function(e, t, r) {
  return e._gsap[t] = r;
}, AC = function(e, t, r) {
  return e._gsap.scaleX = e._gsap.scaleY = r;
}, OC = function(e, t, r, i, o) {
  var a = e._gsap;
  a.scaleX = a.scaleY = r, a.renderTransform(o, a);
}, EC = function(e, t, r, i, o) {
  var a = e._gsap;
  a[t] = r, a.renderTransform(o, a);
}, we = "transform", Ze = we + "Origin", IC = function n(e, t) {
  var r = this, i = this.target, o = i.style, a = i._gsap;
  if (e in jt && o) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = wt[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(s) {
        return r.tfm[s] = Dt(i, s);
      }) : this.tfm[e] = a.x ? a[e] : Dt(i, e), e === Ze && (this.tfm.zOrigin = a.zOrigin);
    else
      return wt.transform.split(",").forEach(function(s) {
        return n.call(r, s, t);
      });
    if (this.props.indexOf(we) >= 0)
      return;
    a.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(Ze, t, "")), e = we;
  }
  (o || t) && this.props.push(e, t, o[e]);
}, bg = function(e) {
  e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, NC = function() {
  var e = this.props, t = this.target, r = t.style, i = t._gsap, o, a;
  for (o = 0; o < e.length; o += 3)
    e[o + 1] ? e[o + 1] === 2 ? t[e[o]](e[o + 2]) : t[e[o]] = e[o + 2] : e[o + 2] ? r[e[o]] = e[o + 2] : r.removeProperty(e[o].substr(0, 2) === "--" ? e[o] : e[o].replace(Uu, "-$1").toLowerCase());
  if (this.tfm) {
    for (a in this.tfm)
      i[a] = this.tfm[a];
    i.svg && (i.renderTransform(), t.setAttribute("data-svg-origin", this.svgo || "")), o = Bu(), (!o || !o.isStart) && !r[we] && (bg(r), i.zOrigin && r[Ze] && (r[Ze] += " " + i.zOrigin + "px", i.zOrigin = 0, i.renderTransform()), i.uncache = 1);
  }
}, yg = function(e, t) {
  var r = {
    target: e,
    props: [],
    revert: NC,
    save: IC
  };
  return e._gsap || Xe.core.getCache(e), t && e.style && e.nodeType && t.split(",").forEach(function(i) {
    return r.save(i);
  }), r;
}, Cg, Vl = function(e, t) {
  var r = Qt.createElementNS ? Qt.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Qt.createElement(e);
  return r && r.style ? r : Qt.createElement(e);
}, dt = function n(e, t, r) {
  var i = getComputedStyle(e);
  return i[t] || i.getPropertyValue(t.replace(Uu, "-$1").toLowerCase()) || i.getPropertyValue(t) || !r && n(e, tn(t) || t, 1) || "";
}, Dh = "O,Moz,ms,Ms,Webkit".split(","), tn = function(e, t, r) {
  var i = t || br, o = i.style, a = 5;
  if (e in o && !r)
    return e;
  for (e = e.charAt(0).toUpperCase() + e.substr(1); a-- && !(Dh[a] + e in o); )
    ;
  return a < 0 ? null : (a === 3 ? "ms" : a >= 0 ? Dh[a] : "") + e;
}, zl = function() {
  mC() && window.document && (Ih = window, Qt = Ih.document, Gr = Qt.documentElement, br = Vl("div") || {
    style: {}
  }, Vl("div"), we = tn(we), Ze = we + "Origin", br.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", Cg = !!tn("perspective"), Bu = Xe.core.reverting, qu = 1);
}, Rh = function(e) {
  var t = e.ownerSVGElement, r = Vl("svg", t && t.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), i = e.cloneNode(!0), o;
  i.style.display = "block", r.appendChild(i), Gr.appendChild(r);
  try {
    o = i.getBBox();
  } catch {
  }
  return r.removeChild(i), Gr.removeChild(r), o;
}, Ph = function(e, t) {
  for (var r = t.length; r--; )
    if (e.hasAttribute(t[r]))
      return e.getAttribute(t[r]);
}, wg = function(e) {
  var t, r;
  try {
    t = e.getBBox();
  } catch {
    t = Rh(e), r = 1;
  }
  return t && (t.width || t.height) || r || (t = Rh(e)), t && !t.width && !t.x && !t.y ? {
    x: +Ph(e, ["x", "cx", "x1"]) || 0,
    y: +Ph(e, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : t;
}, Tg = function(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && wg(e));
}, Ir = function(e, t) {
  if (t) {
    var r = e.style, i;
    t in jt && t !== Ze && (t = we), r.removeProperty ? (i = t.substr(0, 2), (i === "ms" || t.substr(0, 6) === "webkit") && (t = "-" + t), r.removeProperty(i === "--" ? t : t.replace(Uu, "-$1").toLowerCase())) : r.removeAttribute(t);
  }
}, Jt = function(e, t, r, i, o, a) {
  var s = new Ye(e._pt, t, r, 0, 1, a ? _g : mg);
  return e._pt = s, s.b = i, s.e = o, e._props.push(r), s;
}, Mh = {
  deg: 1,
  rad: 1,
  turn: 1
}, kC = {
  grid: 1,
  flex: 1
}, ar = function n(e, t, r, i) {
  var o = parseFloat(r) || 0, a = (r + "").trim().substr((o + "").length) || "px", s = br.style, l = _C.test(t), u = e.tagName.toLowerCase() === "svg", c = (u ? "client" : "offset") + (l ? "Width" : "Height"), d = 100, f = i === "px", h = i === "%", g, p, v, w;
  if (i === a || !o || Mh[i] || Mh[a])
    return o;
  if (a !== "px" && !f && (o = n(e, t, r, "px")), w = e.getCTM && Tg(e), (h || a === "%") && (jt[t] || ~t.indexOf("adius")))
    return g = w ? e.getBBox()[l ? "width" : "height"] : e[c], xe(h ? o / g * d : o / 100 * g);
  if (s[l ? "width" : "height"] = d + (f ? a : i), p = i !== "rem" && ~t.indexOf("adius") || i === "em" && e.appendChild && !u ? e : e.parentNode, w && (p = (e.ownerSVGElement || {}).parentNode), (!p || p === Qt || !p.appendChild) && (p = Qt.body), v = p._gsap, v && h && v.width && l && v.time === Je.time && !v.uncache)
    return xe(o / v.width * d);
  if (h && (t === "height" || t === "width")) {
    var y = e.style[t];
    e.style[t] = d + i, g = e[c], y ? e.style[t] = y : Ir(e, t);
  } else
    (h || a === "%") && !kC[dt(p, "display")] && (s.position = dt(e, "position")), p === e && (s.position = "static"), p.appendChild(br), g = br[c], p.removeChild(br), s.position = "absolute";
  return l && h && (v = Cr(p), v.time = Je.time, v.width = p[c]), xe(f ? g * o / d : g && o ? d / g * o : 0);
}, Dt = function(e, t, r, i) {
  var o;
  return qu || zl(), t in wt && t !== "transform" && (t = wt[t], ~t.indexOf(",") && (t = t.split(",")[0])), jt[t] && t !== "transform" ? (o = Hn(e, i), o = t !== "transformOrigin" ? o[t] : o.svg ? o.origin : bi(dt(e, Ze)) + " " + o.zOrigin + "px") : (o = e.style[t], (!o || o === "auto" || i || ~(o + "").indexOf("calc(")) && (o = _i[t] && _i[t](e, t, r) || dt(e, t) || Uv(e, t) || (t === "opacity" ? 1 : 0))), r && !~(o + "").trim().indexOf(" ") ? ar(e, t, o, r) + r : o;
}, DC = function(e, t, r, i) {
  if (!r || r === "none") {
    var o = tn(t, e, 1), a = o && dt(e, o, 1);
    a && a !== r ? (t = o, r = a) : t === "borderColor" && (r = dt(e, "borderTopColor"));
  }
  var s = new Ye(this._pt, e.style, t, 0, 1, pg), l = 0, u = 0, c, d, f, h, g, p, v, w, y, _, b, C;
  if (s.b = r, s.e = i, r += "", i += "", i.substring(0, 6) === "var(--" && (i = dt(e, i.substring(4, i.indexOf(")")))), i === "auto" && (p = e.style[t], e.style[t] = i, i = dt(e, t) || i, p ? e.style[t] = p : Ir(e, t)), c = [r, i], ig(c), r = c[0], i = c[1], f = r.match(jr) || [], C = i.match(jr) || [], C.length) {
    for (; d = jr.exec(i); )
      v = d[0], y = i.substring(l, d.index), g ? g = (g + 1) % 5 : (y.substr(-5) === "rgba(" || y.substr(-5) === "hsla(") && (g = 1), v !== (p = f[u++] || "") && (h = parseFloat(p) || 0, b = p.substr((h + "").length), v.charAt(1) === "=" && (v = Wr(h, v) + b), w = parseFloat(v), _ = v.substr((w + "").length), l = jr.lastIndex - _.length, _ || (_ = _ || nt.units[t] || b, l === i.length && (i += _, s.e += _)), b !== _ && (h = ar(e, t, p, _) || 0), s._pt = {
        _next: s._pt,
        p: y || u === 1 ? y : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: h,
        c: w - h,
        m: g && g < 4 || t === "zIndex" ? Math.round : 0
      });
    s.c = l < i.length ? i.substring(l, i.length) : "";
  } else
    s.r = t === "display" && i === "none" ? _g : mg;
  return Rv.test(i) && (s.e = 0), this._pt = s, s;
}, Lh = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, RC = function(e) {
  var t = e.split(" "), r = t[0], i = t[1] || "50%";
  return (r === "top" || r === "bottom" || i === "left" || i === "right") && (e = r, r = i, i = e), t[0] = Lh[r] || r, t[1] = Lh[i] || i, t.join(" ");
}, PC = function(e, t) {
  if (t.tween && t.tween._time === t.tween._dur) {
    var r = t.t, i = r.style, o = t.u, a = r._gsap, s, l, u;
    if (o === "all" || o === !0)
      i.cssText = "", l = 1;
    else
      for (o = o.split(","), u = o.length; --u > -1; )
        s = o[u], jt[s] && (l = 1, s = s === "transformOrigin" ? Ze : we), Ir(r, s);
    l && (Ir(r, we), a && (a.svg && r.removeAttribute("transform"), i.scale = i.rotate = i.translate = "none", Hn(r, 1), a.uncache = 1, bg(i)));
  }
}, _i = {
  clearProps: function(e, t, r, i, o) {
    if (o.data !== "isFromStart") {
      var a = e._pt = new Ye(e._pt, t, r, 0, 0, PC);
      return a.u = i, a.pr = -10, a.tween = o, e._props.push(r), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, jn = [1, 0, 0, 1, 0, 0], Sg = {}, xg = function(e) {
  return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, qh = function(e) {
  var t = dt(e, we);
  return xg(t) ? jn : t.substr(7).match(Dv).map(xe);
}, ju = function(e, t) {
  var r = e._gsap || Cr(e), i = e.style, o = qh(e), a, s, l, u;
  return r.svg && e.getAttribute("transform") ? (l = e.transform.baseVal.consolidate().matrix, o = [l.a, l.b, l.c, l.d, l.e, l.f], o.join(",") === "1,0,0,1,0,0" ? jn : o) : (o === jn && !e.offsetParent && e !== Gr && !r.svg && (l = i.display, i.display = "block", a = e.parentNode, (!a || !e.offsetParent && !e.getBoundingClientRect().width) && (u = 1, s = e.nextElementSibling, Gr.appendChild(e)), o = qh(e), l ? i.display = l : Ir(e, "display"), u && (s ? a.insertBefore(e, s) : a ? a.appendChild(e) : Gr.removeChild(e))), t && o.length > 6 ? [o[0], o[1], o[4], o[5], o[12], o[13]] : o);
}, Wl = function(e, t, r, i, o, a) {
  var s = e._gsap, l = o || ju(e, !0), u = s.xOrigin || 0, c = s.yOrigin || 0, d = s.xOffset || 0, f = s.yOffset || 0, h = l[0], g = l[1], p = l[2], v = l[3], w = l[4], y = l[5], _ = t.split(" "), b = parseFloat(_[0]) || 0, C = parseFloat(_[1]) || 0, m, T, x, A;
  r ? l !== jn && (T = h * v - g * p) && (x = b * (v / T) + C * (-p / T) + (p * y - v * w) / T, A = b * (-g / T) + C * (h / T) - (h * y - g * w) / T, b = x, C = A) : (m = wg(e), b = m.x + (~_[0].indexOf("%") ? b / 100 * m.width : b), C = m.y + (~(_[1] || _[0]).indexOf("%") ? C / 100 * m.height : C)), i || i !== !1 && s.smooth ? (w = b - u, y = C - c, s.xOffset = d + (w * h + y * p) - w, s.yOffset = f + (w * g + y * v) - y) : s.xOffset = s.yOffset = 0, s.xOrigin = b, s.yOrigin = C, s.smooth = !!i, s.origin = t, s.originIsAbsolute = !!r, e.style[Ze] = "0px 0px", a && (Jt(a, s, "xOrigin", u, b), Jt(a, s, "yOrigin", c, C), Jt(a, s, "xOffset", d, s.xOffset), Jt(a, s, "yOffset", f, s.yOffset)), e.setAttribute("data-svg-origin", b + " " + C);
}, Hn = function(e, t) {
  var r = e._gsap || new lg(e);
  if ("x" in r && !t && !r.uncache)
    return r;
  var i = e.style, o = r.scaleX < 0, a = "px", s = "deg", l = getComputedStyle(e), u = dt(e, Ze) || "0", c, d, f, h, g, p, v, w, y, _, b, C, m, T, x, A, M, O, S, P, k, E, q, H, z, ee, se, ue, oe, le, ce, be;
  return c = d = f = p = v = w = y = _ = b = 0, h = g = 1, r.svg = !!(e.getCTM && Tg(e)), l.translate && ((l.translate !== "none" || l.scale !== "none" || l.rotate !== "none") && (i[we] = (l.translate !== "none" ? "translate3d(" + (l.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (l.rotate !== "none" ? "rotate(" + l.rotate + ") " : "") + (l.scale !== "none" ? "scale(" + l.scale.split(" ").join(",") + ") " : "") + (l[we] !== "none" ? l[we] : "")), i.scale = i.rotate = i.translate = "none"), T = ju(e, r.svg), r.svg && (r.uncache ? (z = e.getBBox(), u = r.xOrigin - z.x + "px " + (r.yOrigin - z.y) + "px", H = "") : H = !t && e.getAttribute("data-svg-origin"), Wl(e, H || u, !!H || r.originIsAbsolute, r.smooth !== !1, T)), C = r.xOrigin || 0, m = r.yOrigin || 0, T !== jn && (O = T[0], S = T[1], P = T[2], k = T[3], c = E = T[4], d = q = T[5], T.length === 6 ? (h = Math.sqrt(O * O + S * S), g = Math.sqrt(k * k + P * P), p = O || S ? Lr(S, O) * gr : 0, y = P || k ? Lr(P, k) * gr + p : 0, y && (g *= Math.abs(Math.cos(y * Yr))), r.svg && (c -= C - (C * O + m * P), d -= m - (C * S + m * k))) : (be = T[6], le = T[7], se = T[8], ue = T[9], oe = T[10], ce = T[11], c = T[12], d = T[13], f = T[14], x = Lr(be, oe), v = x * gr, x && (A = Math.cos(-x), M = Math.sin(-x), H = E * A + se * M, z = q * A + ue * M, ee = be * A + oe * M, se = E * -M + se * A, ue = q * -M + ue * A, oe = be * -M + oe * A, ce = le * -M + ce * A, E = H, q = z, be = ee), x = Lr(-P, oe), w = x * gr, x && (A = Math.cos(-x), M = Math.sin(-x), H = O * A - se * M, z = S * A - ue * M, ee = P * A - oe * M, ce = k * M + ce * A, O = H, S = z, P = ee), x = Lr(S, O), p = x * gr, x && (A = Math.cos(x), M = Math.sin(x), H = O * A + S * M, z = E * A + q * M, S = S * A - O * M, q = q * A - E * M, O = H, E = z), v && Math.abs(v) + Math.abs(p) > 359.9 && (v = p = 0, w = 180 - w), h = xe(Math.sqrt(O * O + S * S + P * P)), g = xe(Math.sqrt(q * q + be * be)), x = Lr(E, q), y = Math.abs(x) > 2e-4 ? x * gr : 0, b = ce ? 1 / (ce < 0 ? -ce : ce) : 0), r.svg && (H = e.getAttribute("transform"), r.forceCSS = e.setAttribute("transform", "") || !xg(dt(e, we)), H && e.setAttribute("transform", H))), Math.abs(y) > 90 && Math.abs(y) < 270 && (o ? (h *= -1, y += p <= 0 ? 180 : -180, p += p <= 0 ? 180 : -180) : (g *= -1, y += y <= 0 ? 180 : -180)), t = t || r.uncache, r.x = c - ((r.xPercent = c && (!t && r.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-c) ? -50 : 0))) ? e.offsetWidth * r.xPercent / 100 : 0) + a, r.y = d - ((r.yPercent = d && (!t && r.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-d) ? -50 : 0))) ? e.offsetHeight * r.yPercent / 100 : 0) + a, r.z = f + a, r.scaleX = xe(h), r.scaleY = xe(g), r.rotation = xe(p) + s, r.rotationX = xe(v) + s, r.rotationY = xe(w) + s, r.skewX = y + s, r.skewY = _ + s, r.transformPerspective = b + a, (r.zOrigin = parseFloat(u.split(" ")[2]) || !t && r.zOrigin || 0) && (i[Ze] = bi(u)), r.xOffset = r.yOffset = 0, r.force3D = nt.force3D, r.renderTransform = r.svg ? LC : Cg ? Ag : MC, r.uncache = 0, r;
}, bi = function(e) {
  return (e = e.split(" "))[0] + " " + e[1];
}, Ys = function(e, t, r) {
  var i = Be(t);
  return xe(parseFloat(t) + parseFloat(ar(e, "x", r + "px", i))) + i;
}, MC = function(e, t) {
  t.z = "0px", t.rotationY = t.rotationX = "0deg", t.force3D = 0, Ag(e, t);
}, pr = "0deg", cn = "0px", vr = ") ", Ag = function(e, t) {
  var r = t || this, i = r.xPercent, o = r.yPercent, a = r.x, s = r.y, l = r.z, u = r.rotation, c = r.rotationY, d = r.rotationX, f = r.skewX, h = r.skewY, g = r.scaleX, p = r.scaleY, v = r.transformPerspective, w = r.force3D, y = r.target, _ = r.zOrigin, b = "", C = w === "auto" && e && e !== 1 || w === !0;
  if (_ && (d !== pr || c !== pr)) {
    var m = parseFloat(c) * Yr, T = Math.sin(m), x = Math.cos(m), A;
    m = parseFloat(d) * Yr, A = Math.cos(m), a = Ys(y, a, T * A * -_), s = Ys(y, s, -Math.sin(m) * -_), l = Ys(y, l, x * A * -_ + _);
  }
  v !== cn && (b += "perspective(" + v + vr), (i || o) && (b += "translate(" + i + "%, " + o + "%) "), (C || a !== cn || s !== cn || l !== cn) && (b += l !== cn || C ? "translate3d(" + a + ", " + s + ", " + l + ") " : "translate(" + a + ", " + s + vr), u !== pr && (b += "rotate(" + u + vr), c !== pr && (b += "rotateY(" + c + vr), d !== pr && (b += "rotateX(" + d + vr), (f !== pr || h !== pr) && (b += "skew(" + f + ", " + h + vr), (g !== 1 || p !== 1) && (b += "scale(" + g + ", " + p + vr), y.style[we] = b || "translate(0, 0)";
}, LC = function(e, t) {
  var r = t || this, i = r.xPercent, o = r.yPercent, a = r.x, s = r.y, l = r.rotation, u = r.skewX, c = r.skewY, d = r.scaleX, f = r.scaleY, h = r.target, g = r.xOrigin, p = r.yOrigin, v = r.xOffset, w = r.yOffset, y = r.forceCSS, _ = parseFloat(a), b = parseFloat(s), C, m, T, x, A;
  l = parseFloat(l), u = parseFloat(u), c = parseFloat(c), c && (c = parseFloat(c), u += c, l += c), l || u ? (l *= Yr, u *= Yr, C = Math.cos(l) * d, m = Math.sin(l) * d, T = Math.sin(l - u) * -f, x = Math.cos(l - u) * f, u && (c *= Yr, A = Math.tan(u - c), A = Math.sqrt(1 + A * A), T *= A, x *= A, c && (A = Math.tan(c), A = Math.sqrt(1 + A * A), C *= A, m *= A)), C = xe(C), m = xe(m), T = xe(T), x = xe(x)) : (C = d, x = f, m = T = 0), (_ && !~(a + "").indexOf("px") || b && !~(s + "").indexOf("px")) && (_ = ar(h, "x", a, "px"), b = ar(h, "y", s, "px")), (g || p || v || w) && (_ = xe(_ + g - (g * C + p * T) + v), b = xe(b + p - (g * m + p * x) + w)), (i || o) && (A = h.getBBox(), _ = xe(_ + i / 100 * A.width), b = xe(b + o / 100 * A.height)), A = "matrix(" + C + "," + m + "," + T + "," + x + "," + _ + "," + b + ")", h.setAttribute("transform", A), y && (h.style[we] = A);
}, qC = function(e, t, r, i, o) {
  var a = 360, s = De(o), l = parseFloat(o) * (s && ~o.indexOf("rad") ? gr : 1), u = l - i, c = i + u + "deg", d, f;
  return s && (d = o.split("_")[1], d === "short" && (u %= a, u !== u % (a / 2) && (u += u < 0 ? a : -a)), d === "cw" && u < 0 ? u = (u + a * kh) % a - ~~(u / a) * a : d === "ccw" && u > 0 && (u = (u - a * kh) % a - ~~(u / a) * a)), e._pt = f = new Ye(e._pt, t, r, i, u, yC), f.e = c, f.u = "deg", e._props.push(r), f;
}, Bh = function(e, t) {
  for (var r in t)
    e[r] = t[r];
  return e;
}, BC = function(e, t, r) {
  var i = Bh({}, r._gsap), o = "perspective,force3D,transformOrigin,svgOrigin", a = r.style, s, l, u, c, d, f, h, g;
  i.svg ? (u = r.getAttribute("transform"), r.setAttribute("transform", ""), a[we] = t, s = Hn(r, 1), Ir(r, we), r.setAttribute("transform", u)) : (u = getComputedStyle(r)[we], a[we] = t, s = Hn(r, 1), a[we] = u);
  for (l in jt)
    u = i[l], c = s[l], u !== c && o.indexOf(l) < 0 && (h = Be(u), g = Be(c), d = h !== g ? ar(r, l, u, g) : parseFloat(u), f = parseFloat(c), e._pt = new Ye(e._pt, s, l, d, f - d, Fl), e._pt.u = g || 0, e._props.push(l));
  Bh(s, i);
};
Ge("padding,margin,Width,Radius", function(n, e) {
  var t = "Top", r = "Right", i = "Bottom", o = "Left", a = (e < 3 ? [t, r, i, o] : [t + o, t + r, i + r, i + o]).map(function(s) {
    return e < 2 ? n + s : "border" + s + n;
  });
  _i[e > 1 ? "border" + n : n] = function(s, l, u, c, d) {
    var f, h;
    if (arguments.length < 4)
      return f = a.map(function(g) {
        return Dt(s, g, u);
      }), h = f.join(" "), h.split(f[0]).length === 5 ? f[0] : h;
    f = (c + "").split(" "), h = {}, a.forEach(function(g, p) {
      return h[g] = f[p] = f[p] || f[(p - 1) / 2 | 0];
    }), s.init(l, h, d);
  };
});
var Og = {
  name: "css",
  register: zl,
  targetTest: function(e) {
    return e.style && e.nodeType;
  },
  init: function(e, t, r, i, o) {
    var a = this._props, s = e.style, l = r.vars.startAt, u, c, d, f, h, g, p, v, w, y, _, b, C, m, T, x;
    qu || zl(), this.styles = this.styles || yg(e), x = this.styles.props, this.tween = r;
    for (p in t)
      if (p !== "autoRound" && (c = t[p], !(Ke[p] && ug(p, t, r, i, e, o)))) {
        if (h = typeof c, g = _i[p], h === "function" && (c = c.call(r, i, e, o), h = typeof c), h === "string" && ~c.indexOf("random(") && (c = qn(c)), g)
          g(this, e, p, c, r) && (T = 1);
        else if (p.substr(0, 2) === "--")
          u = (getComputedStyle(e).getPropertyValue(p) + "").trim(), c += "", rr.lastIndex = 0, rr.test(u) || (v = Be(u), w = Be(c)), w ? v !== w && (u = ar(e, p, u, w) + w) : v && (c += v), this.add(s, "setProperty", u, c, i, o, 0, 0, p), a.push(p), x.push(p, 0, s[p]);
        else if (h !== "undefined") {
          if (l && p in l ? (u = typeof l[p] == "function" ? l[p].call(r, i, e, o) : l[p], De(u) && ~u.indexOf("random(") && (u = qn(u)), Be(u + "") || u === "auto" || (u += nt.units[p] || Be(Dt(e, p)) || ""), (u + "").charAt(1) === "=" && (u = Dt(e, p))) : u = Dt(e, p), f = parseFloat(u), y = h === "string" && c.charAt(1) === "=" && c.substr(0, 2), y && (c = c.substr(2)), d = parseFloat(c), p in wt && (p === "autoAlpha" && (f === 1 && Dt(e, "visibility") === "hidden" && d && (f = 0), x.push("visibility", 0, s.visibility), Jt(this, s, "visibility", f ? "inherit" : "hidden", d ? "inherit" : "hidden", !d)), p !== "scale" && p !== "transform" && (p = wt[p], ~p.indexOf(",") && (p = p.split(",")[0]))), _ = p in jt, _) {
            if (this.styles.save(p), h === "string" && c.substring(0, 6) === "var(--" && (c = dt(e, c.substring(4, c.indexOf(")"))), d = parseFloat(c)), b || (C = e._gsap, C.renderTransform && !t.parseTransform || Hn(e, t.parseTransform), m = t.smoothOrigin !== !1 && C.smooth, b = this._pt = new Ye(this._pt, s, we, 0, 1, C.renderTransform, C, 0, -1), b.dep = 1), p === "scale")
              this._pt = new Ye(this._pt, C, "scaleY", C.scaleY, (y ? Wr(C.scaleY, y + d) : d) - C.scaleY || 0, Fl), this._pt.u = 0, a.push("scaleY", p), p += "X";
            else if (p === "transformOrigin") {
              x.push(Ze, 0, s[Ze]), c = RC(c), C.svg ? Wl(e, c, 0, m, 0, this) : (w = parseFloat(c.split(" ")[2]) || 0, w !== C.zOrigin && Jt(this, C, "zOrigin", C.zOrigin, w), Jt(this, s, p, bi(u), bi(c)));
              continue;
            } else if (p === "svgOrigin") {
              Wl(e, c, 1, m, 0, this);
              continue;
            } else if (p in Sg) {
              qC(this, C, p, f, y ? Wr(f, y + c) : c);
              continue;
            } else if (p === "smoothOrigin") {
              Jt(this, C, "smooth", C.smooth, c);
              continue;
            } else if (p === "force3D") {
              C[p] = c;
              continue;
            } else if (p === "transform") {
              BC(this, c, e);
              continue;
            }
          } else p in s || (p = tn(p) || p);
          if (_ || (d || d === 0) && (f || f === 0) && !bC.test(c) && p in s)
            v = (u + "").substr((f + "").length), d || (d = 0), w = Be(c) || (p in nt.units ? nt.units[p] : v), v !== w && (f = ar(e, p, u, w)), this._pt = new Ye(this._pt, _ ? C : s, p, f, (y ? Wr(f, y + d) : d) - f, !_ && (w === "px" || p === "zIndex") && t.autoRound !== !1 ? wC : Fl), this._pt.u = w || 0, v !== w && w !== "%" && (this._pt.b = u, this._pt.r = CC);
          else if (p in s)
            DC.call(this, e, p, u, y ? y + c : c);
          else if (p in e)
            this.add(e, p, u || e[p], y ? y + c : c, i, o);
          else if (p !== "parseTransform") {
            Ou(p, c);
            continue;
          }
          _ || (p in s ? x.push(p, 0, s[p]) : typeof e[p] == "function" ? x.push(p, 2, e[p]()) : x.push(p, 1, u || e[p])), a.push(p);
        }
      }
    T && vg(this);
  },
  render: function(e, t) {
    if (t.tween._time || !Bu())
      for (var r = t._pt; r; )
        r.r(e, r.d), r = r._next;
    else
      t.styles.revert();
  },
  get: Dt,
  aliases: wt,
  getSetter: function(e, t, r) {
    var i = wt[t];
    return i && i.indexOf(",") < 0 && (t = i), t in jt && t !== Ze && (e._gsap.x || Dt(e, "x")) ? r && Nh === r ? t === "scale" ? AC : xC : (Nh = r || {}) && (t === "scale" ? OC : EC) : e.style && !Su(e.style[t]) ? TC : ~t.indexOf("-") ? SC : Mu(e, t);
  },
  core: {
    _removeProperty: Ir,
    _getMatrix: ju
  }
};
Xe.utils.checkPrefix = tn;
Xe.core.getStyleSaver = yg;
(function(n, e, t, r) {
  var i = Ge(n + "," + e + "," + t, function(o) {
    jt[o] = 1;
  });
  Ge(e, function(o) {
    nt.units[o] = "deg", Sg[o] = 1;
  }), wt[i[13]] = n + "," + e, Ge(r, function(o) {
    var a = o.split(":");
    wt[a[1]] = i[a[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Ge("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(n) {
  nt.units[n] = "px";
});
Xe.registerPlugin(Og);
var Gl = Xe.registerPlugin(Og) || Xe;
Gl.core.Tween;
function Eg(n, e = {}) {
  const {
    fadeDuration: t = 0.4,
    fadeEase: r = "power2.out",
    fromScale: i = 0.95,
    toScale: o = 1,
    autoPlay: a = !0
  } = e;
  let s;
  const l = () => {
    const u = (lp(n) ? n : Q(n)).value;
    if (u)
      return s && s.kill(), Gl.set(u, { opacity: 0, scale: i, willChange: "transform,opacity" }), s = Gl.to(u, {
        opacity: 1,
        scale: o,
        duration: t,
        ease: r,
        clearProps: "willChange"
      }), s;
  };
  return mt(() => {
    a && l();
  }), Yl(() => s && s.kill()), { play: l };
}
var Zs, Uh;
function UC() {
  if (Uh) return Zs;
  Uh = 1;
  var n = Gp(), e = Di(), t = au(), r = lr(), i = Fn(), o = Ii(), a = Ei(), s = uu(), l = "[object Map]", u = "[object Set]", c = Object.prototype, d = c.hasOwnProperty;
  function f(h) {
    if (h == null)
      return !0;
    if (i(h) && (r(h) || typeof h == "string" || typeof h.splice == "function" || o(h) || s(h) || t(h)))
      return !h.length;
    var g = e(h);
    if (g == l || g == u)
      return !h.size;
    if (a(h))
      return !n(h).length;
    for (var p in h)
      if (d.call(h, p))
        return !1;
    return !0;
  }
  return Zs = f, Zs;
}
var jC = UC();
const HC = /* @__PURE__ */ Ht(jC);
var Xs, jh;
function $C() {
  if (jh) return Xs;
  jh = 1;
  var n = "__lodash_hash_undefined__";
  function e(t) {
    return this.__data__.set(t, n), this;
  }
  return Xs = e, Xs;
}
var Ks, Hh;
function FC() {
  if (Hh) return Ks;
  Hh = 1;
  function n(e) {
    return this.__data__.has(e);
  }
  return Ks = n, Ks;
}
var Qs, $h;
function VC() {
  if ($h) return Qs;
  $h = 1;
  var n = ru(), e = $C(), t = FC();
  function r(i) {
    var o = -1, a = i == null ? 0 : i.length;
    for (this.__data__ = new n(); ++o < a; )
      this.add(i[o]);
  }
  return r.prototype.add = r.prototype.push = e, r.prototype.has = t, Qs = r, Qs;
}
var Js, Fh;
function zC() {
  if (Fh) return Js;
  Fh = 1;
  function n(e, t, r, i) {
    for (var o = e.length, a = r + (i ? 1 : -1); i ? a-- : ++a < o; )
      if (t(e[a], a, e))
        return a;
    return -1;
  }
  return Js = n, Js;
}
var el, Vh;
function WC() {
  if (Vh) return el;
  Vh = 1;
  function n(e) {
    return e !== e;
  }
  return el = n, el;
}
var tl, zh;
function GC() {
  if (zh) return tl;
  zh = 1;
  function n(e, t, r) {
    for (var i = r - 1, o = e.length; ++i < o; )
      if (e[i] === t)
        return i;
    return -1;
  }
  return tl = n, tl;
}
var rl, Wh;
function YC() {
  if (Wh) return rl;
  Wh = 1;
  var n = zC(), e = WC(), t = GC();
  function r(i, o, a) {
    return o === o ? t(i, o, a) : n(i, e, a);
  }
  return rl = r, rl;
}
var nl, Gh;
function ZC() {
  if (Gh) return nl;
  Gh = 1;
  var n = YC();
  function e(t, r) {
    var i = t == null ? 0 : t.length;
    return !!i && n(t, r, 0) > -1;
  }
  return nl = e, nl;
}
var il, Yh;
function XC() {
  if (Yh) return il;
  Yh = 1;
  function n(e, t, r) {
    for (var i = -1, o = e == null ? 0 : e.length; ++i < o; )
      if (r(t, e[i]))
        return !0;
    return !1;
  }
  return il = n, il;
}
var ol, Zh;
function KC() {
  if (Zh) return ol;
  Zh = 1;
  function n(e, t) {
    return e.has(t);
  }
  return ol = n, ol;
}
var al, Xh;
function QC() {
  if (Xh) return al;
  Xh = 1;
  function n() {
  }
  return al = n, al;
}
var sl, Kh;
function Ig() {
  if (Kh) return sl;
  Kh = 1;
  function n(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(i) {
      r[++t] = i;
    }), r;
  }
  return sl = n, sl;
}
var ll, Qh;
function JC() {
  if (Qh) return ll;
  Qh = 1;
  var n = Qp(), e = QC(), t = Ig(), r = 1 / 0, i = n && 1 / t(new n([, -0]))[1] == r ? function(o) {
    return new n(o);
  } : e;
  return ll = i, ll;
}
var ul, Jh;
function ew() {
  if (Jh) return ul;
  Jh = 1;
  var n = VC(), e = ZC(), t = XC(), r = KC(), i = JC(), o = Ig(), a = 200;
  function s(l, u, c) {
    var d = -1, f = e, h = l.length, g = !0, p = [], v = p;
    if (c)
      g = !1, f = t;
    else if (h >= a) {
      var w = u ? null : i(l);
      if (w)
        return o(w);
      g = !1, f = r, v = new n();
    } else
      v = u ? [] : p;
    e:
      for (; ++d < h; ) {
        var y = l[d], _ = u ? u(y) : y;
        if (y = c || y !== 0 ? y : 0, g && _ === _) {
          for (var b = v.length; b--; )
            if (v[b] === _)
              continue e;
          u && v.push(_), p.push(y);
        } else f(v, _, c) || (v !== p && v.push(_), p.push(y));
      }
    return p;
  }
  return ul = s, ul;
}
var cl, ep;
function tw() {
  if (ep) return cl;
  ep = 1;
  var n = ew();
  function e(t) {
    return t && t.length ? n(t) : [];
  }
  return cl = e, cl;
}
var rw = tw();
const nw = /* @__PURE__ */ Ht(rw);
function ft({ state: n = {} }) {
  var Dr;
  const e = ((Dr = n == null ? void 0 : n.value) == null ? void 0 : Dr.builder) || {}, t = e.sharedContent || {}, r = t.onContentCreated, i = t.onOpenSettings, o = t.onSaveContentEdited, a = t.onCancelContentEdited, s = t.onContentDetached, l = t.onSharedContentDeleted, u = I(
    () => {
      var N, L, F, W;
      return !!((W = (F = (L = (N = n == null ? void 0 : n.value) == null ? void 0 : N.builder) == null ? void 0 : L.customProperties) == null ? void 0 : F.global) != null && W.sharedContentAllowed);
    }
  ), c = I(
    () => {
      var N, L, F;
      return !!u.value && !!((F = (L = (N = n == null ? void 0 : n.value) == null ? void 0 : N.builder) == null ? void 0 : L.sharedContent) != null && F.createSharedContentAllowed);
    }
  ), d = I(
    () => {
      var N, L, F;
      return !!u.value && !!((F = (L = (N = n == null ? void 0 : n.value) == null ? void 0 : N.builder) == null ? void 0 : L.sharedContent) != null && F.editSharedContentAllowed);
    }
  ), f = I(
    () => {
      var N, L, F;
      return !!u.value && !!((F = (L = (N = n == null ? void 0 : n.value) == null ? void 0 : N.builder) == null ? void 0 : L.sharedContent) != null && F.detachSharedContentAllowed);
    }
  ), h = I(
    () => {
      var N, L, F;
      return !HC(((F = (L = (N = n == null ? void 0 : n.value) == null ? void 0 : N.builder) == null ? void 0 : L.sharedContent) == null ? void 0 : F.content) || {});
    }
  ), g = I(
    () => Object.keys(t.content || {}).length
  ), p = (N) => (N == null ? void 0 : N.type) === Qe, v = I(
    () => {
      var N, L;
      return c.value && !p((N = n == null ? void 0 : n.value) == null ? void 0 : N.activeNode) && !A((L = n == null ? void 0 : n.value) == null ? void 0 : L.activeNode);
    }
  ), w = I(
    () => {
      var N;
      return d.value && p((N = n == null ? void 0 : n.value) == null ? void 0 : N.activeNode);
    }
  ), y = I(
    () => {
      var N;
      return f.value && p((N = n == null ? void 0 : n.value) == null ? void 0 : N.activeNode);
    }
  ), _ = async ({
    node: N = null,
    name: L = "New shared content",
    icon: F = "16:paper-plane",
    accordionId: W = null,
    preventNodeTypes: ie = []
  } = {}) => {
    var re, pt, ye, Vt;
    if (!N && !((re = n == null ? void 0 : n.value) != null && re.activeNode)) return;
    W && (N = Lt(e.structure, W)), ((ye = (pt = n == null ? void 0 : n.value) == null ? void 0 : pt.activeNode) == null ? void 0 : ye.type) === Tt && (N = Lt(e.structure, n.value.activeNode.parentAccordionId));
    let ve = ae();
    const Z = N || ((Vt = n == null ? void 0 : n.value) == null ? void 0 : Vt.activeNode);
    let Re = Dn(Z);
    if (Re = ce(Re), !(ie.length > 0 && ie.some(
      (_t) => !!nv(Z, _t)
    ))) {
      if (typeof r == "function") {
        const It = await r([Re]);
        if (!It) return;
        ve = It.id || ve, L = It.name || L;
      }
      q({
        id: ve,
        name: L,
        icon: F,
        content: Re
      }), H({
        sharedContentId: ve,
        idToReplace: Z.id
      });
    }
  }, b = async (N) => {
    typeof i == "function" && i(N);
  }, C = (N, L, F, W) => {
    var ie, ve;
    n.value && (n.value.editingSharedContent.node = (ie = n == null ? void 0 : n.value) == null ? void 0 : ie.activeNode, n.value.editingSharedContent.boundingRect = {
      top: N,
      left: L,
      width: F,
      height: W
    }, n.value.editingSharedContent.originalContent = Or(
      t.content[(ve = n == null ? void 0 : n.value) == null ? void 0 : ve.activeNode.sharedContentId].content
    ));
  }, m = (N) => {
    var L;
    t.content[(L = n == null ? void 0 : n.value) == null ? void 0 : L.editingSharedContent.node.sharedContentId].content.push(N);
  }, T = I(
    () => {
      var N, L;
      return ((L = (N = n == null ? void 0 : n.value) == null ? void 0 : N.editingSharedContent) == null ? void 0 : L.node) || null;
    }
  ), x = I({
    get: () => {
      var N, L;
      return ((L = t == null ? void 0 : t.content) == null ? void 0 : L[(N = T.value) == null ? void 0 : N.sharedContentId]) || {};
    },
    set: (N) => {
      var L;
      return t.content[(L = T.value) == null ? void 0 : L.sharedContentId] = N;
    }
  }), A = (N) => !!Lt(T.value, N.id), M = (N) => {
    var L;
    return ((L = T.value) == null ? void 0 : L.id) === N.id;
  }, O = I(() => T.value ? {
    isBlocked: !1,
    message: ""
  } : {
    isBlocked: !0,
    message: "builder.cannotNestSharedContent"
  }), S = I(() => (N) => M(N)), P = async () => {
    var L;
    const N = (L = n == null ? void 0 : n.value) == null ? void 0 : L.editingSharedContent.node.sharedContentId;
    if (N) {
      if (typeof o == "function") {
        const F = t.content[N].content || [];
        if (!await o(
          N,
          F
        )) return;
      }
      le();
    }
  }, k = async () => {
    var L, F, W;
    const N = (L = n == null ? void 0 : n.value) == null ? void 0 : L.editingSharedContent.node.sharedContentId;
    N && (typeof a == "function" && !await a(N) || (t.content[(F = n == null ? void 0 : n.value) == null ? void 0 : F.editingSharedContent.node.sharedContentId].content = (W = n == null ? void 0 : n.value) == null ? void 0 : W.editingSharedContent.originalContent, le()));
  }, E = (N) => {
    var F, W;
    const L = (W = t == null ? void 0 : t.content[(F = N == null ? void 0 : N.value) == null ? void 0 : F.sharedContentId]) == null ? void 0 : W.content;
    return L ? N.value.nodes[0].nodes = L : (t.content[N.value.sharedContentId] = {
      content: [
        {
          id: N.value.sharedContentId,
          name: "Shared Component Error",
          type: kn
        }
      ]
    }, N.value.nodes[0].nodes = t.content[N.value.sharedContentId].content);
  };
  function q({ id: N, name: L, icon: F, content: W }) {
    t.content[N] = { name: L, icon: F, content: [W] };
  }
  function H({ sharedContentId: N, idToReplace: L }) {
    var ve;
    const F = Ve({
      sharedContentId: N,
      type: Qe
    }), { parent: W, index: ie } = Pt(
      e.structure,
      L
    );
    W.nodes.splice(ie, 1, F), (ve = n == null ? void 0 : n.value) == null || ve.setActiveNode(F);
  }
  const z = async () => {
    var ie, ve, Z, Re;
    const N = (ve = (ie = n == null ? void 0 : n.value) == null ? void 0 : ie.activeNode) == null ? void 0 : ve.sharedContentId;
    if (!f.value || !N || typeof s == "function" && !await s(N))
      return;
    const L = Dn({
      ...t.content[N].content[0]
    }), { parent: F, index: W } = Pt(
      e.structure,
      (Re = (Z = n == null ? void 0 : n.value) == null ? void 0 : Z.activeNode) == null ? void 0 : Re.id
    );
    F.nodes.splice(W, 1, L);
  }, ee = I(() => Object.entries(t.content || {}).map(([N, L]) => ({
    name: L.name,
    icon: L.icon,
    sharedContentId: N,
    type: Qe
  }))), se = (N) => {
    const { sharedContentId: L, name: F, type: W } = N;
    return Ve({ sharedContentId: L, type: W });
  }, ue = (N) => {
    var W;
    const L = Ve({
      type: wn
    }), F = {
      linked: !0,
      value: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    return L.properties = {
      ...L.properties,
      margin: { ...F },
      padding: { ...F }
    }, L.nodes[0].nodes = ((W = t.content[N]) == null ? void 0 : W.content) || [], L;
  }, oe = (N) => t.content[N] || {};
  function le() {
    var N;
    (N = n == null ? void 0 : n.value) == null || N.clearActiveNode(), n.value.editingSharedContent.node = null, n.value.editingSharedContent.boundingRect = null, n.value.editingSharedContent.originalContent = null;
  }
  function ce(N) {
    var L, F;
    switch (N.type) {
      case $n: {
        N.content.assetUrl = ((L = n == null ? void 0 : n.value) == null ? void 0 : L.builder.assets[N.content.assetId].url) || "";
        break;
      }
      case En:
      case In: {
        N.content.images = N.content.images.map((W) => {
          var ie;
          return W.content.assetUrl = ((ie = n == null ? void 0 : n.value) == null ? void 0 : ie.builder.assets[W.content.assetId].url) || "", W;
        });
        break;
      }
      case Nn: {
        N.content.image.content.assetUrl = ((F = n == null ? void 0 : n.value) == null ? void 0 : F.builder.assets[N.content.image.content.assetId].url) || "";
        break;
      }
    }
    return N;
  }
  const be = ({ allowDuplicates: N = !1 } = {}) => {
    var L, F;
    return (F = (L = n == null ? void 0 : n.value) == null ? void 0 : L.builder) != null && F.structure ? ht(n.value.builder.structure, N) : [];
  };
  function ht(N, L = !1) {
    const F = [], W = (ie) => {
      (ie == null ? void 0 : ie.type) === Qe && F.push(ie == null ? void 0 : ie.sharedContentId);
      let ve = (ie == null ? void 0 : ie.nodes) || {};
      Pi(ve, (Z) => {
        Ri(Z) && W(Z);
      });
    };
    return W(N), L ? F : nw(F);
  }
  return {
    amountOfSharedContent: g,
    isSharedContentAllowed: u,
    canCreateSharedContent: c,
    canEditSharedContent: d,
    canDetachSharedContent: f,
    showCreateSharedContentButton: v,
    showEditSharedContentButton: w,
    showDetachSharedContentButton: y,
    hasSharedContent: h,
    isSharedContentLayout: p,
    createSharedContent: _,
    openSharedContentSettings: b,
    isolateSharedContent: C,
    applyContentToSharedContentLayout: E,
    getSharedContentSidebarNodes: ee,
    onSidebarCloneSharedContent: se,
    generateDialogPreview: ue,
    getSharedContentById: oe,
    editingSharedContent: T,
    editingSharedContentNodes: x,
    isNodeInsideEditingSharedContentLayout: A,
    isCurrentSharedContentBeingEdited: M,
    showEditingSharedContentActions: S,
    blockSharedContentLayout: O,
    detachSharedContent: z,
    saveEditingSharedContent: P,
    cancelEditingSharedContent: k,
    addNodeToEditingSharedContent: m,
    extractSharedContentIds: be,
    deleteSharedContent: async (N) => {
      typeof l != "function" || !await l(N) || delete t.content[N];
    }
  };
}
const iw = {
  __name: "ContentNode",
  props: {
    modelValue: { type: Object, default: () => ({}) },
    level: { type: Number, default: 0 },
    inAccordion: Boolean,
    isEditable: Boolean,
    isActiveNode: Boolean
  },
  setup(n) {
    const e = n, t = Se("state"), r = op(e, "modelValue"), i = {
      EditableAccordionNode: Y(
        () => import("./EditableAccordionNode-DeOpeiSL.js")
      ),
      EditableAccordionPanelNode: Y(
        () => import("./EditableAccordionPanelNode-Bof-gYPT.js")
      ),
      EditableButtonNode: Y(
        () => import("./EditableButtonNode-DofAiWs1.js")
      ),
      EditableCardNode: Y(
        () => import("./EditableCardNode-BvYLy6Ds.js")
      ),
      EditableCodeNode: Y(
        () => import("./EditableCodeNode-xdoTemhx.js")
      ),
      EditableFormNode: Y(
        () => import("./EditableFormNode-C2OVZRoB.js")
      ),
      EditableGalleryNode: Y(
        () => import("./EditableGalleryNode-BtmO7hy4.js")
      ),
      EditableHeadingNode: Y(
        () => import("./EditableHeadingNode-C4nQnuLg.js")
      ),
      EditableImageNode: Y(
        () => import("./EditableImageNode-D3-KwI5Z.js")
      ),
      EditableListNode: Y(
        () => import("./EditableListNode-FYedlSCX.js")
      ),
      EditableQuoteNode: Y(
        () => import("./EditableQuoteNode-DjFBGp6l.js")
      ),
      EditableSeparatorNode: Y(
        () => import("./EditableSeparatorNode-B9mGeej3.js")
      ),
      EditableSpacerNode: Y(
        () => import("./EditableSpacerNode-BetvPw5z.js")
      ),
      EditableTableNode: Y(
        () => import("./EditableTableNode-r8fEYfiY.js")
      ),
      EditableTextNode: Y(
        () => import("./EditableTextNode-DCjhPUii.js")
      ),
      EditableVideoNode: Y(
        () => import("./EditableVideoNode-B43EaqB5.js")
      ),
      EditableSliderNode: Y(
        () => import("./EditableSliderNode-DKYtaeHK.js")
      ),
      EditableNavigationNode: Y(
        () => import("./EditableNavigationNode-DPX20yDW.js")
      ),
      EditableSharedContentErrorNode: Y(
        () => import("./EditableSharedContentErrorNode-g1DvQzmH.js")
      ),
      AccordionNode: Y(
        () => import("./AccordionNode-Dq-Jz1u5.js")
      ),
      AccordionPanelNode: Y(
        () => import("./AccordionPanelNode-CncHOxR0.js")
      ),
      ButtonNode: Y(() => import("./ButtonNode-YQoPwBFN.js").then((_) => _.b)),
      CardNode: Y(() => import("./CardNode-ChTe_lgl.js")),
      CodeNode: Y(() => import("./CodeNode-DwoE4N9S.js")),
      FormNode: Y(() => import("./FormNode-DBGaQA95.js").then((_) => _.a)),
      GalleryNode: Y(() => import("./GalleryNode-CnTmsKBl.js").then((_) => _.b)),
      HeadingNode: Y(() => import("./HeadingNode-B-ltoJx0.js")),
      ImageNode: Y(() => import("./ImageNode-BsdRpIBY.js").then((_) => _.a)),
      ListNode: Y(() => import("./ListNode-BpWyayOe.js")),
      NavigationNode: Y(
        () => import("./NavigationNode-CkCXoJUv.js")
      ),
      QuoteNode: Y(() => import("./QuoteNode-LBqukaCX.js")),
      SeparatorNode: Y(
        () => import("./SeparatorNode-DWm_HLCL.js")
      ),
      SliderNode: Y(() => import("./SliderNode-BixCD6c_.js")),
      SpacerNode: Y(() => import("./SpacerNode-2-KDiTDZ.js")),
      TableNode: Y(() => import("./TableNode-B00rn29h.js")),
      TextNode: Y(() => import("./TextNode-Dt-5QzMF.js")),
      VideoNode: Y(() => import("./VideoNode-DhVe66GJ.js").then((_) => _.a)),
      SharedContentErrorNode: Y(
        () => import("./SharedContentErrorNode-D66T6ULq.js")
      )
    }, o = Se("insideSharedContentLayout"), a = I(
      () => e.isEditable && o.value
    ), s = I(
      () => e.isEditable && !o.value
    ), l = Se("isRenderMode"), { isNodeInsideEditingSharedContentLayout: u } = ft({ state: t }), c = I(() => {
      var _, b;
      return l.value ? !1 : !!((b = (_ = t == null ? void 0 : t.value) == null ? void 0 : _.editingSharedContent) != null && b.node) && !u(r.value);
    }), d = I(() => {
      const b = [...Ci, ...gp].find(
        (m) => m.type === r.value.type
      );
      return (s.value ? `Editable${b.component}` : b.component) || "div";
    }), f = I(() => [
      `content-level-${e.level}`,
      { "in-accordion": e.inAccordion },
      { "is-active": e.isActiveNode && s.value },
      { "is-editable": s.value }
    ]), h = I(
      () => {
        var _, b, C, m, T;
        return ((b = (_ = t == null ? void 0 : t.value) == null ? void 0 : _.nodeDragging) == null ? void 0 : b.type) === Bt && ((m = (C = t == null ? void 0 : t.value) == null ? void 0 : C.nodeDragging) == null ? void 0 : m.id) !== ((T = r.value) == null ? void 0 : T.id);
      }
    ), g = I(
      () => {
        var _, b, C;
        return ((C = (b = (_ = t == null ? void 0 : t.value) == null ? void 0 : _.builder) == null ? void 0 : b.customProperties) == null ? void 0 : C[r.value.type]) || {};
      }
    );
    function p() {
      var _;
      (_ = t == null ? void 0 : t.value) == null || _.setActiveNode(r.value);
    }
    function v(_, b) {
      var C;
      b && ((C = t == null ? void 0 : t.value) == null || C.setActiveNode(r.value)), t.value.editor = _;
    }
    const w = I(() => {
      var _, b, C, m, T, x, A, M;
      return {
        "--root-elements-width": ((m = (C = (b = (_ = t == null ? void 0 : t.value) == null ? void 0 : _.builder) == null ? void 0 : b.customProperties) == null ? void 0 : C.global) == null ? void 0 : m.rootElementsWidth) || "100%",
        "--root-elements-max-width": ((M = (A = (x = (T = t == null ? void 0 : t.value) == null ? void 0 : T.builder) == null ? void 0 : x.customProperties) == null ? void 0 : A.global) == null ? void 0 : M.rootElementsMaxWidth) || "100%"
      };
    });
    if (e.isEditable && !r.value.hasAnimated && r.value.id !== "root") {
      const _ = Cn(r.value.id), { play: b } = Eg(_);
      b(), r.value.hasAnimated = !0;
    }
    return (_, b) => (D(), U("div", {
      ref: r.value.id,
      style: rt({ pointerEvents: c.value ? "none" : "auto" })
    }, [
      (D(), G(Yg, null, {
        default: j(() => [
          (D(), G(si(i[d.value]), {
            ref: r.value.id,
            modelValue: r.value,
            "onUpdate:modelValue": [
              b[0] || (b[0] = (C) => r.value = C),
              b[1] || (b[1] = (C) => r.value = C)
            ],
            class: He(["content-node", f.value]),
            "is-editable": s.value,
            assets: V(t).builder.assets,
            "is-active-node": n.isActiveNode && s.value,
            "is-accordion-dragging": h.value,
            level: n.level,
            "in-accordion": n.inAccordion,
            "custom-properties": g.value,
            style: rt(w.value),
            "is-editable-shared-content-layout": a.value,
            onSetActive: p,
            onFocusEditor: v,
            onAssetEntry: b[2] || (b[2] = (C) => V(t).addAsset(C)),
            onCloseSidebar: b[3] || (b[3] = (C) => V(t).clearActiveNode())
          }, null, 40, ["modelValue", "class", "is-editable", "assets", "is-active-node", "is-accordion-dragging", "level", "in-accordion", "custom-properties", "style", "is-editable-shared-content-layout"]))
        ]),
        _: 1
      }))
    ], 4));
  }
}, ow = /* @__PURE__ */ X(iw, [["__scopeId", "data-v-da39ba7f"]]);
var aw = Ev();
const sw = /* @__PURE__ */ Ht(aw), lw = (n) => {
  var e, t, r, i;
  return (t = (e = n == null ? void 0 : n.properties) == null ? void 0 : e.backgroundColor) != null && t.toggle ? (i = (r = n == null ? void 0 : n.properties) == null ? void 0 : r.backgroundColor) == null ? void 0 : i.value : null;
}, uw = (n, e) => {
  var i, o;
  const t = Math.min(e.width, e.height) / 2;
  return `${((o = (i = n == null ? void 0 : n.properties) == null ? void 0 : i.borderRadius) == null ? void 0 : o.value) / 100 * t}px`;
}, cw = (n, e) => {
  var r, i, o, a, s, l, u, c, d, f, h;
  return !((i = (r = n == null ? void 0 : n.properties) == null ? void 0 : r.backgroundImage) != null && i.toggle) || !((l = (s = (a = (o = n == null ? void 0 : n.properties) == null ? void 0 : o.backgroundImage) == null ? void 0 : a.image) == null ? void 0 : s.content) != null && l.assetId) ? null : `url(${((h = e[(f = (d = (c = (u = n == null ? void 0 : n.properties) == null ? void 0 : u.backgroundImage) == null ? void 0 : c.image) == null ? void 0 : d.content) == null ? void 0 : f.assetId]) == null ? void 0 : h.url) || ""})`;
}, dw = (n) => {
  var t, r, i, o, a;
  const e = ((i = (r = (t = n == null ? void 0 : n.properties) == null ? void 0 : t.backgroundImage) == null ? void 0 : r.image) == null ? void 0 : i.properties) || {};
  switch (e == null ? void 0 : e.backgroundPosition) {
    case "center":
      return {
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "contain",
        transform: `rotate(${(e == null ? void 0 : e.rotation) || 0}deg)`
      };
    case "fill":
      return {
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-position": `${((o = e == null ? void 0 : e.focalPointPosition) == null ? void 0 : o.x) || 50}% ${((a = e == null ? void 0 : e.focalPointPosition) == null ? void 0 : a.y) || 50}%`,
        transform: `rotate(${(e == null ? void 0 : e.rotation) || 0}deg)`
      };
    case "tile":
      return {
        "background-position": "center",
        "background-repeat": "repeat",
        "background-size": `${(e == null ? void 0 : e.tilePercentage) || 100}%`,
        transform: `rotate(${(e == null ? void 0 : e.rotation) || 0}deg)`
      };
    default:
      return {};
  }
}, tp = (n, e, t) => ["top", "bottom", "left", "right"].reduce((r, i) => {
  var o, a, s;
  return {
    ...r,
    [`${e}${sw(i)}`]: ((o = n == null ? void 0 : n.properties[e]) != null && o.linked ? (a = n == null ? void 0 : n.properties[e]) == null ? void 0 : a.value : ((s = n == null ? void 0 : n.properties[e]) == null ? void 0 : s[i]) || 0) / t + "px"
  };
}, {}), fw = (n, e, t, r) => {
  var v, w, y, _, b;
  const { customProperties: i, assets: o } = n, a = e.id === "root";
  if (ev(e) && !a) return {};
  const s = 1, l = a ? !!((v = i == null ? void 0 : i.global) != null && v.backgroundColorAllowed) : !!((w = i == null ? void 0 : i[e.type]) != null && w.backgroundColorAllowed), u = a ? !!((y = i == null ? void 0 : i.global) != null && y.backgroundImageAllowed) : !!((_ = i == null ? void 0 : i[e.type]) != null && _.backgroundImageAllowed), c = l && lw(e), d = u && cw(e, o), f = !!((b = i == null ? void 0 : i.experimentalFeatures) != null && b.roundedLayouts) && uw(e, r), h = dw(e), g = tp(e, "margin", s), p = tp(e, "padding", s);
  return {
    backgroundImage: d,
    backgroundColor: c,
    borderRadius: f,
    ...h,
    ...g,
    ...p
  };
}, hw = {
  __name: "ActiveNodeAction",
  props: {
    tooltipText: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top"
    },
    icon: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = () => {
      r("click");
    };
    return (o, a) => {
      const s = $("a-icon"), l = $("a-button"), u = $("a-tooltip");
      return D(), G(u, {
        label: t.tooltipText,
        position: t.position
      }, {
        default: j(() => [
          B(l, {
            class: "node-action",
            variant: "none",
            onClick: i
          }, {
            default: j(() => [
              tt(o.$slots, "default", {}, () => [
                R("p", { class: "node-action-icon" }, [
                  B(s, {
                    icon: t.icon
                  }, null, 8, ["icon"])
                ])
              ], !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["label", "position"]);
    };
  }
}, ei = /* @__PURE__ */ X(hw, [["__scopeId", "data-v-2aeb3fd3"]]), pw = {};
function vw(n, e) {
  return D(), U("svg", {
    width: "12",
    height: "24",
    viewBox: "0 0 12 24",
    fill: "none"
  }, [
    R("circle", {
      cx: "4",
      cy: "6",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "4",
      cy: "10",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "4",
      cy: "14",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "8",
      cy: "6",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "8",
      cy: "10",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "8",
      cy: "14",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "4",
      cy: "18",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "8",
      cy: "18",
      r: "1",
      fill: "white"
    })
  ]);
}
const Ng = /* @__PURE__ */ X(pw, [["render", vw]]), x2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ng
}, Symbol.toStringTag, { value: "Module" }));
let Zr = null;
const gw = Mp((n) => (Zr || (Zr = Vp(n, {
  deep: !0,
  debounce: 500,
  flush: "post",
  clone: Or
})), Zr)), mw = () => {
  Zr && (Zr.clear(), Zr = null);
};
function Hu(n) {
  return {
    ...gw(n),
    clearSharedHistory: mw
  };
}
const _w = {
  __name: "VerticalScrollText",
  props: {
    text: {
      type: String,
      default: ""
    },
    colorOnHover: {
      type: String,
      default: null
    },
    isHovering: Boolean,
    strikethrough: Boolean,
    activateScroll: Boolean
  },
  setup(n) {
    const e = n, t = Q(null), r = Q(null), i = Q(3), o = Q(0), a = () => {
      !t.value || !r.value || yt(() => {
        const s = t.value, l = r.value, u = s.scrollWidth, c = l.clientWidth;
        o.value = Math.max(0, u - c), i.value = u > c ? Math.ceil(o.value / 50) : 0;
      });
    };
    return mt(() => {
      a();
    }), (s, l) => (D(), U("div", {
      ref_key: "containerRef",
      ref: r,
      class: "text-container"
    }, [
      R("p", {
        ref_key: "textRef",
        ref: t,
        class: He(["scrollable-text", { "scroll-active": !!e.activateScroll }]),
        style: rt({
          color: e.colorOnHover && e.isHovering ? e.colorOnHover : "inherit",
          textDecoration: e.strikethrough ? "line-through" : "none",
          "--scroll-duration": `${i.value}s`,
          "--scroll-distance": `${o.value}px`
        })
      }, [
        tt(s.$slots, "default", {}, () => [
          Me(K(e.text), 1)
        ], !0)
      ], 6)
    ], 512));
  }
}, kg = /* @__PURE__ */ X(_w, [["__scopeId", "data-v-98180b20"]]), bw = {
  __name: "ActiveNodeToolbar",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    activeAccordionId: {
      type: String,
      default: null
    }
  },
  emits: ["delete", "edit-shared-content"],
  setup(n, { emit: e }) {
    up((N) => ({
      "9b5e1a56": w.value
    }));
    const t = Q(!1), r = n, i = e, o = Se("state"), a = Q(!1), s = I(() => {
      var N, L, F, W, ie, ve, Z, Re;
      return ((W = (F = (L = (N = o == null ? void 0 : o.value) == null ? void 0 : N.builder) == null ? void 0 : L.customProperties) == null ? void 0 : F.global) == null ? void 0 : W.confirmOnDeleteDialogAllowed) && ((Re = (Z = (ve = (ie = o == null ? void 0 : o.value) == null ? void 0 : ie.builder) == null ? void 0 : ve.customProperties) == null ? void 0 : Z.global) == null ? void 0 : Re.showConfirmOnDeleteDialog);
    }), l = I(() => {
      var N;
      return P(r.node) && ((N = E(r.node.sharedContentId)) == null ? void 0 : N.name) || r.node.name;
    }), u = I(() => `${r.node.name.toLowerCase().replace(" ", "-")}-toolbar`), c = I(() => {
      var L, F, W, ie, ve, Z;
      const N = ((ie = (W = (F = (L = r.node) == null ? void 0 : L.nodes) == null ? void 0 : F[0]) == null ? void 0 : W.nodes) == null ? void 0 : ie[0]) || {};
      return !!Lt(N, (Z = (ve = o == null ? void 0 : o.value) == null ? void 0 : ve.activeNode) == null ? void 0 : Z.id);
    }), d = I(() => {
      var L, F, W;
      const N = !!((L = o == null ? void 0 : o.value) != null && L.activeNode) && z(r.node) && !z((F = o == null ? void 0 : o.value) == null ? void 0 : F.activeNode) && ue((W = o == null ? void 0 : o.value) == null ? void 0 : W.activeNode);
      return !!q.value && N;
    }), f = I(() => r.node.type.includes(Bt)), h = I(() => r.node.type === Tt), g = I(() => f.value ? c.value : !1), p = I(() => {
      var L, F;
      const N = Lt(
        (L = o == null ? void 0 : o.value) == null ? void 0 : L.builder.structure,
        r.node.parentAccordionId
      );
      return h.value && ((F = N == null ? void 0 : N.nodes[0]) == null ? void 0 : F.nodes.length) === 1;
    }), v = I(() => p.value ? "builder.content.accordion.accordionMustHavePanels" : "builder.toolbar.deleteElement"), w = I(() => {
      var F, W;
      let L = ir(r.node) ? 10 : 0;
      return (W = (F = r.node) == null ? void 0 : F.properties) != null && W.margin && (L = r.node.properties.margin.linked ? r.node.properties.margin.value : r.node.properties.margin.top), `${-15 + L}px`;
    }), y = I(() => {
      var N;
      return ((N = o == null ? void 0 : o.value) == null ? void 0 : N.userAgent) === "mac" ? "⌘" : "Ctrl";
    }), _ = (N) => {
      if (N === "add-custom-code") {
        x();
        return;
      }
      i(N);
    }, b = I(() => [
      {
        id: "copy-node",
        label: "Copy element",
        shortkey: `${y.value} + C`,
        icon: "CopyIcon"
      },
      {
        id: "cut-node",
        label: "Cut element",
        shortkey: `${y.value} + X`,
        icon: "CutIcon"
      },
      {
        id: "paste-node",
        label: "Paste element",
        shortkey: `${y.value} + V`,
        icon: "PasteIcon"
      },
      {
        id: "add-custom-code",
        label: "Add custom attributes",
        shortkey: "",
        icon: "AddCustomCodeIcon"
      }
    ]), C = I(() => {
      var N, L, F, W;
      return !!((W = (F = (L = (N = o == null ? void 0 : o.value) == null ? void 0 : N.builder) == null ? void 0 : L.customProperties) == null ? void 0 : F.global) != null && W.customAttributesAllowed) && !P(r.node);
    }), m = () => {
      p.value || (s.value ? a.value = !0 : i("delete-node"));
    }, T = () => {
      var N;
      (N = o == null ? void 0 : o.value) == null || N.setActiveNode(r.node);
    }, x = () => {
      o.value.showCustomAttributesSidebar = !0;
    }, {
      showCreateSharedContentButton: A,
      showDetachSharedContentButton: M,
      createSharedContent: O,
      detachSharedContent: S,
      isSharedContentLayout: P,
      showEditSharedContentButton: k,
      getSharedContentById: E,
      editingSharedContent: q,
      showEditingSharedContentActions: H,
      isCurrentSharedContentBeingEdited: z,
      saveEditingSharedContent: ee,
      cancelEditingSharedContent: se,
      isNodeInsideEditingSharedContentLayout: ue
    } = ft({
      state: o
    }), { resume: oe } = Hu(o.value.builder), le = () => {
      oe(), ee();
    }, ce = () => {
      oe(), se();
    }, be = [
      {
        id: "create-shared-content",
        showAction: A.value && !h.value,
        tooltipText: "builder.toolbar.createSharedContent",
        icon: Y(
          () => import("./CreateSharedContentIcon-DGH5hkOD.js")
        ),
        onClick: () => {
          O({
            accordionId: r.activeAccordionId
          });
        }
      },
      {
        id: "edit-shared-content",
        showAction: k.value && !h.value,
        tooltipText: "builder.toolbar.editSharedContent",
        icon: Y(
          () => import("./EditSharedContentIcon-CU0PNi8c.js")
        ),
        onClick: () => i("edit-shared-content")
      },
      {
        id: "detach-shared-content",
        showAction: M.value && !h.value,
        tooltipText: "builder.toolbar.detachSharedContent",
        icon: Y(
          () => import("./DetachSharedContentIcon-yPHIlsg1.js")
        ),
        onClick: S
      },
      {
        id: "add-custom-code",
        showAction: C.value,
        tooltipText: "builder.toolbar.addCustomAttributes",
        icon: Y(
          () => import("./AddCustomCodeIcon-pPrLlA6p.js")
        ),
        onClick: x
      },
      {
        id: "duplicate-node",
        showAction: !0,
        tooltipText: "builder.toolbar.duplicateElement",
        icon: Y(
          () => import("./DuplicateIcon-B3MSEfAx.js")
        ),
        onClick: () => i("duplicate-node")
      },
      {
        id: "delete-node",
        showAction: !0,
        tooltipText: v.value,
        icon: Y(
          () => import("./DeleteIcon-OOawWAV-.js")
        ),
        onClick: m
      }
    ], ht = [
      "create-shared-content",
      "edit-shared-content",
      "detach-shared-content",
      "duplicate-node",
      "delete-node"
    ], cr = I(
      () => be.filter(({ id: N }) => ht.includes(N))
    ), Dr = I(() => q.value ? 0 : t.value ? 3 : 2);
    return (N, L) => {
      const F = $("a-text"), W = $("a-button"), ie = $("a-dropdown"), ve = $("a-alert-header"), Z = $("a-alert-content"), Re = $("a-alert-footer"), re = $("a-dialog"), pt = $("portal");
      return D(), U("div", {
        class: He([
          "toolbar",
          u.value,
          {
            "is-first-accordion-panel-active": g.value,
            "is-editing-shared-content": !!V(q),
            "shared-content-first-child-active": d.value
          }
        ]),
        style: rt({ zIndex: Dr.value }),
        onClick: L[6] || (L[6] = dl(() => {
        }, ["stop"]))
      }, [
        R("div", { class: "elements-container" }, [
          R("div", { class: "elements" }, [
            V(H)(r.node) ? J("", !0) : (D(), G(Ng, {
              key: 0,
              class: "handler"
            })),
            B(W, {
              class: "node-name",
              variant: "link",
              onClick: dl(T, ["stop"]),
              disabled: !f.value
            }, {
              default: j(() => [
                B(kg, { style: { maxWidth: "200px" } }, {
                  default: j(() => [
                    B(F, { variant: "h4" }, {
                      default: j(() => [
                        Me(K(l.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            V(H)(r.node) ? (D(), U("div", {
              key: 1,
              class: "actions-group"
            }, [
              B(ei, {
                "tooltip-text": N.$t("builder.toolbar.saveEditingSharedContent"),
                icon: "16:checkmark",
                onClick: le
              }, null, 8, ["tooltip-text"]),
              B(ei, {
                "tooltip-text": N.$t("builder.toolbar.cancelEditingSharedContent"),
                icon: "16:close",
                onClick: ce
              }, null, 8, ["tooltip-text"])
            ])) : (D(), U("div", {
              key: 2,
              class: "actions-group"
            }, [
              (D(!0), U(gt, null, nr(cr.value, (ye) => (D(), U("div", { class: "action-icon" }, [
                ye.showAction ? (D(), G(ei, {
                  key: ye.id,
                  "tooltip-text": N.$t(ye.tooltipText),
                  onClick: ye.onClick
                }, {
                  default: j(() => [
                    (D(), G(si(ye.icon)))
                  ]),
                  _: 2
                }, 1032, ["tooltip-text", "onClick"])) : J("", !0)
              ]))), 256)),
              B(ie, {
                align: "right",
                class: "moreOptions",
                items: b.value,
                onItemClick: _,
                onOpen: L[1] || (L[1] = (ye) => t.value = !0),
                onClose: L[2] || (L[2] = (ye) => t.value = !1)
              }, Zl({
                dropdownTrigger: j(() => [
                  B(ei, {
                    "tooltip-text": N.$t("builder.toolbar.moreOptions"),
                    icon: "16:shishkebab",
                    onClick: L[0] || (L[0] = (ye) => N.showSettings = !0)
                  }, null, 8, ["tooltip-text"])
                ]),
                _: 2
              }, [
                nr(b.value, (ye) => ({
                  name: `dropdown_item_${ye.id}`,
                  fn: j(({ item: Vt }) => [
                    R("div", { class: "dropdown-item" }, [
                      (D(), G(si(Vt.icon))),
                      R("p", { class: "dropdown-item-label" }, K(Vt.label), 1),
                      R("p", { class: "dropdown-item-shortkey" }, K(Vt.shortkey), 1)
                    ])
                  ])
                }))
              ]), 1032, ["items"])
            ]))
          ])
        ]),
        a.value ? (D(), G(pt, {
          key: 0,
          to: "root-dialog-container"
        }, {
          default: j(() => [
            B(re, {
              show: a.value,
              "no-close-on-overlay": "",
              size: "l",
              onClose: L[5] || (L[5] = (ye) => a.value = !1)
            }, {
              default: j(() => [
                B(ve, { alertMode: "warning" }, {
                  default: j(() => [
                    Me(K(N.$t("builder.deleteNodeConfirmation")), 1)
                  ]),
                  _: 1
                }),
                B(Z, null, {
                  default: j(() => [
                    R("span")
                  ]),
                  _: 1
                }),
                B(Re, null, {
                  default: j(() => [
                    B(W, {
                      autofocus: "",
                      variant: "primary",
                      mode: "error",
                      onClick: L[3] || (L[3] = (ye) => N.$emit("delete-node"))
                    }, {
                      default: j(() => [
                        Me(K(N.$t("builder.delete")), 1)
                      ]),
                      _: 1
                    }),
                    B(W, {
                      variant: "default",
                      mode: "error",
                      onClick: L[4] || (L[4] = (ye) => a.value = !1)
                    }, {
                      default: j(() => [
                        Me(K(N.$t("builder.cancel")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        })) : J("", !0)
      ], 6);
    };
  }
}, yw = /* @__PURE__ */ X(bw, [["__scopeId", "data-v-85b21766"]]), qr = Q(/* @__PURE__ */ new Map()), Dg = Mp(() => {
  function n(r, i) {
    if (!i) return null;
    if (qr.value.has(r))
      return qr.value.get(r);
    const o = Vp(i, {
      deep: !0,
      debounce: 500,
      clone: Or
    });
    return qr.value.set(r, o), o;
  }
  function e(r) {
    return qr.value.get(r);
  }
  function t(r) {
    qr.value.has(r) && qr.value.delete(r);
  }
  return {
    createHistory: n,
    getHistory: e,
    deleteHistory: t
  };
}), Cw = {
  __name: "ActiveNodeWrapper",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    isEditable: Boolean
  },
  setup(n) {
    const e = Se("state"), t = n, { node: r, isEditable: i } = Kl(t), o = I(() => I_(r.value)), a = Se("insideSharedContentLayout"), s = I(() => {
      var C, m, T, x;
      if (!i.value) return !1;
      if (g.value) {
        if (!h(r.value) && a.value)
          return !1;
        const A = ((m = (C = e == null ? void 0 : e.value) == null ? void 0 : C.activeNode) == null ? void 0 : m.id) === r.value.id && v(r.value);
        return h(r.value) || A;
      }
      return ((x = (T = e == null ? void 0 : e.value) == null ? void 0 : T.activeNode) == null ? void 0 : x.id) === r.value.id || u.value;
    }), l = (C) => {
      var m;
      return (m = C.nodes) != null && m.length ? C.nodes.some(
        (T) => {
          var x, A;
          return T.id === ((A = (x = e == null ? void 0 : e.value) == null ? void 0 : x.activeNode) == null ? void 0 : A.id) || l(T);
        }
      ) : !1;
    }, u = I(() => {
      var m, T;
      return [
        Bt,
        Tt
      ].includes(r.value.type) && ((T = (m = e == null ? void 0 : e.value) == null ? void 0 : m.activeNode) == null ? void 0 : T.id) && l(r.value);
    }), c = Q(null), {
      isSharedContentLayout: d,
      isolateSharedContent: f,
      isCurrentSharedContentBeingEdited: h,
      editingSharedContent: g,
      editingSharedContentNodes: p,
      isNodeInsideEditingSharedContentLayout: v
    } = ft({
      state: e
    }), { pause: w } = Hu(e.value.builder), { createHistory: y } = Dg(e), _ = () => {
      w();
      const { top: C, left: m, width: T, height: x } = zp(c);
      f(C, m, T, x), y(
        g.value.sharedContentId,
        p
      );
    }, b = I(() => {
      let C = "var(--pb-black)", m = "var(--primary-white)";
      switch (o.value) {
        case mr:
          C = "var(--color-layout)";
          break;
        case _r:
          C = "var(--color-content)";
          break;
        case Ql:
          C = "var(--color-sub-content)", m = "var(--purple)";
          break;
      }
      return d(r.value) && (C = "var(--color-shared-content)"), {
        "--node-group-toolbar-bg-color": C,
        "--node-group-toolbar-color": m
      };
    });
    return (C, m) => {
      var T;
      return D(), U("div", {
        ref_key: "activeNodeRef",
        ref: c,
        class: He([
          `${o.value}-active-wrapper`,
          { "is-editing-shared-content": V(h)(V(r)) }
        ]),
        style: rt(b.value)
      }, [
        s.value ? (D(), G(yw, {
          key: 0,
          node: V(r),
          "active-accordion-id": u.value && ((T = V(r)) == null ? void 0 : T.id),
          onAddCustomAttributes: m[0] || (m[0] = (x) => C.$emit("add-custom-attributes")),
          onCopyNode: m[1] || (m[1] = (x) => C.$emit("copy-node")),
          onCutNode: m[2] || (m[2] = (x) => C.$emit("cut-node")),
          onPasteNode: m[3] || (m[3] = (x) => C.$emit("paste-node")),
          onDuplicateNode: m[4] || (m[4] = (x) => C.$emit("duplicate-node")),
          onFavorite: m[5] || (m[5] = (x) => C.$emit("favorite")),
          onDeleteNode: m[6] || (m[6] = (x) => C.$emit("delete-node")),
          onEditSharedContent: _
        }, null, 8, ["node", "active-accordion-id"])) : J("", !0),
        tt(C.$slots, "default", {}, void 0, !0)
      ], 6);
    };
  }
}, ww = /* @__PURE__ */ X(Cw, [["__scopeId", "data-v-cd4af42f"]]);
function Rg({ node: n, state: e, maxNestingLevelsAllowed: t, isDraggableEditable: r, parentNodeId: i, isInsideSharedContentLayout: o = !1 }) {
  const a = ({ draggedContext: d, to: f }) => {
    const h = Number(f.getAttribute("data-level")) + 1;
    if (ir(d.element) && h >= t.value)
      return !1;
    const p = f.getAttribute("data-in-accordion") === "true";
    if (d.element.type === Bt && p)
      return !1;
  }, s = (d) => {
    e.nodeDragging = d.item._underlying_vm_;
  }, l = () => {
    e.nodeDragging = null;
  }, u = (d) => {
    var h;
    const f = (h = d.added) == null ? void 0 : h.element;
    if (d.added && f.type === Tt) {
      const g = f.parentAccordionId, { parentAccordionId: p } = n.nodes.find(
        (v) => v.parentAccordionId !== g
      );
      p && (f.parentAccordionId = p);
    }
  }, c = I(() => {
    var f;
    const d = (f = e == null ? void 0 : e.editingSharedContent) == null ? void 0 : f.node;
    return o ? !!d : d && i ? d.id === i || !!Lt(d, i) : r.value;
  });
  return {
    handleDraggableNodeMoved: a,
    handleNodeDraggingStarted: s,
    handleNodeDraggingEnded: l,
    handleDraggableNodeChanged: u,
    isDraggableEnabled: c
  };
}
function Pg({
  state: n = {}
}) {
  const { copy: e, isSupported: t } = O0(), r = (c, d, f) => {
    if (n.isLinkModalOpen) return;
    const h = Dn(c);
    Lf(c) && (h.parentAccordionId = c.parentAccordionId), d.nodes.splice(f + 1, 0, h), n == null || n.emitToConsumingApp("amplitude-event", {
      type: h.name,
      action: "added",
      attributes: {
        method: "duplicate",
        component: h.type
      }
    });
  }, i = (c, d, f = !1) => {
    if (n.isLinkModalOpen) return;
    const h = c.nodes[d];
    c.nodes.splice(d, 1), n == null || n.emitToConsumingApp("amplitude-event", {
      type: h.name,
      action: "removed",
      attributes: {
        method: f ? "cut" : "delete",
        component: h.type
      }
    });
  }, o = () => {
    var f, h;
    if (!n.activeNode || !t || n.isLinkModalOpen) return;
    a();
    const { parent: c, index: d } = Pt((f = n.builder) == null ? void 0 : f.structure, (h = n.activeNode) == null ? void 0 : h.id);
    i(c, d, !0), n.clearActiveNode(), n.clearEditor();
  }, a = () => {
    !n.activeNode || !t || n.isLinkModalOpen || e(JSON.stringify(n.activeNode));
  }, s = async () => {
    const c = await navigator.clipboard.readText();
    let d = !1;
    try {
      const f = JSON.parse(c), h = Array.isArray(f) ? [...f] : [f];
      return d = h.some((g) => (g.component || "").includes("ts-")), {
        clipboardData: h,
        isValidNode: !0,
        isLegacyNode: d
      };
    } catch {
      return {
        clipboardData: [c],
        isValidNode: !1,
        isLegacyNode: d
      };
    }
  }, l = async (c = null) => {
    if (!c) {
      const { clipboardData: v = [], isLegacyNode: w } = await s();
      c = v, w && (c = u(c));
    }
    const d = !(n != null && n.activeNode), f = !!(n != null && n.activeNode) && ir(n == null ? void 0 : n.activeNode), h = !!(n != null && n.activeNode) && Jp(n == null ? void 0 : n.activeNode), g = !!(n != null && n.activeNode) && Lf(n == null ? void 0 : n.activeNode);
    (Array.isArray(c) ? c : [c]).forEach((v, w) => {
      var b, C, m, T, x;
      const y = Dn(v), _ = w;
      if (n == null || n.emitToConsumingApp("amplitude-event", {
        type: y.name,
        action: "added",
        attributes: {
          method: "paste",
          component: y.type
        }
      }), d) {
        (m = (C = (b = n == null ? void 0 : n.builder) == null ? void 0 : b.structure) == null ? void 0 : C.nodes) == null || m.push(y);
        return;
      }
      if (f) {
        n.activeNode.nodes[0].nodes.push(y);
        return;
      }
      if (h) {
        const { parent: A, index: M } = Pt((T = n.builder) == null ? void 0 : T.structure, (x = n.activeNode) == null ? void 0 : x.id), O = M + _ + 1;
        A.nodes.splice(O, 0, y);
        return;
      }
      if (g) {
        if (rv(y))
          return;
        n.activeNode.nodes[0].nodes.push(y);
        return;
      }
    });
  }, u = (c = [{}]) => {
    var f, h;
    if (!n) return;
    let d = null;
    if (typeof ((h = (f = n == null ? void 0 : n.builder) == null ? void 0 : f.legacyAdapters) == null ? void 0 : h.pageToBuilder) == "function") {
      const { structure: g, assets: p } = n.builder.legacyAdapters.pageToBuilder(c);
      p && n.addAsset(p), g.id && g.id === "root" ? d = g.nodes || [{}] : d = g || [{}];
    }
    return d;
  };
  return {
    duplicateNode: r,
    deleteNode: i,
    cutSelectedNode: o,
    copySelectedNode: a,
    isClipboardSupported: t,
    dataInClipboard: s,
    pasteNode: l,
    convertLegacyStructureToBuilderStructure: u
  };
}
const Tw = {
  __name: "DraggableNode",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    parentNodeId: {
      type: String,
      default: ""
    },
    inAccordion: Boolean,
    isEditable: Boolean
  },
  setup(n) {
    const e = Y(() => Promise.resolve().then(() => Lg)), t = Se("state"), r = Se("maxNestingLevelsAllowed"), i = n, o = I(() => i.modelValue), a = I(() => i.isEditable);
    function s() {
      var A, M, O, S, P, k;
      (A = t == null ? void 0 : t.value) != null && A.nodeDragging && ((k = t == null ? void 0 : t.value) == null || k.emitToConsumingApp("amplitude-event", {
        type: (O = (M = t == null ? void 0 : t.value) == null ? void 0 : M.nodeDragging) == null ? void 0 : O.name,
        action: "added",
        attributes: {
          method: "drag-and-drop",
          component: (P = (S = t == null ? void 0 : t.value) == null ? void 0 : S.nodeDragging) == null ? void 0 : P.type
        }
      }), t.value.nodeDragging = null);
    }
    function l(A) {
      var M, O;
      (M = t == null ? void 0 : t.value) == null || M.clearEditor(), (O = t == null ? void 0 : t.value) == null || O.clearActiveNode(), _(o.value, A);
    }
    const u = Se("insideSharedContentLayout");
    function c(A, M) {
      var O, S;
      if (m.value) {
        C(M) && (A.stopPropagation(), (O = t == null ? void 0 : t.value) == null || O.setActiveNode(M));
        return;
      }
      u.value || a.value && (A.stopPropagation(), (S = t == null ? void 0 : t.value) == null || S.setActiveNode(M));
    }
    const {
      handleDraggableNodeMoved: d,
      handleNodeDraggingStarted: f,
      handleNodeDraggingEnded: h,
      handleDraggableNodeChanged: g,
      isDraggableEnabled: p
    } = Rg({
      node: o,
      state: t.value,
      maxNestingLevelsAllowed: r,
      isDraggableEditable: a,
      parentNodeId: i.parentNodeId,
      isInsideSharedContentLayout: u.value
    }), {
      copySelectedNode: v,
      cutSelectedNode: w,
      pasteNode: y,
      deleteNode: _,
      duplicateNode: b
    } = Pg({ state: t.value }), { isNodeInsideEditingSharedContentLayout: C, editingSharedContent: m } = ft({
      state: t
    }), T = /* @__PURE__ */ new Map();
    function x(A) {
      const M = A.id;
      if (!T.has(M)) {
        const O = de(null);
        du(O, {
          onEnter() {
            var P, k, E;
            const S = ((k = (P = T.get(M)) == null ? void 0 : P.childNode) == null ? void 0 : k.type) || "";
            [
              $n,
              En,
              In,
              Nn
            ].includes(S) && ((E = t == null ? void 0 : t.value) == null || E.setActiveNode(T.get(M).childNode));
          },
          dataTypes: ["image/png", "image/jpg", "image/jpeg", "image/gif"]
        }), T.set(M, { elRef: O, childNode: A });
      }
      return (O) => {
        const S = T.get(M);
        S && (S.elRef.value = O);
      };
    }
    return (A, M) => o.value.nodes ? (D(), U("div", {
      key: 0,
      class: "draggable-node-list-container"
    }, [
      B(V(fp), {
        ref: "builder-draggable",
        list: o.value.nodes,
        "ghost-class": "ghost-class",
        handle: ".handler",
        class: He([
          "draggable-node-list",
          { "empty-node": !o.value.nodes.length },
          `draggable-level-${n.level}`
        ]),
        group: n.draggableGroup,
        "swap-threshold": 0.5,
        "data-level": n.level,
        disabled: !V(p),
        "item-key": "id",
        "data-in-accordion": n.inAccordion,
        move: V(d),
        onStart: V(f),
        onEnd: V(h),
        onChange: V(g),
        onDrop: s
      }, {
        item: j(({ element: O, index: S }) => [
          o.value.nodes.length ? (D(), G(ww, {
            class: He({ "accordion-panel-active-wrapper": n.inAccordion }),
            key: O.id,
            node: O,
            "is-editable": a.value,
            "in-accordion": n.inAccordion,
            onCopyNode: V(v),
            onCutNode: V(w),
            onPasteNode: V(y),
            onDuplicateNode: (P) => V(b)(O, o.value, S),
            onDeleteNode: (P) => l(S)
          }, {
            default: j(() => [
              B(V(e), {
                modelValue: o.value.nodes[S],
                "onUpdate:modelValue": (P) => o.value.nodes[S] = P,
                level: n.level + 1,
                "in-accordion": n.inAccordion,
                "is-editable": a.value,
                onClick: (P) => c(P, O),
                ref: x(O)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "level", "in-accordion", "is-editable", "onClick"])
            ]),
            _: 2
          }, 1032, ["class", "node", "is-editable", "in-accordion", "onCopyNode", "onCutNode", "onPasteNode", "onDuplicateNode", "onDeleteNode"])) : n.inAccordion ? (D(), U("div", {
            key: 1,
            style: { "pointer-events": "auto" },
            class: "accordion-panel-placeholder"
          }, K(A.$t("builder.content.accordion.emptyAccordionMessage")), 1)) : J("", !0)
        ]),
        _: 1
      }, 8, ["list", "class", "group", "data-level", "disabled", "data-in-accordion", "move", "onStart", "onEnd", "onChange"])
    ])) : J("", !0);
  }
}, Sw = /* @__PURE__ */ X(Tw, [["__scopeId", "data-v-fe0943de"]]), xw = {
  name: "DraggableBlocker",
  props: {
    message: {
      type: String,
      required: !0
    }
  }
};
function Aw(n, e, t, r, i, o) {
  return D(), U("div", {
    class: "blockage-mask",
    "blocked-layout-message": t.message
  }, null, 8, ["blocked-layout-message"]);
}
const Ow = /* @__PURE__ */ X(xw, [["render", Aw], ["__scopeId", "data-v-a3ecc03c"]]), Ew = {
  __name: "BorderRadiusControl",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = I({
      get: () => {
        var o, a, s;
        return ((s = (a = (o = t.node) == null ? void 0 : o.properties) == null ? void 0 : a.borderRadius) == null ? void 0 : s.value) || 0;
      },
      set: (o) => {
        r("update", o);
      }
    });
    return (o, a) => {
      const s = $("a-form-input");
      return D(), G(xr, null, {
        title: j(() => [
          R("h4", null, K(o.$t("builder.borderStyles.borderRadius")), 1)
        ]),
        control: j(() => [
          B(s, {
            modelValue: i.value,
            "onUpdate:modelValue": a[0] || (a[0] = (l) => i.value = l),
            width: "70px",
            type: "number",
            min: 0,
            max: 100
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      });
    };
  }
}, Iw = /* @__PURE__ */ X(Ew, [["__scopeId", "data-v-36b970f3"]]), Nw = {
  name: "MarginControl",
  components: {
    NodeControl: xr
  },
  props: {
    node: {
      type: Object,
      default: () => {
      }
    },
    property: {
      type: String,
      default: "margin"
    }
  },
  computed: {
    toggleLinked: {
      get() {
        var n, e, t;
        return (t = (e = (n = this.node) == null ? void 0 : n.properties) == null ? void 0 : e[this.property]) == null ? void 0 : t.linked;
      },
      set(n) {
        this.$emit("toggle", n);
      }
    }
  },
  methods: {
    updateLinkedValue(n) {
      var e, t;
      this.$emit("update", {
        ...((t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t[this.property]) || {},
        value: Number(n)
      });
    },
    updateMarginPadding(n, e) {
      var t, r;
      this.$emit("update", {
        ...((r = (t = this.node) == null ? void 0 : t.properties) == null ? void 0 : r[this.property]) || {},
        [n]: Number(e)
      });
    }
  }
};
function kw(n, e, t, r, i, o) {
  const a = $("a-form-input"), s = $("a-text"), l = $("a-tooltip"), u = $("a-toggle"), c = $("NodeControl");
  return D(), G(c, null, {
    title: j(() => [
      R("h4", null, K(n.$t(`builder.borderStyles.${t.property}`)), 1)
    ]),
    content: j(() => {
      var d, f, h, g, p, v, w, y, _;
      return [
        R("div", { class: "inline-control" }, [
          B(a, {
            type: "number",
            width: "70px",
            label: "",
            min: 0,
            step: 2,
            disabled: !((h = (f = (d = t.node) == null ? void 0 : d.properties) == null ? void 0 : f[t.property]) != null && h.linked),
            "model-value": ((v = (p = (g = t.node) == null ? void 0 : g.properties) == null ? void 0 : p[t.property]) == null ? void 0 : v.value) || 0,
            "onUpdate:modelValue": o.updateLinkedValue
          }, null, 8, ["disabled", "model-value", "onUpdate:modelValue"]),
          R("div", { class: "more-options-toggle" }, [
            B(l, {
              label: n.$t("builder.linkedTooltip"),
              position: "left",
              size: "small"
            }, {
              default: j(() => [
                B(s, null, {
                  default: j(() => [
                    Me(K(n.$t("builder.linked")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            B(u, {
              modelValue: o.toggleLinked,
              "onUpdate:modelValue": e[0] || (e[0] = (b) => o.toggleLinked = b)
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_ = (y = (w = t.node) == null ? void 0 : w.properties) == null ? void 0 : y[t.property]) != null && _.linked ? J("", !0) : (D(), U("div", {
          key: 0,
          class: "more-options-row"
        }, [
          (D(), U(gt, null, nr(["top", "right", "bottom", "left"], (b) => {
            var C, m, T;
            return R("div", {
              key: b,
              class: "more-options-input-wrapper"
            }, [
              B(a, {
                class: "more-options-input",
                type: "number",
                width: "70px",
                label: b,
                min: 0,
                step: 2,
                modelValue: ((T = (m = (C = t.node) == null ? void 0 : C.properties) == null ? void 0 : m[t.property]) == null ? void 0 : T[b]) || 0,
                "onUpdate:modelValue": (x) => o.updateMarginPadding(b, x)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]);
          }), 64))
        ]))
      ];
    }),
    _: 1
  });
}
const Dw = /* @__PURE__ */ X(Nw, [["render", kw], ["__scopeId", "data-v-88077f9b"]]), Rw = {
  name: "LayoutNodeControl",
  components: {
    BackgroundColorControl: Pp,
    BackgroundImageControl: Sv,
    BorderRadiusControl: Iw,
    MarginPaddingControl: Dw,
    SidebarHeader: wu
  },
  inject: ["state"],
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    layoutCustomProperties() {
      var n, e, t;
      return ((t = (e = (n = this.state) == null ? void 0 : n.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t[this.node.type]) || {};
    },
    node() {
      return this.modelValue;
    },
    experimentalFeatures() {
      var n, e, t;
      return ((t = (e = (n = this.state) == null ? void 0 : n.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t.experimentalFeatures) || {};
    }
  }
};
function Pw(n, e, t, r, i, o) {
  const a = $("SidebarHeader"), s = $("BackgroundColorControl"), l = $("BackgroundImageControl"), u = $("BorderRadiusControl"), c = $("MarginPaddingControl"), d = $("portal");
  return D(), G(d, {
    to: o.node.id
  }, {
    default: j(() => [
      B(a, {
        title: o.node.name,
        onCloseSidebar: e[0] || (e[0] = (f) => n.$emit("close-sidebar"))
      }, null, 8, ["title"]),
      R("div", null, [
        o.layoutCustomProperties.backgroundColorAllowed ? (D(), G(s, {
          key: 0,
          node: o.node,
          onUpdate: e[1] || (e[1] = (f, h) => o.node.properties.backgroundColor[f] = h)
        }, null, 8, ["node"])) : J("", !0),
        o.layoutCustomProperties.backgroundImageAllowed ? (D(), G(l, {
          key: 1,
          node: o.node,
          assets: o.state.builder.assets,
          "upload-api": o.state.builder.api.images,
          onUpdate: e[2] || (e[2] = (f, h) => o.node.properties.backgroundImage[f] = h),
          onAssetEntry: e[3] || (e[3] = (f) => o.state.addAsset(f))
        }, null, 8, ["node", "assets", "upload-api"])) : J("", !0),
        o.experimentalFeatures.roundedLayouts ? (D(), G(u, {
          key: 2,
          node: o.node,
          onUpdate: e[4] || (e[4] = (f) => o.node.properties.borderRadius.value = f)
        }, null, 8, ["node"])) : J("", !0),
        o.layoutCustomProperties.marginAllowed ? (D(), G(c, {
          key: 3,
          node: o.node,
          property: "margin",
          onUpdate: e[5] || (e[5] = (f) => o.node.properties.margin = f),
          onToggle: e[6] || (e[6] = (f) => o.node.properties.margin.linked = f)
        }, null, 8, ["node"])) : J("", !0),
        o.layoutCustomProperties.paddingAllowed ? (D(), G(c, {
          key: 4,
          node: o.node,
          property: "padding",
          onUpdate: e[7] || (e[7] = (f) => o.node.properties.padding = f),
          onToggle: e[8] || (e[8] = (f) => o.node.properties.padding.linked = f)
        }, null, 8, ["node"])) : J("", !0)
      ])
    ]),
    _: 1
  }, 8, ["to"]);
}
const Mw = /* @__PURE__ */ X(Rw, [["render", Pw]]);
function Lw(n) {
  const e = I(() => {
    var i;
    return ((i = n.value) == null ? void 0 : i.properties) || {};
  }), t = I(() => e.value.customClasses || []), r = I(() => e.value.anchorTag || "");
  return {
    nodeProperties: e,
    customClasses: t,
    anchorTag: r
  };
}
const qw = {
  __name: "LayoutNode",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    inAccordion: Boolean,
    isActiveNode: Boolean,
    isEditable: Boolean,
    isEmptyBuilder: Boolean
  },
  setup(n) {
    up((E) => ({
      "58798d59": _.value
    }));
    const e = Se("state"), t = Se("isRenderMode"), r = Se("maxNestingLevelsAllowed"), i = n, {
      modelValue: o,
      level: a,
      draggableGroup: s,
      inAccordion: l,
      isActiveNode: u,
      isEditable: c,
      isEmptyBuilder: d
    } = Kl(i);
    if (!t.value && !o.value.hasAnimated && o.value.id !== "root") {
      const E = Cn(o.value.id), { play: q } = Eg(E);
      q(), o.value.hasAnimated = !0;
    }
    const h = Q({ width: 700, height: 70 }), g = Q(null);
    mt(() => {
      g.value && (h.value.width = g.value.clientWidth || 0, h.value.height = g.value.clientHeight || 0);
    }), fu(g, (E) => {
      var ee;
      const q = E[0], { inlineSize: H, blockSize: z } = ((ee = q.borderBoxSize) == null ? void 0 : ee[0]) || {};
      h.value.width = H || g.value.clientWidth, h.value.height = z || g.value.clientHeight;
    });
    const p = I(() => {
      var E;
      return {
        ...fw(
          (E = e == null ? void 0 : e.value) == null ? void 0 : E.builder,
          o.value,
          !1,
          h.value
        ),
        "--root-level-width": `calc(${b.value} - ${A.value})`,
        "--root-level-max-width": `calc(${C.value} - ${A.value})`
      };
    }), v = I(() => o.value.type.replace(/_/g, "-").toLowerCase().replace("layout-node-", "")), w = I(() => {
      var ee, se, ue, oe, le, ce;
      const E = ((se = (ee = e == null ? void 0 : e.value) == null ? void 0 : ee.nodeDragging) == null ? void 0 : se.id) === ((ue = o.value) == null ? void 0 : ue.id);
      if (!((oe = e == null ? void 0 : e.value) != null && oe.nodeDragging) || E)
        return {
          isBlocked: !1,
          message: ""
        };
      if (O(o.value)) return S.value;
      const q = a.value + 1 >= r.value, H = ir((le = e == null ? void 0 : e.value) == null ? void 0 : le.nodeDragging), z = !!Lt(
        (ce = e == null ? void 0 : e.value) == null ? void 0 : ce.nodeDragging,
        o.value.id
      );
      return {
        isBlocked: q && H && !z,
        message: "builder.cannotNestMoreLayouts"
      };
    }), y = (E) => ir(o.value) || O(o.value) ? o.value.nodes[E] : o.value, _ = I(() => {
      switch (o.value.type) {
        case qe:
        case wn:
        case $r:
        case Qe:
          return 1;
        case Tn:
        case An:
        case On:
          return 2;
        case Sn:
          return 3;
        case xn:
          return 4;
        default:
          return 0;
      }
    }), b = I(() => {
      var E, q, H, z;
      return o.value.type === $r || l.value ? "100%" : ((z = (H = (q = (E = e == null ? void 0 : e.value) == null ? void 0 : E.builder) == null ? void 0 : q.customProperties) == null ? void 0 : H.global) == null ? void 0 : z.rootElementsWidth) || "100%";
    }), C = I(() => {
      var E, q, H, z;
      return o.value.type === $r || l.value ? "100%" : ((z = (H = (q = (E = e == null ? void 0 : e.value) == null ? void 0 : E.builder) == null ? void 0 : q.customProperties) == null ? void 0 : H.global) == null ? void 0 : z.rootElementsMaxWidth) || "100%";
    }), { nodeProperties: m, customClasses: T, anchorTag: x } = Lw(o), A = I(() => {
      var ee, se, ue, oe, le, ce, be, ht;
      const E = !!((se = (ee = m.value) == null ? void 0 : ee.margin) != null && se.linked), q = ((oe = (ue = m.value) == null ? void 0 : ue.margin) == null ? void 0 : oe.left) || 0, H = ((ce = (le = m.value) == null ? void 0 : le.margin) == null ? void 0 : ce.right) || 0, z = ((ht = (be = m.value) == null ? void 0 : be.margin) == null ? void 0 : ht.value) || 0;
      return E ? `${z * 2}px` : `${q + H}px`;
    }), M = I(() => {
      var E, q, H;
      return !!u.value && R_(
        (H = (q = (E = e == null ? void 0 : e.value) == null ? void 0 : E.builder) == null ? void 0 : q.customProperties) == null ? void 0 : H[o.value.type]
      );
    }), {
      isSharedContentLayout: O,
      blockSharedContentLayout: S,
      editingSharedContent: P
    } = ft({
      state: e
    }), k = I(() => {
      var E, q;
      return !!((E = P.value) != null && E.id) && ((q = P.value) == null ? void 0 : q.id) === o.value.id;
    });
    return (E, q) => (D(), U("div", {
      ref: V(o).id,
      class: He(["pb-layout-container", [
        `row-level-${V(a)}`,
        { "in-accordion": V(l) },
        { "is-empty-builder": V(d) }
      ]])
    }, [
      R("div", {
        ref_key: "layoutNodeContainer",
        ref: g,
        class: He(["layout-node-container", [
          { "is-active": V(u) || k.value },
          v.value + "-row",
          V(T)
        ]]),
        style: rt(p.value),
        "data-builder-label": E.$t("builder.emptyBuilderLabel"),
        "data-anchor-tag": V(x)
      }, [
        w.value.isBlocked ? (D(), G(Ow, {
          key: 0,
          message: E.$t(w.value.message)
        }, null, 8, ["message"])) : J("", !0),
        (D(!0), U(gt, null, nr(_.value, (H, z) => (D(), U("div", {
          key: z,
          class: He(["column", [v.value, { "is-editable": V(c) }]])
        }, [
          B(Sw, {
            "model-value": y(z),
            level: V(a),
            "draggable-group": V(s),
            "is-editable": V(c),
            "in-accordion": V(l),
            "parent-node-id": V(o).id || ""
          }, null, 8, ["model-value", "level", "draggable-group", "is-editable", "in-accordion", "parent-node-id"])
        ], 2))), 128))
      ], 14, ["data-builder-label", "data-anchor-tag"]),
      M.value ? (D(), G(Mw, {
        key: 0,
        modelValue: V(o),
        "onUpdate:modelValue": q[0] || (q[0] = (H) => lp(o) ? o.value = H : null),
        onCloseSidebar: q[1] || (q[1] = (H) => V(e).clearActiveNode())
      }, null, 8, ["modelValue"])) : J("", !0)
    ], 2));
  }
}, Bw = /* @__PURE__ */ X(qw, [["__scopeId", "data-v-c8f73711"]]), Uw = {
  __name: "NodeManager",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    isEditable: Boolean,
    inAccordion: Boolean
  },
  setup(n) {
    const e = Se("state"), t = n, { modelValue: r, isEditable: i, inAccordion: o, level: a } = Kl(t), s = I(() => (l(r.value) && u(r), r.value)), {
      isSharedContentLayout: l,
      applyContentToSharedContentLayout: u,
      isCurrentSharedContentBeingEdited: c
    } = ft({ state: e }), d = Se("insideSharedContentLayout"), f = I(
      () => !c(s.value) && (!!(d != null && d.value) || l(s.value))
    );
    ti("insideSharedContentLayout", f);
    const h = I(
      () => ir(s.value) || ev(s.value) || l(s.value)
    ), g = I(
      () => s.value.id === "root" && a.value === 0
    ), p = I(() => {
      var x;
      return i.value ? g.value && ((x = s.value.nodes) == null ? void 0 : x.length) === 0 || E_(s.value, o.value) : !1;
    }), v = I(() => {
      var x, A;
      return i.value && ((x = e == null ? void 0 : e.value) == null ? void 0 : x.activeNode) && ((A = e == null ? void 0 : e.value) == null ? void 0 : A.activeNode.id) === s.value.id;
    }), w = I(() => ({
      "empty-builder": p.value,
      "is-editable": i.value,
      root: g.value,
      "is-active-button-node": v.value && y(s.value)
    })), y = (x) => x.type === li, _ = I(() => !1), b = Q(null), { top: C, left: m } = zp(b), T = I(() => {
      var q, H, z;
      if (!((H = (q = e == null ? void 0 : e.value) == null ? void 0 : q.editingSharedContent) != null && H.node)) return {};
      const {
        top: x,
        left: A,
        width: M,
        height: O
      } = (z = e == null ? void 0 : e.value) == null ? void 0 : z.editingSharedContent.boundingRect, S = x - C.value - 40, P = A - m.value, k = M, E = O;
      return {
        clipPath: `polygon(0% 0%, 0% 100%, ${P}px 100%, ${P}px ${S}px, ${P + k}px ${S}px, ${P + k}px ${S + E}px, ${P}px ${S + E}px, ${P}px 100%, 100% 100%, 100% 0%)`
      };
    });
    return (x, A) => (D(), U("div", {
      ref_key: "nodeManagerContainer",
      ref: b,
      class: He(["node-manager-container", w.value])
    }, [
      h.value ? (D(), G(Bw, {
        key: 0,
        modelValue: s.value,
        "onUpdate:modelValue": A[0] || (A[0] = (M) => s.value = M),
        level: V(a),
        "is-editable": V(i),
        "in-accordion": V(o),
        "draggable-group": n.draggableGroup,
        "is-active-node": v.value,
        "is-empty-builder": p.value
      }, null, 8, ["modelValue", "level", "is-editable", "in-accordion", "draggable-group", "is-active-node", "is-empty-builder"])) : (D(), G(ow, {
        key: 1,
        modelValue: s.value,
        "onUpdate:modelValue": A[1] || (A[1] = (M) => s.value = M),
        "is-editable": V(i),
        "in-accordion": V(o),
        level: V(a),
        isActiveNode: v.value
      }, null, 8, ["modelValue", "is-editable", "in-accordion", "level", "isActiveNode"])),
      _.value ? (D(), G(Sy, {
        key: 2,
        style: rt(T.value)
      }, null, 8, ["style"])) : J("", !0)
    ], 2));
  }
}, Mg = /* @__PURE__ */ X(Uw, [["__scopeId", "data-v-5f70e082"]]), Lg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mg
}, Symbol.toStringTag, { value: "Module" })), jw = {
  __name: "SharedContentDialog",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    contentPreview: {
      type: Object,
      default: () => ({})
    }
  },
  setup(n) {
    const e = n;
    return (t, r) => {
      const i = $("a-icon"), o = $("a-button");
      return D(), U("div", { class: "shared-content-dialog no-drag" }, [
        R("div", { class: "preview-section" }, [
          B(Mg, {
            "model-value": n.contentPreview,
            "is-editable": !1
          }, null, 8, ["model-value"])
        ]),
        R("div", { class: "info-section" }, [
          R("p", { class: "node-name" }, K(e.node.name), 1),
          R("div", { class: "info-actions" }, [
            B(o, {
              class: "settings-button",
              variant: "none",
              onClick: r[0] || (r[0] = (a) => t.$emit("open-settings"))
            }, {
              default: j(() => [
                B(i, { icon: "24:settings-1" })
              ]),
              _: 1
            }),
            J("", !0)
          ])
        ])
      ]);
    };
  }
}, Hw = /* @__PURE__ */ X(jw, [["__scopeId", "data-v-27da9484"]]), $w = {
  __name: "SharedContentIcon",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  setup(n) {
    const e = Se("state"), t = n, r = Q(!1), i = Q(!1), o = (d) => i.value = d, a = (d) => r.value = d, {
      generateDialogPreview: s,
      openSharedContentSettings: l,
      deleteSharedContent: u
    } = ft({
      state: e
    }), c = I(
      () => s(t.node.sharedContentId)
    );
    return (d, f) => {
      const h = $("a-icon");
      return D(), U("div", { class: "shared-content-block" }, [
        yn((D(), U("div", {
          class: "block",
          onDblclick: f[0] || (f[0] = (g) => d.$emit("add-node"))
        }, [
          B(h, {
            class: "icon",
            icon: "32:paper-plane"
          }),
          B(kg, {
            style: { width: "75px" },
            "color-on-hover": "white",
            "is-hovering": r.value,
            "activate-scroll": r.value
          }, {
            default: j(() => [
              R("span", { class: "node-name" }, K(t.node.name), 1)
            ]),
            _: 1
          }, 8, ["is-hovering", "activate-scroll"])
        ], 32)), [
          [V(kl), [a]]
        ]),
        yn((D(), U("div", null, [
          R("div", { class: "triangle" }, [
            B(h, {
              class: "eye-icon",
              icon: "24:eye-open",
              color: "white"
            })
          ]),
          i.value && !r.value ? (D(), G(Hw, {
            key: 0,
            node: t.node,
            "content-preview": c.value,
            onOpenSettings: f[1] || (f[1] = (g) => V(l)(t.node.sharedContentId)),
            onDelete: f[2] || (f[2] = (g) => V(u)(t.node.sharedContentId))
          }, null, 8, ["node", "content-preview"])) : J("", !0)
        ])), [
          [V(kl), [o, { delayLeave: 150 }]]
        ])
      ]);
    };
  }
}, Fw = /* @__PURE__ */ X($w, [["__scopeId", "data-v-4036c559"]]), Vw = {
  __name: "SidebarNodes",
  props: {
    nodesIncluded: {
      type: Array,
      default: () => []
    },
    nodesExcluded: {
      type: Array,
      default: () => []
    },
    isSharedContentSidebar: Boolean
  },
  setup(n) {
    const e = n, t = Se("state"), r = ai({
      nodes: [
        ...Jl,
        ...Ci.filter(
          (O) => ![...nm, ...im].includes(O.type)
        )
      ]
    }), i = I(
      () => {
        var O, S;
        return ((S = (O = t == null ? void 0 : t.value) == null ? void 0 : O.builder) == null ? void 0 : S.customProperties) || {};
      }
    ), {
      isSharedContentLayout: o,
      getSharedContentSidebarNodes: a,
      onSidebarCloneSharedContent: s,
      amountOfSharedContent: l,
      editingSharedContent: u,
      addNodeToEditingSharedContent: c
    } = ft({ state: t }), d = Q(""), f = I(
      () => e.isSharedContentSidebar ? [Qe] : [mr, _r]
    ), h = I(() => {
      let O = e.nodesIncluded.length ? r.nodes.filter((S) => e.nodesIncluded.includes(S.type)) : r.nodes;
      return O = O.filter((S) => {
        var E, q, H;
        const P = !!((H = (q = (E = i.value) == null ? void 0 : E.CONTENT_NODE_NAVIGATION) == null ? void 0 : q.siteMenu) != null && H.length);
        return !(S.type === ci && !P);
      }), O.filter(
        (S) => !e.nodesExcluded.includes(S.type)
      );
    }), g = I(() => {
      var O;
      return ((O = i.value) == null ? void 0 : O.experimentalFeatures) || {};
    }), p = I(() => {
      var O, S;
      return (S = (O = i.value) == null ? void 0 : O.global) == null ? void 0 : S.focusNewNodeOnCreate;
    }), v = (O) => {
      var P, k, E;
      const S = b(O);
      if (u.value) {
        c(S);
        return;
      }
      (k = (P = t == null ? void 0 : t.value) == null ? void 0 : P.builder) == null || k.structure.nodes.push(S), (E = t == null ? void 0 : t.value) == null || E.emitToConsumingApp("amplitude-event", {
        type: S.name,
        action: "added",
        attributes: {
          method: "double-click",
          component: S.type
        }
      });
    }, w = (O) => {
      switch (O) {
        case mr:
          return "Layouts";
        case _r:
          return "Contents";
        case Qe:
          return "Shared Content";
      }
    }, y = (O) => ({
      "blocks-container": !0,
      "shared-blocks-container": O === Qe,
      "layout-blocks-container": O === mr,
      "content-blocks-container": O === _r
    }), _ = (O) => O === Qe ? a.value.filter(
      ({ name: P, sharedContentId: k }) => {
        var E;
        return P.toLowerCase().includes(d.value.toLowerCase().trim()) && k !== ((E = u == null ? void 0 : u.value) == null ? void 0 : E.sharedContentId);
      }
    ) : h.value.filter((S) => S.group === O), b = (O) => o(O) ? m(O) : C(O), C = (O) => {
      var P, k;
      let S = null;
      switch (O.group) {
        case mr:
          S = Ve(O, g.value);
          break;
        case _r:
          S = yr(O, (P = t == null ? void 0 : t.value) == null ? void 0 : P.builder.theme);
          break;
      }
      return p.value && ((k = t == null ? void 0 : t.value) == null || k.setActiveNode(S)), S;
    }, m = (O) => {
      var P;
      const S = s(O);
      return p.value && ((P = t == null ? void 0 : t.value) == null || P.setActiveNode(S)), S;
    }, T = Se("maxNestingLevelsAllowed"), {
      handleDraggableNodeMoved: x,
      handleNodeDraggingStarted: A,
      handleNodeDraggingEnded: M
    } = Rg({
      state: t.value,
      maxNestingLevelsAllowed: T
    });
    return (O, S) => {
      const P = $("a-form-input");
      return D(), U("div", { class: "sidebar-nodes" }, [
        (D(!0), U(gt, null, nr(f.value, (k) => (D(), U("div", {
          key: k,
          class: "group-block"
        }, [
          R("h4", { class: "group-title" }, K(w(k)), 1),
          k === V(Qe) && V(l) > 6 ? (D(), G(P, {
            key: 0,
            type: "search",
            placeholder: O.$t("builder.builderTabs.searchSharedContentPlaceholder"),
            modelValue: d.value,
            "onUpdate:modelValue": S[0] || (S[0] = (E) => d.value = E)
          }, null, 8, ["placeholder", "modelValue"])) : J("", !0),
          B(V(fp), {
            ref_for: !0,
            ref: "sidebar-draggable",
            list: _(k),
            class: He(y(k)),
            filter: ".no-drag",
            group: { name: "structure", pull: "clone", put: !1 },
            clone: b,
            sort: !1,
            "item-key": "id",
            move: V(x),
            onStart: V(A),
            onEnd: V(M)
          }, {
            item: j(({ element: E, index: q }) => [
              k !== V(Qe) ? (D(), G(Cy, {
                node: E,
                "group-type": k,
                key: `${E.type}-${q}`,
                onAddNode: (H) => v(E)
              }, null, 8, ["node", "group-type", "onAddNode"])) : (D(), G(Fw, {
                node: E,
                key: `sc-${E.type}-${q}`,
                onAddNode: (H) => v(E)
              }, null, 8, ["node", "onAddNode"]))
            ]),
            _: 2
          }, 1032, ["list", "class", "move", "onStart", "onEnd"])
        ]))), 128))
      ]);
    };
  }
}, rp = /* @__PURE__ */ X(Vw, [["__scopeId", "data-v-e2aa8f9a"]]), zw = {
  __name: "ContentToolbar",
  props: {
    builder: {
      type: Object,
      default: () => ({})
    },
    nodesIncluded: {
      type: Array,
      default: () => []
    },
    nodesExcluded: {
      type: Array,
      default: () => []
    }
  },
  emits: ["switch-tab"],
  setup(n, { emit: e }) {
    const t = Se("state"), r = Q("content"), i = Q(!1), { isSharedContentAllowed: o, hasSharedContent: a } = ft({
      state: t
    }), s = I(
      () => o.value && a.value
    );
    Ae(s, (d) => {
      d || (r.value = "content", u("switch-tab", r.value));
    });
    const l = Q([
      {
        value: "content",
        label: "Content",
        ariaControls: "Content"
      },
      {
        value: "shared",
        label: "Shared",
        ariaControls: "Shared"
      }
    ]), u = e, c = (d) => {
      r.value = d.target.value, u("switch-tab", r.value);
    };
    return (d, f) => {
      const h = $("a-tabs"), g = $("a-icon"), p = $("a-button");
      return i.value ? (D(), G(rb, {
        key: 0,
        builder: n.builder,
        onCloseSidebar: f[0] || (f[0] = (v) => i.value = !1)
      }, null, 8, ["builder"])) : (D(), U("div", { key: 1 }, [
        R("div", { class: "tabs-section" }, [
          s.value ? (D(), G(h, {
            key: 0,
            selected: r.value,
            tabs: l.value,
            class: "sidebar-tabs",
            onSwitchTabs: c
          }, null, 8, ["selected", "tabs"])) : (D(), U("h3", {
            key: 1,
            class: "sidebar-title"
          }, K(d.$t("builder.builderTabs.dragAndDropElements")), 1)),
          B(p, {
            class: "settings-button",
            variant: "none",
            onClick: f[1] || (f[1] = (v) => i.value = !0)
          }, {
            default: j(() => [
              B(g, { icon: "24:settings-2" })
            ]),
            _: 1
          })
        ]),
        r.value === "content" ? (D(), U("div", { key: 0 }, [
          B(rp, {
            "nodes-included": n.nodesIncluded,
            "nodes-excluded": n.nodesExcluded
          }, null, 8, ["nodes-included", "nodes-excluded"])
        ])) : J("", !0),
        r.value === "shared" ? (D(), U("div", { key: 1 }, [
          B(rp, { "is-shared-content-sidebar": "" })
        ])) : J("", !0)
      ]));
    };
  }
}, Ww = /* @__PURE__ */ X(zw, [["__scopeId", "data-v-a1077ba7"]]), Gw = {
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled ? "0.4" : "1";
    }
  }
};
function Yw(n, e, t, r, i, o) {
  return D(), U("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("g", { opacity: o.isDisabled }, [
      R("path", {
        d: "M4 11.5823H14.92C17.7256 11.5823 20 13.8567 20 16.6623V18.3333M4 11.5823L9.65217 5M4 11.5823L9.65217 18.1646",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], 8, ["opacity"])
  ]);
}
const qg = /* @__PURE__ */ X(Gw, [["render", Yw]]), A2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qg
}, Symbol.toStringTag, { value: "Module" })), Zw = {
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled ? "0.4" : "1";
    }
  }
};
function Xw(n, e, t, r, i, o) {
  return D(), U("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("g", { opacity: o.isDisabled }, [
      R("path", {
        d: "M20 11.5823H9.08C6.27439 11.5823 4 13.8567 4 16.6623V18.3333M20 11.5823L14.3478 5M20 11.5823L14.3478 18.1646",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], 8, ["opacity"])
  ]);
}
const Bg = /* @__PURE__ */ X(Zw, [["render", Xw]]), O2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bg
}, Symbol.toStringTag, { value: "Module" })), Kw = {
  name: "BuilderToolbar",
  components: {
    // BreakpointPreview,
    UndoIcon: qg,
    RedoIcon: Bg
  },
  inject: ["state"],
  props: {
    builder: {
      type: Object,
      default: () => {
      }
    },
    redoDisabled: Boolean,
    undoDisabled: Boolean
  },
  computed: {
    editor() {
      var n;
      return ((n = this.state) == null ? void 0 : n.editor) || {
        editor: {},
        editorKey: "",
        enabledOptions: [],
        removeOptions: [],
        colorPalette: {}
      };
    },
    linkModalOptions() {
      return this.customRTEProperties.linkModalOptions || {};
    },
    colorPalette() {
      var e, t, r;
      return {
        enabled: D_(
          ((e = this.state) == null ? void 0 : e.builder) || {}
        ),
        colors: ((r = (t = this.editor) == null ? void 0 : t.colorPalette) == null ? void 0 : r.colors) || ["*"]
      };
    },
    customRTEProperties() {
      var n, e, t;
      return ((t = (e = (n = this.state) == null ? void 0 : n.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t.RTEBar) || {};
    },
    aiEnabled() {
      var n, e, t, r, i;
      return ((i = (r = (t = (e = (n = this.state) == null ? void 0 : n.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t.global) == null ? void 0 : r.aiOptions) == null ? void 0 : i.enabled) || !1;
    },
    getRemoveOptions() {
      const n = this.customRTEProperties.removeOptions || [], e = this.editor.removeOptions || [];
      return [...n, ...e];
    }
  },
  methods: {
    toggleModal(n) {
      this.state.isLinkModalOpen = n, this.$emit("toggle-modal", n);
    }
  }
};
function Qw(n, e, t, r, i, o) {
  const a = $("UndoIcon"), s = $("a-button"), l = $("a-tooltip"), u = $("RedoIcon"), c = $("a-static-rte");
  return D(), U("div", { class: "sticky-header" }, [
    (D(), G(c, {
      key: o.editor.editorKey,
      class: "editor",
      disabled: !!o.customRTEProperties.disabled,
      "remove-default-actions": o.customRTEProperties.removeDefaultActions,
      "remove-options": o.getRemoveOptions,
      "editor-instance": o.editor.editor,
      "enabled-options": o.editor.enabledOptions,
      "link-modal-options": o.linkModalOptions,
      "color-palette": o.colorPalette,
      "font-sizes": o.customRTEProperties.fontSizes,
      "ai-enabled": o.aiEnabled,
      onToggleModal: o.toggleModal,
      onClick: e[2] || (e[2] = dl(() => {
      }, ["prevent", "stop"]))
    }, {
      "custom-actions": j(() => [
        R("div", { class: "history-buttons" }, [
          B(l, {
            label: n.$t("builder.toolbar.undo"),
            position: "bottom"
          }, {
            default: j(() => [
              B(s, {
                variant: "none",
                disabled: t.undoDisabled,
                onClick: e[0] || (e[0] = (d) => n.$emit("undo"))
              }, {
                default: j(() => [
                  B(a, { disabled: t.undoDisabled }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          B(l, {
            label: n.$t("builder.toolbar.redo"),
            position: "bottom"
          }, {
            default: j(() => [
              B(s, {
                variant: "none",
                disabled: t.redoDisabled,
                onClick: e[1] || (e[1] = (d) => n.$emit("redo"))
              }, {
                default: j(() => [
                  B(u, { disabled: t.redoDisabled }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["disabled", "remove-default-actions", "remove-options", "editor-instance", "enabled-options", "link-modal-options", "color-palette", "font-sizes", "ai-enabled", "onToggleModal"]))
  ]);
}
const Jw = /* @__PURE__ */ X(Kw, [["render", Qw], ["__scopeId", "data-v-114cea93"]]);
function np(...n) {
  return I(() => n.some((e) => pe(e)));
}
function e2({
  state: n = null,
  undo: e = null,
  redo: t = null,
  duplicateNode: r = null,
  deleteNode: i = null,
  allowArrowNavigation: o = !1,
  copySelectedNode: a = null,
  cutSelectedNode: s = null,
  dataInClipboard: l = null,
  pasteNode: u = null,
  isRenderMode: c = !1
}) {
  if (c) return;
  const { text: d } = L0(), { editingSharedContent: f } = ft({ state: n }), h = Ud(), g = I(() => {
    var b, C, m, T;
    return ((b = h.value) == null ? void 0 : b.tagName) === "INPUT" || ((C = h.value) == null ? void 0 : C.tagName) === "TEXTAREA" || ((T = (m = n == null ? void 0 : n.editor) == null ? void 0 : m.editor) == null ? void 0 : T.isFocused);
  }), p = I(() => !!d.value), v = I(() => {
    var b, C;
    return (C = (b = n == null ? void 0 : n.editor) == null ? void 0 : b.editor) == null ? void 0 : C.isFocused;
  });
  mt(() => {
    s && ke(document, "cut", (b) => {
      if (v.value || n.isCodeModalOpen) return !0;
      if (!n || p.value) return !1;
      s();
    }), a && ke(document, "copy", (b) => {
      !n || p.value || n.isCodeModalOpen || a();
    }), u && ke(document, "paste", (b) => {
      y(b);
    });
  });
  const w = P0({
    passive: !1,
    async onEventFired(b) {
      const C = b.type === "keydown", m = {
        ctrlZ: !!e && (b.ctrlKey || b.metaKey) && b.key.toLowerCase() === "z",
        shiftCtrlZ: !!t && b.shiftKey && (b.ctrlKey || b.metaKey) && b.key.toLowerCase() === "z",
        ctrlD: !!r && b.ctrlKey && b.key.toLowerCase() === "d",
        ctrlBackspace: !!i && b.ctrlKey && b.key === "Backspace",
        arrowUp: !g.value && !!o && b.key === "ArrowUp",
        arrowDown: !g.value && !!o && b.key === "ArrowDown",
        arrowLeft: !g.value && !!o && b.key === "ArrowLeft",
        arrowRight: !g.value && !!o && b.key === "ArrowRight",
        escape: b.key === "Escape"
      };
      C && Object.values(m).some((T) => !!T) && b.preventDefault();
    }
  });
  e && Nt(np(w.ctrl_z, w.meta_z), () => {
    n.isCodeModalOpen || e();
  }), t && Nt(np(w.shift_ctrl_z, w.meta_shift_z), () => {
    n.isCodeModalOpen || t();
  }), r && Nt(w.ctrl_d, () => {
    var m, T;
    if (!(n != null && n.activeNode) || n.isCodeModalOpen) return;
    const { parent: b, index: C } = Pt(
      (m = n.builder) == null ? void 0 : m.structure,
      (T = n.activeNode) == null ? void 0 : T.id
    );
    return r(n.activeNode, b, C);
  }), i && Nt(w.ctrl_backspace, () => {
    var m, T;
    if (!(n != null && n.activeNode) || n.isCodeModalOpen) return;
    const { parent: b, index: C } = Pt(
      (m = n.builder) == null ? void 0 : m.structure,
      (T = n.activeNode) == null ? void 0 : T.id
    );
    n.clearActiveNode(), n.clearEditor(), i(b, C);
  }), o && n && Nt(w.arrowUp, () => {
    var C, m, T, x, A, M, O;
    if (!o || g.value || n.isCodeModalOpen || f.value) return;
    if (!(n != null && n.activeNode)) {
      n.setActiveNode(((T = (m = (C = n.builder) == null ? void 0 : C.structure) == null ? void 0 : m.nodes) == null ? void 0 : T[0]) || null);
      return;
    }
    const b = Pt(
      (x = n.builder) == null ? void 0 : x.structure,
      (A = n.activeNode) == null ? void 0 : A.id
    );
    b.index - 1 >= 0 && n.setActiveNode(((O = (M = b.parent) == null ? void 0 : M.nodes) == null ? void 0 : O[(b == null ? void 0 : b.index) - 1]) || null);
  }), o && n && Nt(w.arrowDown, () => {
    var C, m, T, x, A, M, O, S;
    if (!o || g.value || n.isCodeModalOpen || f.value) return;
    if (!(n != null && n.activeNode)) {
      n.setActiveNode(((T = (m = (C = n.builder) == null ? void 0 : C.structure) == null ? void 0 : m.nodes) == null ? void 0 : T[0]) || null);
      return;
    }
    const b = Pt(
      (x = n.builder) == null ? void 0 : x.structure,
      (A = n.activeNode) == null ? void 0 : A.id
    );
    (((M = b.parent) == null ? void 0 : M.nodes) || []).length - 1 >= b.index + 1 && n.setActiveNode(((S = (O = b.parent) == null ? void 0 : O.nodes) == null ? void 0 : S[b.index + 1]) || null);
  }), o && n && Nt(w.arrowLeft, () => {
    var C, m;
    if (!o || g.value || !n.activeNode || n.isCodeModalOpen || f.value) return;
    const b = tv(
      (C = n.builder) == null ? void 0 : C.structure,
      (m = n.activeNode) == null ? void 0 : m.id
    );
    b.grandparent && n.setActiveNode(b.grandparent);
  }), o && n && Nt(w.arrowRight, () => {
    var C, m, T, x, A, M, O, S, P, k;
    if (!o || g.value || !n.activeNode || n.isCodeModalOpen || f.value) return;
    const b = ((m = (C = n.activeNode) == null ? void 0 : C.nodes) == null ? void 0 : m.length) > 0 && ((M = (A = (x = (T = n.activeNode) == null ? void 0 : T.nodes) == null ? void 0 : x[0]) == null ? void 0 : A.nodes) == null ? void 0 : M.length) > 0;
    ir(n.activeNode) && b && n.setActiveNode(((k = (P = (S = (O = n.activeNode) == null ? void 0 : O.nodes) == null ? void 0 : S[0]) == null ? void 0 : P.nodes) == null ? void 0 : k[0]) || null);
  }), n && Nt(w.escape, async () => {
    n.clearActiveNode(), n.clearEditor();
  });
  async function y(b) {
    var S, P;
    if (n.isCodeModalOpen) return;
    const { value: C = {} } = Ud(), m = !!C.editor, T = C.type;
    if (m || g.value && T !== "text")
      return;
    b.preventDefault();
    const { clipboardData: x, isValidNode: A, isLegacyNode: M } = await l();
    let O = x;
    if (M && typeof ((P = (S = n == null ? void 0 : n.builder) == null ? void 0 : S.legacyAdapters) == null ? void 0 : P.pageToBuilder) == "function") {
      const { structure: k, assets: E } = n.builder.legacyAdapters.pageToBuilder(O);
      E && n.addAsset(E), k.id && k.id === "root" ? O = k.nodes || [{}] : O = k || [{}];
    }
    if (!A) {
      g.value && _(x[0], C);
      return;
    }
    u && u(O);
  }
  function _(b, C) {
    const m = C.selectionStart, T = C.selectionEnd, x = C.value, A = x.slice(0, m) + b + x.slice(T);
    C.value = A, C.selectionStart = C.selectionEnd = m + b.length, C.dispatchEvent(new Event("input"));
  }
}
const t2 = {
  __name: "BuilderManager",
  props: {
    isEditable: Boolean
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Se("state"), o = Y(() => Promise.resolve().then(() => Lg)), a = I({
      get() {
        var S;
        return (S = i == null ? void 0 : i.value) == null ? void 0 : S.builder;
      },
      set(S) {
        i.value.builder = S, r("update:modelValue", S);
      }
    });
    Ae(a, (S) => r("update:modelValue", S), {
      deep: !0
    });
    const { undo: s, redo: l, canUndo: u, canRedo: c, pause: d, resume: f, clearSharedHistory: h } = Hu(a), { editingSharedContent: g } = ft({
      state: i
    }), { getHistory: p } = Dg(i);
    cp(() => {
      h();
    });
    const v = I(() => {
      if (g.value) {
        const { canUndo: S } = p(
          g.value.sharedContentId
        );
        return !S;
      }
      return !u.value;
    }), w = () => {
      if (d(), g.value) {
        const { undo: S } = p(
          g.value.sharedContentId
        );
        S();
        return;
      }
      s(), yt(() => {
        f();
      });
    }, y = I(() => {
      if (g.value) {
        const { canRedo: S } = p(
          g.value.sharedContentId
        );
        return !S;
      }
      return !c.value;
    }), _ = () => {
      if (d(), g.value) {
        const { redo: S } = p(
          g.value.sharedContentId
        );
        S();
        return;
      }
      l(), yt(() => {
        f();
      });
    }, {
      duplicateNode: b,
      deleteNode: C,
      copySelectedNode: m,
      cutSelectedNode: T,
      dataInClipboard: x,
      pasteNode: A
    } = Pg({
      state: i.value
    });
    e2({
      state: i.value,
      duplicateNode: b,
      deleteNode: C,
      copySelectedNode: m,
      cutSelectedNode: T,
      dataInClipboard: x,
      pasteNode: A,
      allowArrowNavigation: !0,
      undo: w,
      redo: _,
      isRenderMode: !t.isEditable
    }), dp();
    function M(S = "header") {
      var P;
      (P = i == null ? void 0 : i.value) == null || P.setActiveNode({ id: S });
    }
    function O() {
      var S;
      (S = i == null ? void 0 : i.value) == null || S.clearActiveNode();
    }
    return (S, P) => {
      var k, E, q, H, z, ee;
      return D(), U("div", { class: "builder-manager-container" }, [
        R("section", { class: "builder-toolbar-section" }, [
          n.isEditable ? (D(), G(Jw, {
            key: 0,
            builder: a.value,
            "redo-disabled": y.value,
            "undo-disabled": v.value,
            onRedo: _,
            onUndo: w,
            onToggleModal: P[0] || (P[0] = (se) => S.$emit("toggle-modal", se))
          }, {
            "header-preview": j(() => [
              tt(S.$slots, "header-preview", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["builder", "redo-disabled", "undo-disabled"])) : J("", !0)
        ]),
        R("section", {
          class: He(["builder-draggable-section", { "is-editable": n.isEditable }])
        }, [
          (q = (E = (k = a.value) == null ? void 0 : k.customProperties) == null ? void 0 : E.global) != null && q.showHeaderSlot ? tt(S.$slots, "header", {
            key: 0,
            openSidebar: M,
            closeSidebar: O
          }, void 0, !0) : J("", !0),
          B(V(o), {
            class: "main-node-manager",
            modelValue: a.value.structure,
            "onUpdate:modelValue": P[1] || (P[1] = (se) => a.value.structure = se),
            "is-editable": n.isEditable
          }, null, 8, ["modelValue", "is-editable"]),
          (ee = (z = (H = a.value) == null ? void 0 : H.customProperties) == null ? void 0 : z.global) != null && ee.showFooterSlot ? tt(S.$slots, "footer", { key: 1 }, void 0, !0) : J("", !0)
        ], 2)
      ]);
    };
  }
}, r2 = /* @__PURE__ */ X(t2, [["__scopeId", "data-v-d9966ce3"]]), n2 = {
  __name: "CustomAttributesSidebar",
  setup(n) {
    const e = Se("state"), t = Q(-1), r = Q(null), i = Q(null), o = Q(null), a = Q(!0), s = Q(!0), l = I({
      get: () => {
        var S, P;
        return ((P = (S = e == null ? void 0 : e.value) == null ? void 0 : S.activeNode.properties) == null ? void 0 : P.anchorTag) || "";
      },
      set: (S) => {
        e.value.activeNode.properties.anchorTag = S;
      }
    }), u = I({
      get: () => {
        var S, P;
        return ((P = (S = e == null ? void 0 : e.value) == null ? void 0 : S.activeNode.properties) == null ? void 0 : P.customClasses) || [];
      },
      set: (S) => e.value.activeNode.properties.customClasses = S
    }), c = I(
      () => u.value[t.value]
    ), d = I(() => x(l.value)), f = I(
      () => x(c.value)
    ), h = I(
      () => f.value || d.value
    );
    mt(() => {
      var S;
      r.value = (S = e == null ? void 0 : e.value) == null ? void 0 : S.activeNode.id, !(u.value.length > 0) && (t.value = 0, u.value.push(""));
    }), cp(() => {
      g(r.value);
    });
    const g = (S) => {
      var k, E;
      const P = Lt((k = e == null ? void 0 : e.value) == null ? void 0 : k.builder.structure, S);
      !P || !((E = P == null ? void 0 : P.properties) != null && E.customClasses) || (P.properties.customClasses = P.properties.customClasses.filter(
        (q) => !!(q != null && q.trim())
      ));
    }, p = (S) => {
      var E, q;
      if (!S.value) return;
      const P = ((E = S.value) == null ? void 0 : E.$el) || ((q = S.value[0]) == null ? void 0 : q.$el);
      if (!P) return;
      const k = P.querySelector("input");
      k && k.focus();
    }, v = () => {
      s.value = !0, yt(() => p(o));
    }, w = (S) => {
      f.value || (a.value = !0, t.value = S, yt(() => p(i)));
    }, y = I(() => {
      const S = u.value[u.value.length - 1];
      return !f.value && S !== "";
    }), _ = () => {
      var S, P;
      (S = e == null ? void 0 : e.value) == null || S.activeNode.properties.customClasses.push(""), a.value = !0, t.value = ((P = e == null ? void 0 : e.value) == null ? void 0 : P.activeNode.properties.customClasses.length) - 1, yt(() => p(i));
    }, b = () => {
      e.value.activeNode.properties.anchorTag = "", s.value = !0, yt(() => p(o));
    }, C = I(() => u.value.length > 1), m = (S) => {
      var P;
      (P = e == null ? void 0 : e.value) == null || P.activeNode.properties.customClasses.splice(S, 1), S <= t.value && (t.value -= 1), i.value && yt(() => p(i));
    }, T = /^(?!-\d)[a-zA-Z_-](?:[a-zA-Z0-9_-]|\\[^\n\r])*$/, x = (S) => S !== "" && !T.test(S), A = () => {
      !l.value || d.value || (s.value = !1);
    }, M = () => {
      !c.value || f.value || (a.value = !1);
    }, O = () => {
      h.value || (e.value.showCustomAttributesSidebar = !1);
    };
    return (S, P) => {
      const k = $("a-form-input"), E = $("a-icon"), q = $("a-button");
      return D(), U(gt, null, [
        B(wu, {
          title: S.$t("builder.controls.customAttributes.title"),
          onCloseSidebar: O
        }, null, 8, ["title"]),
        B(xr, null, {
          title: j(() => [
            R("h4", null, K(S.$t("builder.controls.customAttributes.anchorTagLabel")), 1)
          ]),
          content: j(() => [
            s.value ? (D(), G(k, {
              key: 0,
              modelValue: l.value,
              "onUpdate:modelValue": P[0] || (P[0] = (H) => l.value = H),
              id: "anchor-tag-input",
              ref_key: "anchorInput",
              ref: o,
              placeholder: S.$t("builder.controls.customAttributes.anchorTagPlaceholder"),
              label: S.$t("builder.controls.customAttributes.anchorTagPlaceholder"),
              "sr-only": "",
              "label-for": "anchor-tag-input",
              "show-error": d.value,
              "error-message": S.$t("builder.controls.customAttributes.invalidAttributeError", {
                attribute: S.$t("builder.controls.customAttributes.anchorTagLabel")
              }),
              onKeydown: Gu(A, ["enter"]),
              onBlur: A
            }, null, 8, ["modelValue", "placeholder", "label", "show-error", "error-message"])) : (D(), U("div", {
              key: 1,
              class: "non-editable-entry"
            }, [
              R("p", null, K(l.value), 1),
              R("div", { class: "icons-container" }, [
                B(q, {
                  variant: "default",
                  size: "small",
                  onClick: v
                }, {
                  default: j(() => [
                    B(E, { icon: "16:edit" })
                  ]),
                  _: 1
                }),
                B(q, {
                  variant: "default",
                  size: "small",
                  onClick: b
                }, {
                  default: j(() => [
                    B(E, { icon: "16:trashcan" })
                  ]),
                  _: 1
                })
              ])
            ]))
          ]),
          _: 1
        }),
        B(xr, null, {
          title: j(() => [
            R("h4", null, K(S.$t("builder.controls.customAttributes.customClassLabel")), 1)
          ]),
          content: j(() => [
            (D(!0), U(gt, null, nr(u.value, (H, z) => (D(), U("div", {
              key: z,
              class: "custom-class-container"
            }, [
              a.value && z === t.value ? (D(), G(k, {
                key: 0,
                modelValue: u.value[z],
                "onUpdate:modelValue": (ee) => u.value[z] = ee,
                id: `custom-class-input-${z}`,
                ref_for: !0,
                ref_key: "classInput",
                ref: i,
                placeholder: S.$t("builder.controls.customAttributes.customClassPlaceholder"),
                label: S.$t("builder.controls.customAttributes.customClassPlaceholder"),
                "sr-only": "",
                "label-for": `custom-class-input-${z}`,
                "show-error": f.value,
                "error-message": S.$t("builder.controls.customAttributes.invalidAttributeError", {
                  attribute: S.$t(
                    "builder.controls.customAttributes.customClassLabel"
                  )
                }),
                onKeydown: Gu(M, ["enter"]),
                onBlur: M
              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "placeholder", "label", "label-for", "show-error", "error-message"])) : (D(), U("div", {
                key: 1,
                class: "non-editable-entry"
              }, [
                R("p", null, K(H), 1),
                R("div", { class: "icons-container" }, [
                  B(q, {
                    variant: "default",
                    size: "small",
                    onClick: (ee) => w(z)
                  }, {
                    default: j(() => [
                      B(E, { icon: "16:edit" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  C.value ? (D(), G(q, {
                    key: 0,
                    variant: "default",
                    size: "small",
                    onClick: (ee) => m(z)
                  }, {
                    default: j(() => [
                      B(E, { icon: "16:trashcan" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : J("", !0)
                ])
              ]))
            ]))), 128)),
            R("div", { class: "button-container" }, [
              B(q, {
                variant: "link",
                disabled: !y.value,
                onClick: _
              }, {
                default: j(() => [
                  B(E, { icon: "16:plus" }),
                  Me(" " + K(S.$t("builder.controls.customAttributes.addAnotherClass")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ], 64);
    };
  }
};
function i2(n, e, t = { childList: !0, subtree: !0 }, r = 50) {
  const i = Q(null), o = Q(!1);
  let a = null, s = null;
  const l = () => {
    s && clearTimeout(s), s = setTimeout(() => {
      o.value = !!document.querySelector(e);
    }, r);
  }, u = () => {
    a = new MutationObserver(() => {
      l();
    }), i.value && a.observe(i.value, t);
  };
  return mt(() => {
    if (document) {
      if (i.value = document.querySelector(n), !i.value) {
        console.error(
          `Target element with selector "${n}" not found`
        );
        return;
      }
      o.value = !!document.querySelector(e), u();
    }
  }), Yl(() => {
    a && a.disconnect(), s && clearTimeout(s);
  }), { elementExists: o };
}
const o2 = {
  __name: "PageBuilder",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    isRenderMode: Boolean
  },
  emits: [
    "toggle-modal",
    "update:modelValue",
    "ai-on-success",
    "ai-on-loading",
    "ai-on-error",
    "amplitude-event",
    "toast-message"
  ],
  setup(n, { emit: e }) {
    const t = e, r = Q(!1), i = (_) => {
      r.value = _, t("toggle-modal", _);
    }, { elementExists: o } = i2(
      ".root-dialog-container",
      ".a-dialog"
    );
    Ae(o, (_) => {
      t("toggle-modal", _);
    });
    const a = n, s = Q(o0(t));
    ti("state", s), ti("isRenderMode", a.isRenderMode), mt(() => {
      var _;
      (_ = navigator == null ? void 0 : navigator.userAgentData) != null && _.platform && (s.value.userAgent = navigator.userAgentData.platform.toLowerCase().includes("mac") ? "mac" : "windows");
    });
    const l = I(() => {
      var _;
      return (_ = s == null ? void 0 : s.value) == null ? void 0 : _.builder.customProperties;
    }), u = I(
      () => l.value.global.maxNestingLevelsAllowed
    );
    ti("maxNestingLevelsAllowed", u);
    const c = I(() => a.modelValue);
    s.value.builder = c.value instanceof Bd ? c.value : new Bd(c.value);
    const d = I(
      () => {
        var _;
        return a0((_ = s == null ? void 0 : s.value) == null ? void 0 : _.builder);
      }
    ), { extractSharedContentIds: f } = ft({
      state: s
    });
    c.value.extractSharedContentIds = f;
    const h = I(
      () => {
        var _, b, C;
        return (_ = s == null ? void 0 : s.value) != null && _.showCustomAttributesSidebar ? "" : ((C = (b = s == null ? void 0 : s.value) == null ? void 0 : b.activeNode) == null ? void 0 : C.id) || "";
      }
    ), g = I(() => l.value.nodesIncluded), p = I(() => l.value.nodesExcluded), v = Q("content"), w = (_) => {
      v.value = _;
    }, y = I(() => v.value === "content" ? { "overflow-y": "auto", "overflow-x": "hidden" } : {});
    return (_, b) => {
      var C;
      return D(), U("div", {
        style: rt(d.value),
        class: "pb-main"
      }, [
        a.isRenderMode ? J("", !0) : (D(), U("section", {
          key: 0,
          class: "sidebar-section",
          style: rt(y.value)
        }, [
          R("div", { class: "sidebar-container" }, [
            s.value.showCustomAttributesSidebar ? (D(), G(n2, {
              key: (C = s.value.activeNode) == null ? void 0 : C.id
            })) : (D(), G(V(fl), {
              key: 1,
              name: h.value
            }, {
              default: j(() => [
                B(Ww, {
                  builder: s.value.builder,
                  "nodes-included": g.value,
                  "nodes-excluded": p.value,
                  onSwitchTab: w
                }, null, 8, ["builder", "nodes-included", "nodes-excluded"])
              ]),
              _: 1
            }, 8, ["name"]))
          ])
        ], 4)),
        R("section", {
          class: "builder-section",
          style: rt({ "z-index": r.value ? 1 : 0 })
        }, [
          B(r2, {
            "is-editable": !a.isRenderMode,
            "onUpdate:modelValue": b[0] || (b[0] = (m) => _.$emit("update:modelValue", m)),
            onToggleModal: i
          }, {
            header: j(({ openSidebar: m, closeSidebar: T }) => [
              tt(_.$slots, "header", {
                openSidebar: m,
                closeSidebar: T
              }, void 0, !0)
            ]),
            "header-preview": j(() => [
              tt(_.$slots, "header-preview", {}, void 0, !0)
            ]),
            footer: j(() => [
              tt(_.$slots, "footer", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["is-editable"])
        ], 4),
        R("div", { class: "root-dialog-container" }, [
          B(V(fl), { name: "root-dialog-container" })
        ])
      ], 4);
    };
  }
}, a2 = /* @__PURE__ */ X(o2, [["__scopeId", "data-v-7fecf522"]]), E2 = {
  install(n) {
    n.use(rm), n.component("ABuilder", a2);
  }
};
export {
  T2 as $,
  au as A,
  qt as B,
  Tt as C,
  Ow as D,
  lr as E,
  Zp as F,
  Jm as G,
  Mt as H,
  Y1 as I,
  qm as J,
  Ht as K,
  d2 as L,
  _2 as M,
  xr as N,
  Lw as O,
  g_ as P,
  kp as Q,
  Ep as R,
  wu as S,
  m_ as T,
  Pg as U,
  kg as V,
  er as W,
  Ar as X,
  Lp as Y,
  Et as Z,
  X as _,
  m2 as a,
  S2 as a0,
  Ot as a1,
  $t as a2,
  vu as a3,
  E2 as a4,
  qe as a5,
  wn as a6,
  Tn as a7,
  Sn as a8,
  xn as a9,
  y2 as aA,
  C2 as aB,
  w2 as aC,
  x2 as aD,
  Lg as aE,
  A2 as aF,
  O2 as aG,
  $r as aa,
  An as ab,
  On as ac,
  Qe as ad,
  Fr as ae,
  ri as af,
  $n as ag,
  hl as ah,
  pl as ai,
  En as aj,
  vl as ak,
  gl as al,
  li as am,
  ml as an,
  _l as ao,
  In as ap,
  Nn as aq,
  bl as ar,
  Bt as as,
  ui as at,
  ci as au,
  Bd as av,
  Ve as aw,
  ir as ax,
  v2 as ay,
  b2 as az,
  N_ as b,
  Or as c,
  wv as d,
  g2 as e,
  Lt as f,
  yr as g,
  hu as h,
  p2 as i,
  k_ as j,
  Zu as k,
  f2 as l,
  Rp as m,
  U0 as n,
  zb as o,
  HC as p,
  Wp as q,
  du as r,
  VC as s,
  ZC as t,
  h2 as u,
  p_ as v,
  su as w,
  XC as x,
  KC as y,
  xi as z
};
